import * as i0 from '@angular/core';
import { InjectionToken, Injectable, NgModule, Directive, EventEmitter, Injector, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, HostBinding, Output, ViewChild, ContentChild, ContentChildren, ViewChildren, Optional, inject, ElementRef, HostListener, Pipe, Self, Host, forwardRef, TemplateRef, QueryList, APP_INITIALIZER } from '@angular/core';
import * as i1$2 from '@angular/common/http';
import { HttpResponse, HTTP_INTERCEPTORS, HttpHeaders, HttpParams } from '@angular/common/http';
import * as i2$3 from '@angular/material/core';
import { MAT_RIPPLE_GLOBAL_OPTIONS, mixinErrorState, NativeDateAdapter, MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import * as i1$3 from '@angular/material/dialog';
import { MAT_DIALOG_DEFAULT_OPTIONS, MAT_DIALOG_DATA, MatDialogModule, MatDialogState } from '@angular/material/dialog';
import * as i6 from '@angular/material/form-field';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatLabel, MAT_ERROR, MatHint, MatFormFieldModule, MatFormFieldControl } from '@angular/material/form-field';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import * as i1$1 from '@angular/material/tooltip';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import { BREAKPOINTS, FlexLayoutModule } from '@ngbracket/ngx-layout';
import { of, Subject, throwError, BehaviorSubject, combineLatest, forkJoin, merge, fromEvent, race, timer, EMPTY, from, ReplaySubject } from 'rxjs';
import { tap, takeUntil, share, take, distinctUntilChanged, switchMap, shareReplay, concatMap, map, catchError, mapTo, filter, pluck, switchMapTo, startWith, debounceTime, delay, finalize, withLatestFrom, scan, takeWhile, mergeMap } from 'rxjs/operators';
import * as i4$1 from '@angular/material/select';
import { MAT_SELECT_CONFIG, MatSelectModule } from '@angular/material/select';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT, DatePipe } from '@angular/common';
import * as i1$4 from '@angular/forms';
import { NgControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule, FormControl, Validators, FormGroup } from '@angular/forms';
import * as i4 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i6$1 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import { webSocket } from 'rxjs/webSocket';
import * as i2 from '@ngbracket/ngx-layout/extended';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as i2$1 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i7$2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BACKSPACE, ENTER, COMMA, DOWN_ARROW, UP_ARROW } from '@angular/cdk/keycodes';
import * as i9 from '@angular/cdk/overlay';
import { CdkConnectedOverlay, OverlayModule, CdkScrollable } from '@angular/cdk/overlay';
import * as i3 from '@ngbracket/ngx-layout/flex';
import * as i5$1 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i7 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i2$2 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import { SelectionModel } from '@angular/cdk/collections';
import * as i7$4 from '@angular/material/button-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import * as i2$4 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i5$2 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i7$1 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i7$3 from '@angular/material/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import * as i6$2 from '@angular/material/table';
import { MatTableDataSource, MatTableModule, MatColumnDef, MatTable } from '@angular/material/table';
import * as i4$2 from '@angular/material/sort';
import { MatSort, MatSortModule } from '@angular/material/sort';
import * as i12 from '@angular/material/checkbox';
import { MatCheckboxModule, MatCheckbox } from '@angular/material/checkbox';
import { __decorate } from 'tslib';
import * as i2$5 from '@angular/router';
import { RouterModule, NavigationEnd } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';
import * as i3$1 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import { normalizePassiveListenerOptions } from '@angular/cdk/platform';
import * as i1$5 from '@angular/material/paginator';
import { MatPaginator } from '@angular/material/paginator';
import * as i3$2 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i6$3 from '@angular/material/sidenav';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import * as i2$6 from '@angular/platform-browser';
import * as i2$7 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i6$4 from '@angular/material/datepicker';
import { MatCalendarHeader, MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import * as i5$3 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import { OktaAuth } from '@okta/okta-auth-js';
const _c0 = ["fileInput"];
const _c1 = [[["mat-label"]], [["mat-error"], ["", "matError", ""]]];
const _c2 = ["mat-label", "mat-error, [matError]"];
const _c3 = (a0, a1) => ({
  "is-dragging-over-drop-container": a0,
  disabled: a1
});
const _c4 = a0 => ({
  disabled: a0
});
function EcaFileSelectorComponent_ng_template_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
  }
}
function EcaFileSelectorComponent_ng_template_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.multiple ? "Import File(s)" : "Import File");
  }
}
function EcaFileSelectorComponent_ng_template_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function EcaFileSelectorComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 14);
    i0.ɵɵtemplate(1, EcaFileSelectorComponent_ng_template_0_ng_container_1_Template, 2, 0, "ng-container", 15)(2, EcaFileSelectorComponent_ng_template_0_ng_template_2_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, EcaFileSelectorComponent_ng_template_0_span_4_Template, 2, 0, "span", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const defaultLabel_r3 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1._labelId);
    i0.ɵɵattribute("aria-owns", ctx_r1._id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._labelChildNonStatic || ctx_r1._labelChildStatic)("ngIfElse", defaultLabel_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.required);
  }
}
function EcaFileSelectorComponent_ng_template_4_Template(rf, ctx) {}
function EcaFileSelectorComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function EcaFileSelectorComponent_div_12_mat_hint_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r1._hintLabelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Files supported: [", ctx_r1.accept, "]");
  }
}
function EcaFileSelectorComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, EcaFileSelectorComponent_div_12_mat_hint_1_Template, 2, 2, "mat-hint", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.accept);
  }
}
function EcaFileSelectorComponent_div_13_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "mat-icon", 25);
    i0.ɵɵtext(2, "description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 27);
    i0.ɵɵlistener("click", function EcaFileSelectorComponent_div_13_div_1_Template_button_click_5_listener() {
      const i_r5 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeAt(i_r5));
    });
    i0.ɵɵelementStart(6, "mat-icon", 28);
    i0.ɵɵtext(7, "delete");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const file_r6 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(file_r6.name);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", "remove file: " + file_r6.name);
  }
}
function EcaFileSelectorComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, EcaFileSelectorComponent_div_13_div_1_Template, 8, 2, "div", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.files);
  }
}
const _c5 = a0 => ({
  hide: a0
});
const _c6 = ["*"];
const _c7 = a0 => ({
  "has-close": a0
});
const _c8 = (a0, a1) => ({
  "eca-notification-read": a0,
  "eca-notification-unread": a1
});
function EcaNotificationHistoryComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 7);
    i0.ɵɵtext(2, "notifications");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notificationsUnRead_r3 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("matBadge", notificationsUnRead_r3);
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 8);
    i0.ɵɵtext(1, "notifications");
    i0.ɵɵelementEnd();
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const notifications_r6 = i0.ɵɵnextContext().ngIf;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.allAsRead(notifications_r6));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "notifications");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " Mark All as Read ");
    i0.ɵɵelementEnd();
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_h3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 20);
    i0.ɵɵtext(1, " Today ");
    i0.ɵɵelementEnd();
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "a", 22);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_2_Template_a_click_1_listener($event) {
      const notification_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.markAsRead($event, notification_r8));
    })("keydown", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_2_Template_a_keydown_1_listener($event) {
      const notification_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.actionKey($event, notification_r8));
    });
    i0.ɵɵelementStart(3, "div", 23)(4, "h4", 24);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 25);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 26);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 27)(11, "mat-icon", 28);
    i0.ɵɵlistener("click", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_2_Template_mat_icon_click_11_listener($event) {
      const notification_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.remove($event, notification_r8));
    });
    i0.ɵɵtext(12, "cancel");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const notification_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "eca-notification-" + notification_r8.notificationId)("href", i0.ɵɵpipeBind1(2, 6, ctx_r1.generateLink(notification_r8)), i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpureFunction2(8, _c8, notification_r8.isRead, !notification_r8.isRead));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(notification_r8.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(notification_r8.formatted);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(notification_r8.description);
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_mat_divider_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-divider");
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_h3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 20);
    i0.ɵɵtext(1, " Older ");
    i0.ɵɵelementEnd();
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "a", 22);
    i0.ɵɵlistener("click", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_5_Template_a_click_1_listener($event) {
      const notification_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.markAsRead($event, notification_r10));
    })("keydown", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_5_Template_a_keydown_1_listener($event) {
      const notification_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.actionKey($event, notification_r10));
    });
    i0.ɵɵelementStart(2, "div", 23)(3, "h4", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 26);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 27)(10, "mat-icon", 28);
    i0.ɵɵlistener("click", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_5_Template_mat_icon_click_10_listener($event) {
      const notification_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.remove($event, notification_r10));
    });
    i0.ɵɵtext(11, "cancel");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const notification_r10 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "eca-notification-" + notification_r10.notificationId)("href", notification_r10.actionLink, i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpureFunction2(6, _c8, notification_r10.isRead, !notification_r10.isRead));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(notification_r10.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(notification_r10.formatted);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(notification_r10.description);
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_h3_1_Template, 2, 0, "h3", 18)(2, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_2_Template, 13, 11, "div", 19)(3, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_mat_divider_3_Template, 1, 0, "mat-divider", 3)(4, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_h3_4_Template, 2, 0, "h3", 18)(5, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_div_5_Template, 12, 9, "div", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notifications_r6 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notifications_r6.today.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", notifications_r6.today);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notifications_r6.today.length && notifications_r6.older.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notifications_r6.older.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", notifications_r6.older);
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1, "You currently have no notifications");
    i0.ɵɵelementEnd();
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "eca-monotron")(2, "div", 11)(3, "div", 12);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementStart(5, "div", 13)(6, "h2", 14);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 15);
    i0.ɵɵlistener("click", function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_Template_button_click_8_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleOverlay(false, $event));
    });
    i0.ɵɵelementStart(9, "mat-icon", 8);
    i0.ɵɵtext(10, "close");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(11, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_button_11_Template, 4, 0, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "mat-divider");
    i0.ɵɵtemplate(13, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_container_13_Template, 6, 5, "ng-container", 5)(14, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_ng_template_14_Template, 2, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const notifications_r6 = ctx.ngIf;
    const noNotifications_r11 = i0.ɵɵreference(15);
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c7, i0.ɵɵpipeBind1(4, 5, ctx_r1.shouldShowCloseButton)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("Notifications (", notifications_r6.today.length + notifications_r6.older.length, ")");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", notifications_r6.today.length + notifications_r6.older.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", notifications_r6.today.length + notifications_r6.older.length)("ngIfElse", noNotifications_r11);
  }
}
function EcaNotificationHistoryComponent_ng_container_2_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_div_0_Template, 16, 9, "div", 9);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r1.notifications$));
  }
}
function EcaNotificationHistoryComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 4, 0);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("click", function EcaNotificationHistoryComponent_ng_container_2_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleOverlay(!ctx_r1.overlayIsOpen, $event));
    });
    i0.ɵɵtemplate(4, EcaNotificationHistoryComponent_ng_container_2_ng_container_4_Template, 3, 1, "ng-container", 5);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵtemplate(6, EcaNotificationHistoryComponent_ng_container_2_ng_template_6_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, EcaNotificationHistoryComponent_ng_container_2_ng_template_8_Template, 2, 3, "ng-template", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const trigger_r12 = i0.ɵɵreference(2);
    const notRead_r13 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "eca-notification-history-open-button-", ctx_r1.instanceId, "");
    i0.ɵɵattribute("aria-label", "Notifications " + i0.ɵɵpipeBind1(3, 13, ctx_r1.notificationsUnRead$) + " unread");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 15, ctx_r1.notificationsUnRead$))("ngIfElse", notRead_r13);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cdkConnectedOverlayFlexibleDimensions", true)("cdkConnectedOverlayGrowAfterOpen", true)("cdkConnectedOverlayWidth", ctx_r1.overlayWidth)("cdkConnectedOverlayMinHeight", ctx_r1.overlayMinHeight)("cdkConnectedOverlayOrigin", trigger_r12)("cdkConnectedOverlayOpen", ctx_r1.overlayIsOpen)("cdkConnectedOverlayPositions", ctx_r1.overlayPositions)("cdkConnectedOverlayPush", true);
  }
}
function EcaHeaderBaseComponent_a_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5)(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background", ctx_r0.logo.base64Image);
    i0.ɵɵproperty("ngStyle", ctx_r0.logo.styles)("href", ctx_r0.logo.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", ctx_r0.logo.alt);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Link to ", ctx_r0.logo.link, "");
  }
}
function EcaHeaderBaseComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background", ctx_r0.logo.base64Image);
    i0.ɵɵproperty("ngStyle", ctx_r0.logo.styles);
    i0.ɵɵattribute("aria-label", ctx_r0.logo.alt);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.logo.alt);
  }
}
function EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const link_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", link_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r1.label, " ");
  }
}
function EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_template_2_ng_container_3_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const linkInner_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("href", linkInner_r2.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", linkInner_r2.label, " ");
  }
}
function EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_template_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_template_2_ng_container_3_a_1_Template, 2, 2, "a", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const linkInner_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", linkInner_r2.url);
  }
}
function EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(3, EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_template_2_ng_container_3_Template, 2, 1, "ng-container", 7);
  }
  if (rf & 2) {
    const link_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(link_r1.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", link_r1.links);
  }
}
function EcaHelpMenuComponent_ng_container_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_container_1_Template, 3, 2, "ng-container", 8)(2, EcaHelpMenuComponent_ng_container_0_ng_container_7_ng_template_2_Template, 4, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const link_r1 = ctx.$implicit;
    const category_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r1.url)("ngIfElse", category_r3);
  }
}
function EcaHelpMenuComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 4, 0)(3, "mat-icon", 5);
    i0.ɵɵtext(4, "help");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "mat-menu", 6, 1);
    i0.ɵɵtemplate(7, EcaHelpMenuComponent_ng_container_0_ng_container_7_Template, 4, 2, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const help_r4 = i0.ɵɵreference(6);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", help_r4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("overlapTrigger", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.helpLinks);
  }
}
const _c9 = ["userProfileMenuTrigger"];
const _c10 = (a0, a1) => ({
  "show-placeholder": a0,
  "hide-placeholder": a1
});
function EcaAutocompleteComponent_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 8);
    i0.ɵɵlistener("click", function EcaAutocompleteComponent_mat_icon_3_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      const trigger_r4 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(ctx_r2.togglePanel(trigger_r4));
    });
    i0.ɵɵtext(1, " expand_more ");
    i0.ɵɵelementEnd();
  }
}
function EcaAutocompleteComponent_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function EcaAutocompleteComponent_button_4_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearInput($event));
    });
    i0.ɵɵelementStart(1, "mat-icon", 10);
    i0.ɵɵtext(2, " cancel ");
    i0.ɵɵelementEnd()();
  }
}
function EcaAutocompleteComponent_mat_option_7_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
    i0.ɵɵpipe(1, "highlightText");
  }
  if (rf & 2) {
    const option_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, option_r6, ctx_r2.autocompleteInput), i0.ɵɵsanitizeHtml);
  }
}
function EcaAutocompleteComponent_mat_option_7_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
    i0.ɵɵpipe(1, "highlightText");
  }
  if (rf & 2) {
    const option_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, option_r6.label, ctx_r2.autocompleteInput), i0.ɵɵsanitizeHtml);
  }
}
function EcaAutocompleteComponent_mat_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 11);
    i0.ɵɵtemplate(1, EcaAutocompleteComponent_mat_option_7_span_1_Template, 2, 4, "span", 12)(2, EcaAutocompleteComponent_mat_option_7_span_2_Template, 2, 4, "span", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", option_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.optionsAreStrings);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.optionsAreStrings);
  }
}
const _c11 = ["searchInputElement"];
function EcaSearchChipListComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-chip-row", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("removable", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.value.length, " items (VIEW) ");
  }
}
function EcaSearchChipListComponent_ng_container_3_mat_chip_row_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip-row", 12);
    i0.ɵɵlistener("removed", function EcaSearchChipListComponent_ng_container_3_mat_chip_row_1_Template_mat_chip_row_removed_0_listener() {
      const chip_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.remove(chip_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 13);
    i0.ɵɵtext(3, "cancel");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const chip_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("removable", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.optionLabelsIndexedByValue[chip_r4] ? ctx_r1.optionLabelsIndexedByValue[chip_r4] : chip_r4, " ");
  }
}
function EcaSearchChipListComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaSearchChipListComponent_ng_container_3_mat_chip_row_1_Template, 4, 2, "mat-chip-row", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.value);
  }
}
function EcaSearchChipListComponent_mat_option_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r5.label, " ");
  }
}
function EcaSiteSelectorBasicComponent_div_1_mat_spinner_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 9);
  }
  if (rf & 2) {
    const field_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵattribute("aria-label", "Loading " + field_r1.label);
  }
}
function EcaSiteSelectorBasicComponent_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "eca-search-chip-list", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", i0.ɵɵpipeBind1(2, 5, ctx_r1.optionsByType$[field_r1.type]))("formControlName", field_r1.type)("required", true)("maxChipsToShow", 5)("focusInputOnClear", false);
  }
}
function EcaSiteSelectorBasicComponent_div_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "eca-autocomplete", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", i0.ɵɵpipeBind1(2, 4, ctx_r1.optionsByType$[field_r1.type]))("presentAsSelect", ctx_r1.showDropdownArrow)("required", true)("formControlName", field_r1.type);
  }
}
function EcaSiteSelectorBasicComponent_div_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "eca-search-suffix");
    i0.ɵɵelementContainerEnd();
  }
}
function EcaSiteSelectorBasicComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "mat-form-field", 7);
    i0.ɵɵtemplate(2, EcaSiteSelectorBasicComponent_div_1_mat_spinner_2_Template, 1, 1, "mat-spinner", 8);
    i0.ɵɵelementStart(3, "mat-label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, EcaSiteSelectorBasicComponent_div_1_ng_container_5_Template, 3, 7, "ng-container", 2)(6, EcaSiteSelectorBasicComponent_div_1_ng_container_6_Template, 3, 6, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, EcaSiteSelectorBasicComponent_div_1_ng_container_7_Template, 2, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isLoadingByType[field_r1.type]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r1.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.multiple && field_r1.type !== ctx_r1.siteSelectorSiteTypeAdministration);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.multiple || field_r1.type === ctx_r1.siteSelectorSiteTypeAdministration);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.multiple);
  }
}
function EcaSiteSelectorBasicComponent_mat_hint_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint");
    i0.ɵɵtext(1, " One or more of the selected schools does not belong");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3, " to this administration or you do not have access. ");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSelectorBasicComponent_mat_error_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Multiple schools and multiple districts cannot be selected at the same time. ");
    i0.ɵɵelementContainerEnd();
  }
}
function EcaSiteSelectorBasicComponent_mat_error_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " 'All Schools' must be selected when multiple districts are selected. ");
    i0.ɵɵelementContainerEnd();
  }
}
function EcaSiteSelectorBasicComponent_mat_error_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " 'All Schools' should not be selected when selecting multiple schools. ");
    i0.ɵɵelementContainerEnd();
  }
}
function EcaSiteSelectorBasicComponent_mat_error_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " 'All Districts' should not be selected when selecting multiple districts. ");
    i0.ɵɵelementContainerEnd();
  }
}
function EcaSiteSelectorBasicComponent_mat_error_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " 'All Service Components' should not be selected when selecting multiple Service Components. ");
    i0.ɵɵelementContainerEnd();
  }
}
function EcaSiteSelectorBasicComponent_mat_error_3_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Duplicate values should not be selected. ");
    i0.ɵɵelementContainerEnd();
  }
}
function EcaSiteSelectorBasicComponent_mat_error_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtemplate(1, EcaSiteSelectorBasicComponent_mat_error_3_ng_container_1_Template, 2, 0, "ng-container", 2)(2, EcaSiteSelectorBasicComponent_mat_error_3_ng_container_2_Template, 2, 0, "ng-container", 2)(3, EcaSiteSelectorBasicComponent_mat_error_3_ng_container_3_Template, 2, 0, "ng-container", 2)(4, EcaSiteSelectorBasicComponent_mat_error_3_ng_container_4_Template, 2, 0, "ng-container", 2)(5, EcaSiteSelectorBasicComponent_mat_error_3_ng_container_5_Template, 2, 0, "ng-container", 2)(6, EcaSiteSelectorBasicComponent_mat_error_3_ng_container_6_Template, 2, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formGroup.errors.multipleDistrictsAndSites);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formGroup.errors.allSchoolsNotSelected);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formGroup.errors.allSchoolsOrMultiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formGroup.errors.allDistrictsOrMultiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formGroup.errors.allServiceComponentsOrMultiple);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formGroup.errors.duplicateStates || ctx_r1.formGroup.errors.duplicateDistricts || ctx_r1.formGroup.errors.duplicateSchools);
  }
}
const _c12 = "[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent;z-index:1;--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{background-color:var(--drc-light-blue);border:3px solid var(--drc-blue);border-radius:4px;box-shadow:none;padding:0 7px!important;line-height:38px!important}.mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:7px;line-height:inherit}.mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent}.mat-mdc-button.mat-unthemed[_ngcontent-%COMP%]{--mdc-text-button-label-text-color: var(--drc-blue)}button.mat-mdc-button[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]{border-radius:4px;line-height:40px;font-style:normal;font-weight:600;font-size:16px;border:2px solid var(--drc-blue);position:relative;min-width:initial;color:var(--drc-blue);width:max-content;background-color:var(--drc-white);--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0;--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{--mdc-icon-button-state-layer-size: 44px}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%]{max-height:44px;max-width:44px}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{height:44px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only){padding:0 14px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%]{margin-right:8px;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%]{margin-right:0;margin-left:4px}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{background-color:var(--drc-blue);border:2px solid var(--drc-blue);color:var(--drc-white)}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]{padding:0 8px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 10px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin:0;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%]{border-radius:0 4px 4px 0}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{line-height:20px}button.mat-mdc-button[disabled][_ngcontent-%COMP%], button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%], .mat-datepicker-close-button[disabled][_ngcontent-%COMP%]{background-color:var(--drc-light-grey);border:2px solid var(--drc-light-grey);color:var(--drc-dark-grey)!important}button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{line-height:36px}button.mat-mdc-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 16px;background-color:var(--drc-white);color:var(--drc-blue);border:none;box-shadow:0 8px 10px -6px var(--drc-dark-grey-15),inset 0 -2px 0 var(--drc-accent-blue),inset 0 2px 0 var(--drc-accent-blue)}button.mat-mdc-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-button.mat-mdc-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.mat-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled){border-color:var(--drc-blue)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary{border-color:var(--drc-white)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before{background-color:var(--drc-bright-accent-blue);color:var(--drc-black);border:none;box-shadow:0 20px 25px -5px #262d3980,inset 0 -2px 0 var(--drc-white),inset 0 2px 0 var(--drc-white)}button.remove-btn-formatting[_ngcontent-%COMP%]{border:none!important;margin:0;padding:0;background:transparent;font-size:inherit;font-weight:400}button.remove-btn-formatting[_ngcontent-%COMP%]:not(#eca-skip-to-content-link, .nav-menu-link[_ngcontent-%COMP%], .mdc-icon-button[_ngcontent-%COMP%], #eca-user-profile-menu-link[_ngcontent-%COMP%], .eca-notification-history)[_ngcontent-%COMP%]{height:24px;line-height:24px}.eca-link[_ngcontent-%COMP%]:not([disabled]){color:var(--drc-blue);cursor:pointer}.eca-link[_ngcontent-%COMP%]:not([disabled]):not(.mat-mdc-menu-item){text-decoration:underline}[_nghost-%COMP%]{display:flex;width:100%;flex-flow:wrap}[_nghost-%COMP%]   .eca-search[_ngcontent-%COMP%]{width:calc(100% - 30px)}[_nghost-%COMP%]   .eca-search[_ngcontent-%COMP%]     input::-webkit-search-cancel-button{display:none}button.mat-mdc-icon-button[_ngcontent-%COMP%]{position:absolute;top:0;right:-16px;background-color:transparent;height:inherit;width:inherit;max-width:44px}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]{border:2px solid transparent;background-color:transparent}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:var(--drc-light-grey)}";
const _c13 = a0 => ({
  "eca-has-prefix": a0
});
function EcaSiteSelectorTableComponent_mat_form_field_1_mat_spinner_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 26);
  }
}
function EcaSiteSelectorTableComponent_mat_form_field_1_mat_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r1);
  }
}
function EcaSiteSelectorTableComponent_mat_form_field_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 22);
    i0.ɵɵtemplate(1, EcaSiteSelectorTableComponent_mat_form_field_1_mat_spinner_1_Template, 1, 0, "mat-spinner", 23);
    i0.ɵɵelementStart(2, "mat-select", 24);
    i0.ɵɵtemplate(3, EcaSiteSelectorTableComponent_mat_form_field_1_mat_option_3_Template, 2, 2, "mat-option", 25);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.statesLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.stateControl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.stateOptions);
  }
}
function EcaSiteSelectorTableComponent_mat_form_field_2_mat_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r3.label);
  }
}
function EcaSiteSelectorTableComponent_mat_form_field_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 28)(1, "mat-select", 29);
    i0.ɵɵtemplate(2, EcaSiteSelectorTableComponent_mat_form_field_2_mat_option_2_Template, 2, 2, "mat-option", 25);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c13, ctx_r1.stateOptions$));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.siteTypeControl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.siteTypeOptions);
  }
}
function EcaSiteSelectorTableComponent_mat_hint_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint");
    i0.ɵɵtext(1, " Results were limited to 50 records. Please try a more specific search. ");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSelectorTableComponent_th_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 30);
    i0.ɵɵelement(1, "mat-checkbox");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSelectorTableComponent_td_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 31)(1, "mat-checkbox", 32);
    i0.ɵɵlistener("change", function EcaSiteSelectorTableComponent_td_12_Template_mat_checkbox_change_1_listener() {
      const element_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selection.toggle(element_r5));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const element_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.selection.isSelected(element_r5));
  }
}
function EcaSiteSelectorTableComponent_th_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 33);
    i0.ɵɵtext(1, "Name");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSelectorTableComponent_td_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 34);
    i0.ɵɵpipe(1, "highlightText");
  }
  if (rf & 2) {
    const element_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, element_r6.name, ctx_r1.searchControl.value), i0.ɵɵsanitizeHtml);
  }
}
function EcaSiteSelectorTableComponent_th_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 33);
    i0.ɵɵtext(1, "Code");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSelectorTableComponent_td_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 34);
    i0.ɵɵpipe(1, "highlightText");
  }
  if (rf & 2) {
    const element_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, element_r7.code, ctx_r1.searchControl.value), i0.ɵɵsanitizeHtml);
  }
}
function EcaSiteSelectorTableComponent_th_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.parentNameColumnLabel || "Parent Name", " ");
  }
}
function EcaSiteSelectorTableComponent_td_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(element_r8.parentSiteName);
  }
}
function EcaSiteSelectorTableComponent_th_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.parentCodeColumnLabel || "Parent Code", " ");
  }
}
function EcaSiteSelectorTableComponent_td_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(element_r9.parentSiteCode);
  }
}
function EcaSiteSelectorTableComponent_tr_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 35);
  }
}
function EcaSiteSelectorTableComponent_tr_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 36);
    i0.ɵɵlistener("click", function EcaSiteSelectorTableComponent_tr_26_Template_tr_click_0_listener() {
      const row_r11 = i0.ɵɵrestoreView(_r10).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSiteRowClick(row_r11));
    });
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSelectorTableComponent_div_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelement(1, "mat-spinner", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("diameter", 50);
  }
}
function EcaSiteSelectorTableComponent_div_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39)(1, "p");
    i0.ɵɵtext(2, "No results found");
    i0.ɵɵelementEnd()();
  }
}
const _c14 = a0 => ({
  "active": a0
});
function EcaAdminSelectorTableComponent_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Name");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminSelectorTableComponent_td_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r1.name, " ");
  }
}
function EcaAdminSelectorTableComponent_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Code");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminSelectorTableComponent_td_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r2.code, " ");
  }
}
function EcaAdminSelectorTableComponent_th_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Number");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminSelectorTableComponent_td_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r3.number, " ");
  }
}
function EcaAdminSelectorTableComponent_th_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Updated");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminSelectorTableComponent_td_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, element_r4.updateDate), " ");
  }
}
function EcaAdminSelectorTableComponent_th_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 14);
    i0.ɵɵtext(1, "Select");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminSelectorTableComponent_td_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13)(1, "button", 15);
    i0.ɵɵtext(2, " Select ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const element_r5 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c14, ctx_r5.selection.isSelected(element_r5)));
  }
}
function EcaAdminSelectorTableComponent_tr_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 16);
  }
}
function EcaAdminSelectorTableComponent_tr_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 17);
    i0.ɵɵlistener("click", function EcaAdminSelectorTableComponent_tr_18_Template_tr_click_0_listener() {
      const row_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.onAdminRowClick(row_r8));
    });
    i0.ɵɵelementEnd();
  }
}
const _c15 = "[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}.table-scroll-container[_ngcontent-%COMP%]{height:100%;overflow:auto}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row){cursor:pointer}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row):hover{text-decoration:underline}.spinner-container[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;padding-top:24px}.eca-select-spinner.mat-mdc-progress-spinner[_ngcontent-%COMP%]{margin:0 auto -24px}.eca-select-spinner.mat-mdc-progress-spinner[_ngcontent-%COMP%]     circle{stroke:var(--drc-insight-gold)}button.row-select-button[_ngcontent-%COMP%]{margin-right:16px}.mat-icon.mat-clear[_ngcontent-%COMP%]{cursor:pointer}.filter-group[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{margin:-22px 0 -14px}.no-data-container[_ngcontent-%COMP%]{padding:8px;text-align:center}.eca-site-selector-form-field[_ngcontent-%COMP%]{width:480px}.results-count-container[_ngcontent-%COMP%]{padding-left:16px;flex-direction:column;justify-content:center;margin-bottom:16px;display:flex;flex:1 1 auto}";
const _c16 = ["siteAdminStepper"];
function EcaSiteSelectorAdvancedComponent_div_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "chevron_left");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSelectorAdvancedComponent_div_1_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r1.firstStepLabel);
  }
}
function EcaSiteSelectorAdvancedComponent_div_1_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, "Select an Admin");
  }
}
function EcaSiteSelectorAdvancedComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "mat-horizontal-stepper", 5, 0);
    i0.ɵɵtemplate(3, EcaSiteSelectorAdvancedComponent_div_1_ng_template_3_Template, 2, 0, "ng-template", 6);
    i0.ɵɵelementStart(4, "mat-step", 7);
    i0.ɵɵtemplate(5, EcaSiteSelectorAdvancedComponent_div_1_ng_template_5_Template, 1, 1, "ng-template", 8);
    i0.ɵɵelementStart(6, "eca-site-selector-table", 9);
    i0.ɵɵlistener("rowClick", function EcaSiteSelectorAdvancedComponent_div_1_Template_eca_site_selector_table_rowClick_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSiteRowClick($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "mat-step", 7);
    i0.ɵɵtemplate(8, EcaSiteSelectorAdvancedComponent_div_1_ng_template_8_Template, 1, 0, "ng-template", 8);
    i0.ɵɵelementStart(9, "eca-admin-selector-table", 10);
    i0.ɵɵlistener("rowClick", function EcaSiteSelectorAdvancedComponent_div_1_Template_eca_admin_selector_table_rowClick_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAdminRowClick($event));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("completed", ctx_r1.selection.site.hasValue());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("displayedColumns", ctx_r1.displayedColumns.siteTable)("parentNameColumnLabel", ctx_r1.parentNameColumnLabel)("parentCodeColumnLabel", ctx_r1.parentCodeColumnLabel)("loadingResults$", ctx_r1.loadingResults$)("searchControl", ctx_r1.searchControl)("selection", ctx_r1.selection.site)("stateControl", ctx_r1.stateControl)("stateOptions$", ctx_r1.stateOptions$)("siteTypeOptions", ctx_r1.siteTypeOptions)("siteTypeControl", ctx_r1.siteTypeControl)("siteResults$", ctx_r1.siteResults$);
    i0.ɵɵadvance();
    i0.ɵɵproperty("completed", ctx_r1.selection.admin.hasValue());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("adminResults", ctx_r1.adminResults)("displayedColumns", ctx_r1.displayedColumns.adminTable)("selection", ctx_r1.selection.admin);
  }
}
function EcaSiteSelectorAdvancedComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "eca-site-selector-table", 12);
    i0.ɵɵlistener("rowClick", function EcaSiteSelectorAdvancedComponent_div_2_Template_eca_site_selector_table_rowClick_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSiteRowClick($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayedColumns", ctx_r1.displayedColumns.siteTable)("loadingResults$", ctx_r1.loadingResults$)("searchControl", ctx_r1.searchControl)("selection", ctx_r1.selection.site)("stateControl", ctx_r1.stateControl)("stateOptions$", ctx_r1.stateOptions$)("siteTypeOptions", ctx_r1.siteTypeOptions)("siteTypeControl", ctx_r1.siteTypeControl)("siteResults$", ctx_r1.siteResults$);
  }
}
const _c17 = ["trigger"];
function EcaSiteSelectorComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.selectionText, " ");
  }
}
function EcaSiteSelectorComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.openOverlayButtonText, " ");
  }
}
function EcaSiteSelectorComponent_ng_template_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "mat-button-toggle-group", 9)(2, "mat-button-toggle", 10);
    i0.ɵɵtext(3, "Basic Search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-button-toggle", 11);
    i0.ɵɵtext(5, "Advanced Search");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.viewModeControl);
  }
}
function EcaSiteSelectorComponent_ng_template_10_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "eca-site-selector-basic", 12);
    i0.ɵɵlistener("cancel", function EcaSiteSelectorComponent_ng_template_10_ng_container_3_ng_container_1_Template_eca_site_selector_basic_cancel_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCancel());
    })("save", function EcaSiteSelectorComponent_ng_template_10_ng_container_3_ng_container_1_Template_eca_site_selector_basic_save_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSave($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngModel", ctx_r1.selection.selected ? ctx_r1.selection.selected : null)("product", product_r4)("siteHierarchy", ctx_r1.siteHierarchy)("hideAllOption", ctx_r1.hideAllOption)("includeAdmin", ctx_r1.includeAdmin)("acl", ctx_r1.acl)("archived", ctx_r1.archived)("multiple", ctx_r1.multiple)("resultsFilter", ctx_r1.resultsFilter)("showSiteCode", ctx_r1.showSiteCode);
  }
}
function EcaSiteSelectorComponent_ng_template_10_ng_container_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "eca-site-selector-advanced", 13);
    i0.ɵɵlistener("save", function EcaSiteSelectorComponent_ng_template_10_ng_container_3_ng_container_2_Template_eca_site_selector_advanced_save_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSave($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("product", product_r4)("includeAdmin", ctx_r1.includeAdmin)("acl", ctx_r1.acl)("archived", ctx_r1.archived)("labelCallback", ctx_r1.labelCallback)("labelPlaceholder", ctx_r1.labelPlaceholder)("leafOnly", ctx_r1.leafOnly)("masterSearch", ctx_r1.masterSearch)("parentCodeColumnLabel", ctx_r1.parentCodeColumnLabel)("parentNameColumnLabel", ctx_r1.parentNameColumnLabel)("resultsFilter", ctx_r1.resultsFilter)("siteHierarchy", ctx_r1.siteHierarchy);
  }
}
function EcaSiteSelectorComponent_ng_template_10_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaSiteSelectorComponent_ng_template_10_ng_container_3_ng_container_1_Template, 2, 10, "ng-container", 4)(2, EcaSiteSelectorComponent_ng_template_10_ng_container_3_ng_container_2_Template, 2, 12, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.viewModeControl.value === ctx_r1.ecaSiteSelectorService.viewModeBasic);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.viewModeControl.value === ctx_r1.ecaSiteSelectorService.viewModeAdvanced);
  }
}
function EcaSiteSelectorComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, EcaSiteSelectorComponent_ng_template_10_div_1_Template, 6, 1, "div", 7);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, EcaSiteSelectorComponent_ng_template_10_ng_container_3_Template, 3, 2, "ng-container", 4);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.multiple && !((tmp_2_0 = i0.ɵɵpipeBind1(2, 2, ctx_r1.ecaSiteSelectorService.inputParameters$)) == null ? null : tmp_2_0.hideAdvancedSearch));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.siteHierarchy && i0.ɵɵpipeBind1(4, 4, ctx_r1.product$));
  }
}
const _c18 = ["productsMenuTrigger"];
const _c19 = ["applicationsMenuTrigger"];
const _c20 = (a0, a1, a2) => ({
  "large-icon": a0,
  "max-width-1440": a1,
  "silver-text-color": a2
});
function EcaHeaderComponent_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.title$));
  }
}
function EcaHeaderComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function EcaHeaderComponent_button_7_Template_button_click_0_listener() {
      const singleProduct_r3 = i0.ɵɵrestoreView(_r2).ngIf;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.launchProduct(singleProduct_r3));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.selectedProductLabel$), " ");
  }
}
function EcaHeaderComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 24, 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const productsMenu_r4 = i0.ɵɵreference(12);
    i0.ɵɵproperty("matMenuTriggerFor", productsMenu_r4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r0.selectedProductLabel$), " ");
  }
}
function EcaHeaderComponent_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function EcaHeaderComponent_button_14_Template_button_click_0_listener() {
      const product_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.launchProduct(product_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const product_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", product_r6.name, " ");
  }
}
function EcaHeaderComponent_button_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 26, 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const programsMenu_r7 = i0.ɵɵreference(19);
    i0.ɵɵproperty("matMenuTriggerFor", programsMenu_r7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r0.selectedProgramLabel$), " ");
  }
}
function EcaHeaderComponent_button_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function EcaHeaderComponent_button_21_Template_button_click_0_listener() {
      const program_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.launchProgram(program_r9));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "uppercase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const program_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, program_r9.code), " ");
  }
}
function EcaHeaderComponent_button_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 27, 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const applicationsMenu_r10 = i0.ɵɵreference(26);
    i0.ɵɵproperty("matMenuTriggerFor", applicationsMenu_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r0.selectedApplicationLabel$), " ");
  }
}
function EcaHeaderComponent_div_28_ng_container_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function EcaHeaderComponent_div_28_ng_container_1_button_4_Template_button_click_0_listener() {
      const app_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.launchApplication(app_r12));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const app_r12 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", app_r12.label, " ");
  }
}
function EcaHeaderComponent_div_28_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, EcaHeaderComponent_div_28_ng_container_1_button_4_Template, 2, 1, "button", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const category_r13 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(category_r13.name || category_r13.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r13.applications);
  }
}
function EcaHeaderComponent_div_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, EcaHeaderComponent_div_28_ng_container_1_Template, 5, 2, "ng-container", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r14 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", column_r14);
  }
}
function EcaHeaderComponent_mat_spinner_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 31);
  }
}
function EcaHeaderComponent_eca_site_selector_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "eca-site-selector", 32);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("product$", ctx_r0.selectedProduct$);
  }
}
function EcaHeaderComponent_eca_notification_history_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "eca-notification-history");
  }
}
function EcaHeaderComponent_eca_user_profile_menu_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "eca-user-profile-menu", 33);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", i0.ɵɵpipeBind1(1, 1, ctx_r0.username$));
  }
}
const _c21 = ["input"];
const _c22 = ["eca-editable-heading", "", "formControl", ""];
const _c23 = a0 => ({
  "eca-heading-chips": a0
});
function EcaEditableHeadingComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function EcaEditableHeadingComponent_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleEdit());
    });
    i0.ɵɵtext(1, " Edit\n");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("disabled", !ctx_r2.canEdit);
  }
}
const _c24 = ["bodyCardContainer"];
const _c25 = ["sidePanelContainer"];
const _c26 = ["*", [["", 8, "eca-monotron-side-panel"]]];
const _c27 = ["*", ".eca-monotron-side-panel"];
const _c28 = a0 => ({
  "flex-basis.%": a0
});
function EcaMonotronBodyComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5, 1);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c28, ctx_r0.sidePanelPercent));
  }
}
const _c29 = a0 => ({
  active: a0
});
function EcaSiteSearchTableComponent_th_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵtext(1, "Name");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSearchTableComponent_td_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 18);
    i0.ɵɵpipe(1, "highlightText");
  }
  if (rf & 2) {
    const element_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, element_r1.name, ctx_r1.searchControl.value), i0.ɵɵsanitizeHtml);
  }
}
function EcaSiteSearchTableComponent_th_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵtext(1, "Code");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSearchTableComponent_td_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 18);
    i0.ɵɵpipe(1, "highlightText");
  }
  if (rf & 2) {
    const element_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, element_r3.code, ctx_r1.searchControl.value), i0.ɵɵsanitizeHtml);
  }
}
function EcaSiteSearchTableComponent_th_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.parentNameColumnLabel || "Parent Name");
  }
}
function EcaSiteSearchTableComponent_td_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(element_r4.parentSiteName);
  }
}
function EcaSiteSearchTableComponent_th_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.parentCodeColumnLabel || "Parent Code");
  }
}
function EcaSiteSearchTableComponent_td_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(element_r5.parentSiteCode);
  }
}
function EcaSiteSearchTableComponent_th_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵtext(1, "Select");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSearchTableComponent_td_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19)(1, "button", 20);
    i0.ɵɵtext(2, " Select ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const element_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c29, ctx_r1.selection.isSelected(element_r6)));
  }
}
function EcaSiteSearchTableComponent_tr_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 21);
  }
}
function EcaSiteSearchTableComponent_tr_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 22);
    i0.ɵɵlistener("click", function EcaSiteSearchTableComponent_tr_23_Template_tr_click_0_listener() {
      const row_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSiteRowClick(row_r8));
    });
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSearchTableComponent_div_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "mat-spinner", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("diameter", 50);
  }
}
function EcaSiteSearchTableComponent_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "p");
    i0.ɵɵtext(2, "No results found");
    i0.ɵɵelementEnd()();
  }
}
function EcaAdminTableComponent_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Name");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminTableComponent_td_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r1.name, " ");
  }
}
function EcaAdminTableComponent_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Code");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminTableComponent_td_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r2.code, " ");
  }
}
function EcaAdminTableComponent_th_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Number");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminTableComponent_td_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", element_r3.number, " ");
  }
}
function EcaAdminTableComponent_th_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1, "Updated");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminTableComponent_td_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, element_r4.updateDate), " ");
  }
}
function EcaAdminTableComponent_th_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 14);
    i0.ɵɵtext(1, "Select");
    i0.ɵɵelementEnd();
  }
}
function EcaAdminTableComponent_td_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13)(1, "button", 15);
    i0.ɵɵtext(2, " Select ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const element_r5 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c14, ctx_r5.selection.isSelected(element_r5)));
  }
}
function EcaAdminTableComponent_tr_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 16);
  }
}
function EcaAdminTableComponent_tr_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 17);
    i0.ɵɵlistener("click", function EcaAdminTableComponent_tr_18_Template_tr_click_0_listener() {
      const row_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.onAdminRowClick(row_r8));
    });
    i0.ɵɵelementEnd();
  }
}
const _c30 = ".table-scroll-container[_ngcontent-%COMP%]{height:100%;overflow:auto}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row){cursor:pointer}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row):hover{text-decoration:underline}.spinner-container[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;padding-top:24px}button.row-select-button[_ngcontent-%COMP%]{margin-right:16px}.mat-icon.mat-clear[_ngcontent-%COMP%]{cursor:pointer}.filter-group[_ngcontent-%COMP%]   .eca-site-search-form-field[_ngcontent-%COMP%]{margin:8px 0 -16px}.no-data-container[_ngcontent-%COMP%]{padding:8px;text-align:center}.eca-site-search-form-field[_ngcontent-%COMP%]{width:300px}";
function EcaSiteSearchDialogComponent_div_6_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "chevron_left");
    i0.ɵɵelementEnd();
  }
}
function EcaSiteSearchDialogComponent_div_6_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r1.firstStepLabel);
  }
}
function EcaSiteSearchDialogComponent_div_6_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, "Select an Admin");
  }
}
function EcaSiteSearchDialogComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "mat-horizontal-stepper", 7, 0);
    i0.ɵɵtemplate(3, EcaSiteSearchDialogComponent_div_6_ng_template_3_Template, 2, 0, "ng-template", 8);
    i0.ɵɵelementStart(4, "mat-step", 9);
    i0.ɵɵtemplate(5, EcaSiteSearchDialogComponent_div_6_ng_template_5_Template, 1, 1, "ng-template", 10);
    i0.ɵɵelementStart(6, "eca-site-search-table", 11);
    i0.ɵɵlistener("rowClick", function EcaSiteSearchDialogComponent_div_6_Template_eca_site_search_table_rowClick_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSiteRowClick($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "mat-step", 9);
    i0.ɵɵtemplate(8, EcaSiteSearchDialogComponent_div_6_ng_template_8_Template, 1, 0, "ng-template", 10);
    i0.ɵɵelementStart(9, "eca-admin-table", 12);
    i0.ɵɵlistener("rowClick", function EcaSiteSearchDialogComponent_div_6_Template_eca_admin_table_rowClick_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAdminRowClick($event));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("completed", ctx_r1.selection.site.hasValue());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("displayedColumns", ctx_r1.displayedColumns.siteTable)("parentNameColumnLabel", ctx_r1.data.parentNameColumnLabel)("parentCodeColumnLabel", ctx_r1.data.parentCodeColumnLabel)("loadingResults", ctx_r1.loadingResults)("searchControl", ctx_r1.searchControl)("selection", ctx_r1.selection.site)("siteResults", ctx_r1.siteResults);
    i0.ɵɵadvance();
    i0.ɵɵproperty("completed", ctx_r1.selection.admin.hasValue());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("adminResults", ctx_r1.adminResults)("displayedColumns", ctx_r1.displayedColumns.adminTable)("selection", ctx_r1.selection.admin);
  }
}
function EcaSiteSearchDialogComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "eca-site-search-table", 14);
    i0.ɵɵlistener("rowClick", function EcaSiteSearchDialogComponent_div_7_Template_eca_site_search_table_rowClick_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSiteRowClick($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayedColumns", ctx_r1.displayedColumns.siteTable)("loadingResults", ctx_r1.loadingResults)("searchControl", ctx_r1.searchControl)("selection", ctx_r1.selection.site)("siteResults", ctx_r1.siteResults);
  }
}
function EcaMultiSelectComponent_span_8_mat_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r1);
  }
}
function EcaMultiSelectComponent_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, EcaMultiSelectComponent_span_8_mat_option_1_Template, 2, 2, "mat-option", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
  }
}
function EcaMultiSelectComponent_span_9_mat_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r3.label);
  }
}
function EcaMultiSelectComponent_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, EcaMultiSelectComponent_span_9_mat_option_1_Template, 2, 2, "mat-option", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
  }
}
const _c31 = ["searchInput"];
const _c32 = a0 => ({
  item: a0
});
function EcaCollectionBoxComponent_ng_container_8_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EcaCollectionBoxComponent_ng_container_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function EcaCollectionBoxComponent_ng_container_8_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.toggle(item_r3));
    })("keyup", function EcaCollectionBoxComponent_ng_container_8_div_1_Template_div_keyup_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.toggle(item_r3));
    })("dblclick", function EcaCollectionBoxComponent_ng_container_8_div_1_Template_div_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const item_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.collect(item_r3));
    });
    i0.ɵɵelementStart(1, "span", 14);
    i0.ɵɵtemplate(2, EcaCollectionBoxComponent_ng_container_8_div_1_ng_container_2_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r3.isSelected(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c32, item_r3));
  }
}
function EcaCollectionBoxComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaCollectionBoxComponent_ng_container_8_div_1_Template, 3, 6, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.isCollected(item_r3));
  }
}
function EcaCollectionBoxComponent_ng_container_32_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EcaCollectionBoxComponent_ng_container_32_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function EcaCollectionBoxComponent_ng_container_32_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const item_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.toggle(item_r6));
    })("keyup", function EcaCollectionBoxComponent_ng_container_32_div_1_Template_div_keyup_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const item_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.toggle(item_r6));
    })("dblclick", function EcaCollectionBoxComponent_ng_container_32_div_1_Template_div_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const item_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.disperse(item_r6));
    });
    i0.ɵɵelementStart(1, "span", 14);
    i0.ɵɵtemplate(2, EcaCollectionBoxComponent_ng_container_32_div_1_ng_container_2_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r3.isSelected(item_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c32, item_r6));
  }
}
function EcaCollectionBoxComponent_ng_container_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaCollectionBoxComponent_ng_container_32_div_1_Template, 3, 6, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isCollected(item_r6));
  }
}
const _c33 = ["*", [["eca-inline-header-end"]]];
const _c34 = ["*", "eca-inline-header-end"];
function EcaPillarBoxComponent_header_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "header", 2)(1, "h1", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(3, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.headerTitle);
  }
}
function EcaPaginatorComponent_div_10_mat_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 16);
    i0.ɵɵtext(1, "0");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("value", 1);
  }
}
function EcaPaginatorComponent_div_10_mat_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageNumber_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", pageNumber_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", pageNumber_r3, " ");
  }
}
function EcaPaginatorComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "mat-form-field")(2, "mat-select", 12);
    i0.ɵɵlistener("selectionChange", function EcaPaginatorComponent_div_10_Template_mat_select_selectionChange_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectPage($event.value));
    });
    i0.ɵɵtemplate(3, EcaPaginatorComponent_div_10_mat_option_3_Template, 2, 1, "mat-option", 13)(4, EcaPaginatorComponent_div_10_mat_option_4_Template, 2, 2, "mat-option", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 15)(6, "label");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("panelWidth", null)("value", ctx_r1.pageIndex + 1)("disabled", ctx_r1.getNumberOfPages() <= 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.pages.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.pages);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("of ", ctx_r1.pages.length, " page(s)");
  }
}
function EcaPaginatorComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
  }
}
function EcaPaginatorComponent_div_13_mat_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageSizeOption_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", pageSizeOption_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", pageSizeOption_r5, " ");
  }
}
function EcaPaginatorComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "label");
    i0.ɵɵtext(3, "Items per page:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-form-field")(5, "mat-select", 20);
    i0.ɵɵlistener("selectionChange", function EcaPaginatorComponent_div_13_Template_mat_select_selectionChange_5_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectPageSize($event.value));
    });
    i0.ɵɵtemplate(6, EcaPaginatorComponent_div_13_mat_option_6_Template, 2, 2, "mat-option", 14);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("panelWidth", null)("aria-label", ctx_r1._intl.itemsPerPageLabel)("value", ctx_r1.pageSize);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._displayedPageSizeOptions);
  }
}
function EcaPaginatorComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Total ", ctx_r1.length, " items");
  }
}
function EcaDrcInsightLogoComponent_img_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.logoUrl, i0.ɵɵsanitizeUrl);
  }
}
const _c35 = a0 => [a0];
function EcaLoginBaseComponent_mat_label_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
  }
}
function EcaLoginBaseComponent_a_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵtext(1, "Forgot your password?");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c35, ctx_r0.forgotPasswordLink));
  }
}
function EcaLoginBaseComponent_div_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "mat-spinner", 18);
    i0.ɵɵelementEnd();
  }
}
function EcaPageHeaderComponent_div_1_ng_container_3_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 11)(1, "a", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", breadcrumb_r1.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(breadcrumb_r1.text);
  }
}
function EcaPageHeaderComponent_div_1_ng_container_3_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r1.text, " ");
  }
}
function EcaPageHeaderComponent_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaPageHeaderComponent_div_1_ng_container_3_li_1_Template, 3, 2, "li", 9)(2, EcaPageHeaderComponent_div_1_ng_container_3_li_2_Template, 2, 1, "li", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", breadcrumb_r1.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !breadcrumb_r1.routerLink);
  }
}
function EcaPageHeaderComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "nav", 6)(2, "ol", 7);
    i0.ɵɵtemplate(3, EcaPageHeaderComponent_div_1_ng_container_3_Template, 3, 2, "ng-container", 8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.breadcrumbs);
  }
}
const _c36 = ["*", [["", "side-panel-title", ""]], [["", "side-panel-content", ""]]];
const _c37 = ["*", "[side-panel-title]", "[side-panel-content]"];
function EcaReorderTableComponent_mat_header_cell_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, "Order");
    i0.ɵɵelementEnd();
  }
}
function EcaReorderTableComponent_mat_cell_3_ng_template_3_ng_container_0_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function EcaReorderTableComponent_mat_cell_3_ng_template_3_ng_container_0_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const moveToIndex_r2 = i0.ɵɵnextContext().index;
      const i_r3 = i0.ɵɵnextContext(2).index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.movePosition(i_r3, moveToIndex_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const moveToIndex_r2 = i0.ɵɵnextContext().index;
    i0.ɵɵproperty("value", moveToIndex_r2 + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", moveToIndex_r2 + 1, " ");
  }
}
function EcaReorderTableComponent_mat_cell_3_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaReorderTableComponent_mat_cell_3_ng_template_3_ng_container_0_button_1_Template, 2, 2, "button", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const moveToIndex_r2 = ctx.index;
    const i_r3 = i0.ɵɵnextContext(2).index;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", moveToIndex_r2 !== i_r3);
  }
}
function EcaReorderTableComponent_mat_cell_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EcaReorderTableComponent_mat_cell_3_ng_template_3_ng_container_0_Template, 2, 1, "ng-container", 10);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.dataSource.data);
  }
}
function EcaReorderTableComponent_mat_cell_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell")(1, "mat-menu", null, 0);
    i0.ɵɵtemplate(3, EcaReorderTableComponent_mat_cell_3_ng_template_3_Template, 1, 1, "ng-template", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const i_r3 = ctx.index;
    const matMenu_r5 = i0.ɵɵreference(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matMenuTriggerFor", matMenu_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r3 + 1, " ");
  }
}
function EcaReorderTableComponent_mat_header_cell_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, "Move");
    i0.ɵɵelementEnd();
  }
}
function EcaReorderTableComponent_mat_cell_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-cell")(1, "button", 13);
    i0.ɵɵlistener("click", function EcaReorderTableComponent_mat_cell_6_Template_button_click_1_listener() {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.moveRowUp(i_r7));
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "arrow_upward");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "button", 14);
    i0.ɵɵlistener("click", function EcaReorderTableComponent_mat_cell_6_Template_button_click_4_listener() {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.moveRowDown(i_r7));
    });
    i0.ɵɵelementStart(5, "mat-icon");
    i0.ɵɵtext(6, "arrow_downward");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", i_r7 === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", i_r7 === ctx_r3.dataSource.data.length - 1);
  }
}
function EcaReorderTableComponent_mat_header_row_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
  }
}
function EcaReorderTableComponent_mat_row_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
  }
  if (rf & 2) {
    const i_r8 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("order-row-moved", ctx_r3.lastMovedIndex === i_r8);
  }
}
function EcaNoResultsComponent_h2_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function EcaNoResultsComponent_h3_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function EcaNoResultsComponent_h4_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function EcaNoResultsComponent_h5_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function EcaNoResultsComponent_h6_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
const _c38 = ["browserWarningTemplate"];
function EcaBrowserDetectorComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 1)(2, "mat-icon");
    i0.ɵɵtext(3, "close");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "h4", 2);
    i0.ɵɵtext(5, "Error: ");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "Unsupported browser");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 3)(9, "div", 4);
    i0.ɵɵtext(10, " The browser you are using has been limited to best effort support, which may cause some features to be limited or non-functional. We recommend using a more modern browser for optimal experience with Portal applications. For additional information, please visit the ");
    i0.ɵɵelementStart(11, "a", 5);
    i0.ɵɵlistener("click", function EcaBrowserDetectorComponent_ng_template_0_Template_a_click_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateTo($event, "docs/minimum-browser-requirements"));
    })("keydown", function EcaBrowserDetectorComponent_ng_template_0_Template_a_keydown_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateTo($event, "docs/minimum-browser-requirements"));
    });
    i0.ɵɵtext(12, "Minimum Web Browser Requirements");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13, " page. ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 6)(15, "button", 7);
    i0.ɵɵtext(16, "OK");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("mat-dialog-close", true);
  }
}
function EcaDialogComponent_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 5)(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
  }
}
function EcaDialogComponent_div_7_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r0.ecaDialogNegativeButtonDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.buttons.negative.label, " ");
  }
}
function EcaDialogComponent_div_7_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function EcaDialogComponent_div_7_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.ok());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r0.ecaDialogPositiveButtonDisabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.buttons.positive.label || "OK", " ");
  }
}
function EcaDialogComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, EcaDialogComponent_div_7_button_1_Template, 2, 2, "button", 7)(2, EcaDialogComponent_div_7_button_2_Template, 2, 2, "button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.buttons == null ? null : ctx_r0.data.buttons.negative == null ? null : ctx_r0.data.buttons.negative.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.buttons == null ? null : ctx_r0.data.buttons.positive == null ? null : ctx_r0.data.buttons.positive.label);
  }
}
function EcaGenericMessageDialogComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "eca-icon", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r0.data.icon);
  }
}
function EcaGenericMessageDialogComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r0.domSanitizer.bypassSecurityTrustHtml(ctx_r0.data.message), i0.ɵɵsanitizeHtml);
  }
}
function EcaGenericMessageDialogComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", ctx_r0.domSanitizer.bypassSecurityTrustHtml(message_r2), i0.ɵɵsanitizeHtml);
  }
}
const _c39 = ["*", [["mat-label"]], [["mat-error"], ["", "matError", ""]], [["mat-hint", 3, "align", "end"]], [["mat-hint", "align", "end"]]];
const _c40 = ["*", "mat-label", "mat-error, [matError]", "mat-hint:not([align='end'])", "mat-hint[align='end']"];
function EcaCheckboxGroupComponent_ng_template_0_label_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function EcaCheckboxGroupComponent_ng_template_0_label_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 8);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵtemplate(2, EcaCheckboxGroupComponent_ng_template_0_label_0_span_2_Template, 2, 0, "span", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0._labelId);
    i0.ɵɵattribute("aria-owns", ctx_r0._id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.required);
  }
}
function EcaCheckboxGroupComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EcaCheckboxGroupComponent_ng_template_0_label_0_Template, 3, 3, "label", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0._labelChildNonStatic || ctx_r0._labelChildStatic);
  }
}
function EcaCheckboxGroupComponent_ng_template_4_Template(rf, ctx) {}
function EcaCheckboxGroupComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
function EcaCheckboxGroupComponent_div_8_mat_hint_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0._hintLabelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.hintLabel);
  }
}
function EcaCheckboxGroupComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, EcaCheckboxGroupComponent_div_8_mat_hint_1_Template, 2, 2, "mat-hint", 13);
    i0.ɵɵprojection(2, 3);
    i0.ɵɵelement(3, "div", 14);
    i0.ɵɵprojection(4, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hintLabel);
  }
}
function EcaDatepickerCalendarHeaderComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 6);
    i0.ɵɵtext(2, "expand_less");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function EcaDatepickerCalendarHeaderComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 6);
    i0.ɵɵtext(1, "expand_more");
    i0.ɵɵelementEnd();
  }
}
const _c41 = ["ecaHourInput"];
const _c42 = ["ecaMinuteInput"];
const _c43 = ["ecaMeridianInput"];
const _c44 = a0 => ({
  "eca-is-using-military-format": a0
});
const _c45 = a0 => ({
  "eca-selected-time": a0
});
function EcaTimeComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1, ":");
    i0.ɵɵelementEnd();
  }
}
function EcaTimeComponent_input_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 13, 3);
    i0.ɵɵtwoWayListener("ngModelChange", function EcaTimeComponent_input_7_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.meridianInput, $event) || (ctx_r2.meridianInput = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keydown", function EcaTimeComponent_input_7_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.keydownMeridian($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.meridianInput);
    i0.ɵɵproperty("required", ctx_r2.required)("readonly", ctx_r2.readonly)("disabled", ctx_r2.disabled);
  }
}
function EcaTimeComponent_ng_template_11_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function EcaTimeComponent_ng_template_11_div_2_Template_div_click_0_listener() {
      const h_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.hourInputClick(h_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const h_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", h_r6 === ctx_r2.hourInput || !ctx_r2.hourInput && i_r7 === 0 ? 0 : -1)("ngClass", i0.ɵɵpureFunction1(3, _c45, h_r6 === ctx_r2.hourInput));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", h_r6, " ");
  }
}
function EcaTimeComponent_ng_template_11_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function EcaTimeComponent_ng_template_11_div_4_Template_div_click_0_listener() {
      const m_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.minuteInputClick(m_r9));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", m_r9 === ctx_r2.minuteInput || !ctx_r2.minuteInput && i_r10 === 0 ? 0 : -1)("ngClass", i0.ɵɵpureFunction1(3, _c45, m_r9 === ctx_r2.minuteInput));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", m_r9, " ");
  }
}
function EcaTimeComponent_ng_template_11_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function EcaTimeComponent_ng_template_11_div_5_div_1_Template_div_click_0_listener() {
      const m_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.meridianInput = m_r13);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tabindex", m_r13 === ctx_r2.meridianInput || !ctx_r2.meridianInput && i_r14 === 0 ? 0 : -1)("ngClass", i0.ɵɵpureFunction1(3, _c45, m_r13 === ctx_r2.meridianInput));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", m_r13, " ");
  }
}
function EcaTimeComponent_ng_template_11_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("keydown", function EcaTimeComponent_ng_template_11_div_5_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.keydownSelector($event));
    });
    i0.ɵɵtemplate(1, EcaTimeComponent_ng_template_11_div_5_div_1_Template, 2, 5, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r2.id + "-meridian-column");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.meridianOptions);
  }
}
function EcaTimeComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵlistener("keydown", function EcaTimeComponent_ng_template_11_Template_div_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.keydownSelector($event));
    });
    i0.ɵɵtemplate(2, EcaTimeComponent_ng_template_11_div_2_Template, 2, 5, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 17);
    i0.ɵɵlistener("keydown", function EcaTimeComponent_ng_template_11_Template_div_keydown_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.keydownSelector($event));
    });
    i0.ɵɵtemplate(4, EcaTimeComponent_ng_template_11_div_4_Template, 2, 5, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, EcaTimeComponent_ng_template_11_div_5_Template, 2, 2, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id + "-hour-column");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.hourOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id + "-minute-column");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.minuteOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.is12HourFormat);
  }
}
function EcaNavigationTileComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const text_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(text_r1);
  }
}
const _c46 = a0 => ({
  link: a0
});
const _c47 = () => ({
  exact: true
});
function EcaLeftNavComponent_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "menu");
    i0.ɵɵelementEnd();
  }
}
function EcaLeftNavComponent_mat_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
  }
}
function EcaLeftNavComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const link_r2 = ctx.$implicit;
    i0.ɵɵnextContext();
    const parentMenu_r3 = i0.ɵɵreference(10);
    const childMenu_r4 = i0.ɵɵreference(13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", link_r2.links ? childMenu_r4 : parentMenu_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c46, link_r2));
  }
}
function EcaLeftNavComponent_ng_template_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r5 = i0.ɵɵnextContext().link;
    i0.ɵɵproperty("href", link_r5.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r5.label, " ");
  }
}
function EcaLeftNavComponent_ng_template_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r5 = i0.ɵɵnextContext().link;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", !link_r5.external ? link_r5.url : undefined)("routerLinkActive", ctx_r5.routeActiveClass)("routerLinkActiveOptions", i0.ɵɵpureFunction0(4, _c47));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r5.label, " ");
  }
}
function EcaLeftNavComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EcaLeftNavComponent_ng_template_9_Conditional_0_Template, 2, 2, "a", 13)(1, EcaLeftNavComponent_ng_template_9_Conditional_1_Template, 2, 5, "a", 14);
  }
  if (rf & 2) {
    const link_r5 = ctx.link;
    i0.ɵɵconditional(link_r5.external ? 0 : 1);
  }
}
function EcaLeftNavComponent_ng_template_12_ng_container_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13, 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const submenu_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", submenu_r7.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", submenu_r7.label, " ");
  }
}
function EcaLeftNavComponent_ng_template_12_ng_container_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15, 3);
    i0.ɵɵlistener("isActiveChange", function EcaLeftNavComponent_ng_template_12_ng_container_5_Conditional_2_Template_a_isActiveChange_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const navListItem_r9 = i0.ɵɵreference(1);
      i0.ɵɵnextContext(2);
      const expansionPanel_r10 = i0.ɵɵreference(1);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.isActiveChange(expansionPanel_r10, navListItem_r9));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const submenu_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", submenu_r7.url)("routerLinkActive", ctx_r5.routeActiveClass)("routerLinkActiveOptions", i0.ɵɵpureFunction0(4, _c47));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", submenu_r7.label, " ");
  }
}
function EcaLeftNavComponent_ng_template_12_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EcaLeftNavComponent_ng_template_12_ng_container_5_Conditional_1_Template, 3, 2, "a", 13)(2, EcaLeftNavComponent_ng_template_12_ng_container_5_Conditional_2_Template, 3, 5, "a", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const submenu_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(submenu_r7.external ? 1 : 2);
  }
}
function EcaLeftNavComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel", null, 2)(2, "mat-expansion-panel-header");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-nav-list");
    i0.ɵɵtemplate(5, EcaLeftNavComponent_ng_template_12_ng_container_5_Template, 3, 1, "ng-container", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const link_r11 = ctx.link;
    i0.ɵɵclassProp("mat-elevation-z0", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", link_r11.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", link_r11.label + " Expanded Sub");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", link_r11.links);
  }
}
function EcaWorkflowFormComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "mat-spinner", 18);
    i0.ɵɵelementEnd();
  }
}
function EcaWorkflowFormComponent_mat_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const opt_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", opt_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", opt_r2.label, " ");
  }
}
function EcaWorkflowFormComponent_mat_error_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Please select a value");
    i0.ɵɵelementEnd();
  }
}
function EcaWorkflowFormComponent_mat_error_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.nameControl.getError("error"));
  }
}
function EcaWorkflowFormComponent_mat_error_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Please enter a value");
    i0.ɵɵelementEnd();
  }
}
function EcaWorkflowFormComponent_mat_error_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Please enter a value");
    i0.ɵɵelementEnd();
  }
}
function EcaWorkflowFormComponent_mat_error_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Please enter a value");
    i0.ɵɵelementEnd();
  }
}
const UX_PATTERN_RIPPLE_CONFIG = {
  disabled: true,
  animation: {
    enterDuration: 0,
    exitDuration: 0
  }
};
const UX_PATTERN_FORM_FIELD_OPTIONS = {
  appearance: 'outline'
};

// these breakpoints are also defined in src/styles/_breakpoints.scss
var BreakpointWidth = /*#__PURE__*/function (BreakpointWidth) {
  BreakpointWidth["xs"] = "256px";
  BreakpointWidth["ltsm"] = "479px";
  BreakpointWidth["sm"] = "480px";
  BreakpointWidth["ltmd"] = "767px";
  BreakpointWidth["md"] = "768px";
  BreakpointWidth["ltlg"] = "1023px";
  BreakpointWidth["lg"] = "1024px";
  BreakpointWidth["ltxl"] = "1399px";
  BreakpointWidth["xl"] = "1400px";
  BreakpointWidth["ltxxl"] = "1599px";
  BreakpointWidth["xxl"] = "1600px";
  return BreakpointWidth;
}(BreakpointWidth || {});
var BreakpointHeight = /*#__PURE__*/function (BreakpointHeight) {
  BreakpointHeight["xs"] = "192px";
  BreakpointHeight["sm"] = "360px";
  BreakpointHeight["md"] = "576px";
  BreakpointHeight["lg"] = "768px";
  BreakpointHeight["xl"] = "900px";
  BreakpointHeight["xxl"] = "1050px";
  return BreakpointHeight;
}(BreakpointHeight || {});
// These are the (custom) breakpoint definitions used by the Angular Flex-Layout library
// See https://github.com/angular/flex-layout/wiki/Breakpoints for related documentation
const UX_PATTERN_BREAKPOINTS = [{
  alias: 'xs',
  mediaQuery: '(min-width:' + BreakpointWidth.xs + ') and (max-width:' + BreakpointWidth.ltsm + ')',
  suffix: 'Xs',
  overlapping: false
}, {
  alias: 'gt-xs',
  mediaQuery: '(min-width: ' + BreakpointWidth.sm + ')',
  suffix: 'GtXs',
  overlapping: true
}, {
  alias: 'lt-sm',
  mediaQuery: '(max-width: ' + BreakpointWidth.ltsm + ')',
  suffix: 'LtSm',
  overlapping: true
}, {
  alias: 'sm',
  mediaQuery: '(min-width: ' + BreakpointWidth.sm + ') and (max-width: ' + BreakpointWidth.ltmd + ')',
  suffix: 'Sm',
  overlapping: false
}, {
  alias: 'gt-sm',
  mediaQuery: '(min-width: ' + BreakpointWidth.md + ')',
  suffix: 'GtSm',
  overlapping: true
}, {
  alias: 'lt-md',
  mediaQuery: '(max-width: ' + BreakpointWidth.ltmd + ')',
  suffix: 'LtMd',
  overlapping: true
}, {
  alias: 'md',
  mediaQuery: '(min-width: ' + BreakpointWidth.md + ') and (max-width: ' + BreakpointWidth.ltlg + ')',
  suffix: 'Md',
  overlapping: false
}, {
  alias: 'gt-md',
  mediaQuery: '(min-width: ' + BreakpointWidth.lg + ')',
  suffix: 'GtMd',
  overlapping: true
}, {
  alias: 'lt-lg',
  mediaQuery: '(max-width: ' + BreakpointWidth.ltlg + ')',
  suffix: 'LtLg',
  overlapping: true
}, {
  alias: 'lg',
  mediaQuery: '(min-width: ' + BreakpointWidth.lg + ') and (max-width: ' + BreakpointWidth.ltxl + ')',
  suffix: 'Lg',
  overlapping: false
}, {
  alias: 'gt-lg',
  mediaQuery: '(min-width: ' + BreakpointWidth.xl + ')',
  suffix: 'GtLg',
  overlapping: true
}, {
  alias: 'lt-xl',
  mediaQuery: '(max-width: ' + BreakpointWidth.ltxl + ')',
  suffix: 'LtXl',
  overlapping: true
}, {
  alias: 'xl',
  mediaQuery: '(min-width: ' + BreakpointWidth.xl + ') and (max-width: ' + BreakpointWidth.ltxxl + ')',
  suffix: 'Xl',
  overlapping: false
},
// the breakpoints below are for future reference if needed
{
  alias: 'gt-xl',
  mediaQuery: '(min-width: ' + BreakpointWidth.xxl + ')',
  suffix: 'GtXl',
  overlapping: true
}, {
  alias: 'lt-xxl',
  mediaQuery: '(max-width: ' + BreakpointWidth.ltxxl + ')',
  suffix: 'LtXxl',
  overlapping: true
}, {
  alias: 'xxl',
  mediaQuery: '(min-width: ' + BreakpointWidth.xxl + ') and (max-width: 5000px)',
  suffix: 'Xxl',
  overlapping: false
}];
const UX_PATERN_DIALOG_DEFAULT_OPTIONS = {
  autoFocus: 'dialog',
  restoreFocus: true,
  panelClass: 'eca-modal-panel',
  role: 'dialog'
};

// Injection token that can be used to specify API Gateway Configuration
const API_GATEWAY_CONFIG = new InjectionToken('api-gateway-config');
let EcaCacheInterceptor = /*#__PURE__*/(() => {
  class EcaCacheInterceptor {
    constructor() {}
    intercept(req, next) {
      if (req.headers.has('eca-cache')) {
        const key = this.getKey(req);
        let cachedItem;
        try {
          cachedItem = JSON.parse(sessionStorage.getItem(key));
        } catch {
          cachedItem = null;
        }
        return cachedItem ? of(new HttpResponse({
          status: 200,
          body: cachedItem
        })) : this.sendRequest(req, next, key);
      }
      return next.handle(this.removeCacheHeaders(req));
    }
    sendRequest(req, next, key) {
      return next.handle(this.removeCacheHeaders(req)).pipe(tap(response => {
        if (response instanceof HttpResponse) {
          try {
            sessionStorage.setItem(key, JSON.stringify(response.body));
          } catch {
            // Not the end of the world if we can't cache it
          }
        }
      }));
    }
    getKey(req) {
      if (req.headers.has('eca-cache-key')) {
        return `eca-cache:${req.headers.get('eca-cache-key')}`;
      } else {
        return `eca-cache:${req.urlWithParams}`;
      }
    }
    removeCacheHeaders(req) {
      const headers = req.headers.delete('eca-cache').delete('eca-cache-key');
      return req.clone({
        headers
      });
    }
    static {
      this.ɵfac = function EcaCacheInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaCacheInterceptor)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaCacheInterceptor,
        factory: EcaCacheInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaCacheInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const UX_PATTERN_TAB_CONFIG = {
  animationDuration: '0ms'
};
const TOOLTIP_DEFAULT_OPTIONS = {
  hideDelay: 300,
  showDelay: 100,
  touchendHideDelay: 300,
  position: 'above',
  touchGestures: 'auto'
};
const UX_PATTERN_SELECT_OPTIONS = {
  disableOptionCentering: true
};
let EcaComponentsLibModule = /*#__PURE__*/(() => {
  class EcaComponentsLibModule {
    static forRoot(apiGatewayConfig = null) {
      return {
        ngModule: EcaComponentsLibModule,
        providers: apiGatewayConfig ? apiGatewayConfig.enableCache ? [{
          provide: MAT_RIPPLE_GLOBAL_OPTIONS,
          useValue: UX_PATTERN_RIPPLE_CONFIG
        }, {
          provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
          useValue: UX_PATTERN_FORM_FIELD_OPTIONS
        }, {
          provide: MAT_SELECT_CONFIG,
          useValue: UX_PATTERN_SELECT_OPTIONS
        }, {
          provide: BREAKPOINTS,
          useValue: UX_PATTERN_BREAKPOINTS
        }, {
          provide: MAT_TABS_CONFIG,
          useValue: UX_PATTERN_TAB_CONFIG
        }, {
          provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
          useValue: TOOLTIP_DEFAULT_OPTIONS
        }, {
          provide: API_GATEWAY_CONFIG,
          useValue: apiGatewayConfig
        }, {
          provide: HTTP_INTERCEPTORS,
          useClass: EcaCacheInterceptor,
          multi: true
        }, {
          provide: MAT_DIALOG_DEFAULT_OPTIONS,
          useValue: UX_PATERN_DIALOG_DEFAULT_OPTIONS
        }] : [{
          provide: MAT_RIPPLE_GLOBAL_OPTIONS,
          useValue: UX_PATTERN_RIPPLE_CONFIG
        }, {
          provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
          useValue: UX_PATTERN_FORM_FIELD_OPTIONS
        }, {
          provide: MAT_SELECT_CONFIG,
          useValue: UX_PATTERN_SELECT_OPTIONS
        }, {
          provide: BREAKPOINTS,
          useValue: UX_PATTERN_BREAKPOINTS
        }, {
          provide: MAT_TABS_CONFIG,
          useValue: UX_PATTERN_TAB_CONFIG
        }, {
          provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
          useValue: TOOLTIP_DEFAULT_OPTIONS
        }, {
          provide: API_GATEWAY_CONFIG,
          useValue: apiGatewayConfig
        }, {
          provide: MAT_DIALOG_DEFAULT_OPTIONS,
          useValue: UX_PATERN_DIALOG_DEFAULT_OPTIONS
        }] : [{
          provide: MAT_RIPPLE_GLOBAL_OPTIONS,
          useValue: UX_PATTERN_RIPPLE_CONFIG
        }, {
          provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
          useValue: UX_PATTERN_FORM_FIELD_OPTIONS
        }, {
          provide: MAT_SELECT_CONFIG,
          useValue: UX_PATTERN_SELECT_OPTIONS
        }, {
          provide: BREAKPOINTS,
          useValue: UX_PATTERN_BREAKPOINTS
        }, {
          provide: MAT_TABS_CONFIG,
          useValue: UX_PATTERN_TAB_CONFIG
        }, {
          provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
          useValue: TOOLTIP_DEFAULT_OPTIONS
        }, {
          provide: MAT_DIALOG_DEFAULT_OPTIONS,
          useValue: UX_PATERN_DIALOG_DEFAULT_OPTIONS
        }]
      };
    }
    static {
      this.ɵfac = function EcaComponentsLibModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaComponentsLibModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaComponentsLibModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return EcaComponentsLibModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Taken from https://github.dev/angular/components/tree/main/src/material/form-field/directives/floating-label.ts
 */
/**
 * Internal directive that maintains a MDC floating label. This directive does not
 * use the `MDCFloatingLabelFoundation` class, as it is not worth the size cost of
 * including it just to measure the label width and toggle some classes.
 *
 * The use of a directive allows us to conditionally render a floating label in the
 * template without having to manually manage instantiation and destruction of the
 * floating label component based on.
 *
 * The component is responsible for setting up the floating label styles, measuring label
 * width for the outline notch, and providing inputs that can be used to toggle the
 * label's floating or required state.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
let EcaFileSelectorLabel = /*#__PURE__*/(() => {
  class EcaFileSelectorLabel {
    constructor(_elementRef) {
      this._elementRef = _elementRef;
    }
    /** Gets the HTML element for the floating label. */
    get element() {
      return this._elementRef.nativeElement;
    }
    static {
      this.ɵfac = function EcaFileSelectorLabel_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFileSelectorLabel)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaFileSelectorLabel,
        selectors: [["label", "ecaFileSelectorLabel", ""]],
        hostAttrs: [1, "eca-label"]
      });
    }
  }
  return EcaFileSelectorLabel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let nextUniqueId$2 = 0;
const ECA_FILE_SELECTOR = new InjectionToken('ECA_FILE_SELECTOR');
var Display = /*#__PURE__*/function (Display) {
  Display["Hint"] = "hint";
  Display["Error"] = "error";
  return Display;
}(Display || {});
/**
 * # EcaFileSelectorComponent
 *
 * Use when EcaFileSelectorComponent when selecting files from a file system
 *
 * * `[accept]` (default: '') - adding `accept` to your template will restrict the file(s) that can be selected using a comma separated list for example `.csv` or `.png,.jpg`
 *
 * * `[disabled]` (default: false) - adding `disabled` to your template will disable the ability to add file(s)
 *
 * * `[multiple]` (default: false) - adding `multiple` to your template will allow the ability to add more than one file
 *
 * * `[required]` (default: false) - adding `required` to your template will add the "required" `*` to the label
 *
 * * `[formControl]` - adding `formControl` to your template will set the control for the file(s) to be added to
 *
 * * `formControlName` - adding `formControlName` to your template will set the control for the file(s) to be added to
 *
 * * `[(ngModel)]` - adding `ngModel` to your template will set the binding for the file(s) to be added to
 *
 * * `(filesChange)` - adding `filesChange` to your template will emit the change of the current selection of file(s)
 *
 * * `(touchChange)` - adding `touchChange` to your template will emit the change the current state of touched or untouched
 *
 * * `<mat-label>` (default: multiple: true - 'Import File(s)', multiple: false - 'Import File') - adding `mat-label` to your template will override the default label
 *
 * * `<mat-error>` - adding `mat-error` to your template will assign a description to the user upon error
 *
 * ### ex. with inputs accept, disabled, multiple and required
 *
 * ```ts
 * accept = '.csv,.png'
 * disabled = false
 * multiple = true
 * required = false
 * ```
 *
 * ```html
 * <eca-file-selector
 *   [accept]="accept"
 *   [disabled]="disabled"
 *   [multiple]="multiple"
 *   [required]="required"
 * ></eca-file-selector>
 * ```
 *
 * ### ex. with formControl
 *
 * ```ts
 * control = new FormControl<File[]>([])
 * ```
 *
 * ```html
 * <eca-file-selector
 *   [formControl]="control"
 * ></eca-file-selector>
 * ```
 *
 * ### ex. with formControlName
 *
 * ```ts
 * form = new FormGroup({
 *   control: new FormControl<File[]>([])
 * })
 * ```
 *
 * ```html
 * <form [formGroup]="form">
 *   <eca-file-selector
 *     formControlName="control"
 *   ></eca-file-selector>
 * </form>
 * ```
 *
 * ### ex. with ngModel
 *
 * ```ts
 * files: File[] = []
 * ```
 *
 * ```html
 * <eca-file-selector
 *   [(ngModel)]="files"
 * ></eca-file-selector>
 * ```
 *
 * ### ex. with filesChange
 *
 * ```ts
 * files: File[] = []
 * ```
 *
 * ```html
 * <eca-file-selector
 *   (filesChange)="$event = files"
 * ></eca-file-selector>
 * ```
 *
 * ### ex. with mat-label and mat-error
 *
 * Show errors after the component has been touched
 *
 * If `accept` is shown the error should also display the accepted file types
 *
 * ```ts
 * error = true
 * touched = false
 * ```
 *
 * ```html
 * <eca-file-selector (touchChange)="touched = $event">
 *   <mat-label>Select a file</mat-label>
 *   <mat-error *ngIf="error && touched">There is an error</mat-error>
 * </eca-file-selector>
 * ```
 */
let EcaFileSelectorComponent = /*#__PURE__*/(() => {
  class EcaFileSelectorComponent {
    /**
     * When true disables file selection
     */
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = coerceBooleanProperty(value);
    }
    /**
     * When true allows multiple files
     */
    get multiple() {
      return this._multiple;
    }
    set multiple(value) {
      this._multiple = coerceBooleanProperty(value);
    }
    /**
     * When true the label will show the required `*`
     */
    get required() {
      return this._required;
    }
    set required(value) {
      this._required = coerceBooleanProperty(value);
    }
    // #endregion inputs
    // #region HostBinding
    get __id() {
      return this._id;
    }
    get _ariaDisabled() {
      return this.disabled;
    }
    constructor(_elementRef, _changeDetectorRef, _injector) {
      this._elementRef = _elementRef;
      this._changeDetectorRef = _changeDetectorRef;
      this._injector = _injector;
      // #region inputs
      this.accept = '';
      this._disabled = false;
      this._multiple = false;
      this._required = false;
      // #endregion HostBinding
      this.filesChange = new EventEmitter();
      this.touchChange = new EventEmitter();
      /**
       * @internal
       */
      this._hintLabelId = `eca-hint-fileselector-${nextUniqueId$2}`;
      /**
       * @internal
       */
      this._labelId = `eca-fileselector-label-${nextUniqueId$2}`;
      /**
       * @internal
       */
      this._id = `eca-fileselector-id-${nextUniqueId$2}`;
      this._destroyed = new Subject();
      this.files = [];
      this.touched = false;
      ++nextUniqueId$2;
    }
    /**
     * Initializes the registered form field control.
     */
    _initializeControl() {
      this._setLabelledById(this._label.element.id);
      try {
        const injectedControl = this._injector.get(NgControl);
        this._control = injectedControl.control;
        // Subscribe to the value change in case the host sets the value to mark changes
        this._control.valueChanges.pipe(takeUntil(this._destroyed)).subscribe(() => {
          this._changeDetectorRef.markForCheck();
        });
      } catch {
        // Injector.get throws an error if there's no control
      }
    }
    /**
     * Does any extra processing that is required when handling the hints.
     */
    _processHints() {
      this._syncDescribedByIds();
    }
    /**
     * Sets the list of element IDs that describe the child control. This allows the control to update
     * its `aria-describedby` attribute accordingly.
     */
    _syncDescribedByIds() {
      const ids = [];
      if (this._getDisplayedMessages() === Display.Hint) {
        const hint = this._hintChildren.first;
        if (hint) {
          ids.push(hint.id);
        }
      } else if (this._errorChildren) {
        ids.push(...this._errorChildren.map(error => error.id));
      }
      this._setDescribedByIds(ids);
    }
    _setDescribedByIds(ids) {
      const controlElement = this._elementRef.nativeElement;
      const label = ids.join(' ') || null;
      if (label) {
        controlElement.setAttribute('aria-describedby', label);
      } else {
        controlElement.removeAttribute('aria-describedby');
      }
    }
    _setLabelledById(id) {
      const controlElement = this._elementRef.nativeElement;
      controlElement.setAttribute('aria-labelledby', id);
    }
    /**
     * Initializes the subscript by validating hints and synchronizing "aria-describedby" ids
     * with the custom form field control. Also subscribes to hint and error changes in order
     * to be able to validate and synchronize ids on change.
     */
    _initializeSubscript() {
      // Re-validate when the number of hints changes.
      this._hintChildren.changes.pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._processHints();
        this._changeDetectorRef.markForCheck();
      });
      // Update the aria-described by when the number of errors changes.
      this._errorChildren.changes.pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._syncDescribedByIds();
        this._changeDetectorRef.markForCheck();
      });
    }
    /**
     * Determines whether to display hints or errors.
     *
     * @internal
     */
    _getDisplayedMessages() {
      return this._errorChildren && this._errorChildren.length > 0 ? Display.Error : Display.Hint;
    }
    /**
     * @internal
     */
    ngOnDestroy() {
      this._destroyed.next(true);
      this._destroyed.complete();
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
      this._initializeControl();
      this._initializeSubscript();
      this._syncDescribedByIds();
    }
    /**
     * Browse for files
     */
    browse() {
      if (!this.disabled) {
        this._fileInput.nativeElement.click();
      }
    }
    /**
     * @internal
     */
    _onFileBrowseChange(e) {
      if (e) {
        this._setFiles(this._fileInput.nativeElement.files);
        // clear the native file input so that this change event fires with every selection (same as drag&drop)
        this._fileInput.nativeElement.value = '';
      }
    }
    _setFiles(fileList) {
      const upperLimit = this.multiple ? fileList.length : 1;
      for (let i = 0; i < upperLimit; i++) {
        const file = fileList.item(i);
        if (file && this._verifyFileType(file)) {
          if (!this.multiple) {
            this.files = [];
          }
          this.files.push(fileList.item(i));
        }
      }
      this._changeAndTouch();
    }
    /**
     * Removes a file at a given index
     *
     * @param index file position in array
     */
    removeAt(index) {
      if (index > -1) {
        this.files.splice(index, 1);
      }
      this._changeAndTouch();
    }
    /**
     * @internal
     */
    _markTouched() {
      this.touched = true;
      this._control?.markAsTouched();
      this.touchChange.emit(true);
    }
    _changeAndTouch() {
      if (this.onChange) {
        this.onChange(this.files);
      }
      if (this.onTouched) {
        this.onTouched();
        this._markTouched();
      }
      this.filesChange.next(this.files);
    }
    _verifyFileType(file) {
      const fileName = file.name;
      if (this.accept) {
        return this.accept.split(',').some(fileEnding => fileName.endsWith(fileEnding.trim()));
      }
      return true;
    }
    /**
     * @internal
     */
    _onDragover(event) {
      if (!this._isDraggingOverDropContainer) {
        this._isDraggingOverDropContainer = true;
      }
      this._stopPropPreventDef(event);
    }
    /**
     * @internal
     */
    _onDragleave(event) {
      if (this._isDraggingOverDropContainer) {
        this._isDraggingOverDropContainer = false;
      }
      this._stopPropPreventDef(event);
    }
    /**
     * @internal
     */
    _onDrop(event) {
      this._isDraggingOverDropContainer = false;
      if (this.disabled) {
        return;
      }
      if (event.dataTransfer) {
        this._stopPropPreventDef(event);
        if (event.dataTransfer.files) {
          this._setFiles(event.dataTransfer.files);
        }
      }
    }
    _stopPropPreventDef(event) {
      event.stopPropagation();
      event.preventDefault();
    }
    // #region ControlValueAccessor
    // Functions required by ControlValueAccessor
    /**
     * Writes a new value to the element (from the outside).
     *
     * @internal
     */
    writeValue(value) {
      if (this.multiple) {
        this.files = value ? value : [];
        return;
      }
      // if not multiple then only one file/value is allowed
      if (Array.isArray(value)) {
        this.files = value[0] ? [value[0]] : [];
      } else {
        this.files = value ? [value] : [];
      }
    }
    /**
     * Registers a callback function that should be called when the control's value changes in the UI.
     *
     * @internal
     */
    registerOnChange(fn) {
      this.onChange = fn;
    }
    /**
     * Registers a callback function that should be called when the control receives a blur event.
     *
     * @internal
     */
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    /**
     * This function is called by the forms API when the control status changes to or from "DISABLED".
     *
     * @internal
     */
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaFileSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFileSelectorComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(Injector));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaFileSelectorComponent,
        selectors: [["eca-file-selector"]],
        contentQueries: function EcaFileSelectorComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatLabel, 5);
            i0.ɵɵcontentQuery(dirIndex, MatLabel, 7);
            i0.ɵɵcontentQuery(dirIndex, MAT_ERROR, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._labelChildNonStatic = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._labelChildStatic = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._errorChildren = _t);
          }
        },
        viewQuery: function EcaFileSelectorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(EcaFileSelectorLabel, 5);
            i0.ɵɵviewQuery(MatHint, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._fileInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._label = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._hintChildren = _t);
          }
        },
        hostVars: 2,
        hostBindings: function EcaFileSelectorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("id", ctx.__id);
            i0.ɵɵattribute("aria-disabled", ctx._ariaDisabled);
          }
        },
        inputs: {
          accept: "accept",
          disabled: "disabled",
          multiple: "multiple",
          required: "required"
        },
        outputs: {
          filesChange: "filesChange",
          touchChange: "touchChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: ECA_FILE_SELECTOR,
          useExisting: EcaFileSelectorComponent
        }, {
          provide: NG_VALUE_ACCESSOR,
          useExisting: EcaFileSelectorComponent,
          multi: true
        }])],
        ngContentSelectors: _c2,
        decls: 16,
        vars: 15,
        consts: [["labelTemplate", ""], ["fileInput", ""], ["defaultLabel", ""], [1, "eca-file-selector-wrapper", "eca-file-selector"], [1, "eca-file-selector-label"], [3, "ngTemplateOutlet"], [1, "eca-file-selector-file-drop-container", 3, "drop", "dragover", "dragleave", "ngClass"], ["mat-button", "", "color", "primary", "aria-label", "open file browser window", 3, "click", "blur", "disabled"], [1, "eca-file-selector-drag-drop-text", 3, "ngClass"], [1, "eca-file-selector-subscript-wrapper", 3, "ngSwitch"], ["class", "eca-file-selector-error-wrapper", 4, "ngSwitchCase"], ["class", "eca-file-selector-hint-wrapper", 4, "ngSwitchCase"], ["class", "eca-file-selector-files-container", 4, "ngIf"], ["type", "file", "aria-hidden", "true", "tabindex", "-1", 1, "cdk-visually-hidden", 2, "opacity", "0", "width", "0", "height", "0", 3, "change", "accept", "multiple"], ["ecaFileSelectorLabel", "", 3, "id"], [4, "ngIf", "ngIfElse"], ["aria-hidden", "true", "class", "eca-required-marker", 4, "ngIf"], ["aria-hidden", "true", 1, "eca-required-marker"], [1, "eca-file-selector-error-wrapper"], [1, "eca-file-selector-hint-wrapper"], [3, "id", 4, "ngIf"], [3, "id"], [1, "eca-file-selector-files-container"], ["class", "eca-file-selector-file", 4, "ngFor", "ngForOf"], [1, "eca-file-selector-file"], [1, "mat-file"], [1, "eca-file-selector-file-name"], ["matTooltip", "remove", 1, "eca-file-selector-remove-icon", "remove-btn-formatting", "eca-link", 3, "click"], [1, "mat-clear"]],
        template: function EcaFileSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵtemplate(0, EcaFileSelectorComponent_ng_template_0_Template, 5, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(2, "div", 3)(3, "div", 4);
            i0.ɵɵtemplate(4, EcaFileSelectorComponent_ng_template_4_Template, 0, 0, "ng-template", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 6);
            i0.ɵɵlistener("drop", function EcaFileSelectorComponent_Template_div_drop_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx._onDrop($event));
            })("dragover", function EcaFileSelectorComponent_Template_div_dragover_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx._onDragover($event));
            })("dragleave", function EcaFileSelectorComponent_Template_div_dragleave_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx._onDragleave($event));
            });
            i0.ɵɵelementStart(6, "button", 7);
            i0.ɵɵlistener("click", function EcaFileSelectorComponent_Template_button_click_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.browse());
            })("blur", function EcaFileSelectorComponent_Template_button_blur_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx._markTouched());
            });
            i0.ɵɵtext(7, " Browse ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "p", 8);
            i0.ɵɵtext(9, " or drag and drop ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 9);
            i0.ɵɵtemplate(11, EcaFileSelectorComponent_div_11_Template, 2, 0, "div", 10)(12, EcaFileSelectorComponent_div_12_Template, 2, 1, "div", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, EcaFileSelectorComponent_div_13_Template, 2, 1, "div", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "input", 13, 1);
            i0.ɵɵlistener("change", function EcaFileSelectorComponent_Template_input_change_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx._onFileBrowseChange($event));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const labelTemplate_r7 = i0.ɵɵreference(1);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngTemplateOutlet", labelTemplate_r7);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c3, ctx._isDraggingOverDropContainer, ctx.disabled));
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c4, ctx.disabled));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitch", ctx._getDisplayedMessages());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "error");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "hint");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.files.length);
            i0.ɵɵadvance();
            i0.ɵɵproperty("accept", ctx.accept)("multiple", ctx.multiple);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgSwitch, i1.NgSwitchCase, i4.MatButton, i6.MatLabel, i6.MatHint, i5.MatIcon, i1$1.MatTooltip, EcaFileSelectorLabel],
        styles: [":root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}.eca-file-selector-label{font-size:16px;margin-bottom:8px}.eca-file-selector-error-wrapper,.eca-file-selector-hint-wrapper,.eca-file-selector-files-container{font-size:16px;margin-top:8px}.eca-file-selector-file-drop-container,.eca-file-selector-files-container{width:100%;max-width:63ch}.eca-file-selector-file-drop-container{container:fileselection/inline-size;background-color:#fefefe;padding:22px;border:2px var(--drc-blue) dashed;border-radius:2px;box-sizing:border-box;text-align:center}.eca-file-selector-file-drop-container.disabled{border-color:#43434342;cursor:no-drop}.eca-file-selector-file-drop-container.disabled .mat-mdc-button{cursor:no-drop}.eca-file-selector-file-drop-container.disabled .remove-btn-formatting{color:#00000042}.eca-file-selector-file-drop-container.disabled .remove-btn-formatting:hover{text-decoration:none;cursor:no-drop}.eca-file-selector-file-drop-container.is-dragging-over-drop-container:not(.disabled){background:linear-gradient(#1991ec21,#1991ec21)}@container fileselection (max-width: 300px){.eca-file-selector-file-drop-container .mat-mdc-button{width:100%}.eca-file-selector-file-drop-container p{display:block!important;margin-bottom:0;margin-top:8px}}.eca-file-selector-drag-drop-text{font-size:22px;font-weight:600;display:inline}.eca-file-selector-drag-drop-text.disabled{color:#00000042}.eca-file-selector-files-container{flex:0 1 auto;display:flex;flex-direction:column;text-align:left}.eca-file-selector-files-container mat-icon{font-size:18px;min-width:24px;line-height:24px}.eca-file-selector-files-container mat-icon.mat-file{color:var(--drc-cool-grey);flex-basis:24px}.eca-file-selector-file{flex:auto;display:flex;align-content:center;padding:4px 0}.eca-file-selector-file:not(:first-child){border-top:1px solid var(--drc-medium-grey)}.eca-file-selector-file-name{flex:auto;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;line-height:24px}.eca-file-selector-remove-icon{flex:0 1 24px}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return EcaFileSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFileSelectorModule = /*#__PURE__*/(() => {
  class EcaFileSelectorModule {
    static {
      this.ɵfac = function EcaFileSelectorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFileSelectorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaFileSelectorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatTooltipModule, ReactiveFormsModule]
      });
    }
  }
  return EcaFileSelectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ApiEnvironments = {
  dev: 'dev',
  sqa: 'sqa',
  stg: 'staging',
  lt: 'loadtesting',
  prod: 'production'
};
let ApiGatewayService = /*#__PURE__*/(() => {
  class ApiGatewayService {
    get gatewayConfigError() {
      return throwError('API_GATEWAY_CONFIG was not provided. See http://drc-app-ux-dev.drcedirect.com/components/header');
    }
    constructor(config, http, _document) {
      this.config = config;
      this.http = http;
      this._document = _document;
      this.eventsStream = new Subject();
      this.requestClusters = {};
      const dynatraceConfig = config?.dynatraceConfig;
      // Only provide Dynatrace if a config is provided and that the route will not be redirected to localhost
      if (dynatraceConfig && !location.toString().includes('localhost')) {
        this.provideDynatrace(dynatraceConfig);
      }
    }
    provideDynatrace(environment) {
      if (this._document.defaultView['_dynatrace']) {
        return console.log(`'Dynatrace' already loaded`);
      }
      this._document.defaultView['_dynatrace'] = 'Dynatrace';
      const script = this._document.createElement('script');
      script.async = true;
      script.src = environment.scriptUrl;
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.crossOrigin = 'anonymous';
      script.addEventListener('load', this.dynatraceListener.bind(this));
      this._document.head.appendChild(script);
    }
    dynatraceListener() {
      const _dT_ = this._document.defaultView['dT_'];
      if (typeof _dT_ != 'undefined' && _dT_.initAngularNg) {
        _dT_.initAngularNg(this.http, HttpHeaders);
      }
    }
    get(path, options = {}) {
      if (!this.config) {
        return this.gatewayConfigError;
      }
      // if clustering is not explicitly false, assume true
      if (options.enableClustering !== false) {
        options.enableClustering = true;
      }
      if (this.config.enableRequestClustering !== false) {
        this.config.enableRequestClustering = true;
      }
      const url = this.getUrl(path);
      const httpOptions = this.processRequestOptions(options);
      this.eventsStream.next({
        type: 'get',
        url: url
      });
      if (!this.config.enableRequestClustering || !options.enableClustering) {
        return this.http.get(url, httpOptions);
      }
      if (this.requestClusters[url]) {
        return this.requestClusters[url];
      } else {
        this.requestClusters[url] = this.http.get(url, httpOptions).pipe(tap(() => delete this.requestClusters[url]), share());
        return this.requestClusters[url];
      }
    }
    post(path, data, options = {}) {
      if (!this.config) {
        return this.gatewayConfigError;
      }
      const url = this.getUrl(path);
      const httpOptions = this.processRequestOptions(options);
      this.eventsStream.next({
        type: 'post',
        url: url
      });
      return this.http.post(url, data, httpOptions);
    }
    put(path, data, options = {}) {
      if (!this.config) {
        return this.gatewayConfigError;
      }
      const url = this.getUrl(path);
      const httpOptions = this.processRequestOptions(options);
      this.eventsStream.next({
        type: 'put',
        url: url
      });
      return this.http.put(url, data, httpOptions);
    }
    patch(path, data, options = {}) {
      if (!this.config) {
        return this.gatewayConfigError;
      }
      const url = this.getUrl(path);
      const httpOptions = this.processRequestOptions(options);
      this.eventsStream.next({
        type: 'patch',
        url: url
      });
      return this.http.patch(url, data, httpOptions);
    }
    delete(path, options = {}, data) {
      if (!this.config) {
        return this.gatewayConfigError;
      }
      const url = this.getUrl(path);
      const httpOptions = {
        ...this.processRequestOptions(options),
        body: data
      };
      this.eventsStream.next({
        type: 'delete',
        url: url
      });
      return this.http.request('DELETE', url, httpOptions);
    }
    makeApiConfigString(gatewayConfig = {}) {
      // Theroretically a scenario exist where one client requires a distinct
      // service endpoint url, i.e. /some-service/mi-production-v2/endpoint
      // If/when that case arises, the logic should go here. We can have the
      // caller pass in the URL. We can cross reference the URL with the client
      // (which we would extract from the token using jwtDecode lib) and finally,
      // modify the output of this string accordingly.
      const client = gatewayConfig.client ? gatewayConfig.client : 'all';
      const deployment = this.config.deployment;
      const version = gatewayConfig.version ? gatewayConfig.version : 'v0';
      return `${client}-${deployment}-${version}`;
    }
    clearCache() {
      Object.keys(sessionStorage).forEach(key => {
        if (key.startsWith('eca-cache:')) {
          sessionStorage.removeItem(key);
        }
      });
    }
    clearCacheKey(key) {
      sessionStorage.removeItem(`eca-cache:${key}`);
    }
    getEventStream() {
      return this.eventsStream.asObservable();
    }
    // issue on localhost where the cloud url has a trailing '/', this
    // cleans the apiGatewayCloudUrl
    getCloudDomain() {
      let domain = this.config.apiGatewayCloudUrl;
      if (domain.endsWith('/')) {
        domain = domain.substring(0, domain.length - 1);
      }
      return domain;
    }
    getCachingDomain() {
      let domain = this.config.apiGatewayCachingUrl;
      if (!domain) {
        return this.getCloudDomain();
      }
      if (domain.endsWith('/')) {
        domain = domain.substring(0, domain.length - 1);
      }
      return domain;
    }
    getEnvironment() {
      const domain = this.config.apiGatewayCloudUrl;
      let matchedEnvironment = '';
      for (const env in ApiEnvironments) {
        if (domain.indexOf('cloud-' + env) >= 0) {
          matchedEnvironment = env;
        }
      }
      if (!matchedEnvironment && domain.indexOf('api-gateway-cloud.drcedirect.com')) {
        matchedEnvironment = ApiEnvironments.prod;
      }
      return matchedEnvironment;
    }
    isLowerEnvironment() {
      return this.getEnvironment() !== ApiEnvironments.prod;
    }
    getUrl(path) {
      if (path.indexOf('://') === -1) {
        return this.config.apiGatewayUrl + path;
      } else {
        return path;
      }
    }
    processRequestOptions(options) {
      let httpOptions = options.httpOptions || {};
      if (!httpOptions.headers) {
        httpOptions.headers = {};
      }
      // default to withCredentials=true, unless caller specifically requests not to
      if (options.withCredentials !== false) {
        httpOptions.withCredentials = true;
      }
      // default to including the user token, unless caller specifically requests not to
      if (options.includeToken !== false) {
        if (this.accessToken && !options.forceEcaToken) {
          httpOptions.headers['Authorization'] = `Bearer ${this.accessToken}`;
        } else {
          httpOptions.headers['Authorization'] = `Bearer ${this.userToken}`;
        }
      }
      httpOptions = this.applyCacheSettings(options, httpOptions);
      return httpOptions;
    }
    applyCacheSettings(options, httpOptions) {
      if (this.config.enableCache) {
        if (typeof options.cache === 'boolean') {
          httpOptions.headers['eca-cache'] = 'true';
        } else if (typeof options.cache !== 'undefined') {
          if (options.cache.cache !== false) {
            httpOptions.headers['eca-cache'] = 'true';
          }
          if (options.cache.key) {
            httpOptions.headers['eca-cache-key'] = options.cache.key;
          }
          if (options.cache.clearKey) {
            this.clearCacheKey(options.cache.clearKey);
          }
        }
      }
      return httpOptions;
    }
    static {
      this.ɵfac = function ApiGatewayService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ApiGatewayService)(i0.ɵɵinject(API_GATEWAY_CONFIG, 8), i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ApiGatewayService,
        factory: ApiGatewayService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ApiGatewayService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WindowService = /*#__PURE__*/(() => {
  class WindowService {
    constructor() {
      // this allows for mocking in the unit tests
      this.window = window;
    }
    get location() {
      return this.window.location;
    }
    get ECA_HEADER_ELEMENT() {
      return this.window.ECA_HEADER_ELEMENT;
    }
    set ECA_HEADER_ELEMENT(value) {
      this.window.ECA_HEADER_ELEMENT = value;
    }
    get ECA_PORTAL_HEADER() {
      return this.window.ECA_PORTAL_HEADER;
    }
    set ECA_PORTAL_HEADER(value) {
      this.window.ECA_PORTAL_HEADER = value;
    }
    requestAnimationFrame(callback) {
      return this.window.requestAnimationFrame.call(this, callback);
      // * Not Needed, Probably
      // if (
      //   // If requestAnimationFrame isn't available use legacy polyfill
      //   typeof this.window.requestAnimationFrame === 'function'
      // ) {
      //   return this.window.requestAnimationFrame.call(this, callback);
      // }
      // let perf: number;
      // if (
      //   // If performance.now isn't available use legacy polyfill
      //   typeof this.window.performance?.now === 'function'
      // ) {
      //   perf = this.window.performance.now()
      // } else {
      //   perf = Date.now();
      // }
      // return this.window.setTimeout.call(this, callback?.bind(this, perf), 16);
    }
    cancelAnimationFrame(handle) {
      this.window.cancelAnimationFrame(handle);
      // * Not Needed, Probably
      // if (
      //   // If cancelAnimationFrame isn't available use legacy polyfill
      //   typeof this.window.cancelAnimationFrame === 'function'
      // ) {
      //   this.window.cancelAnimationFrame(handle);
      // } else {
      //   this.window.clearTimeout(handle);
      // }
    }
    navigateTo(url, openInNewWindow = false) {
      if (openInNewWindow) {
        this.window.open(url, '_blank');
      } else {
        this.window.location.href = url;
      }
    }
    static {
      this.ɵfac = function WindowService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WindowService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WindowService,
        factory: WindowService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return WindowService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AppContextService = /*#__PURE__*/(() => {
  class AppContextService {
    constructor(apiGatewayService, windowService) {
      this.apiGatewayService = apiGatewayService;
      this.windowService = windowService;
      const q = this.getQueryString();
      // try the query string first
      let token = q.get('t');
      // if token isn't on query string, check sessionStorage
      if (!token) {
        try {
          token = JSON.parse(sessionStorage.getItem('ngStorage-ecatoken'));
        } catch {
          // swallow this error
        }
      }
      this.token = new BehaviorSubject(token);
      this.setToken(token);
      if (q.has('u')) {
        this.setPortalUrl(q.get('u'));
      }
      if (q.has('v')) {
        this.setHeaderVersion(q.get('v'));
      }
      this.product = this.recallSelectedProduct(q);
      this.programNumber = this.recallSelectedProgramNumber(q);
      this.application = this.recallSelectedApplication(q);
      this.siteSelectorValueMap = this.recallSelectedSites();
    }
    /**
     * Gets the current token and completes
     */
    getToken() {
      return this.token.asObservable().pipe(take(1));
    }
    setToken(value) {
      sessionStorage.setItem('ngStorage-ecatoken', JSON.stringify(value));
      this.apiGatewayService.userToken = value;
      this.token.next(value);
      if (!value) {
        this.toggleDynatraceUser(value);
      }
    }
    /**
     * Gets the current token and continues watching for token updates.
     * Since this observable never completes, you will need to unsubscribe manually.
     */
    get token$() {
      return this.token.pipe(distinctUntilChanged());
    }
    /**
     * Updates the EcaHeaderComponent to display the correct product. It does NOT navigate to the product's welcome page
     * @param productCode
     */
    setSelectedProductCode(productCode) {
      if (productCode) {
        productCode = productCode.toUpperCase();
      }
      sessionStorage.setItem('ngStorage-ecaselectedClient', JSON.stringify(productCode));
      this.product.next(productCode);
    }
    /**
     * Gets the selected product code and completes the observable sequence
     */
    getSelectedProductCode() {
      return this.product.asObservable().pipe(take(1));
    }
    /**
     * Gets the selected product code and continues watching for product changes indefinitely.
     */
    get selectedProductCode$() {
      return this.product.pipe(distinctUntilChanged());
    }
    /**
     * Updates the EcaHeaderComponent to use the correct program number
     * @param programNumber
     */
    setSelectedProgramNumber(programNumber) {
      sessionStorage.setItem('ngStorage-ecaSelectedProgramNumber', JSON.stringify(programNumber));
      this.programNumber.next(programNumber);
    }
    /**
     * Gets the selected program number and completes the observable sequence
     */
    getSelectedProgramNumber() {
      return this.programNumber.asObservable().pipe(take(1));
    }
    /**
     * Gets the selected program number and continues watching for program changes indefinitely.
     */
    get selectedProgramNumber$() {
      return this.programNumber.pipe(distinctUntilChanged());
    }
    /**
     * Updates the currently active application displayed in the EcaHeaderComponent. It does NOT navigate to the application.
     * @param appId
     */
    setSelectedApplicationId(appId) {
      sessionStorage.setItem('ngStorage-ecaSelectedApplication', JSON.stringify(appId));
      this.application.next(appId);
    }
    /**
     * Gets the selected application ID and completes the observable sequence
     */
    getSelectedApplicationId() {
      return this.application.asObservable().pipe(take(1));
    }
    /**
     * Gets the selected application ID and continues watching for changes indefinitely
     */
    get selectedApplicationId$() {
      return this.application.pipe(distinctUntilChanged());
    }
    /**
     * Gets the current portal URL
     */
    getPortalUrl() {
      if (!this._portalUrl) {
        try {
          this._portalUrl = JSON.parse(sessionStorage.getItem('ngStorage-portalUrl')) || '';
        } catch {
          this._portalUrl = '';
        }
      }
      return this._portalUrl;
    }
    /**
     * Set the portalUrl. This should only be used by the eca-portal-v2-ui project.
     */
    setPortalUrl(url) {
      this._portalUrl = url;
      sessionStorage.setItem('ngStorage-portalUrl', JSON.stringify(url));
    }
    /**
     * Set the userId. This should only be used by the eca-portal-v2-ui project.
     */
    setUserId(userId) {
      this.userId = userId;
      this.toggleDynatraceUser(userId);
      sessionStorage.setItem('ngStorage-ecauserId', JSON.stringify(userId));
    }
    /**
     * Set the userId for Dynatrace.
     */
    toggleDynatraceUser(userId) {
      let meta = document.getElementsByTagName('meta').namedItem('eca-user-id');
      // If UserId is being cleared we're done.
      if (!userId) {
        // Remove the meta tag if it exists.
        if (meta) {
          document.head.removeChild(meta);
        }
        return;
      }
      let exists = true;
      if (!meta) {
        exists = false;
        meta = document.createElement('meta');
      }
      meta.name = 'eca-user-id';
      meta.content = userId;
      if (!exists) {
        document.head.appendChild(meta);
      }
    }
    /**
     * Gets the current user Id.
     */
    getUserId() {
      try {
        return this.userId || (this.userId = JSON.parse(sessionStorage.getItem('ngStorage-ecauserId')));
      } catch {
        return undefined;
      }
    }
    /**
     * Retrieve the current header version that should be used with the selected client
     */
    getHeaderVersion() {
      try {
        return JSON.parse(sessionStorage.getItem('ngStorage-ecaHeaderVersion')) || 'v1';
      } catch {
        return 'v1';
      }
    }
    /**
     * Set the header version that should be used
     */
    setHeaderVersion(version) {
      sessionStorage.setItem('ngStorage-ecaHeaderVersion', JSON.stringify(version));
    }
    getQueryString() {
      // Because we are using HashLocationStrategy on some apps, window.location.search turns up empty/incomplete
      // Instead we find the query string the old fashioned way
      let query = '';
      const first = this.windowService.location.href.split('?');
      if (first[1]) {
        query = first[1].split('#')[0];
      }
      return new URLSearchParams(query);
    }
    /**
     * Set the Selected Site for EcaSiteSelector
     * in this file 'productCode' is actually Product.abbreviation not Product.code
     * so for consistency use the 2-4 letter abbreviation and call it productCode
     */
    setSelectedSite(site, productCode) {
      this.siteSelectorValueMap.set(productCode, site);
      this.emitSite(site);
      this.setCacheValue('ecaSelectedSiteMap', this.siteSelectorValueMap);
    }
    /**
     * get the selected Site corresponding to the selected Product
     */
    selectedSite$(productCode) {
      if (productCode) {
        const site = this.siteSelectorValueMap.get(productCode);
        this.emitSite(site);
        return this.siteSelectorValue$;
      } else {
        return of(null);
      }
    }
    emitSite(site) {
      if (this.siteSelectorValue$) {
        this.siteSelectorValue$.next(site);
      } else {
        this.siteSelectorValue$ = new BehaviorSubject(site);
      }
    }
    /**
     * handles stringifying values including Map types
     */
    setCacheValue(storageKey, value) {
      sessionStorage.setItem(`ngStorage-${storageKey}`, JSON.stringify(value, (k, v) => {
        if (v instanceof Map) {
          return {
            dataType: 'Map',
            value: [...v.entries()]
          };
        } else {
          return v;
        }
      }));
    }
    /**
     * handles parsing values including Map types
     */
    getCacheValue(storageKey) {
      const sessionValue = sessionStorage.getItem(`ngStorage-${storageKey}`);
      const parsedValue = JSON.parse(sessionValue, (k, v) => {
        if (typeof v === 'object' && v !== null) {
          if (v.dataType === 'Map') {
            return new Map(v.value);
          }
        }
        return v;
      });
      return parsedValue && parsedValue.size ? parsedValue : null;
    }
    /**
     * Get the saved Map ([productCode, Site]) pairs in session storage
     */
    recallSelectedSites() {
      try {
        const ecaSelectedSiteMap = this.getCacheValue('ecaSelectedSiteMap');
        return ecaSelectedSiteMap || new Map();
      } catch {
        return new Map();
      }
    }
    recallSelectedProduct(q) {
      try {
        if (q.has('c')) {
          const productCode = q.get('c').toUpperCase();
          sessionStorage.setItem('ngStorage-ecaselectedClient', JSON.stringify(productCode));
          return new BehaviorSubject(productCode);
        } else {
          return new BehaviorSubject(JSON.parse(sessionStorage.getItem('ngStorage-ecaselectedClient')));
        }
      } catch {
        return new BehaviorSubject('');
      }
    }
    recallSelectedProgramNumber(q) {
      try {
        if (q.has('p')) {
          const programNumber = parseInt(q.get('p'), 10);
          sessionStorage.setItem('ngStorage-ecaSelectedProgramNumber', JSON.stringify(programNumber));
          return new BehaviorSubject(programNumber);
        } else {
          return new BehaviorSubject(JSON.parse(sessionStorage.getItem('ngStorage-ecaSelectedProgramNumber')));
        }
      } catch {
        return new BehaviorSubject(0);
      }
    }
    recallSelectedApplication(q) {
      try {
        if (q.has('a')) {
          const applicationId = parseInt(q.get('a'), 10);
          sessionStorage.setItem('ngStorage-ecaSelectedApplication', JSON.stringify(applicationId));
          return new BehaviorSubject(applicationId);
        } else {
          return new BehaviorSubject(JSON.parse(sessionStorage.getItem('ngStorage-ecaSelectedApplication')));
        }
      } catch {
        return new BehaviorSubject(0);
      }
    }
    static {
      this.ɵfac = function AppContextService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppContextService)(i0.ɵɵinject(ApiGatewayService), i0.ɵɵinject(WindowService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AppContextService,
        factory: AppContextService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AppContextService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Injection token that can be used to specify Menu Item Overrides
const MENU_ITEM_OVERRIDES = new InjectionToken('menu-item-overrides');
let EcaSetupConfigurationService = /*#__PURE__*/(() => {
  class EcaSetupConfigurationService {
    constructor(appContextService, apiGatewayService) {
      this.appContextService = appContextService;
      this.apiGatewayService = apiGatewayService;
    }
    getSelectedProgram() {
      return this.selectedProgram$.pipe(take(1));
    }
    /**
     * Fetches the Client Program attribute group for selected product and program number
     * which contains the program code,
     * then returns an object with the program number and code
     */
    get selectedProgram$() {
      return combineLatest([this.appContextService.selectedProgramNumber$, this.appContextService.selectedProductCode$]).pipe(switchMap(([programNumber, productCode]) => {
        if (!programNumber || !productCode) {
          return of(null);
        } else {
          return this.getProgramFromAttribute(productCode, programNumber);
        }
      }), shareReplay(1));
    }
    /**
     * given a selected product code, get the Program config from Setup Config attributes
     * 1. get the order in common-client-config
     * 2. for each program in that order get its details
     * 3. return the full list of programs
     * Observable<Program[]>
     */
    getPrograms() {
      return this.appContextService.getSelectedProductCode().pipe(concatMap(productCode => {
        if (!productCode) {
          return of([]);
        } else {
          return this.getAttributesForClientByTag(productCode, 'client-config', {
            cache: true
          }).pipe(concatMap(attrs => {
            const programOrderAttr = attrs.find(attr => attr.attribute.key === 'program-order');
            const programOrderArray = programOrderAttr.value.split(',').map(o => parseInt(o, 10));
            return forkJoin([...programOrderArray.map(programNumber => {
              return this.getProgramFromAttribute(productCode, programNumber);
            })]);
          }));
        }
      }));
    }
    getProgramFromAttribute(productCode, programNumber) {
      return this.getAttributesForClientByTag(productCode, `program-${programNumber}`).pipe(map(attrs => {
        if (!attrs) {
          return null;
        } else {
          let title, description, code, number;
          for (const attr of attrs) {
            if (attr.attribute.key.endsWith('title') && !attr.attribute.key.endsWith('customer-service-knowledge-title')) {
              title = attr.value;
            } else if (attr.attribute.key.endsWith('about')) {
              description = attr.value;
            } else if (attr.attribute.key.endsWith('programCode')) {
              code = attr.value;
            } else if (attr.attribute.key.endsWith('programNumber')) {
              number = parseInt(attr.value, 10);
            }
          }
          if (!code) {
            return null;
          } else {
            return {
              number,
              code,
              title,
              description
            };
          }
        }
      }), catchError(error => {
        console.error('eca-setup-configuration-service: ', error);
        return of(null);
      }));
    }
    /**
     * Fetches a list of applications for the pre-selected product/client
     */
    getApplications() {
      return this.appContextService.getSelectedProductCode().pipe(switchMap(productCode => this.getApplicationsForClient(productCode)));
    }
    /**
     * Fetches a list of all applications a specified client/product has available
     */
    getApplicationsForClient(clientCode) {
      const url = `${this.getBaseUrl()}/v0/clients/${clientCode.toUpperCase()}/applications`;
      const options = {
        cache: true
      };
      return this.apiGatewayService.get(url, options);
    }
    /**
     * Fetches application views for the pre-selected product/client
     */
    getApplicationViews() {
      return this.appContextService.getSelectedProductCode().pipe(switchMap(productCode => this.appContextService.getSelectedApplicationId().pipe(switchMap(applicationId => this.getApplicationViewsForClient(productCode, applicationId)))));
    }
    /**
     * Fetches the application views for a specified client/application
     */
    getApplicationViewsForClient(clientCode, applicationId) {
      if (!clientCode) {
        return of([]);
      }
      clientCode = clientCode.toUpperCase();
      const url = `${this.getBaseUrl()}/v0/clients/${clientCode}/applications/${applicationId}/views`;
      const options = {
        cache: true
      };
      return this.apiGatewayService.get(url, options).pipe(map(views => views.filter(view => view.isActive)));
    }
    /**
     * Simplified version of getApplicationViews for easy use with Nav Tabs
     */
    getApplicationNavTabs() {
      return this.getApplicationViews().pipe(map(views => views.map(view => ({
        label: view.label,
        link: view.applicationViewUrl,
        order: view.order
      }))));
    }
    /**
     * Get the Client Application Categories for the client
     */
    getClientApplicationCategories(clientCode) {
      const clientCode$ = clientCode ? of(clientCode) : this.appContextService.getSelectedProductCode();
      return clientCode$.pipe(switchMap(clientCode => {
        const categoriesUrl = `${this.getBaseUrl()}/v0/clients/${clientCode}/client-application-categories`;
        return this.apiGatewayService.get(categoriesUrl);
      }));
    }
    /**
     * Get all attributes for the pre-selected product/client
     */
    getAttributes() {
      return this.appContextService.getSelectedProductCode().pipe(switchMap(productCode => this.getAttributesForClient(productCode)));
    }
    /**
     * Fetch attributes for the specified product/client
     */
    getAttributesForClient(clientCode) {
      const url = `${this.getBaseUrl()}/v0/clients/${clientCode.toUpperCase()}/attributes`;
      return this.getClientAttributesCacheKeyForClient(clientCode).pipe(switchMap(cacheKey => {
        const options = {
          cache: {
            key: cacheKey
          }
        };
        return this.apiGatewayService.get(url, options);
      }));
    }
    /**
     * Fetch a specific attribute by key for a pre-selected product/client
     */
    getAttribute(key) {
      return this.appContextService.getSelectedProductCode().pipe(switchMap(productCode => this.getAttributeForClient(productCode, key)));
    }
    /**
     * Fetch a specific attribute by key for the specified product/client
     */
    getAttributeForClient(clientCode, key) {
      return this.getAttributesForClient(clientCode).pipe(map(attributes => attributes.find(item => item.attribute && item.attribute.key === key)));
    }
    getAttributesForClientByTag(clientAbbr, tag, options = {}) {
      const tagAttr = encodeURIComponent(tag);
      const url = `${this.getBaseUrl()}/v0/clients/${clientAbbr.toUpperCase()}/attributes?tags=${tagAttr}`;
      return this.apiGatewayService.get(url, options);
    }
    /**
     * set the value of a client attribute, and clear the client attributes from the cache
     *
     */
    updateClientAttribute(clientAttributeId, clientAttributeValue) {
      const url = `${this.getBaseUrl()}/v0/client-attributes/${clientAttributeId}`;
      return this.apiGatewayService.put(url, {
        value: clientAttributeValue
      }).pipe(switchMap(attribute => this.getClientAttributesCacheKeyForClient().pipe(tap(cacheKey => this.apiGatewayService.clearCacheKey(cacheKey)), mapTo(attribute))));
    }
    getUserMenu(productCode, programNumber) {
      const url = `${this.getBaseUrl()}/v0/clients/${productCode}/menu`;
      const options = {
        forceEcaToken: true,
        cache: true,
        httpOptions: {
          params: {
            program: programNumber?.toString() || '1'
          }
        }
      };
      return this.apiGatewayService.get(url, options);
    }
    /**
     * returns cache key for client attributes
     *
     */
    getClientAttributesCacheKeyForClient(clientCode) {
      const getProductCode = clientCode ? of(clientCode) : this.appContextService.getSelectedProductCode();
      return forkJoin([getProductCode, this.appContextService.getToken()]).pipe(map(responses => {
        const productCode = responses[0];
        const token = responses[1];
        const suffix = token ? 'auth' : 'anon';
        if (!productCode) {
          throw new Error('No product code found.');
        }
        // This service will return different results depending on whether a token is provided.
        // We add a suffix to make sure the cache key is unique between the two cases
        return `${this.getBaseUrl()}/v0/clients/${productCode.toUpperCase()}/attributes:${suffix}`;
      }));
    }
    getBaseUrl() {
      const apiConfig = this.apiGatewayService.makeApiConfigString();
      return `${this.apiGatewayService.getCachingDomain()}/eca-setup-configuration-service/${apiConfig}`;
    }
    static {
      this.ɵfac = function EcaSetupConfigurationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSetupConfigurationService)(i0.ɵɵinject(AppContextService), i0.ɵɵinject(ApiGatewayService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaSetupConfigurationService,
        factory: EcaSetupConfigurationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaSetupConfigurationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SiteSelectorParameterDefault = {
  acl: 'site-service:site:view',
  hideAdvancedSearch: false,
  includeAdmin: false,
  multiple: true,
  openOverlayButtonText: 'Select a Site ...',
  showSiteCode: false
};
let EcaSiteSelectorService = /*#__PURE__*/(() => {
  class EcaSiteSelectorService {
    static {
      this.ViewMode = 'viewMode';
    }
    static {
      this.SearchText = 'searchText';
    }
    static {
      this.SortColumn = 'sortColumn';
    }
    static {
      this.SortDirection = 'sortDirection';
    }
    static {
      this.SiteTypeFilter = 'siteTypeFilter';
    }
    static {
      this.StateFilterAdvanced = 'stateFilterAdvanced';
    }
    static {
      this.Field = 'field-';
    }
    constructor(appContextService) {
      this.appContextService = appContextService;
      this.viewModeBasic = 'basic';
      this.viewModeAdvanced = 'advanced';
      this.lastVisitedDate = 'lastVisitedDate';
      this.defaultState = new Map([[EcaSiteSelectorService.ViewMode, this.viewModeBasic], [EcaSiteSelectorService.SortColumn, this.lastVisitedDate], [EcaSiteSelectorService.SortDirection, 'desc']]);
      this.visible$ = new BehaviorSubject(false);
      this.parameters$ = new BehaviorSubject(SiteSelectorParameterDefault);
      this.overlayIsOpen$ = new BehaviorSubject(false);
      this.store = this.retrieveStore();
    }
    get(key) {
      return this.store.get(key);
    }
    set(key, value) {
      this.store.set(key, value);
      this.appContextService.setCacheValue('ecaSiteSelectorStore', this.store);
    }
    remove(key) {
      this.store.delete(key);
      this.appContextService.setCacheValue('ecaSiteSelectorStore', this.store);
    }
    retrieveStore() {
      try {
        const parsedValue = this.appContextService.getCacheValue('ecaSiteSelectorStore');
        return parsedValue || this.defaultState;
      } catch {
        return this.defaultState;
      }
    }
    /**
     * ToDo: persist in storage the last 50 sites that were selected/visited
     */
    // markVisited(site: Site) {
    //
    // }
    /**
     * Not all applications/routes need a Site context so this will show/hide it in the header accordingly
     */
    showSiteSelector() {
      this.visible$.next(true);
    }
    hideSiteSelector() {
      this.visible$.next(false);
    }
    get siteSelectorVisible$() {
      return this.visible$.asObservable();
    }
    closeOverlay() {
      this.overlayIsOpen$.next(false);
    }
    openOverlay() {
      this.overlayIsOpen$.next(true);
    }
    get siteSelectorOverlayIsOpen$() {
      return this.overlayIsOpen$.asObservable();
    }
    /**
     * The configuration includes values that would otherwise be passed to the HTML component via input attributes
     */
    setInputParameters(params) {
      this.parameters$.next(params);
    }
    get inputParameters$() {
      return this.parameters$.asObservable();
    }
    /**
     * Pass-through methods for setting/getting the selected Site
     * defined in AppContextService as it interacts with Session Storage and has other 'context' values
     */
    setValue(site, productAbbreviation) {
      this.appContextService.setSelectedSite(site, productAbbreviation);
    }
    getValue(productAbbreviation) {
      return this.appContextService.selectedSite$(productAbbreviation);
    }
    static {
      this.ɵfac = function EcaSiteSelectorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSelectorService)(i0.ɵɵinject(AppContextService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaSiteSelectorService,
        factory: EcaSiteSelectorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaSiteSelectorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var NotificationRequest = /*#__PURE__*/function (NotificationRequest) {
  NotificationRequest["all"] = "all";
  NotificationRequest["update"] = "update";
  return NotificationRequest;
}(NotificationRequest || {});
/**
 * A base WebsocketService to provide setting up the websocket.
 *
 * * _socketAvailability = Observable<boolean>
 * * _messages$ = Observable
 * * _socketUrl = string
 * * closeConnection
 * * setPing$ = Observable<5 minute timer>
 * * sendMessage
 */
class WebsocketService {
  constructor() {
    this._appContextService = inject(AppContextService);
    /**
     * Tell the websocket that a token is required to be open (default: true)
     */
    this._requiresToken = true;
    this._pingTime = 300000;
    this._socketAvailability = new BehaviorSubject(false);
    /**
     * An Observable of websocket messages when the websocket is responding.
     *
     * When a websocket is not available the default is (`null`)
     */
    this._messages$ = this._appContextService.token$.pipe(switchMap(token => {
      this.closeConnection();
      if (!this._socketUrl) {
        return of(null);
      }
      if (!token && this._requiresToken) {
        return of(null);
      }
      if (this._requiresToken || token) {
        this._webSocket$ = webSocket({
          url: `${this._socketUrl}?token=${token}`
        });
      } else {
        this._webSocket$ = webSocket({
          url: `${this._socketUrl}`
        });
      }
      this._socketAvailability.next(true);
      return this._webSocket$;
    }));
    /**
     * A simple Observable returning the websocket availability
     */
    this.isSocketOpen$ = this._socketAvailability.asObservable();
    /**
     * A ping Observable to "clear" the ping timer or "set" the ping timer based on if the websocket is closed ("clear") or open ("set")
     */
    this.setPing$ = this.isSocketOpen$.pipe(tap(isOpen => {
      clearTimeout(this._pingInterval);
      if (isOpen) {
        this.ping();
      }
    }));
  }
  ping() {
    this._pingInterval = setTimeout(() => {
      if (!this._webSocket$) {
        return console.warn('Websocket ping should only occur when a websocket has been established');
      }
      this.sendMessage();
      this.ping();
    }, this._pingTime);
  }
  /**
   * This will close the websocket, and cancel the ping timer
   */
  closeConnection() {
    if (this._webSocket$) {
      this._webSocket$.complete();
      this._webSocket$ = null;
    }
    clearTimeout(this._pingInterval);
    this._socketAvailability.next(false);
  }
  /**
   * Send a request to the websocket
   *
   * Example
   * ```json
   * {
   *   "action": "ping",
   *   "data": {}
   * }
   * ```
   * @param action an action type for the websocket request (default: "ping")
   * @param data the data to send to the websocket (default: {})
   */
  sendMessage(action = 'ping', data) {
    if (!data) {
      data = {};
    }
    if (this._webSocket$ && !this._webSocket$.closed) {
      this._webSocket$.next({
        action: action,
        data: data
      });
    }
  }
}
const socketUrl = 'wss://REPLACE_ME-ws.uns-le.drcedirect.com';
let EcaNotificationHistoryService = /*#__PURE__*/(() => {
  class EcaNotificationHistoryService extends WebsocketService {
    get messages() {
      return this._messages.getValue();
    }
    constructor() {
      super();
      this.apiGatewayService = inject(ApiGatewayService);
      this.startTime = 1000;
      this._socketUrl = '';
      this.visible$ = new BehaviorSubject(false);
      this._messages = new BehaviorSubject([]);
      this.messages$ = this._messages.asObservable();
    }
    initialize() {
      this.setSocketUrl(this.apiGatewayService.config?.deployment);
      this.setMessages();
      this.setPing();
    }
    showNotificationBell() {
      this.visible$.next(true);
    }
    hideNotificationBell() {
      this.visible$.next(false);
    }
    get notificationBellVisible$() {
      return this.visible$.asObservable();
    }
    setMessages() {
      this._messages$.subscribe({
        next: response => {
          if (!response) {
            return;
          }
          // Do logic with messages.
          switch (response.action) {
            case NotificationRequest.all:
              // Replace all messages
              this.allResponse(response);
              break;
            case NotificationRequest.update:
              this.updateResponse(response);
              break;
            default:
              break;
          }
        },
        error: error => {
          console.log('error', error);
        }
      });
    }
    allResponse(response) {
      this._messages.next(response.notifications);
    }
    updateResponse(response) {
      const newMessages = [];
      for (const message of this.messages) {
        for (const notification of response.notifications) {
          if (message.notificationId === notification.notificationId) {
            message.isDeleted = notification.isDeleted;
            message.isRead = notification.isRead;
            continue;
          }
        }
        if (!message.isDeleted) {
          newMessages.push(message);
        }
      }
      const remaining = response.notifications.filter(notification => {
        const exists = this.messages.findIndex(message => {
          return message.notificationId === notification.notificationId;
        });
        return exists === -1;
      });
      // Remove if isDeleted and notificationId
      // Update if isRead and notificationId
      this._messages.next([...newMessages, ...remaining]);
    }
    setPing() {
      this.isSocketOpen$.subscribe(isOpen => {
        if (!isOpen) {
          if (this.pingSub) {
            this.pingSub.unsubscribe();
            this.pingSub = null;
          }
          return;
        }
        this.pingSub = this.setPing$.subscribe();
        setTimeout(() => {
          this.sendMessage(NotificationRequest.all, {});
        }, this.startTime);
      });
    }
    setSocketUrl(deployment) {
      switch (deployment) {
        case 'development':
          this._socketUrl = socketUrl.replace('REPLACE_ME', 'dev');
          break;
        case 'sqa':
          this._socketUrl = socketUrl.replace('REPLACE_ME', 'sqa');
          break;
        case 'staging':
          this._socketUrl = socketUrl.replace('REPLACE_ME', 'stg');
          break;
        case 'loadtesting':
          this._socketUrl = socketUrl.replace('REPLACE_ME', 'lt');
          break;
        case 'testdevelopment':
          this._socketUrl = socketUrl.replace('REPLACE_ME', 'td');
          break;
        case 'production':
          this._socketUrl = socketUrl.replace('REPLACE_ME', 'prod').replace('-le', '');
          break;
      }
    }
    /**
     * Update user notification(s) by sending the update to the websocket
     *
     * @param {NotificationUpdate[]} data the notification(s) to update
     */
    updateNotifications(data) {
      this.sendMessage(NotificationRequest.update, data);
    }
    static {
      this.ɵfac = function EcaNotificationHistoryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaNotificationHistoryService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaNotificationHistoryService,
        factory: EcaNotificationHistoryService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaNotificationHistoryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UrlService = /*#__PURE__*/(() => {
  class UrlService {
    constructor(windowService) {
      this.windowService = windowService;
    }
    /**
     * Add params to the url, but make sure they are appended AFTER a hash/anchor tag so it doesn't get sent across the wires
     * (which would be a much bigger security concern)
     */
    concatQueryString(url, params) {
      const parameterString = Object.keys(params).map(key => [key, params[key]].map(encodeURIComponent).join('=')).join('&');
      function hasQuery() {
        return url.indexOf('?') >= 0;
      }
      function hasAnchor() {
        return url.indexOf('#') >= 0;
      }
      if (!hasQuery() && !hasAnchor()) {
        return `${url}#?${parameterString}`;
      } else if (hasQuery() && !hasAnchor()) {
        return `${url}&${parameterString}`;
      } else if (!hasQuery() && hasAnchor()) {
        return `${url}?${parameterString}`;
      } else {
        return `${url}&${parameterString}`;
      }
    }
    isSameOrigin(url) {
      try {
        if (url.indexOf('://') === -1) {
          url = `${this.windowService.location.origin}/${url}`;
        }
        const url1 = new URL(this.windowService.location.href);
        const url2 = new URL(url);
        return url1.origin === url2.origin;
      } catch {
        return false;
      }
    }
    static {
      this.ɵfac = function UrlService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UrlService)(i0.ɵɵinject(WindowService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UrlService,
        factory: UrlService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UrlService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHeaderService = /*#__PURE__*/(() => {
  class EcaHeaderService {
    constructor(menuItemOverrides, setupConfigService, apiGatewayService, appContextService, ecaSiteSelectorService, notificationService, urlService, windowService) {
      this.menuItemOverrides = menuItemOverrides;
      this.setupConfigService = setupConfigService;
      this.apiGatewayService = apiGatewayService;
      this.appContextService = appContextService;
      this.ecaSiteSelectorService = ecaSiteSelectorService;
      this.notificationService = notificationService;
      this.urlService = urlService;
      this.windowService = windowService;
      this.helpLinks = new BehaviorSubject(null);
      this.title = new BehaviorSubject(null);
      this.inited = new BehaviorSubject(false);
      this.eventEmitter = new Subject();
    }
    initialized() {
      if (this.apiGatewayService.config !== null) {
        this.initialize();
      }
      return this.inited.asObservable().pipe(filter(value => value === true));
    }
    initialize() {
      this.inited.next(true);
    }
    // get menu data from Client Application Categories defined in Setup Config
    getMenuDataForProduct(clientCode, programNumber) {
      if (!clientCode) {
        return of(null);
      }
      return this.setupConfigService.getUserMenu(clientCode, programNumber).pipe(map(menu => {
        // If user has specified any URL overrides, implement them
        // This is used by eDIRECT to jump locally between legacy apps when developing locally
        if (this.menuItemOverrides) {
          menu.forEach(category => {
            category.applications.forEach(app => {
              this.menuItemOverrides.forEach(override => {
                if (app.applicationId === override.applicationId) {
                  app.applicationUrl = override.url;
                } else if (override.pattern && override.substitution) {
                  app.applicationUrl = app.applicationUrl.replace(override.pattern, override.substitution);
                }
              });
            });
          });
        }
        return menu;
      }));
    }
    setMenuOverrides(overrides) {
      this.menuItemOverrides = overrides;
    }
    setTitle(title) {
      this.title.next(title);
    }
    getTitle() {
      return this.title.asObservable();
    }
    setHelpLinks(helpLinks) {
      this.helpLinks.next(helpLinks);
    }
    getHelpLinks() {
      return this.helpLinks.asObservable();
    }
    getSetupConfigValues(attributeName, product) {
      let attribute$;
      if (product) {
        attribute$ = this.setupConfigService.getAttribute(attributeName);
      } else {
        attribute$ = this.setupConfigService.getAttributeForClient('DRCPortal', attributeName);
      }
      return attribute$.pipe(map(v => v === undefined ? {} : v), pluck('value'));
    }
    // Used whenever the product is switched inside of the menu
    launchProductProgramSelector(product) {
      this.setupConfigService.getAttributeForClient(product.abbreviation, 'portal-header-version').subscribe(version => {
        this.appContextService.setHeaderVersion(version.value);
        const portalUrlV2 = this.appContextService.getPortalUrl();
        if (version.value === 'v2') {
          this.windowService.navigateTo(`${portalUrlV2}/#/products/${product.abbreviation}/program-selection`);
        } else {
          this.setupConfigService.getAttributeForClient(product.abbreviation, 'portal-url').subscribe(portaUrlV1 => {
            this.windowService.navigateTo(`https://${portaUrlV1.value}program-selection/${product.abbreviation}`);
          });
        }
      });
    }
    launchProduct(options) {
      const program = options.program || {
        number: 1,
        code: 'default'
      };
      this.setupConfigService.getAttributeForClient(options.product.abbreviation, 'portal-header-version').subscribe(version => {
        this.appContextService.setHeaderVersion(version.value);
        const portalUrlV2 = this.appContextService.getPortalUrl();
        if (options.returnUrl) {
          if (this.urlService.isSameOrigin(options.returnUrl) && !options.openInNewWindow) {
            // if same origin and not open in new window, context is passed via sessionStorage
            this.windowService.navigateTo(options.returnUrl, !!options.openInNewWindow);
          } else {
            // if different origin or open in new window, pass context in query string
            this.appContextService.getToken().subscribe(token => {
              const context = {
                c: options.product.abbreviation,
                p: program.number.toString(),
                t: token,
                u: portalUrlV2,
                v: version.value
              };
              const urlWithContext = this.urlService.concatQueryString(options.returnUrl, context);
              this.windowService.navigateTo(urlWithContext, !!options.openInNewWindow);
            });
          }
        } else if (version.value === 'v2') {
          this.windowService.navigateTo(`${portalUrlV2}/#/products/${options.product.abbreviation}/${program.code}/welcome`, !!options.openInNewWindow);
        } else {
          this.setupConfigService.getAttributeForClient(options.product.abbreviation, 'portal-url').subscribe(portaUrlV1 => {
            this.windowService.navigateTo(`https://${portaUrlV1.value}${program.code}/welcome/${options.product.abbreviation}`, !!options.openInNewWindow);
          });
        }
        const temp = window.onload;
        window.onload = () => {
          this.appContextService.setSelectedProductCode(options.product.abbreviation);
          this.appContextService.setSelectedApplicationId(0);
          this.appContextService.setSelectedProgramNumber(options.program.number || 1);
          window.onload = temp;
        };
      });
    }
    launchApplication(application) {
      if (!application.shouldOpenNewWindow) {
        this.appContextService.setSelectedApplicationId(application.applicationId);
      }
      if (this.urlService.isSameOrigin(application.applicationUrl) && !application.shouldOpenNewWindow) {
        // if same origin and not open in new window, context is already in sessionStorage
        this.windowService.navigateTo(application.applicationUrl, application.shouldOpenNewWindow);
      } else {
        // if different origin or open in new window, context needs to be passed via query string
        forkJoin([this.appContextService.getToken(), this.appContextService.getSelectedProductCode(), this.appContextService.getSelectedProgramNumber()]).subscribe(([token, productCode, programNumber]) => {
          const context = {
            t: token,
            u: this.appContextService.getPortalUrl(),
            a: application.applicationId.toString(10),
            c: productCode
            // v: this.appContextService.getHeaderVersion()
          };
          if (typeof programNumber === 'string' || typeof programNumber === 'number') {
            context.p = programNumber.toString();
          }
          this.windowService.navigateTo(this.urlService.concatQueryString(application.applicationUrl, context), application.shouldOpenNewWindow);
        });
      }
    }
    /* Dispatch an event to interested subscribers */
    dispatchEvent(event) {
      this.eventEmitter.next(event);
    }
    /* Broadcasts events to subscribers */
    getEvents() {
      return this.eventEmitter.asObservable();
    }
    /**
     * Pass-through methods for interacting with EcaSiteSelector
     */
    showSiteSelector() {
      this.ecaSiteSelectorService.showSiteSelector();
    }
    hideSiteSelector() {
      this.ecaSiteSelectorService.hideSiteSelector();
    }
    get siteSelectorVisible$() {
      return this.ecaSiteSelectorService.siteSelectorVisible$;
    }
    /**
     * Pass-through methods for interacting with EcaNotificationBell
     */
    showNotificationBell() {
      this.notificationService.showNotificationBell();
    }
    hideNotificationBell() {
      this.notificationService.hideNotificationBell();
    }
    get notificationBellVisible$() {
      return this.notificationService.notificationBellVisible$;
    }
    static {
      this.ɵfac = function EcaHeaderService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHeaderService)(i0.ɵɵinject(MENU_ITEM_OVERRIDES, 8), i0.ɵɵinject(EcaSetupConfigurationService), i0.ɵɵinject(ApiGatewayService), i0.ɵɵinject(AppContextService), i0.ɵɵinject(EcaSiteSelectorService), i0.ɵɵinject(EcaNotificationHistoryService), i0.ɵɵinject(UrlService), i0.ɵɵinject(WindowService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaHeaderService,
        factory: EcaHeaderService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaHeaderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFooterContactModalComponent = /*#__PURE__*/(() => {
  class EcaFooterContactModalComponent {
    constructor(data) {
      this.data = data;
      this.contactEmail = '';
      this.contactPhone = '';
    }
    ngOnInit() {
      this.contactEmail = this.data.email;
      this.contactPhone = this.data.phone;
    }
    static {
      this.ɵfac = function EcaFooterContactModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFooterContactModalComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaFooterContactModalComponent,
        selectors: [["eca-eca-footer-contact-modal"]],
        decls: 13,
        vars: 2,
        consts: [[1, "eca-fx-col"], ["mat-icon-button", "", "mat-dialog-close", "", "aria-label", "close", 1, "close-dialog"], ["mat-dialog-title", ""], ["mat-dialog-content", ""], ["x-ms-format-detection", "none", 1, "phone"], [1, "email-text"]],
        template: function EcaFooterContactModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1)(2, "mat-icon");
            i0.ɵɵtext(3, "close");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2", 2);
            i0.ɵɵtext(5, "Contact Us");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 3)(7, "p", 4);
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "p");
            i0.ɵɵtext(10, " Email: ");
            i0.ɵɵelementStart(11, "span", 5);
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate1("Phone: ", ctx.contactPhone, "");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.contactEmail);
          }
        },
        dependencies: [i1$3.MatDialogClose, i1$3.MatDialogTitle, i1$3.MatDialogContent, i5.MatIcon, i4.MatIconButton],
        styles: ["p[_ngcontent-%COMP%]{padding:5px 0;font-weight:600}h5[_ngcontent-%COMP%]{font-size:1.2em;font-weight:600}.email-text[_ngcontent-%COMP%]{color:#1991eb}p.phone[_ngcontent-%COMP%]{margin-top:30px}.eca-fx-col[_ngcontent-%COMP%]{max-height:calc(100vh - 90px)}"]
      });
    }
  }
  return EcaFooterContactModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFooterBaseComponent = /*#__PURE__*/(() => {
  class EcaFooterBaseComponent {
    constructor(dialog, appContextService, windowService) {
      this.dialog = dialog;
      this.appContextService = appContextService;
      this.windowService = windowService;
      this.contactEmail = '';
      this.contactPhone = '';
      this.linkVisibility = 'visible';
      this.logoVisibility = 'hidden';
    }
    ngOnInit() {
      this.portalUrl = this.appContextService.getPortalUrl();
    }
    openModal() {
      this.dialog.open(EcaFooterContactModalComponent, {
        position: {
          top: '70px'
        },
        width: '500px',
        height: '240px',
        data: {
          email: this.contactEmail,
          phone: this.contactPhone
        }
      });
    }
    setReturnUrl() {
      const returnUrl = this.windowService.location.href;
      const docPaths = ['privacy-policy', 'terms-of-use', 'minimum-browser-requirements'];
      // Don't save url if traversing through doc pages
      if (docPaths.some(docUrl => returnUrl.includes(docUrl))) return;
      sessionStorage.setItem('ngStorage-returnFromDocsUrl', returnUrl);
    }
    getCurrentYear() {
      return new Date().getFullYear();
    }
    static {
      this.ɵfac = function EcaFooterBaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFooterBaseComponent)(i0.ɵɵdirectiveInject(i1$3.MatDialog), i0.ɵɵdirectiveInject(AppContextService), i0.ɵɵdirectiveInject(WindowService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaFooterBaseComponent,
        selectors: [["eca-footer-base"]],
        inputs: {
          contactEmail: "contactEmail",
          contactPhone: "contactPhone",
          linkVisibility: "linkVisibility",
          logoVisibility: "logoVisibility"
        },
        decls: 20,
        vars: 10,
        consts: [[1, "drc-footer"], [1, "footer-copyright"], [1, "footer-links"], [1, "contact-link", 3, "ngClass"], ["id", "contact-us-link", 1, "eca-link", "remove-btn-formatting", 3, "click"], [1, "terms-link"], ["id", "terms-link", 3, "click", "href"], [1, "privacy-link"], ["id", "privacy-link", 3, "click", "href"], [1, "browser-reqs-link"], ["id", "browser-reqs-link", 3, "click", "href"], [1, "footer-logo", 3, "ngClass"], ["id", "drc-logo-link-to-home", "title", "DRC Logo", "aria-label", "DRC logo link to home", "href", "http://www.datarecognitioncorp.com", 1, "footer-brand"], [1, "sr-only"]],
        template: function EcaFooterBaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "button", 4);
            i0.ɵɵlistener("click", function EcaFooterBaseComponent_Template_button_click_5_listener() {
              return ctx.openModal();
            });
            i0.ɵɵtext(6, "Contact Us");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 5)(8, "a", 6);
            i0.ɵɵlistener("click", function EcaFooterBaseComponent_Template_a_click_8_listener() {
              return ctx.setReturnUrl();
            });
            i0.ɵɵtext(9, "Terms of Use");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 7)(11, "a", 8);
            i0.ɵɵlistener("click", function EcaFooterBaseComponent_Template_a_click_11_listener() {
              return ctx.setReturnUrl();
            });
            i0.ɵɵtext(12, "Privacy Policy");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 9)(14, "a", 10);
            i0.ɵɵlistener("click", function EcaFooterBaseComponent_Template_a_click_14_listener() {
              return ctx.setReturnUrl();
            });
            i0.ɵɵtext(15, "Browser Requirements");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(16, "div", 11)(17, "a", 12)(18, "span", 13);
            i0.ɵɵtext(19, "DRC logo link to home");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" \xA9 DRC Insight ", ctx.getCurrentYear(), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c5, ctx.linkVisibility === "hidden"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("href", ctx.portalUrl + "/#/terms-of-use", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("href", ctx.portalUrl + "/#/privacy-policy", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("href", ctx.portalUrl + "/#/docs/minimum-browser-requirements", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c5, ctx.logoVisibility === "hidden"));
          }
        },
        dependencies: [i1.NgClass, i2.DefaultClassDirective],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}.drc-footer[_ngcontent-%COMP%]{background-color:var(--drc-white);display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;height:56px;width:100%;min-width:800px;box-shadow:0 0 4px #00000040;color:var(--drc-black);font-family:Source Sans Pro,Helvetica,Verdana,sans-serif;font-size:16px}@media screen and (max-width: 856px){.drc-footer[_ngcontent-%COMP%]{flex-flow:column;height:auto;min-width:auto}.drc-footer[_ngcontent-%COMP%]   .footer-links[_ngcontent-%COMP%]{flex-wrap:wrap}.drc-footer[_ngcontent-%COMP%]   .footer-links[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{white-space:nowrap;margin-top:6px!important;margin-bottom:6px!important}.drc-footer[_ngcontent-%COMP%]   .footer-copyright[_ngcontent-%COMP%], .drc-footer[_ngcontent-%COMP%]   .footer-links[_ngcontent-%COMP%], .drc-footer[_ngcontent-%COMP%]   .footer-logo[_ngcontent-%COMP%]{padding-top:10px;padding-bottom:10px}.drc-footer[_ngcontent-%COMP%]   .footer-copyright[_ngcontent-%COMP%]{padding-left:0!important}.drc-footer[_ngcontent-%COMP%]   .footer-logo[_ngcontent-%COMP%]{padding-right:0!important}.drc-footer[_ngcontent-%COMP%]   .footer-logo.hide[_ngcontent-%COMP%]{display:none!important}}.drc-footer[_ngcontent-%COMP%]   .footer-copyright[_ngcontent-%COMP%]{flex:0 1 0;padding-left:24px;white-space:nowrap;font-size:16px}.drc-footer[_ngcontent-%COMP%]   .hide[_ngcontent-%COMP%]{display:none}@media screen and (-ms-high-contrast: none),(-ms-high-contrast: active){.drc-footer[_ngcontent-%COMP%]   .footer-links[_ngcontent-%COMP%]{justify-content:space-around}}@supports (-ms-ime-align: auto){.drc-footer[_ngcontent-%COMP%]   div.footer-links[_ngcontent-%COMP%]{justify-content:space-around}}.drc-footer[_ngcontent-%COMP%]   .footer-links[_ngcontent-%COMP%]{flex:4 4 0;display:flex;justify-content:center;align-items:center}.drc-footer[_ngcontent-%COMP%]   .footer-links[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:0;margin:0 16px}.drc-footer[_ngcontent-%COMP%]   .footer-logo[_ngcontent-%COMP%]{flex:0 1 0;padding-right:24px;text-align:right}.drc-footer[_ngcontent-%COMP%]   .footer-logo.hide[_ngcontent-%COMP%]{display:block}.drc-footer[_ngcontent-%COMP%]   .footer-logo.hide[_ngcontent-%COMP%]   .footer-brand[_ngcontent-%COMP%]{visibility:hidden}.drc-footer[_ngcontent-%COMP%]   .footer-brand[_ngcontent-%COMP%]{display:block;height:40px;width:66px;margin-left:auto;background-image:url(\"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2266px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2066%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2050.2%20(55047)%20-%20http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%20--%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Styleguide-3---Cards%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22DRC-Logo%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Fill-1%22%20fill%3D%22%231C2646%22%20points%3D%220.7%204.155%200.7%205.884%2065.768%205.884%2065.768%203.987%2065.473%203.987%2065.473%205.737%2065.621%205.59%200.847%205.59%200.994%205.737%200.994%204.155%200.7%204.155%22%3E%3C%2Fpolyline%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Stroke-2%22%20stroke%3D%22%231C2646%22%20stroke-width%3D%220.25%22%20points%3D%220.7%204.155%200.7%205.884%2065.768%205.884%2065.768%203.987%2065.473%203.987%2065.473%205.737%2065.621%205.59%200.847%205.59%200.994%205.737%200.994%204.155%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolyline%20id%3D%22Fill-4%22%20fill%3D%22%231C2646%22%20points%3D%220.994%2035.713%200.994%2034.131%200.847%2034.278%2065.621%2034.278%2065.473%2034.131%2065.473%2035.88%2065.768%2035.88%2065.768%2033.985%200.7%2033.985%200.7%2035.713%200.994%2035.713%22%3E%3C%2Fpolyline%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Stroke-5%22%20stroke%3D%22%231C2646%22%20stroke-width%3D%220.25%22%20points%3D%220.994%2035.713%200.994%2034.131%200.847%2034.278%2065.621%2034.278%2065.473%2034.131%2065.473%2035.88%2065.768%2035.88%2065.768%2033.985%200.7%2033.985%200.7%2035.713%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M65.651%2C27.211%20C65.586%2C28.283%2065.619%2C28.704%2064.612%2C29.29%20C62.792%2C30.395%2060.487%2C30.783%2058.378%2C30.783%20C55.52%2C30.783%2052.175%2C30.135%2049.838%2C28.38%20C47.368%2C26.53%2045.714%2C23.445%2045.714%2C20.329%20C45.714%2C17.114%2047.336%2C14.191%2049.902%2C12.277%20C52.434%2C10.425%2055.908%2C9.548%2059.027%2C9.548%20C60.553%2C9.548%2062.402%2C9.808%2063.898%2C10.23%20C64.773%2C10.489%2064.773%2C10.62%2064.937%2C11.529%20L65.193%2C13.184%20C65.261%2C13.509%2065.326%2C13.801%2065.326%2C14.126%20C65.326%2C14.484%2065.066%2C14.678%2064.709%2C14.678%20C63.214%2C14.678%2063.119%2C10.815%2058.735%2C10.815%20C56.59%2C10.815%2054.61%2C12.016%2053.375%2C13.736%20C52.11%2C15.522%2051.59%2C17.893%2051.59%2C20.036%20C51.59%2C22.145%2052.08%2C24.485%2053.213%2C26.271%20C54.449%2C28.188%2056.396%2C29.516%2058.735%2C29.516%20C60.001%2C29.516%2061.169%2C29.063%2062.143%2C28.283%20C63.119%2C27.471%2063.701%2C26.398%2064.287%2C25.297%20C64.449%2C24.939%2064.676%2C24.615%2065.099%2C24.615%20C65.812%2C24.615%2065.78%2C25.361%2065.748%2C25.849%20L65.651%2C27.211%22%20id%3D%22Fill-7%22%20fill%3D%22%231C2646%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-8%22%20fill%3D%22%231C2646%22%20points%3D%2227.655%2025.308%2032.818%2025.308%2032.818%2023.558%2027.655%2023.558%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M26.24%2C9.987%20C25.075%2C9.987%2024.992%2C11.319%2026.157%2C11.319%20C27.242%2C11.319%2033.151%2C11.319%2034.361%2C11.339%20C36.632%2C11.339%2037.932%2C13.32%2037.932%2C15.398%20C37.932%2C16.6%2037.41%2C17.866%2036.404%2C18.58%20C35.594%2C19.196%2034.624%2C19.359%2033.651%2C19.359%20C32.817%2C19.359%2033.066%2C20.658%2033.566%2C20.658%20C33.956%2C20.658%2034.164%2C20.693%2034.458%2C20.982%20C34.977%2C21.438%2035.627%2C22.735%2035.951%2C23.386%20L38.937%2C29.327%20C39.23%2C29.978%2039.296%2C30.367%2040.042%2C30.367%20C40.951%2C30.367%2041.828%2C30.302%2042.736%2C30.302%20C43.647%2C30.302%2044.523%2C30.367%2045.433%2C30.367%20C45.854%2C30.367%2046.407%2C30.302%2046.407%2C29.749%20C46.407%2C29.295%2046.114%2C29.165%2045.725%2C29.069%20C44.295%2C28.776%2044.134%2C28.095%2043.515%2C26.861%20L41.374%2C22.672%20C40.595%2C21.178%2039.848%2C19.978%2037.996%2C19.814%20C40.788%2C19.554%2043.515%2C18.158%2043.515%2C15.041%20C43.515%2C13.45%2042.836%2C12.021%2041.601%2C11.079%20C40.464%2C10.235%2038.937%2C10.072%2037.543%2C10.072%20C35.042%2C10.072%2028.773%2C9.987%2026.24%2C9.987%22%20id%3D%22Fill-9%22%20fill%3D%22%231C2646%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-10%22%20fill%3D%22%231C2646%22%20points%3D%2227.655%2013.817%2032.818%2013.817%2032.818%2012.069%2027.655%2012.069%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-11%22%20fill%3D%22%231C2646%22%20points%3D%2227.655%2016.689%2032.818%2016.689%2032.818%2014.941%2027.655%2014.941%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-12%22%20fill%3D%22%231C2646%22%20points%3D%2227.655%2019.563%2032.818%2019.563%2032.818%2017.814%2027.655%2017.814%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-13%22%20fill%3D%22%231C2646%22%20points%3D%2227.655%2022.435%2032.818%2022.435%2032.818%2020.687%2027.655%2020.687%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-14%22%20fill%3D%22%231C2646%22%20points%3D%2227.655%2028.18%2032.818%2028.18%2032.818%2026.43%2027.655%2026.43%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M35.065%2C30.38%20C35.432%2C30.38%2035.732%2C30.081%2035.732%2C29.714%20C35.732%2C29.347%2035.432%2C29.047%2035.065%2C29.047%20L25.408%2C29.047%20C25.04%2C29.047%2024.742%2C29.347%2024.742%2C29.714%20C24.742%2C30.081%2025.04%2C30.38%2025.408%2C30.38%20L35.065%2C30.38%22%20id%3D%22Fill-15%22%20fill%3D%22%231C2646%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.667%2C10.898%20C0.299%2C10.898%200%2C10.601%200%2C10.232%20C0%2C9.865%200.299%2C9.567%200.667%2C9.567%20L10.614%2C9.567%20C13.731%2C9.548%2016.622%2C10.003%2019.317%2C11.692%20C22.142%2C13.478%2023.895%2C16.302%2023.895%2C19.679%20C23.895%2C26.367%2017.433%2C30.427%2011.296%2C30.427%20C8.569%2C30.427%205.84%2C30.296%203.113%2C30.296%20C2.529%2C30.296%201.88%2C30.427%201.263%2C30.427%20C0.84%2C30.427%200.483%2C30.23%200.483%2C29.712%20C0.483%2C29.194%200.971%2C29.16%201.392%2C29.063%20C3.471%2C28.575%203.34%2C28.057%203.34%2C25.881%20L3.34%2C13.563%20C3.34%2C11.907%203.438%2C10.77%201.587%2C10.9%20C1.208%2C10.941%200.667%2C10.898%200.667%2C10.898%20Z%20M8.698%2C25.102%20C8.698%2C27.277%208.569%2C29.194%2011.263%2C29.194%20C13.406%2C29.194%2015.388%2C27.894%2016.556%2C26.141%20C17.758%2C24.419%2018.245%2C21.985%2018.245%2C19.906%20C18.245%2C15.588%2015.874%2C10.977%2011.068%2C10.977%20C8.73%2C10.977%208.698%2C11.496%208.698%2C13.704%20L8.698%2C25.102%20Z%22%20id%3D%22Fill-16%22%20fill%3D%22%231C2646%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3.509%2C0.793%20C3.509%2C0.616%203.514%2C0.507%203.543%2C0.462%20C3.572%2C0.416%203.665%2C0.388%203.795%2C0.388%20C4.673%2C0.388%205.134%2C0.998%205.134%2C2.025%20C5.134%2C2.8%204.848%2C3.679%204.009%2C3.679%20C3.834%2C3.679%203.693%2C3.627%203.606%2C3.513%20C3.52%2C3.393%203.509%2C3.188%203.509%2C2.874%20L3.509%2C0.793%20Z%20M2.816%2C3.085%20C2.816%2C3.61%202.787%2C3.65%202.57%2C3.695%20L2.419%2C3.725%20C2.379%2C3.753%202.379%2C3.889%202.419%2C3.923%20C2.695%2C3.913%202.942%2C3.907%203.175%2C3.907%20C3.35%2C3.907%203.593%2C3.941%203.819%2C3.941%20C4.319%2C3.941%204.717%2C3.866%205.046%2C3.672%20C5.604%2C3.347%205.915%2C2.732%205.915%2C1.968%20C5.915%2C1.254%205.565%2C0.582%204.931%2C0.313%20C4.596%2C0.171%204.198%2C0.125%203.8%2C0.125%20C3.287%2C0.125%202.909%2C0.148%202.501%2C0.176%20C2.444%2C0.182%202.444%2C0.348%202.491%2C0.377%20L2.583%2C0.388%20C2.807%2C0.416%202.816%2C0.525%202.816%2C1.067%20L2.816%2C3.085%20Z%22%20id%3D%22Fill-17%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.144%2C2.315%20C8.022%2C2.315%207.994%2C2.298%208.041%2C2.144%20L8.164%2C1.717%20C8.236%2C1.454%208.313%2C1.214%208.362%2C1.089%20C8.406%2C1.209%208.469%2C1.442%208.537%2C1.687%20L8.662%2C2.15%20C8.706%2C2.298%208.678%2C2.315%208.565%2C2.315%20L8.144%2C2.315%20Z%20M8.59%2C2.617%20C8.759%2C2.617%208.798%2C2.629%208.822%2C2.72%20L8.953%2C3.211%20C9.012%2C3.421%209.045%2C3.559%209.045%2C3.599%20C9.045%2C3.633%209.025%2C3.672%208.915%2C3.695%20L8.759%2C3.725%20C8.706%2C3.77%208.716%2C3.889%208.769%2C3.923%20C8.992%2C3.913%209.181%2C3.907%209.424%2C3.907%20C9.675%2C3.907%209.938%2C3.913%2010.17%2C3.923%20C10.214%2C3.889%2010.205%2C3.753%2010.175%2C3.725%20L9.99%2C3.691%20C9.812%2C3.65%209.768%2C3.524%209.666%2C3.182%20L9.007%2C0.946%20C8.886%2C0.542%208.827%2C0.331%208.789%2C0.166%20C8.769%2C0.08%208.74%2C0.051%208.678%2C0.051%20C8.667%2C0.051%208.488%2C0.331%208.255%2C0.394%20C8.271%2C0.559%208.182%2C0.758%208.067%2C1.117%20L7.63%2C2.509%20C7.5%2C2.92%207.417%2C3.193%207.329%2C3.421%20C7.252%2C3.644%207.15%2C3.691%207.033%2C3.707%20L6.903%2C3.725%20C6.869%2C3.77%206.865%2C3.889%206.917%2C3.923%20C7.14%2C3.923%207.252%2C3.907%207.417%2C3.907%20C7.62%2C3.913%207.814%2C3.913%207.984%2C3.923%20C8.033%2C3.896%208.022%2C3.764%207.994%2C3.725%20L7.848%2C3.695%20C7.712%2C3.668%207.673%2C3.633%207.673%2C3.599%20C7.673%2C3.553%207.678%2C3.506%207.708%2C3.393%20L7.887%2C2.732%20C7.916%2C2.623%207.931%2C2.617%208.047%2C2.617%20L8.59%2C2.617%20Z%22%20id%3D%22Fill-18%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.841%2C3.085%20C11.841%2C3.616%2011.811%2C3.656%2011.594%2C3.695%20L11.375%2C3.725%20C11.337%2C3.758%2011.337%2C3.889%2011.375%2C3.923%20C11.715%2C3.913%2011.968%2C3.907%2012.2%2C3.907%20C12.418%2C3.907%2012.661%2C3.913%2012.976%2C3.923%20C13.009%2C3.889%2013.009%2C3.758%2012.976%2C3.725%20L12.782%2C3.695%20C12.563%2C3.656%2012.534%2C3.616%2012.534%2C3.085%20L12.534%2C0.57%20C12.534%2C0.422%2012.549%2C0.405%2012.665%2C0.405%20L12.956%2C0.405%20C13.32%2C0.405%2013.387%2C0.673%2013.471%2C1.038%20C13.494%2C1.084%2013.625%2C1.072%2013.649%2C1.022%20C13.64%2C0.695%2013.674%2C0.233%2013.722%2C0.04%20C13.712%2C0.023%2013.678%2C0%2013.649%2C0%20C13.621%2C0%2013.606%2C0.005%2013.586%2C0.017%20C13.542%2C0.137%2013.471%2C0.142%2013.15%2C0.142%20L11.347%2C0.142%20C10.978%2C0.142%2010.963%2C0.119%2010.94%2C0.023%20C10.92%2C0.005%2010.896%2C0%2010.871%2C0%20C10.847%2C0%2010.823%2C0.011%2010.804%2C0.028%20C10.77%2C0.251%2010.746%2C0.604%2010.644%2C0.998%20C10.673%2C1.072%2010.766%2C1.084%2010.823%2C1.049%20C10.969%2C0.633%2011.07%2C0.405%2011.424%2C0.405%20L11.725%2C0.405%20C11.841%2C0.405%2011.841%2C0.434%2011.841%2C0.57%20L11.841%2C3.085%22%20id%3D%22Fill-19%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.384%2C2.315%20C15.262%2C2.315%2015.232%2C2.298%2015.282%2C2.144%20L15.403%2C1.717%20C15.475%2C1.454%2015.553%2C1.214%2015.601%2C1.089%20C15.645%2C1.209%2015.708%2C1.442%2015.776%2C1.687%20L15.902%2C2.15%20C15.946%2C2.298%2015.916%2C2.315%2015.805%2C2.315%20L15.384%2C2.315%20Z%20M15.83%2C2.617%20C15.999%2C2.617%2016.038%2C2.629%2016.062%2C2.72%20L16.193%2C3.211%20C16.251%2C3.421%2016.284%2C3.559%2016.284%2C3.599%20C16.284%2C3.633%2016.266%2C3.672%2016.154%2C3.695%20L15.999%2C3.725%20C15.946%2C3.77%2015.956%2C3.889%2016.008%2C3.923%20C16.232%2C3.913%2016.42%2C3.907%2016.663%2C3.907%20C16.915%2C3.907%2017.177%2C3.913%2017.41%2C3.923%20C17.453%2C3.889%2017.443%2C3.753%2017.415%2C3.725%20L17.231%2C3.691%20C17.051%2C3.65%2017.007%2C3.524%2016.906%2C3.182%20L16.246%2C0.946%20C16.125%2C0.542%2016.067%2C0.331%2016.028%2C0.166%20C16.008%2C0.08%2015.979%2C0.051%2015.916%2C0.051%20C15.907%2C0.051%2015.728%2C0.331%2015.495%2C0.394%20C15.509%2C0.559%2015.422%2C0.758%2015.305%2C1.117%20L14.87%2C2.509%20C14.739%2C2.92%2014.656%2C3.193%2014.569%2C3.421%20C14.491%2C3.644%2014.39%2C3.691%2014.274%2C3.707%20L14.142%2C3.725%20C14.108%2C3.77%2014.103%2C3.889%2014.157%2C3.923%20C14.381%2C3.923%2014.491%2C3.907%2014.656%2C3.907%20C14.86%2C3.913%2015.054%2C3.913%2015.224%2C3.923%20C15.272%2C3.896%2015.262%2C3.764%2015.232%2C3.725%20L15.088%2C3.695%20C14.952%2C3.668%2014.913%2C3.633%2014.913%2C3.599%20C14.913%2C3.553%2014.918%2C3.506%2014.947%2C3.393%20L15.125%2C2.732%20C15.156%2C2.623%2015.17%2C2.617%2015.287%2C2.617%20L15.83%2C2.617%20Z%22%20id%3D%22Fill-20%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M21.554%2C0.678%20C21.563%2C0.405%2021.563%2C0.388%2021.761%2C0.388%20C22.14%2C0.388%2022.396%2C0.718%2022.396%2C1.231%20C22.396%2C1.568%2022.304%2C1.751%2022.222%2C1.847%20C22.129%2C1.956%2022.028%2C2.007%2021.853%2C2.007%20C21.567%2C2.007%2021.554%2C1.99%2021.554%2C1.791%20L21.554%2C0.678%20Z%20M20.889%2C3.085%20C20.889%2C3.61%2020.859%2C3.65%2020.641%2C3.695%20L20.51%2C3.725%20C20.472%2C3.753%2020.472%2C3.889%2020.51%2C3.923%20C20.763%2C3.913%2020.976%2C3.907%2021.218%2C3.907%20C21.451%2C3.907%2021.673%2C3.913%2021.931%2C3.923%20C21.965%2C3.889%2021.965%2C3.753%2021.931%2C3.725%20L21.8%2C3.695%20C21.582%2C3.65%2021.554%2C3.61%2021.554%2C3.085%20L21.554%2C2.384%20C21.554%2C2.27%2021.563%2C2.258%2021.732%2C2.258%20C21.853%2C2.258%2021.931%2C2.305%2021.988%2C2.459%20C22.101%2C2.76%2022.212%2C3.04%2022.367%2C3.342%20C22.58%2C3.753%2022.86%2C3.941%2023.308%2C3.941%20C23.458%2C3.941%2023.613%2C3.93%2023.69%2C3.889%20C23.714%2C3.856%2023.714%2C3.77%2023.671%2C3.741%20C23.598%2C3.735%2023.473%2C3.701%2023.346%2C3.581%20C23.114%2C3.347%2022.915%2C2.92%2022.595%2C2.155%20C22.57%2C2.092%2022.57%2C2.059%2022.619%2C2.03%20C22.842%2C1.9%2023.133%2C1.682%2023.133%2C1.174%20C23.133%2C0.81%2022.987%2C0.525%2022.707%2C0.331%20C22.523%2C0.199%2022.168%2C0.125%2021.757%2C0.125%20C21.295%2C0.125%2020.918%2C0.148%2020.554%2C0.176%20C20.496%2C0.206%2020.496%2C0.348%2020.544%2C0.377%20L20.676%2C0.399%20C20.879%2C0.434%2020.889%2C0.496%2020.889%2C1.067%20L20.889%2C3.085%20Z%22%20id%3D%22Fill-21%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M25.706%2C0.628%20C25.706%2C0.416%2025.706%2C0.405%2025.865%2C0.405%20L26.253%2C0.405%20C26.491%2C0.405%2026.636%2C0.473%2026.728%2C0.582%20C26.792%2C0.661%2026.859%2C0.832%2026.913%2C1.032%20C26.961%2C1.084%2027.072%2C1.072%2027.092%2C1.008%20C27.067%2C0.628%2027.034%2C0.217%2027.029%2C0.125%20C26.966%2C0.137%2026.69%2C0.142%2026.38%2C0.142%20L25.352%2C0.142%20C25.119%2C0.142%2024.882%2C0.137%2024.653%2C0.125%20C24.605%2C0.16%2024.601%2C0.291%2024.645%2C0.324%20L24.765%2C0.353%20C24.983%2C0.399%2025.013%2C0.439%2025.013%2C0.958%20L25.013%2C3.085%20C25.013%2C3.61%2024.983%2C3.65%2024.765%2C3.684%20L24.537%2C3.725%20C24.498%2C3.753%2024.498%2C3.889%2024.537%2C3.923%20C24.901%2C3.913%2025.138%2C3.907%2025.371%2C3.907%20L26.001%2C3.907%20C26.399%2C3.907%2026.864%2C3.913%2027.121%2C3.923%20C27.189%2C3.77%2027.305%2C3.308%2027.325%2C3.011%20C27.305%2C2.942%2027.184%2C2.92%2027.146%2C2.983%20C26.879%2C3.627%2026.714%2C3.644%2026.292%2C3.644%20C25.938%2C3.644%2025.846%2C3.599%2025.783%2C3.496%20C25.725%2C3.399%2025.706%2C3.217%2025.706%2C2.954%20L25.706%2C2.275%20C25.706%2C2.105%2025.71%2C2.098%2025.842%2C2.098%20L26.176%2C2.098%20C26.428%2C2.098%2026.481%2C2.144%2026.535%2C2.419%20L26.558%2C2.561%20C26.593%2C2.612%2026.714%2C2.606%2026.738%2C2.555%20C26.728%2C2.373%2026.724%2C2.167%2026.724%2C1.951%20C26.724%2C1.734%2026.728%2C1.528%2026.738%2C1.346%20C26.714%2C1.294%2026.593%2C1.294%2026.558%2C1.34%20L26.535%2C1.483%20C26.481%2C1.756%2026.428%2C1.796%2026.176%2C1.796%20L25.842%2C1.796%20C25.71%2C1.796%2025.706%2C1.785%2025.706%2C1.626%20L25.706%2C0.628%22%20id%3D%22Fill-22%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M30.36%2C0.051%20C29.856%2C0.051%2029.361%2C0.222%2029.017%2C0.559%20C28.683%2C0.883%2028.43%2C1.374%2028.43%2C2.07%20C28.43%2C2.777%2028.697%2C3.251%2029.046%2C3.564%20C29.39%2C3.866%2029.875%2C3.998%2030.35%2C3.998%20C30.729%2C3.998%2031.072%2C3.872%2031.334%2C3.787%20C31.402%2C3.656%2031.484%2C3.314%2031.518%2C2.892%20C31.489%2C2.823%2031.373%2C2.806%2031.334%2C2.852%20C31.204%2C3.239%2030.932%2C3.735%2030.345%2C3.735%20C29.763%2C3.735%2029.206%2C3.126%2029.206%2C1.99%20C29.206%2C0.855%2029.782%2C0.313%2030.322%2C0.313%20C30.791%2C0.313%2031.101%2C0.599%2031.232%2C1.129%20C31.267%2C1.18%2031.397%2C1.158%2031.417%2C1.089%20C31.373%2C0.758%2031.359%2C0.301%2031.359%2C0.199%20C31.213%2C0.188%2030.854%2C0.051%2030.36%2C0.051%22%20id%3D%22Fill-23%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M35.274%2C2.082%20C35.274%2C3.006%2035.028%2C3.735%2034.393%2C3.735%20C33.603%2C3.735%2033.393%2C2.617%2033.393%2C1.922%20C33.393%2C0.969%2033.713%2C0.313%2034.309%2C0.313%20C34.912%2C0.313%2035.274%2C1.107%2035.274%2C2.082%20Z%20M34.351%2C0.051%20C33.336%2C0.051%2032.619%2C0.923%2032.619%2C2.052%20C32.619%2C3.245%2033.326%2C3.998%2034.299%2C3.998%20C35.342%2C3.998%2036.05%2C3.251%2036.05%2C2.007%20C36.05%2C0.849%2035.357%2C0.051%2034.351%2C0.051%20Z%22%20id%3D%22Fill-24%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M40.369%2C2.942%20C40.369%2C2.634%2040.396%2C2.583%2040.542%2C2.549%20L40.654%2C2.527%20C40.693%2C2.492%2040.693%2C2.36%2040.654%2C2.327%20C40.49%2C2.338%2040.253%2C2.343%2040.019%2C2.343%20C39.782%2C2.343%2039.545%2C2.338%2039.2%2C2.327%20C39.146%2C2.36%2039.146%2C2.492%2039.2%2C2.527%20L39.413%2C2.561%20C39.646%2C2.601%2039.675%2C2.634%2039.675%2C2.942%20L39.675%2C3.302%20C39.675%2C3.672%2039.615%2C3.735%2039.341%2C3.735%20C39.161%2C3.735%2038.908%2C3.701%2038.677%2C3.519%20C38.361%2C3.268%2038.122%2C2.783%2038.122%2C1.968%20C38.122%2C1.067%2038.497%2C0.313%2039.268%2C0.313%20C39.718%2C0.313%2040.025%2C0.582%2040.179%2C1.117%20C40.213%2C1.174%2040.346%2C1.169%2040.363%2C1.107%20C40.315%2C0.758%2040.311%2C0.36%2040.295%2C0.188%20C40.141%2C0.188%2039.874%2C0.051%2039.336%2C0.051%20C38.923%2C0.051%2038.53%2C0.142%2038.202%2C0.353%20C37.619%2C0.736%2037.349%2C1.363%2037.349%2C2.076%20C37.349%2C2.897%2037.736%2C3.53%2038.303%2C3.799%20C38.648%2C3.958%2038.927%2C3.998%2039.259%2C3.998%20C39.53%2C3.998%2039.947%2C3.923%2040.117%2C3.861%20C40.248%2C3.81%2040.373%2C3.793%2040.456%2C3.775%20C40.483%2C3.758%2040.49%2C3.662%2040.471%2C3.639%20C40.378%2C3.616%2040.369%2C3.502%2040.369%2C3.262%20L40.369%2C2.942%22%20id%3D%22Fill-25%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M44.781%2C1.573%20C44.781%2C1.112%2044.801%2C0.685%2044.854%2C0.53%20C44.897%2C0.411%2044.988%2C0.377%2045.115%2C0.342%20L45.203%2C0.324%20C45.242%2C0.279%2045.232%2C0.16%2045.203%2C0.125%20C45.015%2C0.137%2044.84%2C0.142%2044.659%2C0.142%20C44.461%2C0.142%2044.272%2C0.137%2044.01%2C0.125%20C43.98%2C0.16%2043.973%2C0.279%2044.01%2C0.324%20L44.141%2C0.348%20C44.272%2C0.377%2044.381%2C0.411%2044.422%2C0.53%20C44.476%2C0.685%2044.496%2C1.112%2044.496%2C1.573%20L44.496%2C2.36%20C44.496%2C2.463%2044.496%2C2.561%2044.476%2C2.617%20C44.365%2C2.486%2044.228%2C2.287%2044.01%2C1.99%20L43.603%2C1.425%20C43.165%2C0.816%2042.854%2C0.382%2042.802%2C0.125%20C42.701%2C0.137%2042.562%2C0.142%2042.395%2C0.142%20C42.198%2C0.142%2041.955%2C0.137%2041.727%2C0.125%20C41.679%2C0.142%2041.674%2C0.279%2041.706%2C0.324%20L41.843%2C0.348%20C42.013%2C0.388%2042.087%2C0.445%2042.12%2C0.542%20C42.154%2C0.622%2042.154%2C0.713%2042.154%2C1.027%20L42.154%2C2.476%20C42.154%2C2.937%2042.134%2C3.364%2042.087%2C3.519%20C42.041%2C3.639%2041.95%2C3.672%2041.818%2C3.707%20L41.737%2C3.725%20C41.697%2C3.77%2041.706%2C3.889%2041.737%2C3.923%20C41.92%2C3.913%2042.101%2C3.907%2042.279%2C3.907%20C42.474%2C3.907%2042.668%2C3.913%2042.929%2C3.923%20C42.959%2C3.889%2042.968%2C3.77%2042.929%2C3.725%20L42.793%2C3.701%20C42.668%2C3.672%2042.556%2C3.639%2042.512%2C3.519%20C42.46%2C3.364%2042.44%2C2.937%2042.44%2C2.476%20L42.44%2C1.369%20C42.44%2C1.158%2042.44%2C1.06%2042.464%2C1.004%20C42.551%2C1.089%2042.715%2C1.323%2042.992%2C1.734%20L44.112%2C3.364%20C44.341%2C3.695%2044.5%2C3.986%2044.505%2C3.986%20C44.621%2C3.986%2044.758%2C3.923%2044.79%2C3.856%20C44.781%2C3.668%2044.781%2C3.308%2044.781%2C2.937%20L44.781%2C1.573%22%20id%3D%22Fill-26%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M47.399%2C0.976%20C47.399%2C0.439%2047.429%2C0.399%2047.652%2C0.353%20L47.787%2C0.324%20C47.827%2C0.291%2047.827%2C0.16%2047.787%2C0.125%20C47.527%2C0.137%2047.284%2C0.142%2047.057%2C0.142%20C46.824%2C0.142%2046.581%2C0.137%2046.319%2C0.125%20C46.28%2C0.16%2046.28%2C0.291%2046.319%2C0.324%20L46.454%2C0.353%20C46.678%2C0.399%2046.707%2C0.439%2046.707%2C0.976%20L46.707%2C3.074%20C46.707%2C3.61%2046.678%2C3.65%2046.454%2C3.695%20L46.319%2C3.725%20C46.28%2C3.758%2046.28%2C3.889%2046.319%2C3.923%20C46.581%2C3.913%2046.824%2C3.907%2047.057%2C3.907%20C47.284%2C3.907%2047.521%2C3.913%2047.781%2C3.923%20C47.821%2C3.889%2047.827%2C3.758%2047.787%2C3.725%20L47.652%2C3.695%20C47.429%2C3.65%2047.399%2C3.61%2047.399%2C3.074%20L47.399%2C0.976%22%20id%3D%22Fill-27%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M50.082%2C3.085%20C50.082%2C3.616%2050.054%2C3.656%2049.836%2C3.695%20L49.617%2C3.725%20C49.578%2C3.758%2049.578%2C3.889%2049.617%2C3.923%20C49.957%2C3.913%2050.208%2C3.907%2050.441%2C3.907%20C50.658%2C3.907%2050.901%2C3.913%2051.216%2C3.923%20C51.25%2C3.889%2051.25%2C3.758%2051.216%2C3.725%20L51.023%2C3.695%20C50.805%2C3.656%2050.776%2C3.616%2050.776%2C3.085%20L50.776%2C0.57%20C50.776%2C0.422%2050.789%2C0.405%2050.906%2C0.405%20L51.196%2C0.405%20C51.561%2C0.405%2051.627%2C0.673%2051.712%2C1.038%20C51.735%2C1.084%2051.867%2C1.072%2051.892%2C1.022%20C51.883%2C0.695%2051.915%2C0.233%2051.962%2C0.04%20C51.953%2C0.023%2051.919%2C0%2051.892%2C0%20C51.86%2C0%2051.846%2C0.005%2051.826%2C0.017%20C51.783%2C0.137%2051.712%2C0.142%2051.392%2C0.142%20L49.588%2C0.142%20C49.22%2C0.142%2049.204%2C0.119%2049.18%2C0.023%20C49.163%2C0.005%2049.137%2C0%2049.113%2C0%20C49.089%2C0%2049.065%2C0.011%2049.045%2C0.028%20C49.012%2C0.251%2048.986%2C0.604%2048.886%2C0.998%20C48.914%2C1.072%2049.007%2C1.084%2049.065%2C1.049%20C49.209%2C0.633%2049.312%2C0.405%2049.664%2C0.405%20L49.966%2C0.405%20C50.082%2C0.405%2050.082%2C0.434%2050.082%2C0.57%20L50.082%2C3.085%22%20id%3D%22Fill-28%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M54.124%2C0.976%20C54.124%2C0.439%2054.152%2C0.399%2054.374%2C0.353%20L54.509%2C0.324%20C54.549%2C0.291%2054.549%2C0.16%2054.509%2C0.125%20C54.247%2C0.137%2054.006%2C0.142%2053.778%2C0.142%20C53.546%2C0.142%2053.303%2C0.137%2053.04%2C0.125%20C53.001%2C0.16%2053.001%2C0.291%2053.04%2C0.324%20L53.176%2C0.353%20C53.399%2C0.399%2053.428%2C0.439%2053.428%2C0.976%20L53.428%2C3.074%20C53.428%2C3.61%2053.399%2C3.65%2053.176%2C3.695%20L53.04%2C3.725%20C53.001%2C3.758%2053.001%2C3.889%2053.04%2C3.923%20C53.303%2C3.913%2053.546%2C3.907%2053.778%2C3.907%20C54.006%2C3.907%2054.243%2C3.913%2054.505%2C3.923%20C54.544%2C3.889%2054.549%2C3.758%2054.509%2C3.725%20L54.374%2C3.695%20C54.152%2C3.65%2054.124%2C3.61%2054.124%2C3.074%20L54.124%2C0.976%22%20id%3D%22Fill-29%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M58.419%2C2.082%20C58.419%2C3.006%2058.17%2C3.735%2057.537%2C3.735%20C56.747%2C3.735%2056.537%2C2.617%2056.537%2C1.922%20C56.537%2C0.969%2056.857%2C0.313%2057.454%2C0.313%20C58.054%2C0.313%2058.419%2C1.107%2058.419%2C2.082%20Z%20M57.493%2C0.051%20C56.478%2C0.051%2055.762%2C0.923%2055.762%2C2.052%20C55.762%2C3.245%2056.47%2C3.998%2057.443%2C3.998%20C58.486%2C3.998%2059.194%2C3.251%2059.194%2C2.007%20C59.194%2C0.849%2058.501%2C0.051%2057.493%2C0.051%20Z%22%20id%3D%22Fill-30%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M63.459%2C1.573%20C63.459%2C1.112%2063.477%2C0.685%2063.529%2C0.53%20C63.575%2C0.411%2063.667%2C0.377%2063.794%2C0.342%20L63.881%2C0.324%20C63.919%2C0.279%2063.911%2C0.16%2063.881%2C0.125%20C63.692%2C0.137%2063.517%2C0.142%2063.338%2C0.142%20C63.138%2C0.142%2062.95%2C0.137%2062.688%2C0.125%20C62.658%2C0.16%2062.649%2C0.279%2062.688%2C0.324%20L62.819%2C0.348%20C62.95%2C0.377%2063.056%2C0.411%2063.1%2C0.53%20C63.153%2C0.685%2063.172%2C1.112%2063.172%2C1.573%20L63.172%2C2.36%20C63.172%2C2.463%2063.172%2C2.561%2063.153%2C2.617%20C63.043%2C2.486%2062.905%2C2.287%2062.688%2C1.99%20L62.282%2C1.425%20C61.845%2C0.816%2061.528%2C0.382%2061.481%2C0.125%20C61.38%2C0.137%2061.238%2C0.142%2061.074%2C0.142%20C60.874%2C0.142%2060.633%2C0.137%2060.405%2C0.125%20C60.355%2C0.142%2060.352%2C0.279%2060.384%2C0.324%20L60.52%2C0.348%20C60.691%2C0.388%2060.763%2C0.445%2060.797%2C0.542%20C60.831%2C0.622%2060.831%2C0.713%2060.831%2C1.027%20L60.831%2C2.476%20C60.831%2C2.937%2060.812%2C3.364%2060.763%2C3.519%20C60.72%2C3.639%2060.628%2C3.672%2060.496%2C3.707%20L60.414%2C3.725%20C60.375%2C3.77%2060.384%2C3.889%2060.414%2C3.923%20C60.599%2C3.913%2060.778%2C3.907%2060.958%2C3.907%20C61.15%2C3.907%2061.346%2C3.913%2061.606%2C3.923%20C61.634%2C3.889%2061.645%2C3.77%2061.606%2C3.725%20L61.471%2C3.701%20C61.346%2C3.672%2061.232%2C3.639%2061.19%2C3.519%20C61.137%2C3.364%2061.118%2C2.937%2061.118%2C2.476%20L61.118%2C1.369%20C61.118%2C1.158%2061.118%2C1.06%2061.142%2C1.004%20C61.228%2C1.089%2061.395%2C1.323%2061.669%2C1.734%20L62.79%2C3.364%20C63.018%2C3.695%2063.177%2C3.986%2063.183%2C3.986%20C63.299%2C3.986%2063.436%2C3.923%2063.47%2C3.856%20C63.459%2C3.668%2063.459%2C3.308%2063.459%2C2.937%20L63.459%2C1.573%22%20id%3D%22Fill-31%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.453%2C35.479%20C3.949%2C35.479%203.455%2C35.648%203.112%2C35.986%20C2.778%2C36.311%202.526%2C36.8%202.526%2C37.496%20C2.526%2C38.202%202.791%2C38.676%203.141%2C38.988%20C3.484%2C39.292%203.969%2C39.421%204.443%2C39.421%20C4.822%2C39.421%205.165%2C39.297%205.426%2C39.21%20C5.494%2C39.08%205.576%2C38.738%205.611%2C38.316%20C5.582%2C38.248%205.465%2C38.231%205.426%2C38.275%20C5.296%2C38.663%205.025%2C39.159%204.438%2C39.159%20C3.857%2C39.159%203.3%2C38.55%203.3%2C37.417%20C3.3%2C36.282%203.876%2C35.741%204.415%2C35.741%20C4.884%2C35.741%205.194%2C36.027%205.325%2C36.557%20C5.359%2C36.608%205.489%2C36.584%205.51%2C36.517%20C5.465%2C36.186%205.451%2C35.731%205.451%2C35.626%20C5.306%2C35.614%204.947%2C35.479%204.453%2C35.479%22%20id%3D%22Fill-32%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.072%2C37.507%20C11.072%2C38.43%2010.825%2C39.159%2010.191%2C39.159%20C9.401%2C39.159%209.193%2C38.043%209.193%2C37.349%20C9.193%2C36.396%209.513%2C35.741%2010.108%2C35.741%20C10.709%2C35.741%2011.072%2C36.533%2011.072%2C37.507%20Z%20M10.147%2C35.479%20C9.135%2C35.479%208.418%2C36.35%208.418%2C37.478%20C8.418%2C38.671%209.125%2C39.421%2010.098%2C39.421%20C11.14%2C39.421%2011.847%2C38.676%2011.847%2C37.434%20C11.847%2C36.277%2011.155%2C35.479%2010.147%2C35.479%20Z%22%20id%3D%22Fill-33%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.874%2C36.106%20C15.883%2C35.832%2015.883%2C35.815%2016.083%2C35.815%20C16.459%2C35.815%2016.717%2C36.146%2016.717%2C36.658%20C16.717%2C36.994%2016.625%2C37.176%2016.543%2C37.274%20C16.45%2C37.382%2016.349%2C37.434%2016.175%2C37.434%20C15.889%2C37.434%2015.874%2C37.417%2015.874%2C37.216%20L15.874%2C36.106%20Z%20M15.21%2C38.51%20C15.21%2C39.035%2015.182%2C39.073%2014.964%2C39.118%20L14.833%2C39.149%20C14.794%2C39.176%2014.794%2C39.313%2014.833%2C39.348%20C15.085%2C39.337%2015.298%2C39.33%2015.541%2C39.33%20C15.773%2C39.33%2015.995%2C39.337%2016.252%2C39.348%20C16.286%2C39.313%2016.286%2C39.176%2016.252%2C39.149%20L16.122%2C39.118%20C15.903%2C39.073%2015.874%2C39.035%2015.874%2C38.51%20L15.874%2C37.811%20C15.874%2C37.695%2015.883%2C37.684%2016.053%2C37.684%20C16.175%2C37.684%2016.252%2C37.729%2016.31%2C37.884%20C16.421%2C38.186%2016.533%2C38.465%2016.688%2C38.766%20C16.901%2C39.176%2017.182%2C39.364%2017.628%2C39.364%20C17.776%2C39.364%2017.933%2C39.353%2018.009%2C39.313%20C18.035%2C39.278%2018.035%2C39.194%2017.991%2C39.164%20C17.918%2C39.159%2017.792%2C39.124%2017.666%2C39.005%20C17.434%2C38.772%2017.235%2C38.345%2016.915%2C37.581%20C16.892%2C37.519%2016.892%2C37.485%2016.94%2C37.455%20C17.163%2C37.325%2017.453%2C37.107%2017.453%2C36.603%20C17.453%2C36.236%2017.308%2C35.951%2017.027%2C35.758%20C16.842%2C35.626%2016.489%2C35.552%2016.078%2C35.552%20C15.617%2C35.552%2015.239%2C35.576%2014.876%2C35.604%20C14.819%2C35.633%2014.819%2C35.775%2014.867%2C35.804%20L14.998%2C35.826%20C15.202%2C35.861%2015.21%2C35.924%2015.21%2C36.492%20L15.21%2C38.51%20Z%22%20id%3D%22Fill-34%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M21.04%2C38.51%20C21.04%2C39.04%2021.01%2C39.08%2020.792%2C39.124%20L20.657%2C39.154%20C20.604%2C39.182%2020.614%2C39.313%2020.666%2C39.348%20C20.929%2C39.337%2021.161%2C39.33%2021.393%2C39.33%20C21.626%2C39.33%2021.863%2C39.337%2022.134%2C39.348%20C22.187%2C39.313%2022.187%2C39.182%2022.134%2C39.154%20L21.979%2C39.124%20C21.761%2C39.08%2021.733%2C39.04%2021.733%2C38.51%20L21.733%2C36.106%20C21.733%2C35.878%2021.742%2C35.815%2021.921%2C35.815%20C22.357%2C35.815%2022.541%2C36.271%2022.541%2C36.693%20C22.541%2C37.113%2022.458%2C37.451%2022.056%2C37.598%20C22.022%2C37.633%2022.032%2C37.725%2022.071%2C37.753%20C22.125%2C37.759%2022.167%2C37.759%2022.226%2C37.759%20C22.482%2C37.759%2023.282%2C37.62%2023.282%2C36.687%20C23.282%2C36.136%2022.986%2C35.832%2022.691%2C35.7%20C22.488%2C35.61%2022.216%2C35.552%2021.805%2C35.552%20C21.383%2C35.552%2021.005%2C35.576%2020.687%2C35.604%20C20.632%2C35.643%2020.632%2C35.77%2020.676%2C35.799%20L20.827%2C35.821%20C21.03%2C35.856%2021.04%2C35.917%2021.04%2C36.492%20L21.04%2C38.51%22%20id%3D%22Fill-35%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M28.856%2C37.507%20C28.856%2C38.43%2028.608%2C39.159%2027.975%2C39.159%20C27.185%2C39.159%2026.977%2C38.043%2026.977%2C37.349%20C26.977%2C36.396%2027.296%2C35.741%2027.892%2C35.741%20C28.492%2C35.741%2028.856%2C36.533%2028.856%2C37.507%20Z%20M27.93%2C35.479%20C26.918%2C35.479%2026.201%2C36.35%2026.201%2C37.478%20C26.201%2C38.671%2026.908%2C39.421%2027.882%2C39.421%20C28.924%2C39.421%2029.63%2C38.676%2029.63%2C37.434%20C29.63%2C36.277%2028.938%2C35.479%2027.93%2C35.479%20Z%22%20id%3D%22Fill-36%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M33.657%2C36.106%20C33.668%2C35.832%2033.668%2C35.815%2033.864%2C35.815%20C34.243%2C35.815%2034.501%2C36.146%2034.501%2C36.658%20C34.501%2C36.994%2034.408%2C37.176%2034.326%2C37.274%20C34.235%2C37.382%2034.133%2C37.434%2033.958%2C37.434%20C33.673%2C37.434%2033.657%2C37.417%2033.657%2C37.216%20L33.657%2C36.106%20Z%20M32.994%2C38.51%20C32.994%2C39.035%2032.964%2C39.073%2032.747%2C39.118%20L32.616%2C39.149%20C32.578%2C39.176%2032.578%2C39.313%2032.616%2C39.348%20C32.868%2C39.337%2033.082%2C39.33%2033.324%2C39.33%20C33.557%2C39.33%2033.778%2C39.337%2034.036%2C39.348%20C34.07%2C39.313%2034.07%2C39.176%2034.036%2C39.149%20L33.904%2C39.118%20C33.687%2C39.073%2033.657%2C39.035%2033.657%2C38.51%20L33.657%2C37.811%20C33.657%2C37.695%2033.668%2C37.684%2033.836%2C37.684%20C33.958%2C37.684%2034.036%2C37.729%2034.094%2C37.884%20C34.204%2C38.186%2034.314%2C38.465%2034.472%2C38.766%20C34.685%2C39.176%2034.966%2C39.364%2035.41%2C39.364%20C35.562%2C39.364%2035.715%2C39.353%2035.792%2C39.313%20C35.815%2C39.278%2035.815%2C39.194%2035.774%2C39.164%20C35.701%2C39.159%2035.576%2C39.124%2035.448%2C39.005%20C35.217%2C38.772%2035.018%2C38.345%2034.699%2C37.581%20C34.675%2C37.519%2034.675%2C37.485%2034.725%2C37.455%20C34.946%2C37.325%2035.236%2C37.107%2035.236%2C36.603%20C35.236%2C36.236%2035.091%2C35.951%2034.811%2C35.758%20C34.626%2C35.626%2034.272%2C35.552%2033.861%2C35.552%20C33.4%2C35.552%2033.022%2C35.576%2032.659%2C35.604%20C32.601%2C35.633%2032.601%2C35.775%2032.649%2C35.804%20L32.781%2C35.826%20C32.984%2C35.861%2032.994%2C35.924%2032.994%2C36.492%20L32.994%2C38.51%20Z%22%20id%3D%22Fill-37%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M39.395%2C37.74%20C39.272%2C37.74%2039.243%2C37.725%2039.294%2C37.569%20L39.413%2C37.142%20C39.486%2C36.88%2039.564%2C36.641%2039.611%2C36.517%20C39.656%2C36.637%2039.718%2C36.869%2039.787%2C37.113%20L39.914%2C37.575%20C39.956%2C37.725%2039.928%2C37.74%2039.815%2C37.74%20L39.395%2C37.74%20Z%20M39.841%2C38.043%20C40.01%2C38.043%2040.049%2C38.054%2040.072%2C38.146%20L40.203%2C38.634%20C40.261%2C38.846%2040.295%2C38.982%2040.295%2C39.023%20C40.295%2C39.057%2040.276%2C39.096%2040.166%2C39.118%20L40.01%2C39.149%20C39.956%2C39.194%2039.965%2C39.313%2040.019%2C39.348%20C40.243%2C39.337%2040.432%2C39.33%2040.675%2C39.33%20C40.926%2C39.33%2041.186%2C39.337%2041.42%2C39.348%20C41.462%2C39.313%2041.453%2C39.176%2041.424%2C39.149%20L41.239%2C39.114%20C41.062%2C39.073%2041.017%2C38.948%2040.915%2C38.606%20L40.257%2C36.374%20C40.137%2C35.97%2040.076%2C35.758%2040.038%2C35.594%20C40.019%2C35.507%2039.99%2C35.479%2039.928%2C35.479%20C39.918%2C35.479%2039.738%2C35.758%2039.506%2C35.821%20C39.521%2C35.986%2039.435%2C36.186%2039.317%2C36.545%20L38.88%2C37.935%20C38.751%2C38.345%2038.669%2C38.618%2038.582%2C38.846%20C38.504%2C39.069%2038.401%2C39.114%2038.286%2C39.131%20L38.155%2C39.149%20C38.12%2C39.194%2038.115%2C39.313%2038.168%2C39.348%20C38.392%2C39.348%2038.504%2C39.33%2038.669%2C39.33%20C38.872%2C39.337%2039.066%2C39.337%2039.234%2C39.348%20C39.282%2C39.319%2039.272%2C39.188%2039.243%2C39.149%20L39.1%2C39.118%20C38.965%2C39.091%2038.925%2C39.057%2038.925%2C39.023%20C38.925%2C38.977%2038.93%2C38.932%2038.959%2C38.819%20L39.138%2C38.157%20C39.168%2C38.05%2039.182%2C38.043%2039.298%2C38.043%20L39.841%2C38.043%20Z%22%20id%3D%22Fill-38%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M44.798%2C38.51%20C44.798%2C39.04%2044.769%2C39.08%2044.55%2C39.118%20L44.332%2C39.149%20C44.294%2C39.182%2044.294%2C39.313%2044.332%2C39.348%20C44.67%2C39.337%2044.924%2C39.33%2045.155%2C39.33%20C45.374%2C39.33%2045.616%2C39.337%2045.932%2C39.348%20C45.965%2C39.313%2045.965%2C39.182%2045.932%2C39.149%20L45.737%2C39.118%20C45.518%2C39.08%2045.49%2C39.04%2045.49%2C38.51%20L45.49%2C35.997%20C45.49%2C35.849%2045.503%2C35.832%2045.62%2C35.832%20L45.91%2C35.832%20C46.273%2C35.832%2046.344%2C36.1%2046.424%2C36.464%20C46.45%2C36.512%2046.579%2C36.5%2046.604%2C36.447%20C46.594%2C36.122%2046.629%2C35.661%2046.676%2C35.468%20C46.666%2C35.451%2046.633%2C35.428%2046.604%2C35.428%20C46.575%2C35.428%2046.56%2C35.433%2046.54%2C35.444%20C46.497%2C35.565%2046.424%2C35.569%2046.105%2C35.569%20L44.304%2C35.569%20C43.935%2C35.569%2043.922%2C35.548%2043.895%2C35.451%20C43.878%2C35.433%2043.854%2C35.428%2043.829%2C35.428%20C43.806%2C35.428%2043.781%2C35.439%2043.762%2C35.456%20C43.727%2C35.679%2043.704%2C36.031%2043.603%2C36.425%20C43.63%2C36.5%2043.724%2C36.512%2043.781%2C36.476%20C43.926%2C36.06%2044.029%2C35.832%2044.382%2C35.832%20L44.681%2C35.832%20C44.798%2C35.832%2044.798%2C35.861%2044.798%2C35.997%20L44.798%2C38.51%22%20id%3D%22Fill-39%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M50.541%2C36.402%20C50.541%2C35.866%2050.571%2C35.826%2050.794%2C35.78%20L50.931%2C35.753%20C50.968%2C35.719%2050.968%2C35.588%2050.931%2C35.552%20C50.669%2C35.565%2050.426%2C35.569%2050.199%2C35.569%20C49.966%2C35.569%2049.724%2C35.565%2049.462%2C35.552%20C49.423%2C35.588%2049.423%2C35.719%2049.462%2C35.753%20L49.598%2C35.78%20C49.821%2C35.826%2049.851%2C35.866%2049.851%2C36.402%20L49.851%2C38.498%20C49.851%2C39.035%2049.821%2C39.073%2049.598%2C39.118%20L49.462%2C39.149%20C49.423%2C39.182%2049.423%2C39.313%2049.462%2C39.348%20C49.724%2C39.337%2049.966%2C39.33%2050.199%2C39.33%20C50.426%2C39.33%2050.662%2C39.337%2050.924%2C39.348%20C50.964%2C39.313%2050.968%2C39.182%2050.931%2C39.149%20L50.794%2C39.118%20C50.571%2C39.073%2050.541%2C39.035%2050.541%2C38.498%20L50.541%2C36.402%22%20id%3D%22Fill-40%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M56.543%2C37.507%20C56.543%2C38.43%2056.296%2C39.159%2055.662%2C39.159%20C54.872%2C39.159%2054.665%2C38.043%2054.665%2C37.349%20C54.665%2C36.396%2054.982%2C35.741%2055.581%2C35.741%20C56.18%2C35.741%2056.543%2C36.533%2056.543%2C37.507%20Z%20M55.62%2C35.479%20C54.606%2C35.479%2053.891%2C36.35%2053.891%2C37.478%20C53.891%2C38.671%2054.598%2C39.421%2055.57%2C39.421%20C56.61%2C39.421%2057.318%2C38.676%2057.318%2C37.434%20C57.318%2C36.277%2056.626%2C35.479%2055.62%2C35.479%20Z%22%20id%3D%22Fill-41%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M63.288%2C37%20C63.288%2C36.539%2063.308%2C36.111%2063.361%2C35.958%20C63.404%2C35.838%2063.495%2C35.804%2063.62%2C35.77%20L63.71%2C35.753%20C63.748%2C35.707%2063.737%2C35.588%2063.71%2C35.552%20C63.519%2C35.565%2063.347%2C35.569%2063.166%2C35.569%20C62.968%2C35.569%2062.779%2C35.565%2062.518%2C35.552%20C62.486%2C35.588%2062.478%2C35.707%2062.518%2C35.753%20L62.649%2C35.775%20C62.779%2C35.804%2062.886%2C35.838%2062.929%2C35.958%20C62.983%2C36.111%2063.002%2C36.539%2063.002%2C37%20L63.002%2C37.786%20C63.002%2C37.89%2063.002%2C37.985%2062.983%2C38.043%20C62.87%2C37.91%2062.736%2C37.712%2062.518%2C37.417%20L62.111%2C36.852%20C61.675%2C36.242%2061.36%2C35.811%2061.312%2C35.552%20C61.21%2C35.565%2061.069%2C35.569%2060.905%2C35.569%20C60.706%2C35.569%2060.464%2C35.565%2060.237%2C35.552%20C60.19%2C35.569%2060.184%2C35.707%2060.218%2C35.753%20L60.352%2C35.775%20C60.521%2C35.815%2060.597%2C35.871%2060.628%2C35.97%20C60.664%2C36.049%2060.664%2C36.141%2060.664%2C36.451%20L60.664%2C37.9%20C60.664%2C38.361%2060.644%2C38.789%2060.597%2C38.944%20C60.553%2C39.063%2060.46%2C39.096%2060.33%2C39.131%20L60.246%2C39.149%20C60.207%2C39.194%2060.218%2C39.313%2060.246%2C39.348%20C60.43%2C39.337%2060.609%2C39.33%2060.789%2C39.33%20C60.983%2C39.33%2061.176%2C39.337%2061.437%2C39.348%20C61.469%2C39.313%2061.477%2C39.194%2061.437%2C39.149%20L61.301%2C39.124%20C61.176%2C39.096%2061.065%2C39.063%2061.022%2C38.944%20C60.969%2C38.789%2060.949%2C38.361%2060.949%2C37.9%20L60.949%2C36.795%20C60.949%2C36.584%2060.949%2C36.488%2060.973%2C36.429%20C61.06%2C36.517%2061.226%2C36.749%2061.501%2C37.159%20L62.62%2C38.789%20C62.847%2C39.118%2063.007%2C39.409%2063.011%2C39.409%20C63.127%2C39.409%2063.264%2C39.348%2063.296%2C39.278%20C63.288%2C39.091%2063.288%2C38.732%2063.288%2C38.361%20L63.288%2C37%22%20id%3D%22Fill-42%22%20fill%3D%22%23A26F5B%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E\");background-size:contain;background-repeat:no-repeat}"]
      });
    }
  }
  return EcaFooterBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFooterComponent = /*#__PURE__*/(() => {
  class EcaFooterComponent {
    static {
      this.DEFAULT_CONTACT_EMAIL = 'No email address is available.';
    }
    static {
      this.DEFAULT_CONTACT_PHONE = 'No phone number is available.';
    }
    static {
      this.DEFAULT_LOGO_VISIBILITY = 'visible';
    }
    constructor(appContextService, headerService, setupConfigurationService) {
      this.appContextService = appContextService;
      this.headerService = headerService;
      this.setupConfigurationService = setupConfigurationService;
      this.contactEmail = '';
      this.contactPhone = '';
      this.linkVisibility = 'visible';
    }
    ngOnInit() {
      this.headerService.initialized().pipe(filter(initialized => initialized), take(1), switchMapTo(this.appContextService.selectedProductCode$.pipe(switchMap(code => {
        if (!code) {
          return of([]);
        }
        return combineLatest([this.setupConfigurationService.getAttributeForClient(code, 'Customer Service Email'), this.setupConfigurationService.getAttributeForClient(code, 'Customer Service Phone'), this.setupConfigurationService.getAttributeForClient(code, 'Footer Logo Visibility')]);
      })))).subscribe(([email, phone, logo]) => {
        this.linkVisibility = email || phone ? 'visible' : 'hidden';
        const emailAttr = email ? email.value ? email.value.trim() : '' : '';
        const phoneAttr = phone ? phone.value ? phone.value.trim() : '' : '';
        const logoAttr = logo ? logo.value ? logo.value.trim() : '' : '';
        this.contactEmail = emailAttr || EcaFooterComponent.DEFAULT_CONTACT_EMAIL;
        this.contactPhone = phoneAttr || EcaFooterComponent.DEFAULT_CONTACT_PHONE;
        this.logoVisibility = logoAttr || EcaFooterComponent.DEFAULT_LOGO_VISIBILITY;
      });
    }
    static {
      this.ɵfac = function EcaFooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFooterComponent)(i0.ɵɵdirectiveInject(AppContextService), i0.ɵɵdirectiveInject(EcaHeaderService), i0.ɵɵdirectiveInject(EcaSetupConfigurationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaFooterComponent,
        selectors: [["eca-footer"]],
        decls: 1,
        vars: 4,
        consts: [[3, "contactEmail", "contactPhone", "logoVisibility", "linkVisibility"]],
        template: function EcaFooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "eca-footer-base", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("contactEmail", ctx.contactEmail)("contactPhone", ctx.contactPhone)("logoVisibility", ctx.logoVisibility)("linkVisibility", ctx.linkVisibility);
          }
        },
        dependencies: [EcaFooterBaseComponent]
      });
    }
  }
  return EcaFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFooterContactModalModule = /*#__PURE__*/(() => {
  class EcaFooterContactModalModule {
    static {
      this.ɵfac = function EcaFooterContactModalModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFooterContactModalModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaFooterContactModalModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule]
      });
    }
  }
  return EcaFooterContactModalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFooterBaseModule = /*#__PURE__*/(() => {
  class EcaFooterBaseModule {
    static {
      this.ɵfac = function EcaFooterBaseModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFooterBaseModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaFooterBaseModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FlexLayoutModule, EcaFooterContactModalModule, MatDialogModule]
      });
    }
  }
  return EcaFooterBaseModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFooterModule = /*#__PURE__*/(() => {
  class EcaFooterModule {
    static {
      this.ɵfac = function EcaFooterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFooterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaFooterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, EcaFooterBaseModule]
      });
    }
  }
  return EcaFooterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * rxjs operator to perform a pluck then distinctUntilChanged
 * @param property
 */
function select(property) {
  return o$ => {
    return o$.pipe(pluck(property), distinctUntilChanged());
  };
}

/**
 * rxjs operator to perform a null-safe version of distinctUntilKeyChanged
 * @param key
 */
function distinctUntilKeyChangedNullSafe(key) {
  return o$ => {
    return o$.pipe(distinctUntilChanged((a, b) => {
      if (a === b) {
        return true;
      }
      if (!Array.isArray(key)) {
        key = [key];
      }
      for (const k of key) {
        if (a && b && a[k] === b[k]) {
          continue;
        }
        return false;
      }
      return true;
    }));
  };
}
let EcaSessionTimeoutComponent = /*#__PURE__*/(() => {
  class EcaSessionTimeoutComponent {
    constructor(data) {
      this.data = data;
      this.timeElapsed = 0;
      this.timeRemaining = 0;
    }
    ngOnInit() {
      this.timeElapsed = this.data.elapsed;
      this.timeRemaining = this.data.remaining;
    }
    static {
      this.ɵfac = function EcaSessionTimeoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSessionTimeoutComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSessionTimeoutComponent,
        selectors: [["eca-session-timeout"]],
        decls: 12,
        vars: 4,
        consts: [["mat-dialog-title", ""], ["mat-dialog-content", ""], ["mat-dialog-actions", ""], ["mat-button", "", 3, "mat-dialog-close"], ["mat-button", "", "color", "primary", "cdkFocusInitial", "", 3, "mat-dialog-close"]],
        template: function EcaSessionTimeoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h3", 0);
            i0.ɵɵtext(1, " Activity Timer\n");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1)(3, "h4");
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "h4");
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 2)(8, "button", 3);
            i0.ɵɵtext(9, "Log Out");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "button", 4);
            i0.ɵɵtext(11, "Continue");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("Your browser has been idle for ", ctx.timeElapsed, " minutes.");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("Press Continue or your session will log out in ", ctx.timeRemaining, " minutes.");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", "logout");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", "continue");
          }
        },
        dependencies: [i1$3.MatDialogClose, i1$3.MatDialogTitle, i1$3.MatDialogActions, i1$3.MatDialogContent, i4.MatButton],
        styles: [".mat-mdc-dialog-actions[_ngcontent-%COMP%]{align-content:center;justify-content:flex-end}h4[_ngcontent-%COMP%]:first-child{margin-top:36px;margin-bottom:4px}h4[_ngcontent-%COMP%]:nth-child(2){margin-top:4px;margin-bottom:36px}"]
      });
    }
  }
  return EcaSessionTimeoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ActivityMonitorService = /*#__PURE__*/(() => {
  class ActivityMonitorService {
    static {
      this.ACTIVE = 'ACTIVE';
    }
    static {
      this.IDLE = 'IDLE';
    }
    static {
      this.EXPIRED = 'EXPIRED';
    }
    static {
      this.LOGGED_OUT = 'LOGGED_OUT';
    }
    constructor(dialog, ngZone) {
      this.dialog = dialog;
      this.ngZone = ngZone;
      this.DEFAULT_SESSION_IDLE_MINUTES = 20;
      this.DEFAULT_MODAL_IDLE_MINUTES = 10;
      this.allUserEvents$ = merge(...['mousemove', 'keydown', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart'].map(event => fromEvent(document.body, event)));
    }
    get sessionIdleMinutes() {
      const override = localStorage.getItem('ngStorage-ecaSessionIdleMinutes');
      return override ? parseFloat(override) : this.DEFAULT_SESSION_IDLE_MINUTES;
    }
    get modalIdleMinutes() {
      const override = localStorage.getItem('ngStorage-ecaModalIdleMinutes');
      return override ? parseFloat(override) : this.DEFAULT_MODAL_IDLE_MINUTES;
    }
    get userState() {
      this.startMonitoring();
      return this.userActivity$.asObservable();
    }
    startMonitoring() {
      if (this.subscription && !this.subscription.closed) {
        return false;
      }
      this.userActivity$ = new BehaviorSubject(ActivityMonitorService.ACTIVE);
      this.subscription = this.allUserEvents$.pipe(startWith(true), debounceTime(this.sessionIdleMinutes * 60000), switchMap(() => this.inactivityModal())).subscribe(state => {
        // Need to run this in an NgZone, otherwise header-element acts very weird (see https://datarecognitioncorp.atlassian.net/browse/ED-4564)
        this.ngZone.run(() => {
          this.userActivity$.next(state);
        });
      });
      return true;
    }
    stopMonitoring() {
      if (this.subscription && !this.subscription.closed) {
        this.subscription.unsubscribe();
      }
      if (this.userActivity$ && !this.userActivity$.closed) {
        this.userActivity$.complete();
      }
    }
    setIdleTimes(sessionIdleMinutes, modalIdleMinutes) {
      this.DEFAULT_SESSION_IDLE_MINUTES = sessionIdleMinutes;
      this.DEFAULT_MODAL_IDLE_MINUTES = modalIdleMinutes;
      this.stopMonitoring();
      this.startMonitoring();
    }
    inactivityModal() {
      let dialogRef;
      // Need to run this in an NgZone, otherwise header-element acts very weird (see https://datarecognitioncorp.atlassian.net/browse/ED-4564)
      this.ngZone.run(() => {
        dialogRef = this.dialog.open(EcaSessionTimeoutComponent, {
          position: {
            top: '70px'
          },
          data: {
            elapsed: this.sessionIdleMinutes,
            remaining: this.modalIdleMinutes
          },
          disableClose: true
        });
      });
      // Race user clicking on the modal (continue/logout) with a second idle timer; first of the two to emit an event 'wins'
      return race(dialogRef.afterClosed().pipe(map(result => result === 'continue' ? ActivityMonitorService.ACTIVE : ActivityMonitorService.LOGGED_OUT)), timer(this.modalIdleMinutes * 60000).pipe(tap(() => dialogRef.close()), mapTo(ActivityMonitorService.EXPIRED))).pipe(startWith(ActivityMonitorService.IDLE)); // Do we need idle to be emitted?;
    }
    static {
      this.ɵfac = function ActivityMonitorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ActivityMonitorService)(i0.ɵɵinject(i1$3.MatDialog), i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ActivityMonitorService,
        factory: ActivityMonitorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ActivityMonitorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSecurityService = /*#__PURE__*/(() => {
  class EcaSecurityService {
    constructor(apiGatewayService, appContextService, activityMonitorService, urlService, windowService) {
      this.apiGatewayService = apiGatewayService;
      this.appContextService = appContextService;
      this.activityMonitorService = activityMonitorService;
      this.urlService = urlService;
      this.windowService = windowService;
      this.logoutTasks = [];
      this.TOKEN_REFRESH_MARGIN = 5 * 60; // five minutes (in s)
      this.userReplay$ = this.getUserReplay();
    }
    handleUserActivity() {
      return this.isUserLoggedIn.pipe(switchMap(isLoggedIn => {
        if (isLoggedIn) {
          return this.activityMonitorService.userState.pipe(filter(state => state === ActivityMonitorService.EXPIRED || state === ActivityMonitorService.LOGGED_OUT), switchMap(state => this.logout(state === ActivityMonitorService.EXPIRED)));
        } else {
          // if the user is logged out, there is nothing to do here
          // complete the inner observable and wait for the next change to isUserLoggedIn
          return EMPTY;
        }
      }));
    }
    get isUserLoggedIn() {
      return this.appContextService.token$.pipe(map(token => !!token), distinctUntilChanged());
    }
    startTokenRefresh() {
      return this.appContextService.token$.pipe(
      // NOTE to future self:
      //   You might consider filtering out null tokens here.
      //   DON'T! That leaves the previous token-delay-refresh stream running which is bad for everyone
      switchMap(token => this.waitForTokenToMature(token)), switchMap(token => this.refreshToken(token)));
    }
    /**
     * calculate the ideal time to refresh token and delay until then
     * i.e. <TOKEN_REFRESH_MARGIN> seconds before expiry
     * @param token
     */
    waitForTokenToMature(token) {
      const time = this.calculateTokenWaitTime(token);
      if (time >= 0) {
        return of(token).pipe(delay(time));
      } else {
        // if token is null or invalid, we have nothing to wait for
        // kill this inner stream so refreshToken is not called
        return EMPTY;
      }
    }
    calculateTokenWaitTime(token) {
      try {
        const {
          exp
        } = new JwtHelperService().decodeToken(token); // in s
        const now = new Date().getTime() / 1000; // in s
        const timeLeft = Math.round(exp - now); // time left until token expires, in s
        const waitTime = Math.max(timeLeft - this.TOKEN_REFRESH_MARGIN, 0);
        return waitTime * 1000;
      } catch {
        return -1;
      }
    }
    /**
     * Refreshes the token by exchanging the current one for a new token
     * There is a slim chance eca-components-lib consumers need to call this since the eca-header schedules regular token refreshes.
     */
    refreshToken(token) {
      const data = JSON.stringify({
        token: token
      });
      const tag = this.apiGatewayService.makeApiConfigString();
      const options = {
        forceEcaToken: true
      };
      return this.apiGatewayService.post(`eca-security-service/${tag}/v0/refresh`, data, options).pipe(tap(response => {
        this.appContextService.setToken(response.token);
        this.appContextService.setUserId(response.uid);
      }), map(response => response.token));
    }
    authenticateCredentials(username, password) {
      const data = {
        username: username,
        password: password
      };
      const apiConfig = this.apiGatewayService.makeApiConfigString();
      const url = `eca-security-service/${apiConfig}/v0/authenticate/`;
      return this.apiGatewayService.post(url, data, {
        includeToken: false
      }).pipe(switchMap(response => {
        this.appContextService.setToken(response.token);
        this.appContextService.setUserId(response.uid);
        this.apiGatewayService.userToken = response.token;
        return this.getUserForId(response.uid).pipe(map(user => ({
          ...user,
          token: response.token
        })));
      }));
    }
    authenticateToken(token) {
      if (!token) {
        return throwError('no token specified');
      }
      const apiConfig = this.apiGatewayService.makeApiConfigString();
      const url = `eca-security-service/${apiConfig}/v0/authenticate/${token}`;
      return this.apiGatewayService.get(url, {
        includeToken: false
      }).pipe(tap(response => this.appContextService.setUserId(response.sub)), catchError(error => {
        this.appContextService.setUserId(null);
        return throwError(error);
      }));
    }
    getUserReplay() {
      return this.appContextService.token$.pipe(distinctUntilChanged(), switchMap(token => {
        if (token) {
          return this.getUserForToken(token).pipe(catchError(error => {
            console.error('eca-security-service: ', error);
            return of(null);
          }));
        } else {
          return of(null);
        }
      }), distinctUntilKeyChangedNullSafe(['userId', 'firstName', 'middleName', 'lastName', 'email', 'username']), shareReplay(1));
    }
    get user$() {
      return this.userReplay$;
    }
    getUser() {
      return this.appContextService.getToken().pipe(switchMap(token => this.getUserForToken(token)));
    }
    getUserForId(userId) {
      const apiConfig = this.apiGatewayService.makeApiConfigString();
      const url = `eca-security-service/${apiConfig}/v0/user/${userId}`;
      const options = {
        cache: {
          key: this.getUserCacheKey(userId)
        },
        forceEcaToken: true
      };
      return this.apiGatewayService.get(url, options);
    }
    getUserForToken(token) {
      return this.authenticateToken(token).pipe(switchMap(response => this.getUserForId(response.sub)));
    }
    getToken() {
      return this.appContextService.getToken();
    }
    getAcl() {
      return this.user$.pipe(map(user => user.allow), take(1));
    }
    isAuthenticated() {
      return this.user$.pipe(map(user => !!user), take(1));
    }
    /**
     * Checks to see if the current user has the given permission
     * @param ace a string or string array representing a certain permission ace; example: 'DRCPORTAL:portal:view'
     * @returns true (as Observable) if the user has the permission, false as Observable otherwise
     */
    userHasPermission(ace) {
      if (!Array.isArray(ace)) {
        ace = [ace];
      }
      return this.user$.pipe(map(user => {
        if (!user) {
          return false;
        }
        // Check if user has an exact match, else look for wildcards
        if (user.allow.filter(item => ace.includes(item)).length !== 0) {
          return true;
        }
        let matched = false;
        for (let i = 0; i < ace.length; i++) {
          // no exact match found, consider wildcard permissions
          const aceParts = ace[i].split(':');
          const matches = user.allow.filter(item => {
            const itemParts = item.split(':');
            if (itemParts.length !== aceParts.length) {
              return false;
            }
            let keepIt = true;
            itemParts.forEach((itemPart, index) => {
              if (itemPart !== '*' && itemPart !== aceParts[index]) {
                keepIt = false;
              }
            });
            return keepIt;
          });
          if (matches.length !== 0) {
            matched = true;
            break;
          }
        }
        return matched;
      }), take(1));
    }
    /**
     * register some code to be called before the logout process begins
     * @param task can be an Observable sequence or a function that returns an observable sequence or a function that returns a promise
     */
    registerLogoutTask(task) {
      this.logoutTasks.push(task);
    }
    logout(timeout = false) {
      const performLogout = () => this.appContextService.getSelectedProductCode().pipe(map(productCode => {
        // snag the portal URL before we clear everything out of session storage
        let url = `${this.appContextService.getPortalUrl()}/#/logout`;
        if (productCode) {
          url += `/${productCode}`;
        }
        if (timeout) {
          url += '?timeout=true';
        }
        if (!this.urlService.isSameOrigin(url)) {
          this.appContextService.setToken(null);
          sessionStorage.clear();
        }
        this.windowService.navigateTo(url);
        return url;
      }));
      if (this.logoutTasks.length > 0) {
        // if any tasks are wrapped in a function, invoke the function to get to the task
        this.logoutTasks = this.logoutTasks.map(task => {
          let taskObservable;
          if (task instanceof Function) {
            taskObservable = from(task());
          } else {
            taskObservable = from(task);
          }
          return taskObservable.pipe(catchError(e => {
            // Log error from task
            console.error('Failed to perform logout task: ', e);
            return of(null);
          }));
        });
        return forkJoin(this.logoutTasks).pipe(switchMap(performLogout));
      } else {
        return performLogout();
      }
    }
    getUserCacheKey(userId) {
      return `${this.apiGatewayService.config.apiGatewayUrl}/eca-security-service/v0/user/${userId}`;
    }
    static {
      this.ɵfac = function EcaSecurityService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSecurityService)(i0.ɵɵinject(ApiGatewayService), i0.ɵɵinject(AppContextService), i0.ɵɵinject(ActivityMonitorService), i0.ɵɵinject(UrlService), i0.ɵɵinject(WindowService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaSecurityService,
        factory: EcaSecurityService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaSecurityService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteService = /*#__PURE__*/(() => {
  class EcaSiteService {
    constructor(apiGatewayService, appContextService, securityService) {
      this.apiGatewayService = apiGatewayService;
      this.appContextService = appContextService;
      this.securityService = securityService;
      this.DrcPortalPermission = 'DRCPORTAL:portal:view';
    }
    searchSites(siteSearchRequest, combineSiteHierarchy = true, apiVersion) {
      const url = `${this.getFullUrl(apiVersion)}/site/search`;
      const options = {
        forceEcaToken: true
      };
      return this.apiGatewayService.post(url, siteSearchRequest, options).pipe(map(data => {
        if (!data || !data.sites) {
          return [];
        }
        return combineSiteHierarchy ? this.combineSitesHierarchies(data) : this.transformSiteHierarchy(data);
      }));
    }
    /**
     * returns the last site in a hierarchy, plus parent info
     */
    searchHierarchy(hierarchyId, path, archived) {
      if (!hierarchyId || !path) {
        throw new Error('hierarchyId and path are required');
      }
      const url = `${this.getFullUrl()}/hierarchy/searchByPath`;
      const payload = {
        path: path,
        hierarchyId: hierarchyId,
        archived: archived
      };
      const options = {
        forceEcaToken: true
      };
      return this.apiGatewayService.post(url, payload, options).pipe(map(data => {
        if (!data || data.length === 0) {
          return null;
        }
        // need to walk down the hierarchy to find the last site
        let site = null;
        let parentSite = null;
        let stateCode = null;
        function siteFinder(hierarchyItem) {
          if (hierarchyItem.children && hierarchyItem.children.length > 0) {
            parentSite = hierarchyItem;
            if (parentSite.type === "state" /* SiteSearchSiteType.State */) {
              stateCode = parentSite.code;
            }
            siteFinder(hierarchyItem.children[0]);
          } else {
            site = hierarchyItem;
            return;
          }
        }
        siteFinder(data[0]);
        return {
          type: site.type,
          id: site.id,
          adminCode: site.admin_number,
          adminName: site.admin_name,
          parentSiteCode: parentSite.code,
          parentSiteName: parentSite.name,
          siteCode: site.code,
          siteName: site.name,
          createDate: site.create_date,
          updateDate: site.update_date,
          path: path,
          stateCode: stateCode
        };
      }));
    }
    /**
     * parentCodeOrId is polymorphic, it can be:
     *  client (eg. WIDA)
     *  State Code (eg. WA)
     *  State ID (eg.26309)
     *  District ID
     *
     * aclSuffix is optional, by default site service uses `site-service:site:view`
     *  apps may want the sites returned filtered, ex `eca-student-service:status:view`
     *
     * Note: Admins are NOT children of Schools so this will not return a list of Admins for a Site
     *
     * returns ChildSite
     */
    listChildren(parentCodeOrId, aclSuffix = '', clientAbbr = '', archived) {
      let url = `${this.getFullUrl()}/hierarchy/listChildren/${parentCodeOrId}`;
      // add the aclSuffix
      if (aclSuffix) {
        url += `?aclSuffix=${aclSuffix}`;
      }
      // add the client
      if (clientAbbr) {
        if (url.includes('?')) {
          url += `&client=${clientAbbr}`;
        } else {
          url += `?client=${clientAbbr}`;
        }
      }
      // add archived
      if (archived) {
        if (url.includes('?')) {
          url += `&archived=${archived}`;
        } else {
          url += `?archived=${archived}`;
        }
      }
      return this.apiGatewayService.get(url, {
        cache: true,
        forceEcaToken: true
      });
    }
    /**
     * Site Id (eg.26309)
     *
     * ToDo: Double Check this Note
     * Note: returns the current site as the first item through the top parent as the last item
     *
     * returns AncestorSite
     */
    listAncestors(siteId, archived) {
      const archivedSegment = archived ? `?archived=${archived}` : '';
      const url = `${this.getFullUrl()}/hierarchy/listAncestors/${siteId}${archivedSegment}`;
      return this.apiGatewayService.get(url, {
        cache: true,
        forceEcaToken: true
      });
    }
    /**
     * Client Abbreviation (eg.WIDA)
     *
     * Note: returns hierarchy template for a given client abbreviation
     * the template contains the type, title, and plural title for each level
     *
     * returns HierarchyTemplate
     */
    getHierarchyTemplateForClient(clientAbbr) {
      const url = `${this.getFullUrl()}/hierarchy/template/${clientAbbr}`;
      return this.apiGatewayService.get(url, {
        cache: true,
        forceEcaToken: true
      });
    }
    /**
     * Client Abbreviation (eg.WIDA)
     *
     * Note: returns the master site path and participating admin site paths for a given client
     *
     * returns ClientLevelSitePath
     */
    getClientLevelSitePath(clientAbbr, archived) {
      const archivedSegment = archived ? `?archived=${archived}` : '';
      const url = `${this.getFullUrl()}/site/client/${clientAbbr}${archivedSegment}`;
      return this.apiGatewayService.get(url, {
        cache: true,
        forceEcaToken: true
      });
    }
    /**
     * returns a payload for a site search request
     */
    getSiteSearchRequest(aclSpec, searchTerm, clientAbbr, siteType = "school" /* SiteSearchSiteType.School */, limit = 50, stateCode, leafOnly = false, masterSearch = false, archived) {
      if (!aclSpec || !searchTerm || !clientAbbr) {
        throw new Error('aclSuffix, searchTerm and clientAbbr are required');
      }
      return of(this.appContextService.getUserId()).pipe(switchMap(user => {
        // if no user id, then get the list of all products
        return user ? this.getProducts(user) : this.getAllProducts();
      }), map(products => {
        const client = products.find(client => client.abbreviation === clientAbbr);
        if (!client) {
          throw new Error('No client found');
        }
        const res = {};
        res.clientId = parseInt(client.id, 10);
        res.scopeBySiteType = siteType === "all" /* SiteSearchSiteType.All */ ? null : siteType;
        res.aclSuffix = aclSpec;
        res.search = searchTerm;
        res.limit = limit;
        res.stateCode = stateCode;
        res.leafOnly = leafOnly;
        res.masterSearch = masterSearch;
        res.archived = archived;
        return res;
      }));
    }
    /**
     * translates site service data into Site Objects
     */
    combineSitesHierarchies(data) {
      const sites = data.sites;
      const hierarchies = data.hierarchies;
      const hierarchyMap = new Map();
      for (const h of hierarchies) {
        hierarchyMap.set(h.hierarchy_id, h);
      }
      const results = [];
      for (const site of sites) {
        for (const siteHierarchy of site.hierarchies) {
          const hierarchy = hierarchyMap.get(siteHierarchy.hierarchy_id.toString());
          const sitePayload = {
            id: site.id,
            type: site.type,
            adminCode: hierarchy.admin_number,
            adminName: hierarchy.admin_name,
            adminCreateDate: hierarchy.create_date,
            adminUpdateDate: hierarchy.update_date,
            parentSiteCode: site.parent_site_code,
            parentSiteName: site.parent_site_name,
            siteCode: site.code,
            siteName: site.name,
            path: siteHierarchy.path
          };
          if (siteHierarchy.ace) {
            sitePayload.ace = siteHierarchy.ace;
          }
          results.push(sitePayload);
        }
      }
      return results;
    }
    /**
     * translates site service data into SiteSearchResult which has sites and hierarchies
     */
    transformSiteHierarchy(data) {
      const results = {
        hierarchies: [],
        sites: []
      };
      for (const hierarchy of data.hierarchies) {
        results.hierarchies.push({
          id: hierarchy.hierarchy_id,
          code: hierarchy.admin_code,
          name: hierarchy.subadmin_name ? hierarchy.subadmin_name : hierarchy.admin_name,
          number: hierarchy.subadmin_number ? hierarchy.subadmin_number : hierarchy.admin_number,
          createDate: hierarchy.create_date,
          updateDate: hierarchy.update_date
        });
      }
      for (const site of data.sites) {
        const hierarchies = site.hierarchies.map(hierarchy => {
          const hierarchyResult = {
            id: hierarchy.hierarchy_id,
            path: hierarchy.path
          };
          // ace is only included on API v2 requests
          if (hierarchy.ace) {
            hierarchyResult.ace = hierarchy.ace;
          }
          return hierarchyResult;
        });
        results.sites.push({
          id: site.id,
          code: site.code,
          name: site.name,
          type: site.type,
          parentSiteCode: site.parent_site_code,
          parentSiteId: site.parent_site_id,
          parentSiteName: site.parent_site_name,
          parentSiteType: site.parent_site_type,
          hierarchies: hierarchies
        });
      }
      return results;
    }
    getProducts(userId) {
      const url = `${this.getFullUrl()}/clients`;
      if (!userId) {
        userId = this.appContextService.getUserId();
      }
      // Sometimes a page is loaded in a new tab/window an is still processing so get the userid from the token
      if (!userId) {
        const token = this.appContextService['token'].getValue()?.split('.');
        if (token?.length) {
          userId = JSON.parse(atob(token[1])).sub;
        } else {
          return of(null);
        }
      }
      // Build the cache key by appending the userId to the url so that each user is cached uniquely
      const options = {
        cache: {
          key: `${url}:${userId}`
        },
        forceEcaToken: true
      };
      const productsFromApi$ = this.apiGatewayService.get(url, options);
      const drcInsight$ = this.getDrcInsightIfAllowed();
      // Concat the list of products from the api with the DRC Insight product (if any)
      return combineLatest([productsFromApi$, drcInsight$]).pipe(map(([productsFromApi, drcInsight]) => {
        return productsFromApi.concat(drcInsight);
      }));
    }
    getAllProducts() {
      const url = `${this.getFullUrl()}/clients/all`;
      const options = {
        forceEcaToken: true
      };
      return this.apiGatewayService.get(url, options);
    }
    getSelectedProduct() {
      return this.selectedProduct$.pipe(take(1));
    }
    get selectedProduct$() {
      return combineLatest([this.appContextService.selectedProductCode$, this.securityService.user$]).pipe(switchMap(([productCode, user]) => {
        if (!productCode || !user) {
          return of(null);
        } else {
          return this.getProducts(user.userId).pipe(map(products => {
            return products ? products.find(product => product.abbreviation === productCode) : null;
          }), catchError(error => {
            console.error('eca-site-service: ', error);
            return of(null);
          }));
        }
      }), shareReplay(1));
    }
    /**
     * Get the list of states for the passed Client
     * @param clientCode - not the id and not the abbreviation
     * @param aclSuffix
     * @param archived - tell whether to return archived sites
     */
    getStatesForClient(clientCode, aclSuffix, archived) {
      const url = `${this.getFullUrl()}/hierarchy/statesForClient`;
      const options = {
        forceEcaToken: true
      };
      return this.apiGatewayService.post(url, {
        clientCode: clientCode,
        aclSuffix: aclSuffix,
        archived: archived
      }, options).pipe(map(states => {
        const mappedStates = states.map(state => {
          return {
            code: state.state_code,
            name: state.state_name
          };
        });
        return mappedStates.sort((a, b) => {
          return a.code < b.code ? -1 : 1;
        });
      }));
    }
    /**
     * Check with the security service to see if the current user had permission for DRCPORTAL.
     * If yes, then a new Product for DRC INSIGHT will be inserted into the stream of API products.
     */
    getDrcInsightIfAllowed() {
      // make up a new product for DRC INSIGHT
      const DrcInsightProduct = {
        id: '0',
        name: 'DRC INSIGHT',
        abbreviation: 'DRCPORTAL',
        code: 'DRCPORTAL'
      };
      return this.securityService.userHasPermission(this.DrcPortalPermission).pipe(map(allowed => {
        return allowed ? [DrcInsightProduct] : [];
      }));
    }
    getSiteById(siteId, archived) {
      const archivedSegment = archived ? `?archived=${archived}` : '';
      const url = `${this.getFullUrl()}/site/find/${siteId}${archivedSegment}`;
      const options = {
        forceEcaToken: true
      };
      return this.apiGatewayService.get(url, options).pipe(map(response => response.site));
    }
    getFullUrl(apiVersion = 'v1') {
      // there's only a v1 of the service, but the search endpoint has a 'v2' specified for /site/search only
      const apiConfig = this.apiGatewayService.makeApiConfigString({
        version: 'v1'
      });
      return `${this.apiGatewayService.getCloudDomain()}/eca-site-service/${apiConfig}/${apiVersion}`;
    }
    smartSortHierarchies(a, b) {
      // determine the year
      a.year ??= this.extractLatestYear(a.label);
      b.year ??= this.extractLatestYear(b.label);
      // when years are equal consider the season
      if (a.year === b.year) {
        a.season ??= this.extractLatestSeason(a.label);
        b.season ??= this.extractLatestSeason(b.label);
        // when seasons are equal, sort alphabetically by name
        if (a.season === b.season) {
          return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1;
        }
        // sort by season
        return a.season < b.season ? 1 : -1;
      }
      // sort by year
      return a.year < b.year ? 1 : -1;
    }
    extractLatestSeason(str) {
      const lower = str.toLowerCase();
      if (lower.includes('fall')) {
        return 4;
      } else if (lower.includes('summer')) {
        return 3;
      } else if (lower.includes('spring')) {
        return 2;
      } else if (lower.includes('winter')) {
        return 1;
      } else {
        return 0;
      }
    }
    extractLatestYear(label) {
      // When admin has name LEAP 2025, 2025 should not be used as a year
      let str = label.replace('LEAP 2025', 'LEAP');
      const matches = [];
      const eightDigits = /\b(\d{4})-(\d{4})\b/g; // 2021-2022
      const sixDigits = /\b(\d{4})-(\d{2})\b/g; // 2021-22
      const fourDigits = /\b\d{4}\b/g; // 2022
      const twoDigits = /\b\d{2}\b/g; // 22
      // Find 8-digit years in the string. i.e. 2021-2022
      // We replace any matches we find with an empty string so that the 4-digit matcher doesn't find them too
      str = str.replace(eightDigits, (match, yearStart, yearEnd) => {
        matches.push((parseInt(yearStart, 10) + parseInt(yearEnd, 10)) / 2);
        return '';
      });
      // Find 6-digit years in the string. i.e.  2021-22
      // We replace any matches we find with an empty string so that the 4-digit and 2-digit matchers don't find them too
      str = str.replace(sixDigits, (match, yearStart, yearEnd) => {
        matches.push((parseInt(yearStart, 10) + 2000 + parseInt(yearEnd, 10)) / 2);
        return '';
      });
      // Find 4-digit years in the string, parse them as integers and add them to the matches array
      matches.push(...(str.match(fourDigits) ?? []).map(fourDigitYear => parseInt(fourDigitYear, 10)));
      // Find 2-digit years in the string, parse them as integers, add 2000 and add them to the matches array
      matches.push(...(str.match(twoDigits) ?? []).map(twoDigitYear => 2000 + parseInt(twoDigitYear, 10)));
      // Return the maximum year found across all of the searches
      return Math.max(...matches);
    }
    static {
      this.ɵfac = function EcaSiteService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteService)(i0.ɵɵinject(ApiGatewayService), i0.ɵɵinject(AppContextService), i0.ɵɵinject(EcaSecurityService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaSiteService,
        factory: EcaSiteService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaSiteService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMonotronComponent = /*#__PURE__*/(() => {
  class EcaMonotronComponent {
    constructor() {
      this.classes = 'eca-monotron';
    }
    static {
      this.ɵfac = function EcaMonotronComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMonotronComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaMonotronComponent,
        selectors: [["eca-monotron"]],
        hostVars: 2,
        hostBindings: function EcaMonotronComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes);
          }
        },
        ngContentSelectors: _c6,
        decls: 2,
        vars: 0,
        consts: [[1, "eca-monotron-wrapper"]],
        template: function EcaMonotronComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".eca-monotron .mat-mdc-tab-group,.eca-monotron .mat-mdc-tab-nav-bar{--mat-tab-header-active-label-text-color: var(--drc-white);--mat-tab-header-inactive-label-text-color: var(--drc-white);border-bottom:0;margin-bottom:0}.eca-monotron{width:100%;background-color:#545761;color:#fff;flex-direction:column;box-sizing:border-box;display:flex}.eca-monotron-wrapper{padding:20px 24px 44px;width:100%;max-width:1440px;flex:1 1 0;box-sizing:border-box;align-self:center}.eca-monotron-wrapper h1,.eca-monotron-wrapper h2,.eca-monotron-wrapper h3,.eca-monotron-wrapper h4,.eca-monotron-wrapper h5{color:#fff;margin:0 0 14px}.eca-monotron-wrapper li{color:#fff}.eca-monotron-wrapper h1{font-size:28px;line-height:32px}.eca-monotron-wrapper .eca-monotron-pipes{font-size:14px;padding-bottom:12px;max-width:648px}.eca-monotron-wrapper .eca-monotron-pipes>div,.eca-monotron-wrapper .eca-monotron-pipes a{display:inline-block}.eca-monotron-wrapper .eca-monotron-pipes>div+a:before,.eca-monotron-wrapper .eca-monotron-pipes>div+div:before,.eca-monotron-wrapper .eca-monotron-pipes a+a:before,.eca-monotron-wrapper .eca-monotron-pipes a+div:before{display:inline-block;padding-left:4px;padding-right:4px;color:#c7c7c7;content:\"|\"}.eca-monotron-wrapper .eca-monotron-description{color:#fff;margin:0;max-width:648px;padding-bottom:24px}\n"],
        encapsulation: 2
      });
    }
  }
  return EcaMonotronComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaNotificationHistoryComponent = /*#__PURE__*/(() => {
  class EcaNotificationHistoryComponent {
    constructor() {
      this.datePipe = inject(DatePipe);
      this.elementRef = inject(ElementRef);
      this.document = inject(DOCUMENT);
      this.appContextService = inject(AppContextService);
      this.windowService = inject(WindowService);
      this.notificationHistoryService = inject(EcaNotificationHistoryService);
      this.instanceId = EcaNotificationHistoryComponent.nextId++;
      this.shouldShowCloseButton = new BehaviorSubject(false);
      this.overlayIsOpen = false;
      this.overlayWidth = '420px';
      this.overlayMinHeight = '240px';
      this.overlayPositions = [{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        panelClass: 'eca-notifications-panel'
      }, {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
        panelClass: 'eca-notifications-panel'
      }, {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
        panelClass: 'eca-notifications-panel'
      }, {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        panelClass: 'eca-notifications-panel'
      }, {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        panelClass: 'eca-notifications-panel'
      }, {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        panelClass: 'eca-notifications-panel'
      }];
      this.visible$ = combineLatest([this.notificationHistoryService.notificationBellVisible$, this.appContextService.token$]).pipe(filter(([visible, token]) => {
        return !visible || !token;
      }), tap(() => {
        this.toggleOverlay(false, new PointerEvent('click'));
      }));
      this.notifications$ = this.notificationHistoryService.messages$.pipe(map(notifications => {
        const results = {
          today: [],
          older: []
        };
        notifications.sort((a, b) => {
          return new Date(b.createDate).getTime() - new Date(a.createDate).getTime();
        }).forEach(notification => {
          const dateFrom = timeAgo(notification.createDate);
          if (dateFrom.includes('hour') || dateFrom.includes('minute') || dateFrom.includes('second')) {
            notification.formatted = dateFrom;
            results.today.push(notification);
          } else if (dateFrom.includes('day') || dateFrom.includes('week')) {
            notification.formatted = dateFrom;
            results.older.push(notification);
          } else if (dateFrom.includes('month') || dateFrom.includes('year')) {
            notification.formatted = this.datePipe.transform(notification.createDate, 'mediumDate');
            results.older.push(notification);
          }
        });
        return results;
      }));
      this.notificationsUnRead$ = this.notifications$.pipe(map(notifications => {
        const todayUnread = notifications.today.filter(notification => {
          return !notification.isRead;
        });
        const olderUnread = notifications.older.filter(notification => {
          return !notification.isRead;
        });
        return todayUnread.length + olderUnread.length;
      }));
    }
    static {
      this.nextId = 0;
    }
    focusHome() {
      if (!this.overlayIsOpen) {
        return;
      }
      const links = this.document.querySelectorAll('.eca-notification-link');
      if (links.length) {
        links[0].focus();
      }
    }
    focusEnd() {
      if (!this.overlayIsOpen) {
        return;
      }
      const links = this.document.querySelectorAll('.eca-notification-link');
      if (links.length) {
        links[links.length - 1].focus();
      }
    }
    escape() {
      this.overlayIsOpen = false;
    }
    // @HostListener('window:beforeunload')
    ngOnDestroy() {
      this.toggleOverlay(false, new PointerEvent('click'));
      this.notificationHistoryService.closeConnection();
    }
    generateLink(notification) {
      if (!notification.actionLink) {
        return of('');
      }
      // We're told to not include these so return the original link
      if (notification.options?.append?.clientCode === false && notification.options?.append?.programNumber === false && notification.options?.append?.token === false) {
        return of(notification.actionLink);
      }
      return combineLatest([this.appContextService.getToken(), this.appContextService.getSelectedProgramNumber(), this.appContextService.getSelectedProductCode()]).pipe(map(([token, programNumber, productCode]) => {
        let query = '';
        // Start the query
        if (notification.actionLink.includes('?')) {
          query += '&';
        } else {
          query += '?';
        }
        if (notification.options?.append?.token !== false) {
          // Set token param
          query += `t=${token}`;
        }
        if (notification.options?.append?.programNumber !== false) {
          if (notification.programNumber) {
            // When a program number is included in the notification use that program number
            query += `&p=${notification.programNumber}`;
          } else if (productCode === notification.clientCode && Number.isInteger(programNumber)) {
            // When the selected client is the same as the notification client and a program has been selected keep the current program
            query += `&p=${programNumber}`;
          } else {
            // Otherwise default to program 1
            query += `&p=1`;
          }
        }
        if (notification.options?.append?.clientCode !== false) {
          if (notification.clientCode) {
            // If the notification has a client use the notification client
            query += `&c=${notification.clientCode}`;
          } else if (productCode) {
            // If the notification does not have a client and a client has been selected use the selected client
            query += `&c=${productCode}`;
          }
        }
        // Finally combine everything
        return notification.actionLink + query;
      }));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toggleOverlay(isOpen, event) {
      this.overlayIsOpen = isOpen;
      // If we want to only focus on keyboard
      // if (isOpen && event.pointerId === -1) {
      if (isOpen) {
        //  This is here wait 1 frame which is roughly 16ms going off of 60 frames a second to make sure the drawer is open.
        timer(16).pipe(take(1)).subscribe(() => {
          const overlayElement = this.overlay['_overlayRef']?.['overlayElement'];
          const isAtTopOfScreen = !(overlayElement?.parentElement.offsetTop || 0);
          this.shouldShowCloseButton.next(isAtTopOfScreen);
          const button = this.document.querySelectorAll('.eca-mark-all-as-read');
          if (button.length) {
            button[0].focus();
            return;
          }
          const div = this.document.querySelectorAll('.no-eca-notifications');
          if (div.length) {
            div[0].focus();
          }
        });
      }
    }
    allAsRead({
      today,
      older
    } = {}) {
      const request = [];
      if (today?.length) {
        const r1 = today.map(({
          notificationId
        }) => {
          return {
            notificationId: notificationId,
            isRead: true
          };
        });
        request.push(...r1);
      }
      if (older?.length) {
        const r2 = older.map(({
          notificationId
        }) => {
          return {
            notificationId: notificationId,
            isRead: true
          };
        });
        request.push(...r2);
      }
      if (request.length) {
        this.notificationHistoryService.updateNotifications(request);
      }
    }
    markAsRead(event, notification) {
      event.preventDefault();
      event.stopPropagation();
      this.notificationHistoryService.updateNotifications([{
        notificationId: notification.notificationId,
        isRead: true
      }]);
      if (notification.actionLink) {
        this.generateLink(notification)
        // Delay a few frames for the websocket
        .pipe(take(64)).subscribe(link => {
          this.windowService.location.assign(link);
        });
      }
    }
    actionKey(event, notification) {
      if (event.keyCode === BACKSPACE || event.keyCode === ENTER) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (event.keyCode === BACKSPACE) {
        const target = event.target;
        const links = this.document.querySelectorAll('.eca-notification-link');
        const thisIndex = Array.from(links).findIndex(link => {
          return link === target;
        });
        if (links.length && thisIndex !== -1) {
          let toFocusElement;
          if (thisIndex < links.length - 1) {
            toFocusElement = links[thisIndex + 1];
          } else if (thisIndex > 0 && thisIndex === links.length - 1) {
            toFocusElement = links[thisIndex - 1];
          } else {
            toFocusElement = target;
          }
          toFocusElement.focus();
        }
        return this.remove(event, notification);
      }
      if (event.keyCode === ENTER) {
        this.markAsRead(event, notification);
      }
    }
    remove(event, notification) {
      event.preventDefault();
      event.stopPropagation();
      this.notificationHistoryService.updateNotifications([{
        notificationId: notification.notificationId,
        isDeleted: true
      }]);
    }
    static {
      this.ɵfac = function EcaNotificationHistoryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaNotificationHistoryComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaNotificationHistoryComponent,
        selectors: [["eca-notification-history"]],
        viewQuery: function EcaNotificationHistoryComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CdkConnectedOverlay, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlay = _t.first);
          }
        },
        hostBindings: function EcaNotificationHistoryComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.home", function EcaNotificationHistoryComponent_keydown_home_HostBindingHandler($event) {
              return ctx.focusHome($event);
            }, false, i0.ɵɵresolveWindow)("keydown.end", function EcaNotificationHistoryComponent_keydown_end_HostBindingHandler($event) {
              return ctx.focusEnd($event);
            }, false, i0.ɵɵresolveWindow)("keydown.escape", function EcaNotificationHistoryComponent_keydown_escape_HostBindingHandler($event) {
              return ctx.escape($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        decls: 4,
        vars: 6,
        consts: [["trigger", "cdkOverlayOrigin"], ["notRead", ""], ["noNotifications", ""], [4, "ngIf"], ["type", "button", "cdkOverlayOrigin", "", 1, "eca-notification-history", "remove-btn-formatting", "eca-focus-visible-inverse-colors", 3, "click", "id"], [4, "ngIf", "ngIfElse"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayPanelClass", "eca-notification-history-panel", 3, "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPush"], ["aria-hidden", "true", "matBadgeColor", "warn", 3, "matBadge"], ["aria-hidden", "true"], ["class", "overlay-container", "fxFlex", "1 1 auto", "fxLayout", "column", "fxLayoutAlign", "start stretch", "fxLayoutGap", "16px", "style", "overflow: auto;", 4, "ngIf"], ["fxFlex", "1 1 auto", "fxLayout", "column", "fxLayoutAlign", "start stretch", "fxLayoutGap", "16px", 1, "overlay-container", 2, "overflow", "auto"], ["fxLayout", "column", "fxLayoutGap", "16px"], [1, "notification-panel-header", 3, "ngClass"], [1, "header-close"], [1, "title"], ["mat-button", "", "aria-label", "Close Notification Panel", 1, "eca-close-panel", "eca-icon-only", "eca-no-border-icon-button", 3, "click"], ["class", "eca-mark-all-as-read", "mat-button", "", "type", "button", "color", "primary", 3, "click", 4, "ngIf"], ["mat-button", "", "type", "button", "color", "primary", 1, "eca-mark-all-as-read", 3, "click"], ["class", "eca-notification-section-title", 4, "ngIf"], ["class", "eca-notification", 4, "ngFor", "ngForOf"], [1, "eca-notification-section-title"], [1, "eca-notification"], [1, "eca-notification-link", 3, "click", "keydown", "id", "href", "ngClass"], [1, "eca-notification-text"], [1, "eca-notification-title"], [1, "eca-notification-date"], [1, "eca-notification-description"], ["aria-hidden", "true", 1, "eca-notification-button"], [3, "click"], ["tabindex", "-1", 1, "no-eca-notifications"]],
        template: function EcaNotificationHistoryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, EcaNotificationHistoryComponent_ng_container_0_Template, 1, 0, "ng-container", 3);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, EcaNotificationHistoryComponent_ng_container_2_Template, 9, 17, "ng-container", 3);
            i0.ɵɵpipe(3, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.visible$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.notificationHistoryService.isSocketOpen$));
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, EcaMonotronComponent, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultLayoutAlignDirective, i3.DefaultFlexDirective, i2.DefaultClassDirective, i5$1.MatBadge, i4.MatButton, i7.MatDivider, i5.MatIcon, i9.CdkConnectedOverlay, i9.CdkOverlayOrigin, i1.AsyncPipe],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}[_nghost-%COMP%]{display:block}[_nghost-%COMP%]     .mat-badge-warn .mat-badge-content{background:var(--drc-red);border:1px solid var(--drc-dark-grey);width:19px;height:19px;line-height:16px;font-size:14px;font-weight:600}[_nghost-%COMP%]     .mat-badge-medium.mat-badge-overlap.mat-badge-after .mat-badge-content{right:-7px}.eca-mark-all-as-read[_ngcontent-%COMP%], .title[_ngcontent-%COMP%]{white-space:nowrap}.eca-notification-history[_ngcontent-%COMP%]{height:40px;width:40px}.title[_ngcontent-%COMP%]{font-size:24px;line-height:36px;font-weight:600;margin:0}.eca-monotron[_ngcontent-%COMP%]{background-color:#343c48}.eca-monotron[_ngcontent-%COMP%]  .eca-monotron-wrapper{padding:16px}@media screen and (max-width: 420px){.notification-panel-header[_ngcontent-%COMP%]{flex-direction:column!important;align-items:normal!important;gap:16px}}.mat-divider[_ngcontent-%COMP%]{border-top-color:var(--drc-medium-grey)}.no-eca-notifications[_ngcontent-%COMP%]{text-align:center}.eca-notification-section-title[_ngcontent-%COMP%]{color:var(--drc-amber);font-weight:600;font-size:22px;line-height:1.5}.eca-notification-link[_ngcontent-%COMP%]{--notification-unread: #A0CAFF;--notification-text-color: var(--drc-white);border:0;border-radius:4px;padding:8px 16px;width:100%;color:var(--notification-text-color);text-decoration:none;line-height:1.5;display:flex}.eca-notification-link[_ngcontent-%COMP%]:before{display:none!important}.eca-notification-link[_ngcontent-%COMP%]:hover, .eca-notification-link.focus-visible[_ngcontent-%COMP%], .eca-notification-link[_ngcontent-%COMP%]:focus{background-color:var(--drc-light-blue)!important;color:var(--drc-dark-grey)}.eca-notification-link[_ngcontent-%COMP%]:hover   h4[_ngcontent-%COMP%], .eca-notification-link.focus-visible[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .eca-notification-link[_ngcontent-%COMP%]:focus   h4[_ngcontent-%COMP%]{color:var(--drc-dark-grey)}.eca-notification-link.eca-notification-unread[_ngcontent-%COMP%]{box-shadow:inset 4px 0 0 var(--notification-unread)}.eca-notification-link.eca-notification-unread[_ngcontent-%COMP%]:not(.eca-focus-visible-inverse-colors):not(.eca-focus-visible-outline).focus-visible, .eca-notification-link.eca-notification-unread[_ngcontent-%COMP%]:not(.eca-focus-visible-inverse-colors):not(.eca-focus-visible-outline):hover{--notification-unread: var(--drc-dark-grey)}.eca-notification-link[_ngcontent-%COMP%]:not(.eca-focus-visible-inverse-colors):not(.eca-focus-visible-outline).focus-visible   .eca-notification-date[_ngcontent-%COMP%], .eca-notification-link[_ngcontent-%COMP%]:not(.eca-focus-visible-inverse-colors):not(.eca-focus-visible-outline):hover   .eca-notification-date[_ngcontent-%COMP%]{font-weight:400}.eca-notification-link[_ngcontent-%COMP%]:not(.eca-focus-visible-inverse-colors):not(.eca-focus-visible-outline).focus-visible   .eca-notification-description[_ngcontent-%COMP%], .eca-notification-link[_ngcontent-%COMP%]:not(.eca-focus-visible-inverse-colors):not(.eca-focus-visible-outline):hover   .eca-notification-description[_ngcontent-%COMP%]{font-weight:600}.notification-panel-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.notification-panel-header[_ngcontent-%COMP%]   .header-close[_ngcontent-%COMP%]{display:flex}.notification-panel-header[_ngcontent-%COMP%]   .eca-close-panel[_ngcontent-%COMP%]{display:none;align-self:flex-end;background-color:transparent;border-color:transparent;color:#fff}.notification-panel-header.has-close[_ngcontent-%COMP%]{flex-wrap:wrap}.notification-panel-header.has-close[_ngcontent-%COMP%]   .header-close[_ngcontent-%COMP%]{flex:1 0 100%}.notification-panel-header.has-close[_ngcontent-%COMP%]   .header-close[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{flex:1 1 100%}.notification-panel-header.has-close[_ngcontent-%COMP%]   .header-close[_ngcontent-%COMP%]   .eca-close-panel[_ngcontent-%COMP%]{display:initial}.eca-notification-text[_ngcontent-%COMP%]{flex:1 auto}.eca-notification-button[_ngcontent-%COMP%]{flex:0 0 auto;align-self:center}.eca-notification-title[_ngcontent-%COMP%]{font-size:20px;margin-bottom:0}.eca-notification-description[_ngcontent-%COMP%]{font-weight:400}.eca-notification-title[_ngcontent-%COMP%], .eca-notification-date[_ngcontent-%COMP%]{font-weight:600}.eca-notification-date[_ngcontent-%COMP%], .eca-notification-description[_ngcontent-%COMP%]{font-size:16px}"],
        changeDetection: 0
      });
    }
  }
  return EcaNotificationHistoryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// From https://stackoverflow.com/questions/3177836/how-to-format-time-since-xxx-e-g-4-minutes-ago-similar-to-stack-exchange-site
function timeAgo(date) {
  const d = new Date(date);
  const seconds = Math.floor((new Date().getTime() - d.getTime()) / 1000);
  let interval = seconds / 31536000;
  if (interval >= 1) {
    return timeText(interval, 'year');
  }
  interval = seconds / 2592000;
  if (interval >= 1) {
    return timeText(interval, 'month');
  }
  interval = seconds / 604800;
  if (interval >= 1) {
    return timeText(interval, 'week');
  }
  interval = seconds / 86400;
  if (interval >= 1) {
    return timeText(interval, 'day');
  }
  interval = seconds / 3600;
  if (interval >= 1) {
    return timeText(interval, 'hour');
  }
  interval = seconds / 60;
  if (interval >= 1) {
    return timeText(interval, 'minute');
  }
  return timeText(seconds, 'second');
}
function timeText(time, text) {
  const floor = Math.floor(time);
  return `${floor} ${text}${floor === 1 ? '' : 's'} ago`;
}
let EcaHeaderBaseComponent = /*#__PURE__*/(() => {
  class EcaHeaderBaseComponent {
    static {
      this.ɵfac = function EcaHeaderBaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHeaderBaseComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaHeaderBaseComponent,
        selectors: [["eca-header-base"]],
        inputs: {
          logo: "logo"
        },
        ngContentSelectors: _c6,
        decls: 6,
        vars: 2,
        consts: [["aria-label", "DRC primary header toolbar", 1, "drc-header-toolbar"], [1, "drc-header-contents", "eca-fx-row", "eca-fx-wrap"], [1, "drc-logo-wrapper"], ["class", "eca-focus-visible-inverse-colors", 3, "ngStyle", "background", "href", 4, "ngIf"], [3, "ngStyle", "background", 4, "ngIf"], [1, "eca-focus-visible-inverse-colors", 3, "ngStyle", "href"], [1, "alt"], [3, "ngStyle"]],
        template: function EcaHeaderBaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "nav", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, EcaHeaderBaseComponent_a_3_Template, 3, 6, "a", 3)(4, EcaHeaderBaseComponent_div_4_Template, 3, 5, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.logo && ctx.logo.link);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.logo && !ctx.logo.link);
          }
        },
        dependencies: [i1.NgIf, i1.NgStyle, i2.DefaultStyleDirective],
        styles: [".drc-header-toolbar[_ngcontent-%COMP%]{position:relative;background-color:#343c48;color:#bfc2c5;display:flex;box-sizing:border-box;width:100%;min-height:56px;flex-direction:row;align-items:center;justify-content:center;white-space:nowrap;font-weight:500;z-index:2000;padding:0 32px}@media (max-height: 359px){.drc-header-toolbar[_ngcontent-%COMP%]{padding:0 16px}}.drc-header-contents[_ngcontent-%COMP%]{flex:1 1 auto;height:100%}.drc-logo-wrapper[_ngcontent-%COMP%]{padding:0}.alt[_ngcontent-%COMP%]{display:none}"],
        changeDetection: 0
      });
    }
  }
  return EcaHeaderBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHelpMenuComponent = /*#__PURE__*/(() => {
  class EcaHelpMenuComponent {
    constructor() {}
    static {
      this.ɵfac = function EcaHelpMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHelpMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaHelpMenuComponent,
        selectors: [["eca-help-menu"]],
        inputs: {
          helpLinks: "helpLinks"
        },
        decls: 1,
        vars: 1,
        consts: [["helpMenuTrigger", "matMenuTrigger"], ["help", "matMenu"], ["category", ""], [4, "ngIf"], ["mat-icon-button", "", "aria-label", "help", "id", "eca-help-menu-link", "name", "helpMenu", 1, "remove-btn-formatting", "eca-focus-visible-inverse-colors", 3, "matMenuTriggerFor"], [1, "help-menu-icon"], ["xPosition", "before", 1, "header-menu-panel", "right-header-mat-icon-menu-panel", 3, "overlapTrigger"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["target", "_blank", "mat-menu-item", "", 1, "eca-focus-visible-inverse-colors", 3, "href"], [1, "mat-menu-header"], ["target", "_blank", "class", "eca-focus-visible-inverse-colors", "mat-menu-item", "", 3, "href", 4, "ngIf"]],
        template: function EcaHelpMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, EcaHelpMenuComponent_ng_container_0_Template, 8, 3, "ng-container", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.helpLinks);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i2$1.MatMenu, i2$1.MatMenuItem, i2$1.MatMenuTrigger, i4.MatIconButton, i5.MatIcon],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center}"]
      });
    }
  }
  return EcaHelpMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSnackbarAlertComponent = /*#__PURE__*/(() => {
  class EcaSnackbarAlertComponent {
    constructor(data, snackBarRef) {
      this.data = data;
      this.snackBarRef = snackBarRef;
    }
    dismiss() {
      this.snackBarRef.dismiss();
    }
    static {
      this.ɵfac = function EcaSnackbarAlertComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSnackbarAlertComponent)(i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA), i0.ɵɵdirectiveInject(i2$2.MatSnackBarRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSnackbarAlertComponent,
        selectors: [["eca-snackbar-alert"]],
        decls: 5,
        vars: 2,
        consts: [[1, "snack-icon"], [1, "message", 3, "innerHtml"], [1, "snack-icon-close", 3, "click"]],
        template: function EcaSnackbarAlertComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-icon", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "span", 1);
            i0.ɵɵelementStart(3, "mat-icon", 2);
            i0.ɵɵlistener("click", function EcaSnackbarAlertComponent_Template_mat_icon_click_3_listener() {
              return ctx.dismiss();
            });
            i0.ɵɵtext(4, " close\n");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.data.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHtml", ctx.data.message, i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [i5.MatIcon],
        encapsulation: 2
      });
    }
  }
  return EcaSnackbarAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const maxSnackDuration = 99999999999; // material will dismiss anything larger instantly
const alertIcons = {
  info: 'info',
  warning: 'info',
  positive: 'check_circle',
  negative: 'cancel_circle'
};
class EcaSnackbarAlertConfig {
  constructor(message, alertType = 'positive', duration = maxSnackDuration) {
    this.verticalPosition = 'top';
    this.panelClass = `mat-snack-${alertType}`;
    this.duration = duration;
    this.data = {
      message,
      icon: alertIcons[alertType]
    };
  }
}

/**
 * This pipe takes a user's name (usually two words separated by a space) and returns the user's initials as caps.
 * Example: 'John Smith' returns 'JS'; 'John D. Smith' returns 'JS'; 'John' returns 'J'.
 */
let EcaUserInitialsPipe = /*#__PURE__*/(() => {
  class EcaUserInitialsPipe {
    transform(value) {
      if (!value) {
        return '';
      }
      const frags = value.trim().split(' ');
      if (frags.length === 1) {
        const initial = frags[0].charAt(0);
        return initial.toUpperCase();
      } else {
        const lastIndex = frags.length - 1;
        const initials = frags[0].charAt(0) + frags[lastIndex].charAt(0);
        return initials.toUpperCase();
      }
    }
    static {
      this.ɵfac = function EcaUserInitialsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaUserInitialsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "ecaUserInitials",
        type: EcaUserInitialsPipe,
        pure: true
      });
    }
  }
  return EcaUserInitialsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaUserProfileMenuComponent = /*#__PURE__*/(() => {
  class EcaUserProfileMenuComponent {
    constructor(securityService, snackBar, appContextService, windowService) {
      this.securityService = securityService;
      this.snackBar = snackBar;
      this.appContextService = appContextService;
      this.windowService = windowService;
      this.subscriptions = [];
    }
    ngOnInit() {
      // subscribe to window resize events so that any open menus can be closed on resize
      window.onresize = () => {
        this.closeMenu();
      };
    }
    navigateTo(url) {
      if (url) {
        this.windowService.navigateTo(`${this.appContextService.getPortalUrl()}/#/${url}`);
      }
    }
    logOut() {
      this.securityService.logout().subscribe(url => this.windowService.navigateTo(url), err => this.openErrorSnackBar(err));
    }
    /* Closes open menu when a window resize event is received */
    closeMenu() {
      if (this.userProfileMenuTrigger) {
        this.userProfileMenuTrigger.closeMenu();
      }
    }
    openErrorSnackBar(errorMessage) {
      const config = new EcaSnackbarAlertConfig('Logout failed. ' + errorMessage.statusText, 'negative');
      this.snackBar.openFromComponent(EcaSnackbarAlertComponent, config);
    }
    ngOnDestroy() {
      this.subscriptions.forEach(sub => {
        if (sub) {
          sub.unsubscribe();
        }
      });
    }
    static {
      this.ɵfac = function EcaUserProfileMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaUserProfileMenuComponent)(i0.ɵɵdirectiveInject(EcaSecurityService), i0.ɵɵdirectiveInject(i2$2.MatSnackBar), i0.ɵɵdirectiveInject(AppContextService), i0.ɵɵdirectiveInject(WindowService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaUserProfileMenuComponent,
        selectors: [["eca-user-profile-menu"]],
        viewQuery: function EcaUserProfileMenuComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c9, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.userProfileMenuTrigger = _t.first);
          }
        },
        inputs: {
          name: "name"
        },
        decls: 22,
        vars: 5,
        consts: [["userProfileMenuTrigger", "matMenuTrigger"], ["user", "matMenu"], ["id", "eca-user-profile-menu-link", "type", "button", "name", "userProfileMenu", 1, "remove-btn-formatting", "eca-focus-visible-inverse-colors", 3, "matMenuTriggerFor"], [1, "user-profile-link"], ["xPosition", "before", 1, "header-menu-panel", "right-header-menu-panel", 3, "overlapTrigger"], [1, "mat-menu-header"], ["mat-menu-item", "", 1, "user-profile-menu-item", "eca-link", "eca-focus-visible-inverse-colors", 3, "click"]],
        template: function EcaUserProfileMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 2, 0)(2, "span", 3);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "ecaUserInitials");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "mat-menu", 4, 1)(7, "div", 5)(8, "span");
            i0.ɵɵtext(9, "MY PROFILE");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "button", 6);
            i0.ɵɵlistener("click", function EcaUserProfileMenuComponent_Template_button_click_10_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigateTo("user/edit"));
            });
            i0.ɵɵtext(11, " Edit Profile ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "button", 6);
            i0.ɵɵlistener("click", function EcaUserProfileMenuComponent_Template_button_click_12_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigateTo("user/password"));
            });
            i0.ɵɵtext(13, " Change Password ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 5)(15, "span");
            i0.ɵɵtext(16, "PRODUCT");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "button", 6);
            i0.ɵɵlistener("click", function EcaUserProfileMenuComponent_Template_button_click_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navigateTo("user/agreements"));
            });
            i0.ɵɵtext(18, " View My Agreements ");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(19, "br");
            i0.ɵɵelementStart(20, "button", 6);
            i0.ɵɵlistener("click", function EcaUserProfileMenuComponent_Template_button_click_20_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.logOut());
            });
            i0.ɵɵtext(21, " Sign Out ");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const user_r2 = i0.ɵɵreference(6);
            i0.ɵɵproperty("matMenuTriggerFor", user_r2);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, ctx.name));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("overlapTrigger", false);
          }
        },
        dependencies: [i2$1.MatMenu, i2$1.MatMenuItem, i2$1.MatMenuTrigger, EcaUserInitialsPipe],
        styles: ["[_nghost-%COMP%]{display:block}button#eca-user-profile-menu-link[_ngcontent-%COMP%]{height:40px;width:40px}.user-profile-link[_ngcontent-%COMP%]{border-radius:50%;box-sizing:border-box;color:#343c48;display:block;font-size:11px;font-weight:600;line-height:1.9;text-align:center;min-width:20px;min-height:20px;max-width:20px;max-height:20px}  div.right-header-menu-panel[style*=\"transform-origin: right bottom\"]{top:1px;border-radius:6px 6px 0 0}"]
      });
    }
  }
  return EcaUserProfileMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Default field definitions (used in unit tests and when nothing is defined in Setup Config)
const stateDefinition = {
  order: 0,
  type: "state" /* SiteSelectorSiteType.State */,
  label: 'State',
  child: "district" /* SiteSelectorSiteType.District */
};
const districtDefinition = {
  order: 1,
  type: "district" /* SiteSelectorSiteType.District */,
  label: 'District',
  belongsTo: "administration" /* SiteSelectorSiteType.Administration */,
  child: "school" /* SiteSelectorSiteType.School */
};
const schoolDefinition = {
  order: 2,
  type: "school" /* SiteSelectorSiteType.School */,
  label: 'School',
  belongsTo: "administration" /* SiteSelectorSiteType.Administration */,
  child: "administration" /* SiteSelectorSiteType.Administration */
};
const administrationDefinition = {
  order: 3,
  type: "administration" /* SiteSelectorSiteType.Administration */,
  label: 'Administration'
};
const siteSelectorFieldDefaults = [districtDefinition, schoolDefinition];
let EcaSiteSearchService = /*#__PURE__*/(() => {
  class EcaSiteSearchService {
    static {
      this.maxSearchLength = 50;
    }
    constructor(ecaSiteService) {
      this.ecaSiteService = ecaSiteService;
    }
    /**
     * @return Sites and Hierarchies NOT combined
     */
    search(siteSearchParams) {
      return this._search(siteSearchParams, 'v1');
    }
    /**
     * Uses 'v2' of the API
     */
    searchV2(siteSearchParams) {
      return this._search(siteSearchParams, 'v2');
    }
    _search(siteSearchParams, apiVersion) {
      return this.ecaSiteService.getSiteSearchRequest(siteSearchParams.aclSpec, siteSearchParams.searchTerm, siteSearchParams.clientAbbr, siteSearchParams.siteType, siteSearchParams.rowLimit, siteSearchParams.stateAbbr, siteSearchParams.leafOnly, siteSearchParams.masterSearch, siteSearchParams.archived).pipe(switchMap(request => {
        return this.ecaSiteService.searchSites(request, false, apiVersion);
      }));
    }
    searchCombined(siteSearchParams) {
      return this._searchCombined(siteSearchParams, 'v1');
    }
    /**
     * Uses 'v2' of the API
     */
    searchCombinedV2(siteSearchParams) {
      return this._searchCombined(siteSearchParams, 'v2');
    }
    _searchCombined(siteSearchParams, apiVersion) {
      return this.ecaSiteService.getSiteSearchRequest(siteSearchParams.aclSpec, siteSearchParams.searchTerm, siteSearchParams.clientAbbr, siteSearchParams.siteType, siteSearchParams.rowLimit, siteSearchParams.stateAbbr, siteSearchParams.leafOnly, siteSearchParams.masterSearch, siteSearchParams.archived).pipe(switchMap(request => {
        return this.ecaSiteService.searchSites(request, true, apiVersion);
      }));
    }
    getDescription(site, withAdmin = true) {
      const description = `${site.siteName} - ${site.siteCode}`;
      return withAdmin ? description + ` | ${site.adminName} - ${site.adminCode}` : description;
    }
    convertToSite(siteResult, adminResult) {
      const site = {
        id: siteResult.id.toString(10),
        type: siteResult.type,
        parentSiteId: siteResult.parentSiteId ? siteResult.parentSiteId.toString(10) : null,
        parentSiteCode: siteResult.parentSiteCode,
        parentSiteName: siteResult.parentSiteName,
        siteCode: siteResult.code,
        siteName: siteResult.name
      };
      if (siteResult.hierarchies.length === 1) {
        site.adminId = siteResult.hierarchies[0].id.toString(10);
        site.path = siteResult.hierarchies[0].path;
        if (siteResult.hierarchies[0].ace) {
          site.ace = siteResult.hierarchies[0].ace;
        }
      }
      if (adminResult) {
        site.adminCode = adminResult.code;
        site.adminId = adminResult.id.toString(10);
        site.adminName = adminResult.name;
        site.adminNumber = adminResult.number;
        site.adminCreateDate = adminResult.createDate;
        site.adminUpdateDate = adminResult.updateDate;
        const hierarchy = siteResult.hierarchies.find(hierarchy => {
          return hierarchy.id.toString() === adminResult.id.toString();
        });
        site.path = hierarchy.path;
        if (hierarchy.ace) {
          site.ace = hierarchy.ace;
        }
      }
      return site;
    }
    static {
      this.ɵfac = function EcaSiteSearchService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSearchService)(i0.ɵɵinject(EcaSiteService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaSiteSearchService,
        factory: EcaSiteSearchService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaSiteSearchService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHighlightTextPipe = /*#__PURE__*/(() => {
  class EcaHighlightTextPipe {
    transform(text, search) {
      if (search && text) {
        let pattern = search.replace(/[-[\]{}()*+?.\\^$|]/g, '\\$&');
        pattern = pattern.split(' ').filter(t => {
          return t.length > 0;
        }).join('|');
        const regex = new RegExp(pattern, 'gi');
        return text.replace(regex, match => `<span class="highlight">${match}</span>`);
      } else {
        return text;
      }
    }
    static {
      this.ɵfac = function EcaHighlightTextPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHighlightTextPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "highlightText",
        type: EcaHighlightTextPipe,
        pure: true
      });
    }
  }
  return EcaHighlightTextPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// 'inspired' by https://github.com/angular/components/blob/16.2.14/src/material/input/input.ts#L49
const _EcaAutocompleteBase = mixinErrorState(class {
  constructor(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
    this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
    this._parentForm = _parentForm;
    this._parentFormGroup = _parentFormGroup;
    this.ngControl = ngControl;
    this.stateChanges = new Subject();
  }
});
let EcaAutocompleteComponent = /*#__PURE__*/(() => {
  class EcaAutocompleteComponent extends _EcaAutocompleteBase {
    static {
      this.nextId = 0;
    }
    /**
     * Allow string or LabelValue for array of options.
     * This is a workaround since Array<string> | Array<LabelValue> can't be merged into the same call signatures so
     * something like options.filter will give a type error.
     */
    get options() {
      return this._options;
    }
    set options(values) {
      this._options = values;
      this.optionsAreStrings = !this._options || this._options.every(option => typeof option === 'string');
      // execute writeValue logic to handle the case when the value is programmatically set before the options are set
      // writeValue handles filtering options, updating error state and emitting stateChanges
      this.writeValue(this.value);
    }
    // ngModel for the <input> element - ie. text that should be displayed in the autocomplete input
    // can't be a FormControl because we need to convert LabelValue to a string when an option is selected
    get autocompleteInput() {
      return this._autocompleteInput;
    }
    set autocompleteInput(val) {
      const stringLabel = typeof val === 'string' ? val : val.label;
      const stringValue = typeof val === 'string' ? val : val.value;
      // if allowFreeText is false (default) then ensure the value is only one of the options
      // otherwise set the value to whatever was typed in
      if (stringValue !== this.value) {
        this.value = this.allowFreeText ? stringValue : '';
      }
      this._autocompleteInput = stringLabel;
      this.filterOptions(stringLabel);
    }
    get empty() {
      const currentValue = this._value;
      return currentValue === undefined || currentValue === null || !currentValue.trim();
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(plh) {
      this._placeholder = plh;
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(req) {
      this._required = coerceBooleanProperty(req);
      this.updateErrorState();
      this.stateChanges.next();
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    // value should always be string, might be the option label or the (LabelValue) value depending on how 'options' is set;
    // this value is what is what is given to or received from the consuming control
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
      if (this.onChange) {
        this.onChange(val);
      }
      this.updateErrorState();
      this.stateChanges.next();
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick() {
      // the option panel doesn't show in this scenario so don't give the input focus
      // if ((event.target as Element).tagName.toLowerCase() !== 'input') {
      //   this.elementRef.nativeElement.querySelector('input').focus();
      // }
    }
    // end initialization of MatFormFieldControl properties/etc.
    constructor(ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, focusMonitor, elementRef) {
      super(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl);
      this.ngControl = ngControl;
      this.focusMonitor = focusMonitor;
      this.elementRef = elementRef;
      this.optionsAreStrings = false;
      this.showClearIcon = true;
      this.disabled = false;
      this.presentAsSelect = false;
      this.allowFreeText = false;
      this.optionSelected = new EventEmitter();
      // bubble up the blur event, be warned that this will emit before a value is set when selecting an option
      // todo: rename this output with the next breaking change
      // eslint-disable-next-line @angular-eslint/no-output-native
      this.blur = new EventEmitter();
      this.filteredOptions = [];
      /**
       * MatFormFieldControl requires several properties & methods;
       *   the properties are organized alphabetically below
       */
      this.controlType = 'eca-autocomplete';
      this.errorState = false;
      this.focused = false;
      this.id = `eca-autocomplete-${EcaAutocompleteComponent.nextId++}`;
      this.stateChanges = new Subject();
      this.describedBy = '';
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
      focusMonitor.monitor(elementRef.nativeElement, true).subscribe(origin => {
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }
    ngOnInit() {
      this.filterOptions(this.value);
      this.stateChanges.next();
    }
    ngDoCheck() {
      if (this.ngControl) {
        this.updateErrorState();
      }
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      this.focusMonitor.stopMonitoring(this.elementRef.nativeElement);
    }
    displayFn(option) {
      // be warned: 'this' is not a reference to this class so keep the logic in here static
      return typeof option === 'string' ? option : option ? option.label : '';
    }
    filterOptions(value) {
      if (this._options) {
        const filterValue = value ? value.toLowerCase() : '';
        if (this.optionsAreStrings) {
          this.filteredOptions = this._options.filter(option => {
            return option.toLowerCase().includes(filterValue);
          });
        } else {
          this.filteredOptions = this._options.filter(option => {
            return option.label && option.label.toLowerCase().includes(filterValue);
          });
        }
      } else {
        this.filteredOptions = [];
      }
    }
    clearInput(event) {
      this.autocompleteInput = '';
      this.value = '';
      this.updateErrorState();
      this.stateChanges.next();
      this.focused = false;
    }
    onInputBlur(event) {
      this.onTouched();
      this.blur.emit(event);
      this.updateErrorState();
      this.stateChanges.next();
    }
    selectOption(event) {
      if (event.option && event.option.value) {
        // will be string or LabelValue type
        const val = event.option.value;
        this.value = typeof val === 'string' ? val : val.value;
      }
      this.optionSelected.emit(event);
    }
    // defer the call to open the panel to let the click event propagate
    // the click event will close other open autocomplete/option panels
    togglePanel(trigger) {
      if (!trigger.panelOpen) {
        timer(1).subscribe(() => {
          trigger.openPanel();
        });
      }
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      if (value === null || value === undefined || typeof value === 'string') {
        this._value = value;
        // support setting the value programmatically
        if (this.optionsAreStrings && value !== this._autocompleteInput) {
          this._autocompleteInput = value;
        } else if (!this.optionsAreStrings && this._options) {
          const labelValue = this._options.find(opt => opt.value === value);
          if (labelValue && typeof labelValue !== 'string' && labelValue.label !== this._autocompleteInput) {
            this._autocompleteInput = labelValue.label;
          } else if (!value) {
            this._autocompleteInput = '';
          }
        }
        this.filterOptions(value);
        this.updateErrorState();
        this.stateChanges.next();
      } else {
        throw new Error('the assigned value must be of type string');
      }
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaAutocompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAutocompleteComponent)(i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i1$4.NgForm, 8), i0.ɵɵdirectiveInject(i1$4.FormGroupDirective, 8), i0.ɵɵdirectiveInject(i2$3.ErrorStateMatcher), i0.ɵɵdirectiveInject(i2$4.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaAutocompleteComponent,
        selectors: [["eca-autocomplete"]],
        hostVars: 3,
        hostBindings: function EcaAutocompleteComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("aria-describedby", ctx.describedBy);
            i0.ɵɵclassProp("floating", ctx.shouldLabelFloat);
          }
        },
        inputs: {
          options: "options",
          showClearIcon: "showClearIcon",
          disabled: "disabled",
          presentAsSelect: "presentAsSelect",
          allowFreeText: "allowFreeText",
          placeholder: "placeholder",
          required: "required",
          value: "value",
          errorStateMatcher: "errorStateMatcher"
        },
        outputs: {
          optionSelected: "optionSelected",
          blur: "blur"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: EcaAutocompleteComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 15,
        consts: [["trigger", "matAutocompleteTrigger"], ["autocompleteElement", "matAutocomplete"], [1, "eca-autocomplete"], ["type", "text", "matInput", "", 3, "ngModelChange", "blur", "title", "id", "placeholder", "ngModel", "disabled", "matAutocomplete", "required", "ngClass"], ["aria-label", "open select", "class", "eca-autocomplete-dropdown-arrow", 3, "click", 4, "ngIf"], ["aria-label", "clear text", "matSuffix", "", "mat-icon-button", "", "class", "eca-icon-only", 3, "click", 4, "ngIf"], ["panelWidth", "fit", 3, "optionSelected", "displayWith"], [3, "value", 4, "ngFor", "ngForOf"], ["aria-label", "open select", 1, "eca-autocomplete-dropdown-arrow", 3, "click"], ["aria-label", "clear text", "matSuffix", "", "mat-icon-button", "", 1, "eca-icon-only", 3, "click"], ["role", "img"], [3, "value"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]],
        template: function EcaAutocompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2)(1, "input", 3, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function EcaAutocompleteComponent_Template_input_ngModelChange_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.autocompleteInput, $event) || (ctx.autocompleteInput = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("blur", function EcaAutocompleteComponent_Template_input_blur_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputBlur($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, EcaAutocompleteComponent_mat_icon_3_Template, 2, 0, "mat-icon", 4)(4, EcaAutocompleteComponent_button_4_Template, 3, 0, "button", 5);
            i0.ɵɵelementStart(5, "mat-autocomplete", 6, 1);
            i0.ɵɵlistener("optionSelected", function EcaAutocompleteComponent_Template_mat_autocomplete_optionSelected_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectOption($event));
            });
            i0.ɵɵtemplate(7, EcaAutocompleteComponent_mat_option_7_Template, 3, 3, "mat-option", 7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const autocompleteElement_r7 = i0.ɵɵreference(6);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", ctx.placeholder || "autocomplete");
            i0.ɵɵproperty("id", ctx.id)("placeholder", ctx.placeholder);
            i0.ɵɵtwoWayProperty("ngModel", ctx.autocompleteInput);
            i0.ɵɵproperty("disabled", ctx.disabled)("matAutocomplete", autocompleteElement_r7)("required", ctx.required)("ngClass", i0.ɵɵpureFunction2(12, _c10, ctx.presentAsSelect && !ctx.focused, ctx.presentAsSelect && ctx.focused));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.focused && ctx.presentAsSelect && !ctx.value && !ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showClearIcon && !ctx.disabled && ctx.autocompleteInput);
            i0.ɵɵadvance();
            i0.ɵɵproperty("displayWith", ctx.displayFn);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.filteredOptions);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.RequiredValidator, i1$4.NgModel, i5$2.MatAutocomplete, i2$3.MatOption, i5$2.MatAutocompleteTrigger, i4.MatIconButton, i6.MatSuffix, i5.MatIcon, i6$1.MatInput, EcaHighlightTextPipe],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent;z-index:1;--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{background-color:var(--drc-light-blue);border:3px solid var(--drc-blue);border-radius:4px;box-shadow:none;padding:0 7px!important;line-height:38px!important}.mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:7px;line-height:inherit}.mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent}.mat-mdc-button.mat-unthemed[_ngcontent-%COMP%]{--mdc-text-button-label-text-color: var(--drc-blue)}button.mat-mdc-button[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]{border-radius:4px;line-height:40px;font-style:normal;font-weight:600;font-size:16px;border:2px solid var(--drc-blue);position:relative;min-width:initial;color:var(--drc-blue);width:max-content;background-color:var(--drc-white);--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0;--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{--mdc-icon-button-state-layer-size: 44px}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%]{max-height:44px;max-width:44px}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{height:44px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only){padding:0 14px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%]{margin-right:8px;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%]{margin-right:0;margin-left:4px}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{background-color:var(--drc-blue);border:2px solid var(--drc-blue);color:var(--drc-white)}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]{padding:0 8px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 10px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin:0;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%]{border-radius:0 4px 4px 0}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{line-height:20px}button.mat-mdc-button[disabled][_ngcontent-%COMP%], button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%], .mat-datepicker-close-button[disabled][_ngcontent-%COMP%]{background-color:var(--drc-light-grey);border:2px solid var(--drc-light-grey);color:var(--drc-dark-grey)!important}button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{line-height:36px}button.mat-mdc-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 16px;background-color:var(--drc-white);color:var(--drc-blue);border:none;box-shadow:0 8px 10px -6px var(--drc-dark-grey-15),inset 0 -2px 0 var(--drc-accent-blue),inset 0 2px 0 var(--drc-accent-blue)}button.mat-mdc-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-button.mat-mdc-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.mat-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled){border-color:var(--drc-blue)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary{border-color:var(--drc-white)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before{background-color:var(--drc-bright-accent-blue);color:var(--drc-black);border:none;box-shadow:0 20px 25px -5px #262d3980,inset 0 -2px 0 var(--drc-white),inset 0 2px 0 var(--drc-white)}button.remove-btn-formatting[_ngcontent-%COMP%]{border:none!important;margin:0;padding:0;background:transparent;font-size:inherit;font-weight:400}button.remove-btn-formatting[_ngcontent-%COMP%]:not(#eca-skip-to-content-link, .nav-menu-link[_ngcontent-%COMP%], .mdc-icon-button[_ngcontent-%COMP%], #eca-user-profile-menu-link[_ngcontent-%COMP%], .eca-notification-history)[_ngcontent-%COMP%]{height:24px;line-height:24px}.eca-link[_ngcontent-%COMP%]:not([disabled]){color:var(--drc-blue);cursor:pointer}.eca-link[_ngcontent-%COMP%]:not([disabled]):not(.mat-mdc-menu-item){text-decoration:underline}button.mat-mdc-icon-button[_ngcontent-%COMP%]{position:absolute;top:0;right:-16px;background-color:transparent;height:inherit;width:inherit;max-width:44px}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]{border:2px solid transparent;background-color:transparent}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:var(--drc-light-grey)}.eca-autocomplete-dropdown-arrow[_ngcontent-%COMP%]{cursor:pointer;position:absolute;right:-4px;top:12px}"]
      });
    }
  }
  return EcaAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSearchChipListComponent = /*#__PURE__*/(() => {
  class EcaSearchChipListComponent {
    static {
      this.nextId = 0;
    }
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
      if (this.searchInput && value === true) {
        this.searchInput.disable();
      } else {
        this.searchInput.enable();
      }
    }
    get empty() {
      const currentValue = this._value;
      return currentValue === undefined || currentValue === null || currentValue.length === 0;
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(plh) {
      this._placeholder = plh;
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(req) {
      this._required = coerceBooleanProperty(req);
      this.updateErrorState();
      this.stateChanges.next();
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    // the value is what is what is given to or received from the consuming control
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
      this.onChange(val);
      this.updateErrorState();
      this.stateChanges.next();
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick() {
      // the option panel doesn't show in this scenario so don't give the input focus
      // if ((event.target as Element).tagName.toLowerCase() !== 'input') {
      //   this.elementRef.nativeElement.querySelector('input').focus();
      // }
    }
    // end initialization of MatFormFieldControl properties/etc.
    addChip(event) {
      // if options are defined then force selection from that list
      if (!this.options) {
        if (event.value) {
          this.value = this.value ? [...this.value, event.value] : [event.value];
        }
        if (event.chipInput) {
          event.chipInput.clear();
        }
        this.searchInput.setValue(null);
      }
    }
    selected(event) {
      this.value = this.value ? [...this.value, event.option.value] : [event.option.value];
      this.searchInputElement.nativeElement.value = '';
      this.searchInput.setValue(null);
    }
    constructor(ngControl, focusMonitor, elementRef) {
      this.ngControl = ngControl;
      this.focusMonitor = focusMonitor;
      this.elementRef = elementRef;
      this._disabled = false;
      this.focusInputOnClear = true;
      this.maxChipsToShow = 20;
      this.matChipInputSeparatorKeyCodes = [ENTER, COMMA];
      this.matChipInputAddOnBlur = true;
      this.optionLabelsIndexedByValue = {};
      /**
       * MatFormFieldControl requires several properties & methods;
       *   the properties are organized alphabetically below
       */
      this.controlType = 'eca-search-chip';
      this.errorState = false;
      this.focused = false;
      this.id = `eca-search-chip-list-${EcaSearchChipListComponent.nextId++}`;
      this.stateChanges = new Subject();
      this._value = [];
      this.searchInput = new FormControl();
      this.describedBy = '';
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
      focusMonitor.monitor(elementRef.nativeElement, true).pipe(distinctUntilChanged(), debounceTime(200)).subscribe(origin => {
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }
    ngOnInit() {
      this.stateChanges.next();
    }
    ngOnChanges(changes) {
      if (changes.options) {
        this.filteredOptions = this.searchInput.valueChanges.pipe(startWith(null), map(searchText => {
          if (searchText) {
            return this.filter(searchText);
          } else {
            return this.options ? this.options.slice() : [];
          }
        }));
        if (changes.options.currentValue) {
          this.options.forEach(option => {
            this.optionLabelsIndexedByValue[option.value] = option.label;
          });
        }
      }
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      this.focusMonitor.stopMonitoring(this.elementRef.nativeElement);
    }
    remove(chip) {
      const index = this.value.indexOf(chip);
      if (index >= 0) {
        this.value = [...this.value.slice(0, index), ...this.value.slice(index + 1)];
      }
    }
    removeAll(event) {
      this.value = [];
      this.searchInput.setValue('');
      this.updateErrorState();
      this.stateChanges.next();
      if (this.focusInputOnClear) {
        event.stopPropagation();
        this.focusMonitor.focusVia(this.elementRef.nativeElement.querySelector('input'), 'program');
      }
    }
    onInputBlur() {
      this.onTouched();
      this.updateErrorState();
      this.stateChanges.next();
    }
    updateErrorState() {
      if (this.ngControl) {
        this.errorState = this.ngControl.invalid && this.ngControl.touched;
      }
    }
    filter(searchText) {
      const filterValue = searchText.toLowerCase();
      if (this.options && this.options.length) {
        if (filterValue) {
          return this.options.filter(option => option.label.toLowerCase().includes(filterValue));
        } else {
          return this.options.slice();
        }
      }
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      this._value = Array.isArray(value) || !value ? value : [value];
      this.updateErrorState();
      this.stateChanges.next();
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      if (isDisabled) {
        this.searchInput.disable();
      } else {
        this.searchInput.enable();
      }
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaSearchChipListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSearchChipListComponent)(i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i2$4.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSearchChipListComponent,
        selectors: [["eca-search-chip-list"]],
        viewQuery: function EcaSearchChipListComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c11, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInputElement = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function EcaSearchChipListComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("id", ctx.id);
            i0.ɵɵattribute("aria-describedby", ctx.describedBy);
            i0.ɵɵclassProp("floating", ctx.shouldLabelFloat);
          }
        },
        inputs: {
          disabled: "disabled",
          focusInputOnClear: "focusInputOnClear",
          maxChipsToShow: "maxChipsToShow",
          options: "options",
          placeholder: "placeholder",
          required: "required",
          value: "value"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: EcaSearchChipListComponent
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 13,
        vars: 16,
        consts: [["chipListRef", ""], ["searchInputElement", ""], ["auto", "matAutocomplete"], ["title", "Chip List Search", 3, "disabled"], [4, "ngIf"], ["matInput", "", "aria-label", "search", "type", "text", 1, "eca-search-input", 3, "matChipInputTokenEnd", "formControl", "placeholder", "required", "matAutocomplete", "matChipInputFor", "matChipInputSeparatorKeyCodes", "matChipInputAddOnBlur"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "clear text", 1, "eca-icon-only", "eca-multi-line-clear", 3, "click", "disabled"], ["role", "img"], ["panelWidth", "fit", 3, "optionSelected", "hidden"], [3, "value", 4, "ngFor", "ngForOf"], [3, "removable"], [3, "removable", "removed", 4, "ngFor", "ngForOf"], [3, "removed", "removable"], ["matChipRemove", ""], [3, "value"]],
        template: function EcaSearchChipListComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-chip-grid", 3, 0);
            i0.ɵɵtemplate(2, EcaSearchChipListComponent_ng_container_2_Template, 3, 2, "ng-container", 4)(3, EcaSearchChipListComponent_ng_container_3_Template, 2, 1, "ng-container", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "input", 5, 1);
            i0.ɵɵlistener("matChipInputTokenEnd", function EcaSearchChipListComponent_Template_input_matChipInputTokenEnd_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.addChip($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "button", 6);
            i0.ɵɵlistener("click", function EcaSearchChipListComponent_Template_button_click_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.removeAll($event));
            });
            i0.ɵɵelementStart(7, "mat-icon", 7);
            i0.ɵɵtext(8, "cancel");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "mat-autocomplete", 8, 2);
            i0.ɵɵlistener("optionSelected", function EcaSearchChipListComponent_Template_mat_autocomplete_optionSelected_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selected($event));
            });
            i0.ɵɵtemplate(11, EcaSearchChipListComponent_mat_option_11_Template, 2, 2, "mat-option", 9);
            i0.ɵɵpipe(12, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const chipListRef_r6 = i0.ɵɵreference(1);
            const auto_r7 = i0.ɵɵreference(10);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵattribute("aria-hidden", !(ctx.value == null ? null : ctx.value.length));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.focused && ctx.value && ctx.value.length > ctx.maxChipsToShow);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.focused || !ctx.value || ctx.value && ctx.value.length <= ctx.maxChipsToShow);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.searchInput)("placeholder", ctx.placeholder)("required", ctx.required)("matAutocomplete", auto_r7)("matChipInputFor", chipListRef_r6)("matChipInputSeparatorKeyCodes", ctx.matChipInputSeparatorKeyCodes)("matChipInputAddOnBlur", ctx.matChipInputAddOnBlur);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hidden", !ctx.options);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(12, 14, ctx.filteredOptions));
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.RequiredValidator, i1$4.FormControlDirective, i5$2.MatAutocomplete, i2$3.MatOption, i5$2.MatAutocompleteTrigger, i4.MatIconButton, i7$1.MatChipGrid, i7$1.MatChipInput, i7$1.MatChipRemove, i7$1.MatChipRow, i6.MatSuffix, i5.MatIcon, i6$1.MatInput, i1.AsyncPipe],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent;z-index:1;--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{background-color:var(--drc-light-blue);border:3px solid var(--drc-blue);border-radius:4px;box-shadow:none;padding:0 7px!important;line-height:38px!important}.mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:7px;line-height:inherit}.mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent}.mat-mdc-button.mat-unthemed[_ngcontent-%COMP%]{--mdc-text-button-label-text-color: var(--drc-blue)}button.mat-mdc-button[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]{border-radius:4px;line-height:40px;font-style:normal;font-weight:600;font-size:16px;border:2px solid var(--drc-blue);position:relative;min-width:initial;color:var(--drc-blue);width:max-content;background-color:var(--drc-white);--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0;--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{--mdc-icon-button-state-layer-size: 44px}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%]{max-height:44px;max-width:44px}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{height:44px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only){padding:0 14px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%]{margin-right:8px;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%]{margin-right:0;margin-left:4px}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{background-color:var(--drc-blue);border:2px solid var(--drc-blue);color:var(--drc-white)}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]{padding:0 8px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 10px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin:0;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%]{border-radius:0 4px 4px 0}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{line-height:20px}button.mat-mdc-button[disabled][_ngcontent-%COMP%], button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%], .mat-datepicker-close-button[disabled][_ngcontent-%COMP%]{background-color:var(--drc-light-grey);border:2px solid var(--drc-light-grey);color:var(--drc-dark-grey)!important}button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{line-height:36px}button.mat-mdc-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 16px;background-color:var(--drc-white);color:var(--drc-blue);border:none;box-shadow:0 8px 10px -6px var(--drc-dark-grey-15),inset 0 -2px 0 var(--drc-accent-blue),inset 0 2px 0 var(--drc-accent-blue)}button.mat-mdc-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-button.mat-mdc-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.mat-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled){border-color:var(--drc-blue)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary{border-color:var(--drc-white)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before{background-color:var(--drc-bright-accent-blue);color:var(--drc-black);border:none;box-shadow:0 20px 25px -5px #262d3980,inset 0 -2px 0 var(--drc-white),inset 0 2px 0 var(--drc-white)}button.remove-btn-formatting[_ngcontent-%COMP%]{border:none!important;margin:0;padding:0;background:transparent;font-size:inherit;font-weight:400}button.remove-btn-formatting[_ngcontent-%COMP%]:not(#eca-skip-to-content-link, .nav-menu-link[_ngcontent-%COMP%], .mdc-icon-button[_ngcontent-%COMP%], #eca-user-profile-menu-link[_ngcontent-%COMP%], .eca-notification-history)[_ngcontent-%COMP%]{height:24px;line-height:24px}.eca-link[_ngcontent-%COMP%]:not([disabled]){color:var(--drc-blue);cursor:pointer}.eca-link[_ngcontent-%COMP%]:not([disabled]):not(.mat-mdc-menu-item){text-decoration:underline}[_nghost-%COMP%]{display:flex;width:100%;flex-flow:wrap}[_nghost-%COMP%]   .eca-search[_ngcontent-%COMP%]{width:calc(100% - 30px)}[_nghost-%COMP%]   .eca-search[_ngcontent-%COMP%]     input::-webkit-search-cancel-button{display:none}button.mat-mdc-icon-button[_ngcontent-%COMP%]{position:absolute;top:0;right:-16px;background-color:transparent;height:inherit;width:inherit;max-width:44px}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]{border:2px solid transparent;background-color:transparent}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:var(--drc-light-grey)}"]
      });
    }
  }
  return EcaSearchChipListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSearchSuffixComponent = /*#__PURE__*/(() => {
  class EcaSearchSuffixComponent {
    constructor() {}
    static {
      this.ɵfac = function EcaSearchSuffixComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSearchSuffixComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSearchSuffixComponent,
        selectors: [["eca-search-suffix"]],
        decls: 3,
        vars: 0,
        consts: [["mat-button", "", "type", "button", "disabled", "", "aria-hidden", "true", "color", "primary", 1, "eca-icon-only", "eca-suffix"]],
        template: function EcaSearchSuffixComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0)(1, "mat-icon");
            i0.ɵɵtext(2, "search");
            i0.ɵɵelementEnd()();
          }
        },
        dependencies: [i4.MatButton, i5.MatIcon],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}[_nghost-%COMP%]{position:relative;margin-top:30px;display:inline-block;flex:0 1 auto}button[_ngcontent-%COMP%]{margin-left:-2px}button[disabled][_ngcontent-%COMP%]{border-color:var(--drc-blue);background-color:var(--drc-blue)}button[disabled][_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:var(--drc-white)}"]
      });
    }
  }
  return EcaSearchSuffixComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSelectorBasicComponent = /*#__PURE__*/(() => {
  class EcaSiteSelectorBasicComponent {
    constructor(ecaSiteService, ecaSiteSelectorService, ecaSiteSearchService, changeDetector, focusMonitor, snackBar) {
      this.ecaSiteService = ecaSiteService;
      this.ecaSiteSelectorService = ecaSiteSelectorService;
      this.ecaSiteSearchService = ecaSiteSearchService;
      this.changeDetector = changeDetector;
      this.focusMonitor = focusMonitor;
      this.snackBar = snackBar;
      this.hideAllOption = false;
      this.cancel = new EventEmitter();
      this.save = new EventEmitter();
      this.siteSelectorSiteTypeAdministration = "administration" /* SiteSelectorSiteType.Administration */;
      this.showDropdownArrow = true;
      this.saveDisabled = false;
      this.showAdminSelectionWarning = false; // when one or more selected schools are not in the selected admin
      /**
       * These fields handle the data corresponding to the dynamically defined site type fields
       * for the expected types see SiteSelectorSiteType.
       */
      this.isLoadingByType = {}; // boolean indexed by the field type
      this.optionsByType = {}; // LabelValue[] indexed by the field type
      this.optionsByType$ = {}; // Observable of LabelValue[] indexed by the field type
      this.mapByType = {}; // a Map of ChildSite[] keyed by Site id and indexed by the field type
      this.schoolsById = new Map(); // a Map of Schools keyed by School Id
      this.ngDestroyed = new Subject();
      this.writeValueSubject$ = new Subject();
      this.loadingCompleteSubject$ = new Subject();
    }
    ngOnInit() {
      if (!this.product) {
        throw Error('product is a required attribute; please pass the Product object');
      }
      if (!this.siteHierarchy) {
        throw Error('siteHierarchy is a required attribute; please pass a valid configuration');
      }
      if (this.includeAdmin === false) {
        this.siteHierarchy = this.siteHierarchy.filter(s => s.type !== "administration" /* SiteSelectorSiteType.Administration */);
      }
      // ensure Site Hierarchy definition is properly ordered
      this.siteHierarchy.sort((a, b) => a.order < b.order ? -1 : 1);
      // initialize the Form and variables needed for each field
      const formControls = {};
      this.siteHierarchy.forEach(siteDefinition => {
        formControls[siteDefinition.type] = new FormControl();
        formControls[siteDefinition.type].addValidators(Validators.required);
        this.mapByType[siteDefinition.type] = new Map();
        this.isLoadingByType[siteDefinition.type] = false;
      });
      this.formGroup = new FormGroup(formControls);
      // special form validation when multiple sites can be selected
      if (this.multiple) {
        this.formGroup.addValidators(this.validMultiSelection());
      }
      // loop through again now that the formGroup and controls are defined
      this.siteHierarchy.forEach(siteDefinition => {
        this.optionsByType$[siteDefinition.type] = this.getOptions(siteDefinition);
      });
      combineLatest([this.writeValueSubject$.asObservable(), this.loadingCompleteSubject$.asObservable()]).subscribe(values => {
        this.setFormValues(values[0]);
      });
      // disable save if there is an enabled field without a truthy value
      this.formGroup.valueChanges.pipe(takeUntil(this.ngDestroyed), distinctUntilChanged((a, b) => {
        return this.siteHierarchy.every(siteDefinition => {
          return a[siteDefinition.type] === b[siteDefinition.type];
        });
      })).subscribe(form => {
        const missingValue = this.siteHierarchy.some(siteDefinition => {
          let noValueInForm = !form[siteDefinition.type];
          if (Array.isArray(form[siteDefinition.type])) {
            noValueInForm = form[siteDefinition.type].length === 0;
          }
          return noValueInForm && this.formGroup.get(siteDefinition.type).enabled;
        });
        this.saveDisabled = missingValue || this.formGroup.invalid;
        this.showAdminSelectionWarning = this.selectedAdminNotInSchool(form);
      });
    }
    ngAfterViewInit() {
      this.setFocusToFirstField(null, 0);
    }
    /**
     * A recursive function that will try 3 times to set focus on the first field;
     * because using cdkInitialFocus causes change detection related errors
     */
    setFocusToFirstField(parentElement, iteration) {
      if (iteration >= 3) {
        return;
      }
      if (!parentElement) {
        const basicContainer = document.getElementById('eca-site-selector-basic-container');
        window.setTimeout(() => {
          this.setFocusToFirstField(basicContainer, iteration + 1);
        }, 100);
      } else {
        const elements = parentElement.getElementsByTagNameNS('http://www.w3.org/1999/xhtml', this.multiple ? 'mat-chip-list' : 'input');
        if (elements && elements.length > 0) {
          const first = elements.item(0);
          this.focusMonitor.focusVia(first, 'program');
          this.changeDetector.detectChanges();
        }
      }
    }
    ngOnDestroy() {
      this.ngDestroyed.next(true);
      this.ngDestroyed.complete();
    }
    validMultiSelection() {
      return control => {
        const serviceComponentValue = control.get("public:servicecomponent" /* SiteSelectorSiteType.ServiceComponent */)?.value;
        const stateValue = control.get("state" /* SiteSelectorSiteType.State */)?.value;
        const districtValue = control.get("district" /* SiteSelectorSiteType.District */)?.value;
        const schoolValue = control.get("school" /* SiteSelectorSiteType.School */)?.value;
        const serviceComponentIsArray = Array.isArray(serviceComponentValue);
        const stateIsArray = Array.isArray(stateValue);
        const districtIsArray = Array.isArray(districtValue);
        const schoolIsArray = Array.isArray(schoolValue);
        const schoolIsAllSites = schoolIsArray ? this.equalsAllOption(schoolValue[0]) && schoolValue.length === 1 : this.equalsAllOption(schoolValue);
        if (districtIsArray && schoolIsArray && districtValue.length > 1 && schoolValue.length > 1) {
          return {
            multipleDistrictsAndSites: true
          };
        }
        if (districtIsArray && districtValue.length > 1 && !schoolIsAllSites) {
          return {
            allSchoolsNotSelected: true
          };
        }
        if (schoolIsArray && schoolValue.length > 1 && schoolValue.some(val => this.equalsAllOption(val))) {
          return {
            allSchoolsOrMultiple: true
          };
        }
        if (districtIsArray && districtValue.length > 1 && districtValue.some(val => this.equalsAllOption(val))) {
          return {
            allDistrictsOrMultiple: true
          };
        }
        if (serviceComponentIsArray && serviceComponentValue.length > 1 && serviceComponentValue.some(val => this.equalsAllOption(val))) {
          return {
            allServiceComponentsOrMultiple: true
          };
        }
        if (stateIsArray) {
          if (this.arrayHasDuplicate(stateValue)) {
            return {
              duplicateStates: true
            };
          }
        }
        if (districtIsArray) {
          if (this.arrayHasDuplicate(districtValue)) {
            return {
              duplicateDistricts: true
            };
          }
        }
        if (schoolIsArray) {
          if (this.arrayHasDuplicate(schoolValue)) {
            return {
              duplicateSchools: true
            };
          }
        }
        return null;
      };
    }
    arrayHasDuplicate(values) {
      for (let indexA = 0; indexA < values.length; indexA++) {
        const valueA = values[indexA];
        if (values.some((valueB, indexB) => valueA === valueB && indexA !== indexB)) {
          return true;
        }
      }
      return false;
    }
    selectedAdminNotInSchool(form) {
      const schoolValue = form["school" /* SiteSelectorSiteType.School */];
      const adminValue = form["administration" /* SiteSelectorSiteType.Administration */];
      if (schoolValue && adminValue && Array.isArray(schoolValue) && schoolValue.length > 1) {
        // check if the selected admin is not in one or more of the selected schools
        return schoolValue.some(schoolId => {
          const school = this.schoolsById.get(schoolId);
          if (school) {
            return school.hierarchies.findIndex(admin => admin.id.toString(10) === adminValue) === -1;
          }
        });
      }
      return false;
    }
    getStateFromCode(stateCode) {
      for (const [stateId, stateRecord] of this.mapByType["state" /* SiteSelectorSiteType.State */]) {
        if (stateRecord.code === stateCode) {
          return stateId;
        }
      }
      return stateCode;
    }
    /**
     * handles the use case of fields where 'All *' is selected because the All value is not part of the final value
     */
    initFieldFromCache(fieldType) {
      const formControl = this.formGroup.get(fieldType);
      const savedValue = this.ecaSiteSelectorService.get(EcaSiteSelectorService.Field + fieldType);
      if (formControl.enabled && savedValue !== undefined) {
        formControl.setValue(savedValue);
      }
    }
    setFieldInCache(fieldName, value) {
      this.ecaSiteSelectorService.set(EcaSiteSelectorService.Field + fieldName, value);
    }
    removeFieldFromCache(siteConfig) {
      this.ecaSiteSelectorService.remove(EcaSiteSelectorService.Field + siteConfig.type);
    }
    /**
     * Set the dropdown fields given the passed Site(s)
     */
    setFormValues(sites) {
      if (sites && sites.length === 0) {
        return;
      }
      // loop through each site to get the value(s) for each type
      const siteIdMap = new Map();
      sites.forEach(site => {
        // handle the main site
        if (siteIdMap.has(site.type)) {
          let currentValue = siteIdMap.get(site.type);
          if (Array.isArray(currentValue)) {
            currentValue.push(site.id);
          } else {
            currentValue = [currentValue, site.id];
          }
          siteIdMap.set(site.type, currentValue);
        } else {
          siteIdMap.set(site.type, site.id);
        }
        // handle the admin and parent if applicable
        if (site.adminId) {
          siteIdMap.set("administration" /* SiteSelectorSiteType.Administration */, site.adminId);
        }
        if (site.parentSiteId) {
          if (site.type === "school" /* SiteSelectorSiteType.School */) {
            siteIdMap.set("district" /* SiteSelectorSiteType.District */, site.parentSiteId);
          } else if (site.type === "district" /* SiteSelectorSiteType.District */) {
            siteIdMap.set("state" /* SiteSelectorSiteType.State */, site.stateCode);
          }
        }
        if (site.stateCode) {
          siteIdMap.set("state" /* SiteSelectorSiteType.State */, site.stateCode);
        }
      });
      // iterate through each field to set the value
      this.siteHierarchy.forEach(siteConfig => {
        const formControl = this.formGroup.get(siteConfig.type);
        if (formControl) {
          // special handling for the State value
          if (siteConfig.type === "state" /* SiteSelectorSiteType.State */) {
            if (siteIdMap.has("state" /* SiteSelectorSiteType.State */)) {
              const stateId = this.getStateFromCode(siteIdMap.get("state" /* SiteSelectorSiteType.State */));
              formControl.setValue(stateId);
            } else {
              // if Site was selected from Advanced view then the State won't be on the Site object
              const firstSite = Array.isArray(sites) ? sites[0] : sites;
              if (firstSite && firstSite.type === 'product') {
                // if type is 'product' they picked the 'All' option on the first field
                formControl.setValue('0');
              } else {
                this.populateStateFromSite(firstSite, siteConfig);
              }
            }
          } else if (siteIdMap.has(siteConfig.type)) {
            const siteId = siteIdMap.get(siteConfig.type);
            formControl.setValue(siteId);
          } else {
            // if this formControl has no corresponding data in the Site value then check Session storage
            this.initFieldFromCache(siteConfig.type);
          }
        }
      });
    }
    // it would be better if Site Service returned the stateCode or stateId when searching then this logic would be unnecessary
    populateStateFromSite(site, siteDefinition) {
      // search for the Site's parent which should be the State
      const searchTerm = site.parentSiteCode || site.siteCode;
      this.searchForSite(siteDefinition, "all" /* SiteSelectorSiteType.All */, searchTerm).pipe(tap(result => {
        if (result && result.sites) {
          const stateId = result.sites[0].parentSiteId;
          const districtId = site.type === "district" /* SiteSelectorSiteType.District */ ? site.id : site.parentSiteId;
          const schoolId = site.type === "school" /* SiteSelectorSiteType.School */ ? site.id : null;
          // patch the form so that no values are lost
          this.formGroup.patchValue({
            state: stateId,
            district: districtId,
            school: schoolId
          });
        }
        this.isLoadingByType[siteDefinition.type] = false;
      })).subscribe(() => {}, err => {
        console.error(err);
        const message = 'An error occurred while trying to load the related ' + siteDefinition.type;
        const config = new EcaSnackbarAlertConfig(message, 'negative');
        this.snackBar.openFromComponent(EcaSnackbarAlertComponent, config);
      });
    }
    /**
     * eg. the School field is a child of District, when District changes get the list of children Schools
     */
    getChildrenSitesWhenParentValueChanges(siteDefinition) {
      const isTheFirstField = this.siteHierarchy.findIndex(s => s.order === siteDefinition.order) === 0;
      const parentDefinition = this.siteHierarchy.find(s => s.child === siteDefinition.type);
      // if the first (top level) field then its values will be children of the product/client
      if (isTheFirstField) {
        return this.getChildrenSitesOfTheProduct(siteDefinition);
      } else {
        if (parentDefinition) {
          return this.formGroup.get(parentDefinition.type).valueChanges.pipe(takeUntil(this.ngDestroyed), distinctUntilChanged(), switchMap(parentId => {
            // the child field's options are dependent on the parent value
            this.formGroup.get(parentDefinition.child).reset(null);
            this.formGroup.get(parentDefinition.child).enable();
            // if the parent also belongsTo this field do nothing here as getSiteHierarchiesWhenBelongsToValueChanges will handle it
            //  eg. School definition has both 'child' and 'belongsTo' values of Administration
            if (parentId && parentDefinition.belongsTo !== siteDefinition.type) {
              if (this.equalsAllOption(parentId)) {
                this.formGroup.get(parentDefinition.child).disable();
                if (parentDefinition.child === "district" /* SiteSelectorSiteType.District */) {
                  this.formGroup.get("school" /* SiteSelectorSiteType.School */).disable();
                }
                this.isLoadingByType[siteDefinition.type] = false;
                return EMPTY;
              } else {
                // multiple selected so default/enforce All Sites
                if (Array.isArray(parentId) && parentId.length > 1) {
                  this.formGroup.get(parentDefinition.child).setValue('0');
                }
                this.isLoadingByType[siteDefinition.type] = true;
                return this.getChildrenSites(parentId, siteDefinition);
              }
            } else {
              return EMPTY;
            }
          }));
        }
        return EMPTY;
      }
    }
    /**
     * Whenever the product changes retrieve its immediate children sites
     */
    getChildrenSitesOfTheProduct(siteDefinition) {
      return of(this.product.abbreviation).pipe(tap(() => {
        this.isLoadingByType[siteDefinition.type] = true;
      }), concatMap(productAbbreviation => this.getChildrenSites(productAbbreviation, siteDefinition)));
    }
    /**
     * Eg. when the District value changes retrieve its Administrations
     */
    getSiteHierarchiesWhenBelongsToValueChanges(siteDefinition) {
      // fields that belongTo this field (eg. District and School belongsTo Administration)
      const belongsToDefinitions = this.siteHierarchy.filter(s => s.belongsTo === siteDefinition.type);
      if (belongsToDefinitions && belongsToDefinitions.length) {
        const valueChangesArray = belongsToDefinitions.map(belongsTo => {
          return this.formGroup.get(belongsTo.type).valueChanges.pipe(takeUntil(this.ngDestroyed), distinctUntilChanged(), switchMap(id => {
            let parentFieldValue$;
            const belongsToParentDefinition = this.siteHierarchy.find(s => s.child === belongsTo.type);
            const siteParentDefinition = this.siteHierarchy.find(s => s.child === siteDefinition.type);
            // ex. belongsTo is School, siteDefinition is Administration, siteParentDefinition is School
            const childAlsoBelongsToParent = belongsTo.type === siteParentDefinition.type;
            this.formGroup.get(siteDefinition.type).setValue(null);
            let siteType = "all" /* SiteSelectorSiteType.All */;
            if (!this.equalsAllOption(id) && childAlsoBelongsToParent) {
              siteType = siteParentDefinition.type;
            } else if (this.equalsAllOption(id) && belongsToParentDefinition) {
              siteType = belongsToParentDefinition.type;
            }
            if (this.equalsAllOption(id)) {
              // if ALL is selected search for the Site record of that field's parent value
              // ie. All Schools is selected -> search for the selected District to get its hierarchies (eg. admins)
              if (belongsToParentDefinition) {
                // need to get the label which holds the name of the site to search by
                parentFieldValue$ = this.getSelectedOptionLabel(belongsToParentDefinition.type);
              } else {
                parentFieldValue$ = this.ecaSiteService.getSelectedProduct().pipe(pluck('name'));
              }
            } else if (childAlsoBelongsToParent) {
              // if ALL is NOT selected and this field is the child of _and_ belongs to the same field
              // ie. A specific School is selected -> search for that School to get its hierarchies (eg. admins)
              parentFieldValue$ = this.getSelectedOptionLabel(siteParentDefinition.type);
            } else {
              return EMPTY;
            }
            return parentFieldValue$.pipe(concatMap(value => {
              if (Array.isArray(value)) {
                const searchRequests = value.map(val => this.searchForSite(siteDefinition, siteType, val));
                return forkJoin(searchRequests);
              } else {
                return this.searchForSite(siteDefinition, siteType, value);
              }
            }), map(results => this.mapHierarchiesToSites(siteDefinition, results)));
          }));
        });
        // append those field(s) valueChanges to the stream
        return merge(...valueChangesArray);
      } else {
        return EMPTY;
      }
    }
    /**
     * get the label(s) of the selected option given the siteType
     */
    getSelectedOptionLabel(siteType) {
      if (this.optionsByType[siteType]) {
        const selectedValue = this.formGroup.get(siteType).value;
        if (Array.isArray(selectedValue)) {
          const selectedLabels = selectedValue.map(val => {
            const option = this.optionsByType[siteType].find(opt => opt.value === val);
            return option ? option.label : null;
          }).filter(val => val !== null);
          if (selectedLabels) {
            return of(selectedLabels);
          }
        } else {
          const selectedOption = this.optionsByType[siteType].find(opt => opt.value === selectedValue);
          if (selectedOption) {
            return of(selectedOption).pipe(pluck('label'));
          }
        }
      }
      return EMPTY;
    }
    /**
     * searching for a Site is needed to get corresponding Hierarchies / Administrations
     */
    searchForSite(siteDefinition, searchSiteType, searchTerm) {
      this.isLoadingByType[siteDefinition.type] = true;
      const firstParentheses = searchTerm.indexOf(' (');
      const searchTermWithoutCode = firstParentheses !== -1 ? searchTerm.substr(0, firstParentheses) : searchTerm;
      const siteSearchParams = {
        searchTerm: searchTermWithoutCode,
        aclSpec: this.acl,
        clientAbbr: this.product.abbreviation,
        leafOnly: false,
        masterSearch: false,
        siteType: searchSiteType,
        archived: this.archived
      };
      const stateField = this.formGroup.get("state" /* SiteSearchSiteType.State */);
      if (stateField) {
        const stateId = stateField.value;
        if (stateId) {
          const state = this.mapByType["state" /* SiteSearchSiteType.State */].get(stateId.toString());
          if (state) {
            // add state code/abbreviation to the Search to get sub-admin details back
            siteSearchParams.stateAbbr = state.code;
          }
        }
      }
      return this.ecaSiteSearchService.searchV2(siteSearchParams).pipe(map(results => {
        if (results) {
          // use an object instead of Map so we don't fight with string vs. number on the key
          const filteredAdminMap = {};
          if (this.resultsFilter && typeof this.resultsFilter === 'function') {
            results.sites = this.resultsFilter(results.sites, results.hierarchies);
            // filtering sites can also filter admin/hierarchies so construct a map to reference below
            results.sites.forEach(site => {
              site.hierarchies.forEach(h => {
                filteredAdminMap[h.id] = h;
              });
            });
          }
          results.hierarchies = results.hierarchies.filter(hierarchy => {
            return !this.resultsFilter || this.resultsFilter && Object.prototype.hasOwnProperty.call(filteredAdminMap, hierarchy.id);
          });
          return {
            sites: results.sites,
            hierarchies: results.hierarchies
          };
        }
      }));
    }
    /**
     * add the site type to the hierarchy data
     */
    mapHierarchiesToSites(siteDefinition, results) {
      results = Array.isArray(results) ? results : [results];
      this.mapByType[siteDefinition.type].clear();
      this.schoolsById.clear();
      // loop through all hierarchies and create a map with all unique values
      results.forEach(result => {
        result.hierarchies.forEach(h => {
          const hierarchyWithType = {
            ...h,
            type: siteDefinition.type
          };
          this.mapByType[siteDefinition.type].set(h.id, hierarchyWithType);
        });
        result.sites.forEach(s => {
          this.schoolsById.set(s.id, s);
        });
      });
      return Array.from(this.mapByType[siteDefinition.type].values());
    }
    /**
     * Generic function that gets the appropriate options given the site type
     * AND subscribes to any fields it is dependent upon for retrieving options
     */
    getOptions(siteDefinition) {
      const childrenSites$ = this.getChildrenSitesWhenParentValueChanges(siteDefinition);
      const administrations$ = this.getSiteHierarchiesWhenBelongsToValueChanges(siteDefinition);
      return merge(childrenSites$, administrations$).pipe(map(sites => this.mapFilterToOptions(sites, siteDefinition.type)), tap(options => {
        this.isLoadingByType[siteDefinition.type] = false;
        this.optionsByType[siteDefinition.type] = options;
        this.autoSelectSingleOption(siteDefinition, options);
      }), finalize(() => {
        this.isLoadingByType[siteDefinition.type] = false;
        this.loadingCompleteSubject$.next(true);
      }), catchError(err => {
        this.isLoadingByType[siteDefinition.type] = false;
        return err;
      }));
    }
    /**
     * if the user only has access to one option ...
     */
    autoSelectSingleOption(siteDefinition, options) {
      if (options.length === 1) {
        // the theory is Angular needs to bind the options first before setting the value will trigger value changes
        setTimeout(() => {
          this.formGroup.get(siteDefinition.type).setValue(options[0].value);
          // ToDo: multiple disabling isn't working with the search/autocomplete so don't disable for now
          if (this.multiple === false) {
            this.formGroup.get(siteDefinition.type).disable();
          }
          this.changeDetector.detectChanges();
        }, 1);
      }
    }
    /**
     * query ECA Site Service for children sites corresponding to the parentId
     * @param parentId see ecaSiteService.listChildren for expected values
     * @param siteDefinition the site field configuration
     */
    getChildrenSites(parentId, siteDefinition) {
      parentId = Array.isArray(parentId) ? parentId[0] : parentId;
      if (parentId) {
        return this.ecaSiteService.listChildren(parentId, this.acl, this.product.abbreviation, this.archived).pipe(tap(sites => {
          sites.forEach(site => this.mapByType[siteDefinition.type].set(site.id, site));
        }));
      } else {
        return of([]);
      }
    }
    /**
     * filter results to the passed type; map results to LabelValue; and sort alphabetically by label
     */
    mapFilterToOptions(results, typeFilter) {
      let returnResults = [];
      if (typeFilter) {
        returnResults = results.filter(r => r.type === typeFilter || r.type === "all" /* SiteSelectorSiteType.All */);
      }
      let foundAllIndex = -1;
      if (this.hideAllOption) {
        foundAllIndex = returnResults.findIndex(rr => {
          return this.equalsAllOption(rr.id);
        });
      }
      if (foundAllIndex !== -1) {
        returnResults.splice(foundAllIndex, 1);
      }
      const allName = 'ALL ' + typeFilter.toUpperCase() + 'S';
      return returnResults.map(rr => {
        if (this.equalsAllOption(rr.id)) {
          // this also overwrites the name by reference
          rr.name = allName;
        }
        let label = rr.name;
        if (this.showSiteCode && !this.equalsAllOption(rr.id) && (typeFilter === "district" /* SiteSelectorSiteType.District */ || typeFilter === "public:servicecomponent" /* SiteSelectorSiteType.ServiceComponent */ || typeFilter === "school" /* SiteSelectorSiteType.School */ || typeFilter === "administration" /* SiteSelectorSiteType.Administration */)) {
          label = rr.name + ' (' + rr.code + ')';
        }
        return {
          value: rr.id,
          label: label
        };
      }).sort((a, b) => {
        if (typeFilter === "administration" /* SiteSelectorSiteType.Administration */) {
          return this.ecaSiteService.smartSortHierarchies(a, b);
        } else {
          const aLabel = a.label.toLowerCase();
          const bLabel = b.label.toLowerCase();
          // value of 0 correlates to the 'All Sites' option and should be first in the list of options
          return this.equalsAllOption(a.value) || aLabel < bLabel && !this.equalsAllOption(b.value) ? -1 : 1;
        }
      });
    }
    /**
     * '0' is hardcode in Site Service as the 'All Sites' option given to users with the corresponding permission
     */
    equalsAllOption(value) {
      return Array.isArray(value) ? value.length === 1 && value[0] === '0' : value === '0';
    }
    onCancelClick() {
      this.cancel.emit();
    }
    /**
     * Gets the selected ChildSite values and emits the final Site value
     * for any type there could be more than one Site selected
     */
    onSaveClick() {
      const finalValue = new Map();
      this.siteHierarchy.forEach(siteDefinition => {
        const selectedValue = this.formGroup.get(siteDefinition.type).value;
        if (selectedValue) {
          const optionValue = Array.isArray(selectedValue) ? selectedValue.map(val => this.getChildSiteAndPersistIfAll(val, siteDefinition)) : this.getChildSiteAndPersistIfAll(selectedValue, siteDefinition);
          finalValue.set(siteDefinition.type, optionValue);
        }
      });
      const sites = this.transformToSite(finalValue);
      this.save.emit(sites);
    }
    getChildSiteAndPersistIfAll(selectedValue, siteDefinition) {
      const site = this.mapByType[siteDefinition.type].get(selectedValue);
      if (this.equalsAllOption(selectedValue)) {
        site.fieldName = siteDefinition.type;
      } else {
        this.removeFieldFromCache(siteDefinition);
      }
      return site;
    }
    /**
     * transform ChildSite values which may themselves be arrays into one
     * or many Sites depending on if multiple Districts or Schools were selected
     */
    transformToSite(siteValueMap) {
      const admin = siteValueMap.get("administration" /* SiteSelectorSiteType.Administration */);
      const school = siteValueMap.get("school" /* SiteSelectorSiteType.School */);
      let district = siteValueMap.get("district" /* SiteSelectorSiteType.District */);
      const state = siteValueMap.get("state" /* SiteSelectorSiteType.State */);
      const serviceComponent = siteValueMap.get("public:servicecomponent" /* SiteSelectorSiteType.ServiceComponent */);
      if (!admin && !school && !district && !state && !serviceComponent) {
        return null;
      }
      // check whether District or School has multiple selections
      if (Array.isArray(district) && district.length > 1) {
        // create multiple sites for each District
        return district.map(d => {
          return this.childSitesToSite(admin, school[0], d, state, serviceComponent);
        });
      } else {
        district = Array.isArray(district) ? district[0] : district;
        if (Array.isArray(school)) {
          // create multiple sites for each School
          return school.map(s => {
            return this.childSitesToSite(admin, s, district, state, serviceComponent);
          });
        } else if (Array.isArray(serviceComponent)) {
          return serviceComponent.map(sc => {
            return this.childSitesToSite(admin, school, district, state, sc);
          });
        } else if (Array.isArray(state)) {
          return state.map(st => {
            return this.childSitesToSite(admin, school, district, st, serviceComponent);
          });
        } else {
          const site = this.childSitesToSite(admin, school, district, state, serviceComponent);
          return site;
        }
      }
    }
    /**
     * Transform a set of ChildSites into a Site object
     */
    childSitesToSite(admin, school, district, state, serviceComponent) {
      let site = {};
      if (admin) {
        site.adminId = admin.id;
        site.adminCode = admin.code;
        site.adminName = admin.name;
        site.adminNumber = admin.number;
      }
      state = Array.isArray(state) ? state[0] : state;
      // the Site could be a School, District, State or even Product
      if (school && school.type !== "all" /* SiteSelectorSiteType.All */) {
        site = {
          ...site,
          ...this.setSite(school)
        };
        if (district.type !== "all" /* SiteSelectorSiteType.All */) {
          site = {
            ...site,
            ...this.setParentSite(district)
          };
        } else if (state && state.type !== "all" /* SiteSelectorSiteType.All */) {
          site.stateCode = state.code;
        }
      }
      if (district && district.type !== "all" /* SiteSelectorSiteType.All */ && !site.id) {
        site = {
          ...site,
          ...this.setSite(district)
        };
      }
      if (state && state.type !== "all" /* SiteSelectorSiteType.All */) {
        if (!site.id) {
          site = {
            ...site,
            ...this.setSite(state)
          };
        } else {
          site.stateCode = state.code;
        }
      }
      if (serviceComponent) {
        site = {
          ...site,
          ...this.setSite(serviceComponent)
        };
      }
      [serviceComponent, school, district, state].forEach(site => {
        if (site && site.type === "all" /* SiteSelectorSiteType.All */ && site.fieldName) {
          this.setFieldInCache(site.fieldName, site.id);
        }
      });
      if (!site.id) {
        const productSite = {
          id: this.product.id,
          code: this.product.abbreviation,
          name: this.product.name,
          type: 'product',
          path: district ? district.path : state ? state.path : ''
        };
        site = {
          ...site,
          ...this.setSite(productSite)
        };
      }
      return site;
    }
    setSite(childSite) {
      return {
        id: childSite.id,
        siteCode: childSite.code,
        siteName: childSite.name,
        type: childSite.type,
        path: childSite.path
      };
    }
    setParentSite(parentSite) {
      return {
        parentSiteId: parentSite.id,
        parentSiteCode: parentSite.code,
        parentSiteName: parentSite.name
      };
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      if (value) {
        this.writeValueSubject$.next(value);
      } else {
        this.formGroup.reset();
      }
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaSiteSelectorBasicComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSelectorBasicComponent)(i0.ɵɵdirectiveInject(EcaSiteService), i0.ɵɵdirectiveInject(EcaSiteSelectorService), i0.ɵɵdirectiveInject(EcaSiteSearchService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$4.FocusMonitor), i0.ɵɵdirectiveInject(i2$2.MatSnackBar));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSiteSelectorBasicComponent,
        selectors: [["eca-site-selector-basic"]],
        inputs: {
          product: "product",
          siteHierarchy: "siteHierarchy",
          includeAdmin: "includeAdmin",
          acl: "acl",
          archived: "archived",
          hideAllOption: "hideAllOption",
          multiple: "multiple",
          resultsFilter: "resultsFilter",
          showSiteCode: "showSiteCode"
        },
        outputs: {
          cancel: "cancel",
          save: "save"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: EcaSiteSelectorBasicComponent,
          multi: true
        }])],
        decls: 9,
        vars: 5,
        consts: [["id", "eca-site-selector-basic-container", 1, "eca-fx-col", 3, "formGroup"], ["class", "eca-fx-row", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "eca-fx-row", "eca-fx-gap-1", "eca-fx-justify-content-end"], ["mat-button", "", 3, "click"], ["mat-button", "", "color", "primary", 3, "click", "disabled"], [1, "eca-fx-row"], [1, "eca-no-padding-bottom", "eca-fx-auto"], ["diameter", "24", "color", "accent", 4, "ngIf"], ["diameter", "24", "color", "accent"], [3, "options", "formControlName", "required", "maxChipsToShow", "focusInputOnClear"], [3, "options", "presentAsSelect", "required", "formControlName"]],
        template: function EcaSiteSelectorBasicComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, EcaSiteSelectorBasicComponent_div_1_Template, 8, 5, "div", 1)(2, EcaSiteSelectorBasicComponent_mat_hint_2_Template, 4, 0, "mat-hint", 2)(3, EcaSiteSelectorBasicComponent_mat_error_3_Template, 7, 6, "mat-error", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3)(5, "button", 4);
            i0.ɵɵlistener("click", function EcaSiteSelectorBasicComponent_Template_button_click_5_listener() {
              return ctx.onCancelClick();
            });
            i0.ɵɵtext(6, "Cancel");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "button", 5);
            i0.ɵɵlistener("click", function EcaSiteSelectorBasicComponent_Template_button_click_7_listener() {
              return ctx.onSaveClick();
            });
            i0.ɵɵtext(8, "Save");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.formGroup);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.siteHierarchy);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showAdminSelectionWarning);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formGroup.errors);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.saveDisabled);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, EcaAutocompleteComponent, EcaSearchChipListComponent, EcaSearchSuffixComponent, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.RequiredValidator, i4.MatButton, i6.MatFormField, i6.MatLabel, i6.MatHint, i6.MatError, i7$2.MatProgressSpinner, i1$4.FormGroupDirective, i1$4.FormControlName, i1.AsyncPipe],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}[_nghost-%COMP%]{display:block;width:100%;overflow:auto}[_nghost-%COMP%]   .mat-mdc-progress-spinner[_ngcontent-%COMP%]{margin:0 auto -24px}[_nghost-%COMP%]   .mat-mdc-progress-spinner[_ngcontent-%COMP%]     circle{stroke:var(--drc-insight-gold)}[_nghost-%COMP%]   .mat-mdc-form-field-error[_ngcontent-%COMP%], [_nghost-%COMP%]   .mat-mdc-form-field-hint[_ngcontent-%COMP%]{margin-bottom:16px}"]
      });
    }
  }
  return EcaSiteSelectorBasicComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSearchComponent = /*#__PURE__*/(() => {
  class EcaSearchComponent {
    static {
      this.nextId = 0;
    }
    get empty() {
      const currentValue = this._value;
      return currentValue === undefined || currentValue === null || !currentValue.trim();
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(plh) {
      this._placeholder = plh;
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(req) {
      this._required = coerceBooleanProperty(req);
      this.updateErrorState();
      this.stateChanges.next();
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    // the value is what is given to or received from the consuming control
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
      this.onChange(val);
      this.updateErrorState();
      this.stateChanges.next();
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick() {
      // the option panel doesn't show in this scenario so don't give the input focus
      // if ((event.target as Element).tagName.toLowerCase() !== 'input') {
      //   this.elementRef.nativeElement.querySelector('input').focus();
      // }
    }
    // end initialization of MatFormFieldControl properties/etc.
    // ngModel for the <input> element
    get searchInput() {
      return this.value;
    }
    set searchInput(val) {
      this.value = val;
    }
    constructor(ngControl, matFormField, focusMonitor, elementRef, changeDetector) {
      this.ngControl = ngControl;
      this.matFormField = matFormField;
      this.focusMonitor = focusMonitor;
      this.elementRef = elementRef;
      this.changeDetector = changeDetector;
      this.ariaLabel = 'search';
      this.disabled = false;
      this.disableAutocomplete = false;
      /**
       * MatFormFieldControl requires several properties & methods;
       *   the properties are organized alphabetically below
       */
      this.controlType = 'eca-search';
      this.errorState = false;
      this.focused = false;
      this.id = `eca-search-${EcaSearchComponent.nextId++}`;
      this.stateChanges = new Subject();
      this.describedBy = '';
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
      focusMonitor.monitor(elementRef.nativeElement, true).subscribe(origin => {
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }
    ngOnInit() {
      this.stateChanges.next();
      const focusOnInit = this.elementRef.nativeElement.hasAttribute('cdkfocusinitial');
      if (focusOnInit) {
        this.focusMonitor.focusVia(this.elementRef.nativeElement.querySelector('input'), 'program');
      }
    }
    ngAfterViewInit() {
      // clear aria-label if this search field has a visible label
      const hostElement = this.matFormField?._elementRef?.nativeElement;
      if (hostElement) {
        const labelEl = hostElement.querySelector('label');
        if (labelEl && labelEl.textContent?.trim()) {
          this.ariaLabel = labelEl.textContent.trim();
          this.changeDetector.detectChanges();
        }
      }
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      this.focusMonitor.stopMonitoring(this.elementRef.nativeElement);
    }
    clearInput(event) {
      this.searchInput = '';
      this.updateErrorState();
      this.stateChanges.next();
      event.stopPropagation();
      this.focusMonitor.focusVia(this.elementRef.nativeElement.querySelector('input'), 'program');
    }
    onInputBlur() {
      this.onTouched();
      this.updateErrorState();
      this.stateChanges.next();
    }
    updateErrorState() {
      if (this.ngControl) {
        this.errorState = this.ngControl.invalid && this.ngControl.touched;
      }
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      this._value = value;
      this.updateErrorState();
      this.stateChanges.next();
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSearchComponent)(i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i6.MatFormField, 9), i0.ɵɵdirectiveInject(i2$4.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSearchComponent,
        selectors: [["eca-search"]],
        hostVars: 4,
        hostBindings: function EcaSearchComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("id", ctx.id);
            i0.ɵɵattribute("aria-describedby", ctx.describedBy);
            i0.ɵɵclassProp("floating", ctx.shouldLabelFloat);
          }
        },
        inputs: {
          disabled: "disabled",
          maxLength: "maxLength",
          disableAutocomplete: "disableAutocomplete",
          placeholder: "placeholder",
          required: "required",
          value: "value"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: EcaSearchComponent
        }])],
        decls: 6,
        vars: 8,
        consts: [["ecaSearchInput", ""], [1, "eca-search"], ["matInput", "", "type", "search", 1, "eca-search-input", 3, "ngModelChange", "blur", "placeholder", "ngModel", "required", "maxlength", "disabled", "autocomplete"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "clear text", "type", "button", 1, "eca-icon-only", 3, "click", "disabled"], ["role", "img"]],
        template: function EcaSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "input", 2, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function EcaSearchComponent_Template_input_ngModelChange_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.searchInput, $event) || (ctx.searchInput = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("blur", function EcaSearchComponent_Template_input_blur_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 3);
            i0.ɵɵlistener("click", function EcaSearchComponent_Template_button_click_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.clearInput($event));
            });
            i0.ɵɵelementStart(4, "mat-icon", 4);
            i0.ɵɵtext(5, "cancel");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("placeholder", ctx.placeholder);
            i0.ɵɵtwoWayProperty("ngModel", ctx.searchInput);
            i0.ɵɵproperty("required", ctx.required)("maxlength", ctx.maxLength)("disabled", ctx.disabled)("autocomplete", ctx.disableAutocomplete ? "one-time-code" : "");
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.searchInput);
          }
        },
        dependencies: [i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.RequiredValidator, i1$4.MaxLengthValidator, i1$4.NgModel, i4.MatIconButton, i6.MatSuffix, i5.MatIcon, i6$1.MatInput],
        styles: [_c12]
      });
    }
  }
  return EcaSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSelectorTableComponent = /*#__PURE__*/(() => {
  class EcaSiteSelectorTableComponent {
    constructor(ecaSiteSelectorService) {
      this.ecaSiteSelectorService = ecaSiteSelectorService;
      this.rowClick = new EventEmitter();
      this.maxSearchLength = EcaSiteSearchService.maxSearchLength;
      this.ngDestroyed = new Subject();
      this.dataSource = new MatTableDataSource();
    }
    ngOnInit() {
      if (!this.searchControl) {
        this.searchControl = new FormControl('');
      }
      if (!this.siteTypeControl) {
        this.siteTypeControl = new FormControl('');
      }
      if (!this.stateControl) {
        this.stateControl = new FormControl('');
      }
      if (this.stateOptions$) {
        this.statesLoading = true;
        this.stateOptions$.pipe(map(states => {
          this.stateOptions = states.map(s => s.code);
          return this.stateOptions;
        })).subscribe(() => {
          this.statesLoading = false;
        }, () => {
          this.statesLoading = false;
        }, () => {
          this.statesLoading = false;
        });
      }
      // this.sort.sort({ id: 'lastVisitedDate', start: 'desc', disableClear: false });
      this.siteResults$.pipe(takeUntil(this.ngDestroyed), switchMap(siteResults => {
        this.dataSource = new MatTableDataSource(siteResults);
        this.dataSource.sort = this.sort;
        const sortColumn = this.ecaSiteSelectorService.get(EcaSiteSelectorService.SortColumn);
        const sortDirection = this.ecaSiteSelectorService.get(EcaSiteSelectorService.SortDirection);
        if (this.dataSource.sort) {
          this.dataSource.sort.sort({
            id: sortColumn,
            start: sortDirection,
            disableClear: false
          });
          return this.dataSource.sort.sortChange.pipe(tap(sort => {
            this.ecaSiteSelectorService.set(EcaSiteSelectorService.SortColumn, sort.active);
            this.ecaSiteSelectorService.set(EcaSiteSelectorService.SortDirection, sort.direction);
          }));
        } else {
          return EMPTY;
        }
      })).subscribe();
    }
    ngOnDestroy() {
      this.ngDestroyed.next(true);
      this.ngDestroyed.complete();
    }
    onSiteRowClick(row) {
      this.rowClick.emit(row);
    }
    clearInput() {
      this.searchControl.setValue('');
    }
    static {
      this.ɵfac = function EcaSiteSelectorTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSelectorTableComponent)(i0.ɵɵdirectiveInject(EcaSiteSelectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSiteSelectorTableComponent,
        selectors: [["eca-site-selector-table"]],
        viewQuery: function EcaSiteSelectorTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
          }
        },
        inputs: {
          displayedColumns: "displayedColumns",
          loadingResults$: "loadingResults$",
          parentNameColumnLabel: "parentNameColumnLabel",
          parentCodeColumnLabel: "parentCodeColumnLabel",
          stateControl: "stateControl",
          siteTypeControl: "siteTypeControl",
          searchControl: "searchControl",
          stateOptions$: "stateOptions$",
          siteTypeOptions: "siteTypeOptions",
          selection: "selection",
          siteResults$: "siteResults$"
        },
        outputs: {
          rowClick: "rowClick"
        },
        decls: 31,
        vars: 20,
        consts: [[1, "eca-fx-row"], ["class", "eca-search-prefix", 4, "ngIf"], ["class", "eca-search-prefix", 3, "ngClass", 4, "ngIf"], [1, "eca-site-selector-form-field", "eca-search", 3, "ngClass"], ["matInput", "", "cdkFocusInitial", "", "placeholder", "Search by name or code", 3, "maxLength", "formControl"], [4, "ngIf"], [1, "results-count-container", 3, "hidden"], [1, "table-scroll-container"], ["mat-table", "", "matSort", "", 3, "dataSource"], ["matColumnDef", "multi-select"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["matColumnDef", "name"], ["mat-header-cell", "", "mat-sort-header", "", 4, "matHeaderCellDef"], ["mat-cell", "", 3, "innerHTML", 4, "matCellDef"], ["matColumnDef", "code"], ["matColumnDef", "parentSiteName"], ["matColumnDef", "parentSiteCode"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "click", 4, "matRowDef", "matRowDefColumns"], ["class", "spinner-container", 4, "ngIf"], ["class", "no-data-container", 4, "ngIf"], [1, "eca-search-prefix"], ["class", "eca-select-spinner", "diameter", "24", "color", "accent", 4, "ngIf"], [3, "formControl"], [3, "value", 4, "ngFor", "ngForOf"], ["diameter", "24", "color", "accent", 1, "eca-select-spinner"], [3, "value"], [1, "eca-search-prefix", 3, "ngClass"], ["name", "site-type", 3, "formControl"], ["mat-header-cell", ""], ["mat-cell", ""], [3, "change", "checked"], ["mat-header-cell", "", "mat-sort-header", ""], ["mat-cell", "", 3, "innerHTML"], ["mat-header-row", ""], ["mat-row", "", 3, "click"], [1, "spinner-container"], [3, "diameter"], [1, "no-data-container"]],
        template: function EcaSiteSelectorTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, EcaSiteSelectorTableComponent_mat_form_field_1_Template, 4, 3, "mat-form-field", 1)(2, EcaSiteSelectorTableComponent_mat_form_field_2_Template, 3, 5, "mat-form-field", 2);
            i0.ɵɵelementStart(3, "mat-form-field", 3);
            i0.ɵɵelement(4, "eca-search", 4);
            i0.ɵɵtemplate(5, EcaSiteSelectorTableComponent_mat_hint_5_Template, 2, 0, "mat-hint", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 7)(9, "table", 8);
            i0.ɵɵelementContainerStart(10, 9);
            i0.ɵɵtemplate(11, EcaSiteSelectorTableComponent_th_11_Template, 2, 0, "th", 10)(12, EcaSiteSelectorTableComponent_td_12_Template, 2, 1, "td", 11);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(13, 12);
            i0.ɵɵtemplate(14, EcaSiteSelectorTableComponent_th_14_Template, 2, 0, "th", 13)(15, EcaSiteSelectorTableComponent_td_15_Template, 2, 4, "td", 14);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(16, 15);
            i0.ɵɵtemplate(17, EcaSiteSelectorTableComponent_th_17_Template, 2, 0, "th", 13)(18, EcaSiteSelectorTableComponent_td_18_Template, 2, 4, "td", 14);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(19, 16);
            i0.ɵɵtemplate(20, EcaSiteSelectorTableComponent_th_20_Template, 2, 1, "th", 13)(21, EcaSiteSelectorTableComponent_td_21_Template, 2, 1, "td", 11);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(22, 17);
            i0.ɵɵtemplate(23, EcaSiteSelectorTableComponent_th_23_Template, 2, 1, "th", 13)(24, EcaSiteSelectorTableComponent_td_24_Template, 2, 1, "td", 11);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(25, EcaSiteSelectorTableComponent_tr_25_Template, 1, 0, "tr", 18)(26, EcaSiteSelectorTableComponent_tr_26_Template, 1, 0, "tr", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(27, EcaSiteSelectorTableComponent_div_27_Template, 2, 1, "div", 20);
            i0.ɵɵpipe(28, "async");
            i0.ɵɵtemplate(29, EcaSiteSelectorTableComponent_div_29_Template, 3, 0, "div", 21);
            i0.ɵɵpipe(30, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.stateOptions$);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.siteTypeOptions == null ? null : ctx.siteTypeOptions.length) > 1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c13, (ctx.siteTypeOptions == null ? null : ctx.siteTypeOptions.length) > 1));
            i0.ɵɵadvance();
            i0.ɵɵproperty("maxLength", ctx.maxSearchLength)("formControl", ctx.searchControl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.dataSource.data == null ? null : ctx.dataSource.data.length) >= 50);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", !(ctx.dataSource == null ? null : ctx.dataSource.data == null ? null : ctx.dataSource.data.length));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" Results (", ctx.dataSource.data.length, ") ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("dataSource", ctx.dataSource);
            i0.ɵɵadvance(16);
            i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns)("matHeaderRowDefSticky", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(28, 14, ctx.loadingResults$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(30, 16, ctx.loadingResults$) !== true && (ctx.dataSource.data == null ? null : ctx.dataSource.data.length) === 0 && ctx.searchControl.value && (ctx.searchControl.value == null ? null : ctx.searchControl.value.length) > 2);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, EcaSearchComponent, i2.DefaultClassDirective, i1$4.NgControlStatus, i6.MatFormField, i6.MatHint, i7$2.MatProgressSpinner, i4$1.MatSelect, i2$3.MatOption, i4$2.MatSort, i4$2.MatSortHeader, i6$2.MatTable, i6$2.MatHeaderCellDef, i6$2.MatHeaderRowDef, i6$2.MatColumnDef, i6$2.MatCellDef, i6$2.MatRowDef, i6$2.MatHeaderCell, i6$2.MatCell, i6$2.MatHeaderRow, i6$2.MatRow, i1$4.FormControlDirective, i12.MatCheckbox, i1.AsyncPipe, EcaHighlightTextPipe],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}.table-scroll-container[_ngcontent-%COMP%]{height:100%;overflow:auto}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row){cursor:pointer}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row):hover{text-decoration:underline}.spinner-container[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;padding-top:24px}.eca-select-spinner.mat-mdc-progress-spinner[_ngcontent-%COMP%]{margin:0 auto -24px}.eca-select-spinner.mat-mdc-progress-spinner[_ngcontent-%COMP%]     circle{stroke:var(--drc-insight-gold)}button.row-select-button[_ngcontent-%COMP%]{margin-right:16px}.mat-icon.mat-clear[_ngcontent-%COMP%]{cursor:pointer}.filter-group[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{margin:-22px 0 -14px}.no-data-container[_ngcontent-%COMP%]{padding:8px;text-align:center}.eca-site-selector-form-field[_ngcontent-%COMP%]{width:480px}.results-count-container[_ngcontent-%COMP%]{padding-left:16px;flex-direction:column;justify-content:center;margin-bottom:16px;display:flex;flex:1 1 auto}"]
      });
    }
  }
  return EcaSiteSelectorTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function OnChange(functionName) {
  const cachedValueKey = Symbol();
  const isFirstChangeKey = Symbol();
  return (target, key) => {
    Object.defineProperty(target, key, {
      set: function (value) {
        // change status of "isFirstChange"
        this[isFirstChangeKey] = this[isFirstChangeKey] === undefined;
        // No operation if new value is same as old value
        if (!this[isFirstChangeKey] && this[cachedValueKey] === value) {
          return;
        }
        const oldValue = this[cachedValueKey];
        this[cachedValueKey] = value;
        const simpleChange = {
          firstChange: this[isFirstChangeKey],
          previousValue: oldValue,
          currentValue: this[cachedValueKey]
        };
        if (Object.prototype.hasOwnProperty.call(target, functionName)) {
          target[functionName].call(this, this[cachedValueKey], simpleChange);
        } else {
          throw new Error('Unable to find function ' + functionName + ' on this class');
        }
      },
      get: function () {
        return this[cachedValueKey];
      }
    });
  };
}
let EcaAdminSelectorTableComponent = /*#__PURE__*/(() => {
  class EcaAdminSelectorTableComponent {
    constructor() {
      this.dataSource = new MatTableDataSource();
      this.rowClick = new EventEmitter();
    }
    ngOnInit() {
      this.sort.sort({
        id: 'updateDate',
        start: 'desc',
        disableClear: false
      });
      this.dataSource.sort = this.sort;
    }
    adminResultsChanged(value) {
      this.dataSource.data = value || [];
    }
    onAdminRowClick(row) {
      this.rowClick.emit(row);
    }
    static {
      this.ɵfac = function EcaAdminSelectorTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAdminSelectorTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaAdminSelectorTableComponent,
        selectors: [["eca-admin-selector-table"]],
        viewQuery: function EcaAdminSelectorTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
          }
        },
        inputs: {
          adminResults: "adminResults",
          displayedColumns: "displayedColumns",
          selection: "selection"
        },
        outputs: {
          rowClick: "rowClick"
        },
        decls: 19,
        vars: 4,
        consts: [[1, "table-scroll-container"], ["mat-table", "", "matSort", "", 3, "dataSource"], ["matColumnDef", "name"], ["mat-header-cell", "", "mat-sort-header", "", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["matColumnDef", "code"], ["matColumnDef", "number"], ["matColumnDef", "updateDate"], ["matColumnDef", "select"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "click", 4, "matRowDef", "matRowDefColumns"], ["mat-header-cell", "", "mat-sort-header", ""], ["mat-cell", ""], ["mat-header-cell", ""], ["mat-button", "", "matStepperNext", "", 1, "row-select-button", "mat-small-button", 3, "ngClass"], ["mat-header-row", ""], ["mat-row", "", 3, "click"]],
        template: function EcaAdminSelectorTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "table", 1);
            i0.ɵɵelementContainerStart(2, 2);
            i0.ɵɵtemplate(3, EcaAdminSelectorTableComponent_th_3_Template, 2, 0, "th", 3)(4, EcaAdminSelectorTableComponent_td_4_Template, 2, 1, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(5, 5);
            i0.ɵɵtemplate(6, EcaAdminSelectorTableComponent_th_6_Template, 2, 0, "th", 3)(7, EcaAdminSelectorTableComponent_td_7_Template, 2, 1, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(8, 6);
            i0.ɵɵtemplate(9, EcaAdminSelectorTableComponent_th_9_Template, 2, 0, "th", 3)(10, EcaAdminSelectorTableComponent_td_10_Template, 2, 1, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(11, 7);
            i0.ɵɵtemplate(12, EcaAdminSelectorTableComponent_th_12_Template, 2, 0, "th", 3)(13, EcaAdminSelectorTableComponent_td_13_Template, 3, 3, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(14, 8);
            i0.ɵɵtemplate(15, EcaAdminSelectorTableComponent_th_15_Template, 2, 0, "th", 9)(16, EcaAdminSelectorTableComponent_td_16_Template, 3, 3, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(17, EcaAdminSelectorTableComponent_tr_17_Template, 1, 0, "tr", 10)(18, EcaAdminSelectorTableComponent_tr_18_Template, 1, 0, "tr", 11);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("dataSource", ctx.dataSource);
            i0.ɵɵadvance(16);
            i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns)("matHeaderRowDefSticky", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
          }
        },
        dependencies: [i1.NgClass, i2.DefaultClassDirective, i4.MatButton, i4$2.MatSort, i4$2.MatSortHeader, i7$3.MatStepperNext, i6$2.MatTable, i6$2.MatHeaderCellDef, i6$2.MatHeaderRowDef, i6$2.MatColumnDef, i6$2.MatCellDef, i6$2.MatRowDef, i6$2.MatHeaderCell, i6$2.MatCell, i6$2.MatHeaderRow, i6$2.MatRow, i1.DatePipe],
        styles: [_c15]
      });
    }
  }
  __decorate([OnChange('adminResultsChanged')], EcaAdminSelectorTableComponent.prototype, "adminResults", void 0);
  return EcaAdminSelectorTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSelectorAdvancedComponent = /*#__PURE__*/(() => {
  class EcaSiteSelectorAdvancedComponent {
    constructor(ecaSiteSearch, ecaSiteService, ecaSiteSelectorService, setupConfigService, ngZone) {
      this.ecaSiteSearch = ecaSiteSearch;
      this.ecaSiteService = ecaSiteService;
      this.ecaSiteSelectorService = ecaSiteSelectorService;
      this.setupConfigService = setupConfigService;
      this.ngZone = ngZone;
      this.cancel = new EventEmitter();
      this.save = new EventEmitter();
      this.siteTypeOptions = [];
      this.maxSearchLength = EcaSiteSearchService.maxSearchLength;
      this.firstStepDefaultLabel = 'Select a Site';
      this.firstStepLabel = this.firstStepDefaultLabel;
      this.selection = {
        site: new SelectionModel(false, []),
        admin: new SelectionModel(false, [])
      };
      this.displayedColumns = {
        siteTable: ['name', 'code', 'parentSiteName', 'parentSiteCode'],
        adminTable: ['name', 'code', 'number', 'updateDate']
      };
      this.loadingResults$ = new BehaviorSubject(false);
      this.siteResults$ = of([]);
      this.siteMap = new Map();
      this.adminMap = new Map();
      this.ngDestroyed = new Subject();
    }
    ngOnInit() {
      this.stateControl = new FormControl();
      this.siteTypeControl = new FormControl();
      this.searchControl = new FormControl();
      this.getFeatureToggles();
      this.setupSearchFields(this.siteHierarchy);
      this.subscribeToSearchInput();
    }
    ngOnDestroy() {
      this.ngDestroyed.next(true);
      this.ngDestroyed.complete();
    }
    getFeatureToggles() {
      if (this.product) {
        this.setupConfigService.getAttributeForClient(this.product.abbreviation, 'site-search-feature-toggles').subscribe(attribute => {
          const feature = attribute ? attribute.value : null;
          if (feature && feature.hideAdminCodeColumn) {
            const codeIndex = this.displayedColumns.adminTable.indexOf('code');
            this.displayedColumns.adminTable.splice(codeIndex, 1);
          }
          if (feature && feature.hideAdminNumberColumn) {
            const numberIndex = this.displayedColumns.adminTable.indexOf('number');
            this.displayedColumns.adminTable.splice(numberIndex, 1);
          }
          if (feature && feature.hideUpdateDateColumn) {
            const numberIndex = this.displayedColumns.adminTable.indexOf('updateDate');
            this.displayedColumns.adminTable.splice(numberIndex, 1);
          }
        });
      }
    }
    setupSearchFields(siteHierarchy) {
      this.siteTypeOptions = [];
      const storedSearchText = this.ecaSiteSelectorService.get(EcaSiteSelectorService.SearchText);
      if (storedSearchText) {
        this.searchControl.setValue(storedSearchText);
      }
      const storedStateValue = this.ecaSiteSelectorService.get(EcaSiteSelectorService.StateFilterAdvanced);
      this.stateControl.setValue(storedStateValue);
      const hasStates = siteHierarchy.some(s => s.type === "state" /* SiteSelectorSiteType.State */);
      const hasDistrict = siteHierarchy.some(s => s.type === "district" /* SiteSelectorSiteType.District */);
      const hasSchool = siteHierarchy.some(s => s.type === "school" /* SiteSelectorSiteType.School */);
      const hasServiceComponent = siteHierarchy.some(s => s.type === "public:servicecomponent" /* SiteSelectorSiteType.ServiceComponent */);
      if (hasStates) {
        this.stateOptions$ = this.ecaSiteService.getSelectedProduct().pipe(concatMap(product => {
          return this.ecaSiteService.getStatesForClient(product.code, this.acl);
        }));
      }
      if (hasDistrict) {
        this.siteTypeOptions.push({
          label: this.capitalizeFirstLetter("district" /* SiteSelectorSiteType.District */),
          value: "district" /* SiteSelectorSiteType.District */
        });
      }
      if (hasSchool) {
        this.siteTypeOptions.push({
          label: this.capitalizeFirstLetter("school" /* SiteSelectorSiteType.School */),
          value: "school" /* SiteSelectorSiteType.School */
        });
      }
      if (this.siteTypeOptions.length > 1) {
        this.siteTypeOptions.unshift({
          label: "all" /* SiteSelectorSiteType.All */.toUpperCase(),
          value: "all" /* SiteSelectorSiteType.All */
        });
      }
      if (this.siteTypeOptions.length > 0) {
        const storedValue = this.ecaSiteSelectorService.get(EcaSiteSelectorService.SiteTypeFilter);
        const defaultValue = "all" /* SiteSelectorSiteType.All */;
        this.siteTypeControl.setValue(storedValue || defaultValue);
      }
      if (hasServiceComponent) {
        this.masterSearch = true;
      }
    }
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    subscribeToSearchInput() {
      const stateFilter$ = this.stateControl.valueChanges.pipe(tap(state => {
        this.ecaSiteSelectorService.set(EcaSiteSelectorService.StateFilterAdvanced, state);
      }), startWith(this.ecaSiteSelectorService.get(EcaSiteSelectorService.StateFilterAdvanced)));
      const typeFilter$ = this.siteTypeControl.valueChanges.pipe(tap(siteType => {
        this.ecaSiteSelectorService.set(EcaSiteSelectorService.SiteTypeFilter, siteType);
      }), startWith(this.ecaSiteSelectorService.get(EcaSiteSelectorService.SiteTypeFilter)));
      const searchText$ = this.searchControl.valueChanges.pipe(debounceTime(300), tap(searchText => {
        this.ecaSiteSelectorService.set(EcaSiteSelectorService.SearchText, searchText);
      }), startWith(this.ecaSiteSelectorService.get(EcaSiteSelectorService.SearchText)), filter(value => value !== undefined), map(value => {
        // Site Service also truncates the text (50 chars) to avoid a large search query
        return value && value.length > this.maxSearchLength ? value.substring(0, this.maxSearchLength) : value;
      }));
      this.siteResults$ = combineLatest([stateFilter$, typeFilter$, searchText$]).pipe(takeUntil(this.ngDestroyed), switchMap(([stateAbbr, siteType, searchTerm]) => {
        if (!searchTerm || searchTerm === '' || searchTerm.length < 3) {
          return of({
            sites: [],
            hierarchies: []
          });
        }
        const siteSearchParams = {
          searchTerm: searchTerm,
          aclSpec: this.acl,
          clientAbbr: this.product.abbreviation,
          leafOnly: this.leafOnly,
          masterSearch: this.masterSearch,
          siteType: siteType ? siteType : "all" /* SiteSelectorSiteType.All */,
          archived: this.archived
        };
        if (this.siteHierarchy.some(s => s.type === "state" /* SiteSelectorSiteType.State */)) {
          siteSearchParams.stateAbbr = stateAbbr;
        }
        this.loadingResults$.next(true);
        return this.ecaSiteSearch.searchV2(siteSearchParams);
      }), map(results => {
        // use an object instead of Map so we don't fight with string vs. number on the key
        const filteredAdminMap = {};
        if (this.resultsFilter && typeof this.resultsFilter === 'function') {
          results.sites = this.resultsFilter(results.sites, results.hierarchies);
          // by filtering sites we should also filter admin/hierarchies
          results.sites.forEach(site => {
            site.hierarchies.forEach(h => {
              filteredAdminMap[h.id] = h;
            });
          });
        }
        const siteResults = results.sites.sort();
        siteResults.forEach(site => {
          this.siteMap.set(site.id, site);
        });
        results.hierarchies.forEach(hierarchy => {
          if (!this.resultsFilter || this.resultsFilter && Object.prototype.hasOwnProperty.call(filteredAdminMap, hierarchy.id)) {
            this.adminMap.set(hierarchy.id, hierarchy);
          }
        });
        this.loadingResults$.next(false);
        return siteResults;
      }));
    }
    onSiteRowClick(row) {
      this.selection.site.toggle(row);
      if (this.includeAdmin) {
        if (this.selection.site.isSelected(row)) {
          this.firstStepLabel = `${row.name} - ${row.code}`;
          this.selection.admin.clear();
          this.updateAdminTable(row.id);
          setTimeout(() => {
            this.ngZone.run(() => {
              this.siteAdminStepper.next();
            });
          }, 1);
        } else {
          this.firstStepLabel = this.firstStepDefaultLabel;
        }
      } else {
        const site = this.ecaSiteSearch.convertToSite(row, null);
        this.closeDialog(site);
      }
    }
    onAdminRowClick(row) {
      this.selection.admin.toggle(row);
      const site = this.ecaSiteSearch.convertToSite(this.selection.site.selected[0], row);
      this.closeDialog(site);
    }
    closeDialog(site) {
      this.save.emit(site);
    }
    updateAdminTable(siteId) {
      this.adminResults = [];
      const siteHierarchies = this.siteMap.get(siteId).hierarchies;
      if (siteHierarchies.length > 0) {
        const siteHierarchyIds = siteHierarchies.map(hierarchy => {
          return hierarchy.id;
        });
        this.adminMap.forEach(hierarchy => {
          const siteHierarchyFound = siteHierarchyIds.some(id => {
            return id.toString() === hierarchy.id.toString();
          });
          if (siteHierarchyFound) {
            this.adminResults.push(hierarchy);
          }
        });
      }
    }
    static {
      this.ɵfac = function EcaSiteSelectorAdvancedComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSelectorAdvancedComponent)(i0.ɵɵdirectiveInject(EcaSiteSearchService), i0.ɵɵdirectiveInject(EcaSiteService), i0.ɵɵdirectiveInject(EcaSiteSelectorService), i0.ɵɵdirectiveInject(EcaSetupConfigurationService), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSiteSelectorAdvancedComponent,
        selectors: [["eca-site-selector-advanced"]],
        viewQuery: function EcaSiteSelectorAdvancedComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c16, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.siteAdminStepper = _t.first);
          }
        },
        inputs: {
          product: "product",
          includeAdmin: "includeAdmin",
          acl: "acl",
          labelCallback: "labelCallback",
          labelPlaceholder: "labelPlaceholder",
          leafOnly: "leafOnly",
          masterSearch: "masterSearch",
          archived: "archived",
          parentNameColumnLabel: "parentNameColumnLabel",
          parentCodeColumnLabel: "parentCodeColumnLabel",
          resultsFilter: "resultsFilter",
          siteHierarchy: "siteHierarchy"
        },
        outputs: {
          cancel: "cancel",
          save: "save"
        },
        decls: 3,
        vars: 2,
        consts: [["siteAdminStepper", ""], ["id", "eca-site-selector-content", 1, "overlay-content"], ["class", "full-height-container", 4, "ngIf"], ["class", "no-admin-search-table-container", 4, "ngIf"], [1, "full-height-container"], ["linear", ""], ["matStepperIcon", "edit"], [3, "completed"], ["matStepLabel", ""], [3, "rowClick", "displayedColumns", "parentNameColumnLabel", "parentCodeColumnLabel", "loadingResults$", "searchControl", "selection", "stateControl", "stateOptions$", "siteTypeOptions", "siteTypeControl", "siteResults$"], [3, "rowClick", "adminResults", "displayedColumns", "selection"], [1, "no-admin-search-table-container"], [3, "rowClick", "displayedColumns", "loadingResults$", "searchControl", "selection", "stateControl", "stateOptions$", "siteTypeOptions", "siteTypeControl", "siteResults$"]],
        template: function EcaSiteSelectorAdvancedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, EcaSiteSelectorAdvancedComponent_div_1_Template, 10, 16, "div", 2)(2, EcaSiteSelectorAdvancedComponent_div_2_Template, 2, 9, "div", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.includeAdmin);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.includeAdmin);
          }
        },
        dependencies: [i1.NgIf, i5.MatIcon, i7$3.MatStep, i7$3.MatStepLabel, i7$3.MatStepper, i7$3.MatStepperIcon, EcaSiteSelectorTableComponent, EcaAdminSelectorTableComponent],
        styles: [".eca-site-selector-panel div.overlay-container{min-width:inherit}@media (max-height: 768px){.eca-site-selector-panel div.overlay-container{height:calc(90vh - 64px)}}.eca-site-selector-panel div.overlay-container .overlay-content#eca-site-selector-content{height:100%;max-height:100%;overflow:hidden}.eca-site-selector-panel div.overlay-container .full-height-container{height:100%;overflow:hidden}.eca-site-selector-panel div.overlay-container .mat-stepper-horizontal{height:100%;display:flex;flex-direction:column;overflow:hidden}.eca-site-selector-panel div.overlay-container .mat-stepper-horizontal .mat-horizontal-stepper-content[aria-expanded=true]{height:100%;overflow:hidden}.eca-site-selector-panel div.overlay-container .mat-stepper-horizontal .mat-horizontal-stepper-content[aria-expanded=true] eca-site-selector-table{height:100%;display:flex;flex-direction:column;overflow:hidden}.eca-site-selector-panel div.overlay-container .mat-horizontal-content-container{height:100%;padding-bottom:16px}.eca-site-selector-panel div.overlay-container .no-admin-search-table-container{padding:0 8px;height:calc(100% - 16px);overflow:hidden}.eca-site-selector-panel div.overlay-container .table-scroll-container{height:100%}.eca-site-selector-panel div.overlay-container eca-site-selector-table{height:100%;display:flex;flex-direction:column;overflow:hidden}.eca-site-selector-panel div.overlay-container eca-site-selector-table .table-scroll-container{height:calc(100% - 59px)}\n"],
        encapsulation: 2
      });
    }
  }
  return EcaSiteSelectorAdvancedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSelectorComponent = /*#__PURE__*/(() => {
  class EcaSiteSelectorComponent {
    static {
      this.nextId = 0;
    }
    constructor(ecaSiteSelectorService, ecaSetupConfigService, ngZone, windowService) {
      this.ecaSiteSelectorService = ecaSiteSelectorService;
      this.ecaSetupConfigService = ecaSetupConfigService;
      this.ngZone = ngZone;
      this.windowService = windowService;
      this.instanceId = EcaSiteSelectorComponent.nextId++;
      this.openOverlayButtonText = 'Select a Site ...';
      this.ariaLabel = '';
      this.selectionText = '';
      this.selection = new SelectionModel(false, null);
      // size & position of the 'drawer' overlay
      this.overlayWidth = '360px';
      this.overlayMinHeight = '240px';
      this.overlayPositions = [{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top'
      }, {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top'
      }, {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }, {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom'
      }, {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom'
      }, {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom'
      }];
      this.overlayOffsetY = 6;
      this.overlayIsOpen = false;
      this.defaultSiteHierarchy = {
        siteHierarchy: siteSelectorFieldDefaults
      };
      this.ngDestroyed = new Subject();
    }
    ngOnInit() {
      if (!this.product$) {
        throw Error('product$ is a required attribute; please pass an observable of the Product object');
      }
      this.initViewMode();
      this.initFromAttributeConfig();
      this.initFromParameters();
      this.initSelection();
      this.initSubscriptions();
    }
    ngOnDestroy() {
      this.ngDestroyed.next(true);
      this.ngDestroyed.complete();
    }
    initViewMode() {
      this.viewModeControl = new FormControl();
      this.viewModeControl.valueChanges.pipe(takeUntil(this.ngDestroyed), tap(v => {
        if (v === this.ecaSiteSelectorService.viewModeAdvanced) {
          this.overlayWidth = '800px';
          this.overlayMinHeight = '400px';
        } else {
          this.overlayWidth = '360px';
          this.overlayMinHeight = '240px';
        }
        this.ecaSiteSelectorService.set(EcaSiteSelectorService.ViewMode, v);
      })).subscribe();
      const viewMode = this.ecaSiteSelectorService.get(EcaSiteSelectorService.ViewMode);
      this.viewModeControl.setValue(viewMode);
    }
    initFromAttributeConfig() {
      this.siteSelectorAttribute$ = this.product$.pipe(takeUntil(this.ngDestroyed), tap(() => {
        // sites are different per Product/Client
        this.selection.clear();
        this.overlayIsOpen = false;
        if (this.onChange) {
          this.onChange(null);
        }
      }), filter(product => !!product), switchMap(product => this.getSetupConfigAttribute(product.abbreviation)));
      // subscribe now so we get attributes before the overlay is opened
      this.siteSelectorAttribute$.pipe(pluck('siteHierarchy')).subscribe(siteHierarchy => {
        this.siteHierarchy = siteHierarchy;
      });
    }
    initFromParameters() {
      this.ecaSiteSelectorService.inputParameters$.pipe(takeUntil(this.ngDestroyed), tap(params => {
        for (const property in params) {
          if (Object.prototype.hasOwnProperty.call(params, property)) {
            this[property] = params[property];
            if (property === 'includeAdmin' && this.selection.hasValue()) {
              this.setLabel(this.selection.selected);
            }
            if (property === 'multiple') {
              this.selection = new SelectionModel(params[property], this.selection.selected);
              this.multiple = params[property];
            }
          }
        }
      })).subscribe();
    }
    initSelection() {
      this.product$.pipe(takeUntil(this.ngDestroyed), filter(product => !!product), switchMap(product => {
        this.product = product;
        return this.ecaSiteSelectorService.getValue(product.abbreviation);
      }), tap(siteOrSites => {
        if (siteOrSites) {
          this.setSelection(siteOrSites);
          this.setLabel(siteOrSites);
        }
      })).subscribe();
    }
    initSubscriptions() {
      this.ecaSiteSelectorService.siteSelectorOverlayIsOpen$.pipe(tap(open => {
        if (open) {
          this.setTriggerElement();
        } else {
          this.clearTriggerElement();
        }
        this.overlayIsOpen = open;
        if (!open) {
          return;
        }
        // Wait for the DOM render frame to update so it contains the overlay
        // For when the "escape" key is pressed and closes the overlay
        this.ngZone.runOutsideAngular(() => {
          this.windowService.requestAnimationFrame(() => {
            this.subDetach();
          });
        });
      })).subscribe();
    }
    subDetach() {
      this.ngZone.run(() => {
        this.cdkConnectedOverlay.overlayRef?.detachments().pipe(take(1)).subscribe(() => {
          this.toggleOverlay(false);
        });
      });
    }
    toggleOverlay(isOpen) {
      if (isOpen) {
        this.ecaSiteSelectorService.openOverlay();
      } else {
        this.ecaSiteSelectorService.closeOverlay();
      }
    }
    getSetupConfigAttribute(productAbbreviation) {
      return this.ecaSetupConfigService.getAttributeForClient(productAbbreviation, 'site-selector-feature-toggles').pipe(pluck('value'),
      // overwrite the defaults, if defined
      map(features => {
        return features ? {
          ...this.defaultSiteHierarchy,
          ...features
        } : this.defaultSiteHierarchy;
      }));
    }
    setLabel(site) {
      this.selectionText = '';
      this.ariaLabel = '';
      if (this.labelCallback && typeof this.labelCallback === 'function') {
        this.selectionText = this.labelCallback(site);
      } else if (Array.isArray(site) && site.length > 1) {
        const typeLabel = site[0].type === "public:servicecomponent" /* SiteSelectorSiteType.ServiceComponent */ ? 'service component' : site[0].type;
        this.selectionText = `Multiple ${typeLabel}s selected`;
      } else {
        if (Array.isArray(site)) {
          site = site[0];
        }
        if (site.adminName && this.includeAdmin) {
          this.selectionText = site.adminName;
        } else if (site.siteName) {
          this.selectionText = site.siteName;
        } else if (site.parentSiteName) {
          this.selectionText = site.parentSiteName;
        }
      }
      this.ariaLabel = this.selectionText + ', site selector';
    }
    setSelection(value) {
      if (Array.isArray(value)) {
        value.forEach(s => this.selection.select(s));
      } else {
        this.selection.select(value);
      }
    }
    onCancel() {
      this.ecaSiteSelectorService.closeOverlay();
    }
    onSave(site) {
      this.selection.clear();
      this.setSelection(site);
      this.setLabel(site);
      // this.ecaSiteSelectorService.markVisited(site);
      this.ecaSiteSelectorService.closeOverlay();
      if (this.onChange) {
        this.onChange(site);
      }
      this.ecaSiteSelectorService.setValue(site, this.product.abbreviation);
    }
    clearTriggerElement() {
      if (
      // Focus the trigger if it's still in the DOM
      this.triggerElement && document.contains(this.triggerElement)) {
        this.triggerElement.focus();
      } else if (
      // Focus the active element if it's not part of the site selector
      document.activeElement && document.activeElement !== document.body && !document.getElementsByClassName('eca-site-selector-panel')[0]?.contains(document.activeElement)) {
        document.activeElement.focus();
      } else if (
      // Focus the true site selector button if it still exists
      this.buttonRef) {
        this.buttonRef.elementRef.nativeElement.focus();
      }
      // Finally reset the trigger element
      this.triggerElement = undefined;
    }
    setTriggerElement() {
      if (document.activeElement && document.activeElement !== document.body) {
        this.triggerElement = document.activeElement;
      } else {
        this.triggerElement = undefined;
      }
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      if (value) {
        // easiest to clear the previous selection rather than trying to deselect
        this.selection.clear();
        this.setSelection(value);
        this.setLabel(value);
      } else {
        this.selection.clear();
      }
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaSiteSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSelectorComponent)(i0.ɵɵdirectiveInject(EcaSiteSelectorService), i0.ɵɵdirectiveInject(EcaSetupConfigurationService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(WindowService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSiteSelectorComponent,
        selectors: [["eca-site-selector"]],
        viewQuery: function EcaSiteSelectorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c17, 5);
            i0.ɵɵviewQuery(CdkConnectedOverlay, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cdkConnectedOverlay = _t.first);
          }
        },
        inputs: {
          product$: "product$"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: EcaSiteSelectorComponent,
          multi: true
        }])],
        decls: 11,
        vars: 19,
        consts: [["trigger", "cdkOverlayOrigin"], [1, "label-placeholder", 3, "hidden"], ["type", "button", "mat-button", "", "cdkOverlayOrigin", "", 3, "click", "id", "disabled"], [1, "eca-site-selector-button-text-wrap"], [4, "ngIf"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayPanelClass", "eca-site-selector-panel", 3, "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayPush"], [1, "overlay-container", "eca-fx-auto", "eca-fx-col", "eca-fx-justify-content-start", "eca-fx-align-items-stretch", "eca-fx-gap-2"], ["class", "eca-fx-align-self-center", 4, "ngIf"], [1, "eca-fx-align-self-center"], ["name", "viewMode", "aria-label", "Switch View Mode", 3, "formControl"], ["value", "basic"], ["value", "advanced"], [3, "cancel", "save", "ngModel", "product", "siteHierarchy", "hideAllOption", "includeAdmin", "acl", "archived", "multiple", "resultsFilter", "showSiteCode"], [3, "save", "product", "includeAdmin", "acl", "archived", "labelCallback", "labelPlaceholder", "leafOnly", "masterSearch", "parentCodeColumnLabel", "parentNameColumnLabel", "resultsFilter", "siteHierarchy"]],
        template: function EcaSiteSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "span", 1);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "button", 2, 0);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵlistener("click", function EcaSiteSelectorComponent_Template_button_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleOverlay(!ctx.overlayIsOpen));
            });
            i0.ɵɵelementStart(5, "span", 3);
            i0.ɵɵtemplate(6, EcaSiteSelectorComponent_ng_container_6_Template, 2, 1, "ng-container", 4)(7, EcaSiteSelectorComponent_ng_container_7_Template, 2, 1, "ng-container", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "mat-icon");
            i0.ɵɵtext(9, "expand_more");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, EcaSiteSelectorComponent_ng_template_10_Template, 5, 6, "ng-template", 5);
          }
          if (rf & 2) {
            let tmp_4_0;
            const trigger_r6 = i0.ɵɵreference(3);
            i0.ɵɵproperty("hidden", !ctx.labelPlaceholder || ctx.selection.hasValue());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.labelPlaceholder, "\n");
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "eca-site-selector-open-button-", ctx.instanceId, "");
            i0.ɵɵproperty("disabled", ctx.disabled || !((tmp_4_0 = i0.ɵɵpipeBind1(4, 17, ctx.product$)) == null ? null : tmp_4_0.abbreviation));
            i0.ɵɵattribute("aria-label", ctx.selection.hasValue() ? ctx.ariaLabel : "open site selector");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.selection.hasValue());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.selection.hasValue());
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cdkConnectedOverlayFlexibleDimensions", true)("cdkConnectedOverlayGrowAfterOpen", true)("cdkConnectedOverlayWidth", ctx.overlayWidth)("cdkConnectedOverlayMinHeight", ctx.overlayMinHeight)("cdkConnectedOverlayOrigin", trigger_r6)("cdkConnectedOverlayOpen", ctx.overlayIsOpen)("cdkConnectedOverlayPositions", ctx.overlayPositions)("cdkConnectedOverlayOffsetY", ctx.overlayOffsetY)("cdkConnectedOverlayPush", true);
          }
        },
        dependencies: [i1.NgIf, i1$4.NgControlStatus, i1$4.NgModel, i4.MatButton, i7$4.MatButtonToggleGroup, i7$4.MatButtonToggle, i5.MatIcon, i1$4.FormControlDirective, i9.CdkConnectedOverlay, i9.CdkOverlayOrigin, EcaSiteSelectorBasicComponent, EcaSiteSelectorAdvancedComponent, i1.AsyncPipe],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}  .eca-site-selector-panel{overflow:auto}.label-placeholder[_ngcontent-%COMP%]{margin-right:8px}.selected-container[_ngcontent-%COMP%]   .mat-mdc-button[_ngcontent-%COMP%]{margin-left:8px}.eca-site-selector-button-text-wrap[_ngcontent-%COMP%]{display:inline-block;margin-right:8px;overflow:hidden;text-overflow:ellipsis}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button){display:flex;flex-direction:row-reverse}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button)   .mat-icon[_ngcontent-%COMP%]{line-height:1;display:inline-block;font-size:24px;margin-right:0;padding:2px 0 0}eca-site-selector-advanced[_ngcontent-%COMP%]{display:block;height:calc(100% - 44px)}.overlay-container[_ngcontent-%COMP%]{background-color:var(--drc-white);padding:24px;box-shadow:4px 4px 16px #00000026;border-radius:4px}"]
      });
    }
  }
  return EcaSiteSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHeaderComponent = /*#__PURE__*/(() => {
  class EcaHeaderComponent {
    constructor(headerService, appContextService, securityService, setupConfigService, siteService, notificationService, windowService) {
      this.headerService = headerService;
      this.appContextService = appContextService;
      this.securityService = securityService;
      this.setupConfigService = setupConfigService;
      this.siteService = siteService;
      this.notificationService = notificationService;
      this.windowService = windowService;
      this.MAX_MENU_HEIGHT = 450;
    }
    // when backwards compatibility is removed, also remove this logic
    ngOnChanges(changes) {
      if (Object.prototype.hasOwnProperty.call(changes, 'helpLinks')) {
        this.headerService.setHelpLinks(changes.helpLinks.currentValue);
      }
    }
    ngOnInit() {
      if (!this.windowService.ECA_PORTAL_HEADER) {
        this.windowService.ECA_PORTAL_HEADER = {};
      }
      this.windowService.ECA_PORTAL_HEADER.eventLog = [];
      const debug = false;
      /**
       * Custom rxjs operator to start the loading spinner
       */
      function startLoading(description) {
        return o$ => {
          return o$.pipe(withLatestFrom(loadingCount$), map(([event, loadingCount]) => {
            debugMessage(['startLoading', description, loadingCount + 1]);
            actions$.next({
              loadingCount: ++loadingCount
            });
            return event;
          }));
        };
      }
      /**
       * Custom rxjs operator to stop the loading spinner
       */
      function stopLoading(description) {
        return o$ => {
          return o$.pipe(withLatestFrom(loadingCount$, (data, loadingCount) => {
            debugMessage(['  STOP Loading', description, loadingCount - 1]);
            if (loadingCount > 0) {
              actions$.next({
                loadingCount: --loadingCount
              });
            }
            return data;
          }));
        };
      }
      function handleError(e) {
        console.error('eca-header: ', e);
        return of(null);
      }
      const actions$ = new Subject();
      const initialState = {
        loadingCount: 0,
        user: null,
        product: null,
        programNumber: null,
        appId: null,
        title: null,
        helpLinks: null
      };
      // Startup process. It's important we don't subscribe to anything that makes network calls until after this observable has emitted true.
      const initialized$ = this.headerService.initialized().pipe(filter(initialized => initialized), take(1), tap(() => {
        this.securityService.startTokenRefresh().subscribe();
        this.securityService.handleUserActivity().subscribe();
        // This is a hack to let apps using the angular-elements header know that the init succeeded
        if (!this.windowService.ECA_HEADER_ELEMENT) {
          this.windowService.ECA_HEADER_ELEMENT = {};
        }
        this.windowService.ECA_HEADER_ELEMENT.initialized = true;
        this.toShowNotificationBell().pipe(take(1)).subscribe();
      }), shareReplay(1));
      // Inputs (Event Sources)
      const events$ = merge(this.siteService.selectedProduct$.pipe(distinctUntilKeyChangedNullSafe('id'), map(product => ({
        product: product
      }))), this.appContextService.selectedProgramNumber$.pipe(
      // TODO: Change to this once all applications have updated to version of components-lib that includes selectedProgramNumber change
      // distinctUntilKeyChangedNullSafe('id'),
      distinctUntilChanged(), map(programNumber => ({
        programNumber: programNumber
      }))), this.appContextService.selectedApplicationId$.pipe(distinctUntilKeyChangedNullSafe('id'), map(appId => ({
        appId: appId
      }))), this.headerService.getTitle().pipe(distinctUntilChanged(), map(title => ({
        title: title
      }))), this.headerService.getHelpLinks().pipe(distinctUntilChanged(), map(helpLinks => ({
        helpLinks: helpLinks
      }))), this.securityService.user$.pipe(distinctUntilKeyChangedNullSafe(['userId', 'firstName', 'lastName']), map(user => ({
        user: user
      }))), actions$.asObservable());
      // State
      const headerState$ = initialized$.pipe(switchMapTo(events$.pipe(startWith(initialState), tap(event => this.windowService.ECA_PORTAL_HEADER.eventLog.push(event)), scan((state, event) => ({
        ...state,
        ...event
      })), tap(state => this.windowService.ECA_PORTAL_HEADER.currentState = state))), shareReplay(1));
      // Sub-State
      const product$ = headerState$.pipe(select('product'), distinctUntilChanged(), tap(product => {
        debugMessage(['product', product]);
      }));
      const programNumber$ = headerState$.pipe(select('programNumber'), distinctUntilChanged(), tap(program => {
        debugMessage(['program', program]);
      }));
      const appId$ = headerState$.pipe(select('appId'));
      const user$ = headerState$.pipe(select('user'));
      const loadingCount$ = headerState$.pipe(select('loadingCount'), tap(count => {
        debugMessage([' *count* ', count]);
      }));
      // Derivative/Intermediate State
      const featureToggle$ = product$.pipe(switchMap(product => this.headerService.getSetupConfigValues('portal-header-feature-toggles', product)), catchError(handleError), shareReplay(1));
      const applications$ = combineLatest([product$, programNumber$]).pipe(startLoading('application$'),
      // use concatMap because switchMap cancels which prevents stopLoading from getting called
      concatMap(([product, program]) => {
        // TODO: Change to this once all applications have updated to version of components-lib that includes selectedProgramNumber change
        // if (product && program) {
        if (product && program !== 0) {
          return this.headerService.getMenuDataForProduct(product.abbreviation, program);
        } else {
          return of(null);
        }
      }), catchError(handleError), stopLoading('applications$'), shareReplay(1));
      const application$ = combineLatest([appId$, applications$]).pipe(map(([appId, menu]) => {
        let app = null;
        if (menu) {
          menu.some(category => {
            app = category.applications.find(app => app.applicationId === appId);
            return !!app;
          });
        }
        return app;
      }), shareReplay(1));
      // use appContextService because we want the productCode regardless of whether the user is logged in
      const portalHeaderLogo$ = initialized$.pipe(switchMap(() => {
        return this.appContextService.selectedProductCode$;
      }), distinctUntilChanged(), switchMap(productCode => this.headerService.getSetupConfigValues('portal-header-logo', productCode)), catchError(handleError), shareReplay(1));
      // View Models for the UI
      this.isLoading$ = loadingCount$.pipe(map(count => count > 0));
      this.username$ = user$.pipe(map(user => user ? `${user.firstName} ${user.lastName}` : ''));
      this.userLoggedIn$ = this.username$.pipe(map(name => name ? true : false));
      this.selectedProduct$ = product$;
      this.selectedProductCode$ = product$.pipe(select('abbreviation'));
      this.isProductSelected$ = product$.pipe(map(Boolean));
      this.selectedProductLabel$ = product$.pipe(map(product => product ? product.name : 'MY PRODUCTS'));
      // TODO: Change to this once all applications have updated to version of components-lib that includes selectedProgramNumber
      // this.isProgramSelected$ = this.appContextService.selectedProgramNumber$.pipe(map(Boolean));
      this.isProgramSelected$ = this.appContextService.selectedProgramNumber$.pipe(map(programNumber => {
        return programNumber !== 0;
      }));
      this.selectedApplicationLabel$ = application$.pipe(map(app => app ? app.label : 'MY APPLICATIONS'));
      this.menu$ = applications$.pipe(map(apps => apps ? this.balanceMenu(apps) : null));
      this.title$ = headerState$.pipe(select('title'));
      this.showTitle$ = combineLatest([this.isLoading$, this.title$]).pipe(map(([isLoading, title]) => !isLoading && !!title));
      this.showSpinner$ = combineLatest([this.userLoggedIn$, this.isLoading$]).pipe(map(([userLoggedIn, isLoading]) => userLoggedIn && isLoading));
      this.showApplicationsMenu$ = combineLatest([this.userLoggedIn$, this.isLoading$, this.isProductSelected$, this.isProgramSelected$]).pipe(map(([userLoggedIn, isLoading, isProductSelected, programSelected]) => userLoggedIn && !isLoading && isProductSelected && programSelected));
      this.products$ = user$.pipe(startLoading('products$'), switchMap(user => user ? this.siteService.getProducts(user.userId) : of(null)), map(products => products ? products.sort((x, y) => x.name.localeCompare(y.name)) : null), catchError(handleError), stopLoading('products$'), shareReplay(1));
      this.showProductsMenu$ = combineLatest([this.userLoggedIn$, this.showTitle$, this.products$]).pipe(map(([userLoggedIn, showTitle, products]) => userLoggedIn && !showTitle && products && products.length !== 1));
      this.singleProduct$ = combineLatest([this.userLoggedIn$, this.showTitle$, this.products$]).pipe(map(([userLoggedIn, showTitle, products]) => userLoggedIn && !showTitle && products && products.length === 1 ? products[0] : null));
      this.programs$ = product$.pipe(startLoading('programs$'), concatMap(user => user ? this.setupConfigService.getPrograms() : of(null)), catchError(handleError), stopLoading('programs$'), shareReplay(1));
      this.hideProgramSelection$ = featureToggle$.pipe(distinctUntilKeyChangedNullSafe('hideProgramSelection'), select('hideProgramSelection'), map(hide => hide === true));
      this.showProgramsMenu$ = combineLatest([this.userLoggedIn$, this.showTitle$, this.programs$, this.hideProgramSelection$]).pipe(map(([userLoggedIn, showTitle, programs, hideProgram]) => {
        return !hideProgram && userLoggedIn && !showTitle && programs && programs.length > 1;
      }));
      this.selectedProgramLabel$ = this.appContextService.selectedProgramNumber$.pipe(withLatestFrom(this.programs$), map(([programNumber, programs]) => {
        let program = null;
        if (programs) {
          program = programs.find(p => p.number === programNumber);
        }
        return program ? program?.code : 'MY PROGRAMS';
      }));
      this.largeIcon$ = featureToggle$.pipe(distinctUntilKeyChangedNullSafe('iconSize'), select('iconSize'), map(size => size === 'large'));
      this.silverTextColor$ = featureToggle$.pipe(distinctUntilKeyChangedNullSafe('color'), select('color'), map(color => color === 'silver'));
      this.maxWidth1440px$ = featureToggle$.pipe(distinctUntilKeyChangedNullSafe('maxWidth'), select('maxWidth'), map(width => width === '1440px'));
      this.customLogo$ = portalHeaderLogo$;
      this.helpLinks$ = headerState$.pipe(select('helpLinks'));
      this.showSiteSelector$ = this.headerService.siteSelectorVisible$;
      this.showNotificationHistory$ = this.headerService.notificationBellVisible$;
      function debugMessage(params) {
        if (debug) {
          console.log(...params);
        }
      }
    }
    toShowNotificationBell() {
      return this.setupConfigService.getAttributeForClient('DRCPORTAL', 'showNotificationBell').pipe(map(attribute => {
        if (!attribute) {
          return true;
        }
        return attribute.attribute.defaultValue.toLowerCase() === 'true';
      }), tap(toShow => {
        if (toShow) {
          this.notificationService.initialize();
          this.headerService.showNotificationBell();
        } else {
          this.headerService.hideNotificationBell();
        }
      }));
    }
    launchProduct(product) {
      this.headerService.launchProductProgramSelector(product);
    }
    launchProgram(program) {
      this.siteService.selectedProduct$.pipe(take(1), tap(product => {
        this.headerService.launchProduct({
          product,
          program
        });
      })).subscribe();
    }
    launchApplication(application) {
      this.headerService.launchApplication(application);
    }
    /* Closes open menus when a window resize event is received */
    closeMenus() {
      if (this.productsMenuTrigger) {
        this.productsMenuTrigger.closeMenu();
      }
      if (this.applicationsMenuTrigger) {
        this.applicationsMenuTrigger.closeMenu();
      }
    }
    /**
     * Given a list of ApplicationCategories, attempt to distribute evenly into columns
     * (without changing the order of the categories)
     * @param categories
     */
    balanceMenu(categories) {
      const categoryHeight = 57; // height of the category label item plus padding (top and bottom)
      const applicationHeight = 32; // height of the application name item
      // const bottomPadding = 2; // normally 12px, compensates for the lack of top padding of the first label
      const categorySizes = categories.map(category => {
        return categoryHeight + applicationHeight * category.applications.length;
      });
      const menu = [];
      let newColumnStartIndex = 0;
      let categsToPush = 0;
      let currentColumnHeight = 0;
      let categoryIndex = 0;
      while (categoryIndex < categories.length) {
        // add categories of apps to each column until the next category to add would exceed the max height
        while (currentColumnHeight + categorySizes[categoryIndex] <= this.MAX_MENU_HEIGHT) {
          currentColumnHeight += categorySizes[categoryIndex];
          categsToPush++;
          categoryIndex++;
        }
        menu.push(categories.slice(newColumnStartIndex, newColumnStartIndex + categsToPush));
        // start over with a new column
        newColumnStartIndex += categsToPush;
        categsToPush = 0;
        currentColumnHeight = 0;
      }
      return menu;
    }
    static {
      this.ɵfac = function EcaHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHeaderComponent)(i0.ɵɵdirectiveInject(EcaHeaderService), i0.ɵɵdirectiveInject(AppContextService), i0.ɵɵdirectiveInject(EcaSecurityService), i0.ɵɵdirectiveInject(EcaSetupConfigurationService), i0.ɵɵdirectiveInject(EcaSiteService), i0.ɵɵdirectiveInject(EcaNotificationHistoryService), i0.ɵɵdirectiveInject(WindowService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaHeaderComponent,
        selectors: [["eca-header"]],
        viewQuery: function EcaHeaderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c18, 5);
            i0.ɵɵviewQuery(_c19, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.productsMenuTrigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.applicationsMenuTrigger = _t.first);
          }
        },
        inputs: {
          helpLinks: "helpLinks",
          disableSkipLink: "disableSkipLink"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 41,
        vars: 56,
        consts: [["productsMenu", "matMenu"], ["programsMenu", "matMenu"], ["applicationsMenu", "matMenu"], ["productsMenuTrigger", "matMenuTrigger"], ["applicationsMenuTrigger", "matMenuTrigger"], [3, "logo", "ngClass"], ["class", "title", 4, "ngIf"], ["type", "button", "class", "nav-menu-link single-link remove-btn-formatting eca-focus-visible-inverse-colors", "id", "eca-header-client-product-link", 3, "click", 4, "ngIf"], ["type", "button", "class", "nav-menu-link remove-btn-formatting eca-focus-visible-inverse-colors", "id", "eca-header-client-product-menu-link", "name", "productMenu", 3, "matMenuTriggerFor", 4, "ngIf"], [1, "header-menu-panel", "mega-menu", 3, "overlapTrigger"], [1, "eca-fx-col"], ["mat-menu-item", "", "class", "eca-link eca-focus-visible-inverse-colors", 3, "click", 4, "ngFor", "ngForOf"], ["type", "button", "class", "nav-menu-link remove-btn-formatting eca-focus-visible-inverse-colors", "id", "eca-header-client-program-menu-link", "name", "programMenu", 3, "matMenuTriggerFor", 4, "ngIf"], ["type", "button", "class", "nav-menu-link remove-btn-formatting eca-focus-visible-inverse-colors", "id", "eca-header-application-menu-link", "name", "applicationMenu", 3, "matMenuTriggerFor", 4, "ngIf"], [1, "eca-fx-row"], ["class", "menu-column", 4, "ngFor", "ngForOf"], ["mode", "indeterminate", "diameter", "25", 4, "ngIf"], [1, "header-menu-secondary", "eca-fx-auto", "eca-fx-justify-content-end", "eca-fx-align-items-center", "eca-fx-gap-1", "eca-fx-wrap"], [3, "product$", 4, "ngIf"], [4, "ngIf"], [3, "helpLinks"], [3, "name", 4, "ngIf"], [1, "title"], ["type", "button", "id", "eca-header-client-product-link", 1, "nav-menu-link", "single-link", "remove-btn-formatting", "eca-focus-visible-inverse-colors", 3, "click"], ["type", "button", "id", "eca-header-client-product-menu-link", "name", "productMenu", 1, "nav-menu-link", "remove-btn-formatting", "eca-focus-visible-inverse-colors", 3, "matMenuTriggerFor"], ["mat-menu-item", "", 1, "eca-link", "eca-focus-visible-inverse-colors", 3, "click"], ["type", "button", "id", "eca-header-client-program-menu-link", "name", "programMenu", 1, "nav-menu-link", "remove-btn-formatting", "eca-focus-visible-inverse-colors", 3, "matMenuTriggerFor"], ["type", "button", "id", "eca-header-application-menu-link", "name", "applicationMenu", 1, "nav-menu-link", "remove-btn-formatting", "eca-focus-visible-inverse-colors", 3, "matMenuTriggerFor"], [1, "menu-column"], [4, "ngFor", "ngForOf"], [1, "mat-menu-header"], ["mode", "indeterminate", "diameter", "25"], [3, "product$"], [3, "name"]],
        template: function EcaHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "eca-header-base", 5);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵtemplate(5, EcaHeaderComponent_span_5_Template, 3, 3, "span", 6);
            i0.ɵɵpipe(6, "async");
            i0.ɵɵtemplate(7, EcaHeaderComponent_button_7_Template, 3, 3, "button", 7);
            i0.ɵɵpipe(8, "async");
            i0.ɵɵtemplate(9, EcaHeaderComponent_button_9_Template, 4, 4, "button", 8);
            i0.ɵɵpipe(10, "async");
            i0.ɵɵelementStart(11, "mat-menu", 9, 0)(13, "div", 10);
            i0.ɵɵtemplate(14, EcaHeaderComponent_button_14_Template, 2, 1, "button", 11);
            i0.ɵɵpipe(15, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(16, EcaHeaderComponent_button_16_Template, 4, 4, "button", 12);
            i0.ɵɵpipe(17, "async");
            i0.ɵɵelementStart(18, "mat-menu", 9, 1)(20, "div", 10);
            i0.ɵɵtemplate(21, EcaHeaderComponent_button_21_Template, 3, 3, "button", 11);
            i0.ɵɵpipe(22, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(23, EcaHeaderComponent_button_23_Template, 4, 4, "button", 13);
            i0.ɵɵpipe(24, "async");
            i0.ɵɵelementStart(25, "mat-menu", 9, 2)(27, "div", 14);
            i0.ɵɵtemplate(28, EcaHeaderComponent_div_28_Template, 2, 1, "div", 15);
            i0.ɵɵpipe(29, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(30, EcaHeaderComponent_mat_spinner_30_Template, 1, 0, "mat-spinner", 16);
            i0.ɵɵpipe(31, "async");
            i0.ɵɵelementStart(32, "div", 17);
            i0.ɵɵtemplate(33, EcaHeaderComponent_eca_site_selector_33_Template, 1, 1, "eca-site-selector", 18);
            i0.ɵɵpipe(34, "async");
            i0.ɵɵtemplate(35, EcaHeaderComponent_eca_notification_history_35_Template, 1, 0, "eca-notification-history", 19);
            i0.ɵɵpipe(36, "async");
            i0.ɵɵelement(37, "eca-help-menu", 20);
            i0.ɵɵpipe(38, "async");
            i0.ɵɵtemplate(39, EcaHeaderComponent_eca_user_profile_menu_39_Template, 2, 3, "eca-user-profile-menu", 21);
            i0.ɵɵpipe(40, "async");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("logo", i0.ɵɵpipeBind1(1, 18, ctx.customLogo$))("ngClass", i0.ɵɵpureFunction3(52, _c20, i0.ɵɵpipeBind1(2, 20, ctx.largeIcon$), i0.ɵɵpipeBind1(3, 22, ctx.maxWidth1440px$), i0.ɵɵpipeBind1(4, 24, ctx.silverTextColor$)));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 26, ctx.showTitle$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 28, ctx.singleProduct$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 30, ctx.showProductsMenu$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("overlapTrigger", false);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(15, 32, ctx.products$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(17, 34, ctx.showProgramsMenu$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("overlapTrigger", false);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(22, 36, ctx.programs$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(24, 38, ctx.showApplicationsMenu$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("overlapTrigger", false);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(29, 40, ctx.menu$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(31, 42, ctx.showSpinner$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(34, 44, ctx.showSiteSelector$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(36, 46, ctx.showNotificationHistory$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("helpLinks", i0.ɵɵpipeBind1(38, 48, ctx.helpLinks$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(40, 50, ctx.userLoggedIn$));
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2$1.MatMenu, i2$1.MatMenuItem, i2$1.MatMenuTrigger, i7$2.MatProgressSpinner, EcaNotificationHistoryComponent, i2.DefaultClassDirective, EcaHeaderBaseComponent, EcaHelpMenuComponent, EcaUserProfileMenuComponent, EcaSiteSelectorComponent, i1.AsyncPipe, i1.UpperCasePipe],
        styles: ["mat-spinner[_ngcontent-%COMP%]{margin:16px auto 16px 24px}mat-spinner[_ngcontent-%COMP%]     circle{stroke:#a7c5d0!important}.title[_ngcontent-%COMP%]{font-size:16px;color:var(--drc-white);text-transform:uppercase;font-weight:500;padding:20px 0 18px;margin:0 10px}"]
      });
    }
  }
  return EcaHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHeaderBaseModule = /*#__PURE__*/(() => {
  class EcaHeaderBaseModule {
    static {
      this.ɵfac = function EcaHeaderBaseModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHeaderBaseModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaHeaderBaseModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, FlexLayoutModule]
      });
    }
  }
  return EcaHeaderBaseModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaUserProfileMenuModule = /*#__PURE__*/(() => {
  class EcaUserProfileMenuModule {
    static {
      this.ɵfac = function EcaUserProfileMenuModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaUserProfileMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaUserProfileMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatMenuModule, MatSnackBarModule, MatDialogModule, MatButtonModule]
      });
    }
  }
  return EcaUserProfileMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSessionTimeoutModule = /*#__PURE__*/(() => {
  class EcaSessionTimeoutModule {
    static {
      this.ɵfac = function EcaSessionTimeoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSessionTimeoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaSessionTimeoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatDialogModule, MatButtonModule]
      });
    }
  }
  return EcaSessionTimeoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHelpMenuModule = /*#__PURE__*/(() => {
  class EcaHelpMenuModule {
    static {
      this.ɵfac = function EcaHelpMenuModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHelpMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaHelpMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatMenuModule, MatSnackBarModule, MatDialogModule, MatButtonModule, MatIconModule]
      });
    }
  }
  return EcaHelpMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHighLightTextModule = /*#__PURE__*/(() => {
  class EcaHighLightTextModule {
    static {
      this.ɵfac = function EcaHighLightTextModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHighLightTextModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaHighLightTextModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return EcaHighLightTextModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAutoCompleteModule = /*#__PURE__*/(() => {
  class EcaAutoCompleteModule {
    static {
      this.ɵfac = function EcaAutoCompleteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAutoCompleteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaAutoCompleteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, EcaHighLightTextModule, FormsModule, ReactiveFormsModule, MatAutocompleteModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule]
      });
    }
  }
  return EcaAutoCompleteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSearchModule = /*#__PURE__*/(() => {
  class EcaSearchModule {
    static {
      this.ɵfac = function EcaSearchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSearchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaSearchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatAutocompleteModule, MatButtonModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatInputModule]
      });
    }
  }
  return EcaSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSelectorModule = /*#__PURE__*/(() => {
  class EcaSiteSelectorModule {
    static {
      this.ɵfac = function EcaSiteSelectorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSelectorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaSiteSelectorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, EcaAutoCompleteModule, EcaHighLightTextModule, EcaSearchModule, FlexLayoutModule, FormsModule, MatButtonModule, MatButtonToggleModule, MatDialogModule, MatIconModule, MatInputModule, MatFormFieldModule, MatRadioModule, MatProgressSpinnerModule, MatSelectModule, MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule, ReactiveFormsModule, OverlayModule, MatCheckboxModule]
      });
    }
  }
  return EcaSiteSelectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const EDITABLE_HEADING_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EcaEditableHeadingComponent),
  multi: true
};
let EcaEditableHeadingComponent = /*#__PURE__*/(() => {
  class EcaEditableHeadingComponent {
    constructor(renderer) {
      this.renderer = renderer;
      this.isPristine = true;
      this.canEdit = true; // and click edit
      this.enableInput = false; // sets contenteditable attr allowing contenteditable functionality
    }
    onInput(value) {
      this.value = value;
      this.onChange(value);
    }
    onFieldBlur() {
      this.isPristine = false;
      this.enableInput = false;
    }
    /* Prevents form from being submitted on hitting enter on this input */
    onEnter() {
      this.inputRef.nativeElement.blur();
    }
    toggleEdit() {
      if (!this.canEdit) {
        return;
      }
      this.onTouched();
      this.enableInput = true;
      this.checkSelectAll();
    }
    checkSelectAll() {
      setTimeout(() => {
        if (this.selectAllWhenPristine && this.isPristine) {
          this.selectAll();
        } else {
          this.inputRef.nativeElement.focus();
        }
      }, 1);
    }
    selectAll() {
      this.isPristine = false;
      this.inputRef.nativeElement.select();
    }
    writeValue(value) {
      this.value = value;
      const normalizedValue = value == null ? '' : value;
      this.renderer.setProperty(this.inputRef.nativeElement, 'value', normalizedValue);
    }
    registerOnChange(onChange) {
      this.onChange = onChange;
    }
    registerOnTouched(onTouched) {
      this.onTouched = onTouched;
    }
    setDisabledState(disabled) {
      this.canEdit = !disabled;
    }
    static {
      this.ɵfac = function EcaEditableHeadingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaEditableHeadingComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaEditableHeadingComponent,
        selectors: [["", "eca-editable-heading", "", "formControl", ""], ["", "eca-editable-heading", "", "formControlName", ""], ["", "eca-editable-heading", "", "ngModel", ""]],
        viewQuery: function EcaEditableHeadingComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c21, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          selectAllWhenPristine: "selectAllWhenPristine"
        },
        features: [i0.ɵɵProvidersFeature([EDITABLE_HEADING_VALUE_ACCESSOR])],
        attrs: _c22,
        ngContentSelectors: _c6,
        decls: 8,
        vars: 10,
        consts: [["input", ""], ["ref", ""], ["aria-label", "edit title value", 3, "input", "keydown.enter", "blur", "disabled"], [1, "eca-ghost-heading"], [3, "ngClass"], ["mat-button", "", "class", "mat-small-button edit-header-link", 3, "disabled", "click", 4, "ngIf"], ["mat-button", "", 1, "mat-small-button", "edit-header-link", 3, "click"]],
        template: function EcaEditableHeadingComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "input", 2, 0);
            i0.ɵɵlistener("input", function EcaEditableHeadingComponent_Template_input_input_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInput($event.target.value));
            })("keydown.enter", function EcaEditableHeadingComponent_Template_input_keydown_enter_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onEnter());
            })("blur", function EcaEditableHeadingComponent_Template_input_blur_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFieldBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4, 1);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, EcaEditableHeadingComponent_button_7_Template, 2, 2, "button", 5);
          }
          if (rf & 2) {
            const ref_r4 = i0.ɵɵreference(5);
            i0.ɵɵclassProp("active", ctx.enableInput);
            i0.ɵɵproperty("disabled", !ctx.enableInput);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("hide", ctx.enableInput);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.value, "\n");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c23, ref_r4.childNodes.length));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.enableInput);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.DefaultClassDirective, i4.MatButton],
        styles: ["[_nghost-%COMP%]{position:relative;display:flex;align-items:center}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{display:none;border:0;padding:0;color:inherit;font-size:inherit;line-height:inherit;font-family:inherit;position:absolute;left:0;top:0;background-color:transparent;z-index:100}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none}[_nghost-%COMP%]   input.active[_ngcontent-%COMP%]{display:inline-block;border:2px solid #4A90E2;border-radius:2px;padding:3px 5px;top:-5px;left:-7px;width:450px}.edit-header-link[_ngcontent-%COMP%]{margin-left:8px}.eca-ghost-heading[_ngcontent-%COMP%]{display:inline-block;max-width:450px}.eca-ghost-heading.hide[_ngcontent-%COMP%]{opacity:0;z-index:-1;width:450px}.eca-ghost-heading[_ngcontent-%COMP%]:empty:after{content:\"1\";opacity:0}.eca-heading-chips[_ngcontent-%COMP%]{margin-left:16px}"]
      });
    }
  }
  return EcaEditableHeadingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* istanbul ignore file */
/* Modified version of github.com/focus-trap/tabbable */
const candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
const candidateSelector = candidateSelectors.join(',');
const matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
function tabbable(el) {
  const regularTabbables = [];
  const orderedTabbables = [];
  const candidates = el.querySelectorAll(candidateSelector);
  let candidate;
  let candidateTabindex;
  for (let i = 0; i < candidates.length; i++) {
    candidate = candidates[i];
    if (!isNodeMatchingSelectorTabbable(candidate)) {
      continue;
    }
    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  }
  return orderedTabbables.sort(sortOrderedTabbables).map(a => a.node).concat(regularTabbables);
}
tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;
function isNodeMatchingSelectorTabbable(node) {
  if (!isNodeMatchingSelectorFocusable(node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }
  return true;
}
function isTabbable(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(node);
}
function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node)) {
    return false;
  }
  return true;
}
const focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(node);
}
function getTabindex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  }
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) {
    return 0;
  }
  return node.tabIndex;
}
function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}
function isContentEditable(node) {
  return node.contentEditable === 'true';
}
function isInput(node) {
  return node.tagName === 'INPUT';
}
function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}
function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}
function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}
function getCheckedRadio(nodes) {
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}
function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  const radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  const checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}
function isHidden(node) {
  // offsetParent being null will allow detecting cases where an element is invisible or inside an invisible element,
  // as long as the element does not use position: fixed. For them, their visibility has to be checked directly as well.
  return node.offsetParent === null || getComputedStyle(node).visibility === 'hidden';
}

/* istanbul ignore file */
let shadowDomIsSupported;
/** Checks whether the user's browser support Shadow DOM. */
function supportsShadowDom() {
  if (shadowDomIsSupported == null) {
    const head = typeof document !== 'undefined' ? document.head : null;
    shadowDomIsSupported = !!(head && (head.createShadowRoot || head.attachShadow));
  }
  return shadowDomIsSupported;
}
function getShadowRoot(element) {
  if (supportsShadowDom()) {
    const rootNode = element.getRootNode ? element.getRootNode() : null;
    // Note that this should be caught by `_supportsShadowDom`, but some
    // teams have been able to hit this code path on unsupported browsers.
    if (typeof ShadowRoot !== 'undefined' && ShadowRoot && rootNode instanceof ShadowRoot) {
      return rootNode;
    }
  }
  return null;
}
const captureEventListenerOptions = normalizePassiveListenerOptions({
  passive: true,
  capture: true
});
let SidebarFocusSwapFactory = /*#__PURE__*/(() => {
  class SidebarFocusSwapFactory {
    constructor(_checker, _ngZone, _document) {
      this._checker = _checker;
      this._ngZone = _ngZone;
      this._document = _document;
    }
    /**
     * Creates a focus-diversion region around the given element.
     * @param sidebar The element around which focus will be diverted.
     * @returns The created focus trap instance.
     */
    create(sidebar, body, toggleButton) {
      return new SidePanelFocusSwap(sidebar, body, toggleButton, this._checker, this._ngZone, this._document);
    }
    static {
      this.ɵfac = function SidebarFocusSwapFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SidebarFocusSwapFactory)(i0.ɵɵinject(i2$4.InteractivityChecker), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SidebarFocusSwapFactory,
        factory: SidebarFocusSwapFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SidebarFocusSwapFactory;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Class that allows for diverting focus within a body + sidebar DOM element.
 *
 * This class currently uses a relatively simple approach to focus trapping.
 * It assumes that the tab order is the same as DOM order, which is not necessarily true.
 * Things like `tabIndex > 0`, flex `order`, and shadow roots can cause the two to misalign.
 *
 * Note: this is a heavily modified version of Material FocusSwap
 */
class SidePanelFocusSwap {
  constructor(sidePanel, bodyElement, toggleButton, checker, _ngZone, _document) {
    this.sidePanel = sidePanel;
    this.bodyElement = bodyElement;
    this.checker = checker;
    this._ngZone = _ngZone;
    this._document = _document;
    this.hasAttached = false;
    this.toggleButtonFocusListener = () => {
      this.onToggleFocus();
    };
    this.afterToggleButtonFocusListener = () => {
      this.onAfterToggleFocus();
    };
    this.startAnchorFocusListener = () => {
      this.onStartAnchorFocus();
    };
    this.endAnchorFocusListener = () => {
      this.onEndAnchorFocus();
    };
    this.rootNodeBlurListener = event => {
      this.setPreviousBlur(event.target);
    };
    this.toggleButton = toggleButton;
    this.afterToggle = this.getNextBodyTabbable(this.toggleButton);
    this.sidePanel.setAttribute('tabindex', '0');
    this.lastBodyTabbable = this.getLastTabbableElement(this.bodyElement);
    if (this.afterToggle) {
      // We don't have anything after the toggle! Use default order
      this.attachAnchors();
      this.attachFocus();
      this.initGlobalBlur();
    }
  }
  setPreviousBlur(ele) {
    this.previousBlur = ele;
  }
  initGlobalBlur() {
    this.rootNode = getShadowRoot(this.sidePanel) || this._document;
    this._ngZone.runOutsideAngular(() => {
      this.rootNode.addEventListener('blur', this.rootNodeBlurListener, captureEventListenerOptions);
    });
  }
  attachFocus() {
    this._ngZone.runOutsideAngular(() => {
      this.toggleButton.addEventListener('focus', this.toggleButtonFocusListener);
      this.afterToggle.addEventListener('focus', this.afterToggleButtonFocusListener);
    });
  }
  destroyAnchors() {
    const startAnchor = this.startAnchor;
    const endAnchor = this.endAnchor;
    if (startAnchor) {
      startAnchor.removeEventListener('focus', this.startAnchorFocusListener);
      startAnchor.parentNode.removeChild(startAnchor);
    }
    if (endAnchor) {
      endAnchor.removeEventListener('focus', this.endAnchorFocusListener);
      endAnchor.parentNode.removeChild(endAnchor);
    }
    this.startAnchor = this.endAnchor = null;
    this.hasAttached = false;
  }
  /** Creates an anchor element. */
  _createAnchor() {
    const anchor = this._document.createElement('div');
    anchor.setAttribute('tabindex', '0');
    anchor.classList.add('cdk-visually-hidden');
    anchor.classList.add('cdk-focus-trap-anchor');
    anchor.setAttribute('aria-hidden', 'true');
    return anchor;
  }
  attachAnchors() {
    if (this.hasAttached) {
      return true;
    }
    this._ngZone.runOutsideAngular(() => {
      this.startAnchor = this._createAnchor();
      this.startAnchor.addEventListener('focus', this.startAnchorFocusListener);
      this.endAnchor = this._createAnchor();
      this.endAnchor.addEventListener('focus', this.endAnchorFocusListener);
    });
    this.sidePanel.parentNode.insertBefore(this.startAnchor, this.sidePanel);
    this.sidePanel.parentNode.insertBefore(this.endAnchor, this.sidePanel.nextSibling);
    this.hasAttached = true;
    return this.hasAttached;
  }
  destroy() {
    this.destroyAnchors();
    this.toggleButton.removeEventListener('blur', this.toggleButtonFocusListener);
    if (this.afterToggle) {
      this.afterToggle.removeEventListener('blur', this.afterToggleButtonFocusListener);
    }
    if (this.rootNode) {
      this.rootNode.removeEventListener('blur', this.rootNodeBlurListener, captureEventListenerOptions);
    }
  }
  /* if focused from after toggle (shift-tab) => set focus side panel */
  onToggleFocus() {
    if (this.previousBlur === this.afterToggle) {
      this.focusSidePanel();
    }
  }
  focusSidePanel() {
    this.sidePanel.focus();
  }
  onAfterToggleFocus() {
    // if tabbing to focus afterToggle from toggle button
    if (this.previousBlur === this.toggleButton) {
      this.focusSidePanel();
    }
  }
  /*  */
  focusAfterMonotronTabbable() {
    const tabbableList = tabbable(this._document);
    const index = tabbableList.indexOf(this.endAnchor);
    const nextTabbable = tabbableList[index + 1];
    /* istanbul ignore next */
    if (nextTabbable) {
      tabbableList[index + 1].focus();
    }
  }
  getNextBodyTabbable(element) {
    const tabbableList = tabbable(this.bodyElement);
    const index = tabbableList.indexOf(element);
    const nextTabbable = tabbableList[index + 1];
    return nextTabbable || null;
  }
  /* Focus next element after leaving swap container (from last tabbable in swap container) */
  focusAfterToggleElement() {
    this.afterToggle.focus();
  }
  /* If we tab onto the end anchor from the side panel, or from the last tabbable element in the sidepanel
   *  * Note: No need to cover case when there is focus below the last tabbable element from the sidepanel
   *          user can only focus the end anchor from tabbing from last tabbable in the sidebar (tabindex=0 will capture focus)
   * */
  onEndAnchorFocus() {
    const sidePanelLastTabbable = this.getLastTabbableElement(this.sidePanel, true);
    if (this.previousBlur === this.sidePanel || this.previousBlur === sidePanelLastTabbable) {
      this.focusAfterToggleElement();
    } else {
      this.focusLastBodyTabbable();
    }
  }
  /* The start anchor can be tabbed to after the last element in the body,
   * or shift-tabbed from inside the sidepanel
   */
  onStartAnchorFocus() {
    if (this.previousBlur === this.lastBodyTabbable) {
      this.focusAfterMonotronTabbable();
    } else {
      this.focusToggleElement();
    }
  }
  focusLastBodyTabbable() {
    this.lastBodyTabbable.focus();
  }
  /* Focus previous element after leaving (shift-tab) swap container (from first tabbable in swap container) */
  focusToggleElement() {
    this.toggleButton.focus();
  }
  /** Get the last tabbable element from a DOM subtree (inclusive). */
  getLastTabbableElement(root, skipSelf = false) {
    if (!skipSelf && this.checker.isFocusable(root) && this.checker.isTabbable(root)) {
      return root;
    }
    // Iterate in reverse DOM order.
    const children = root.children || root.childNodes;
    for (let i = children.length - 1; i >= 0; i--) {
      /* istanbul ignore next */
      const tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ? this.getLastTabbableElement(children[i]) : null;
      if (tabbableChild) {
        return tabbableChild;
      }
    }
    return null;
  }
}
let EcaMonotronBodyComponent = /*#__PURE__*/(() => {
  class EcaMonotronBodyComponent {
    set sidePanel(element) {
      /* Only set use focus swap when we have an active eca-side-panel-toggle
       *  - this allows for the sidePanel to be used without the focus swapping
       */
      if (element && this.activeSidePanelToggle) {
        this.sidePanelContainer = element;
        this.initializeSidePanelFocus();
      }
    }
    set showSidePanel(show) {
      this._showSidePanel = show;
      if (!show && this.activeSidePanelToggle && this.sidePanelFocusSwap) {
        this.sidePanelFocusSwap.destroy();
      }
    }
    get showSidePanel() {
      return this._showSidePanel;
    }
    constructor(focusSwapFactory, _checker, element) {
      this.focusSwapFactory = focusSwapFactory;
      this._checker = _checker;
      this.element = element;
      this.sidePanelPercent = 33;
      this.classes = 'eca-monotron-body';
    }
    hideSidePanel() {
      this.showSidePanel = false;
      if (this.sidePanelFocusSwap) {
        this.sidePanelFocusSwap.focusToggleElement();
      }
    }
    /* Activates an element to become the base element for the focus swap */
    activateSidePanelToggle(toggle) {
      /* No side panel is open */
      if (!this._showSidePanel) {
        this.showSidePanel = true;
        this.activeSidePanelToggle = toggle;
        return;
      }
      /* A side panel is already open and a different panel toggle is clicked */
      if (this._showSidePanel && this.activeSidePanelToggle !== toggle) {
        this.sidePanelFocusSwap.destroy();
        this.activeSidePanelToggle = toggle;
        this.initializeSidePanelFocus();
      } else {
        /* We toggled the active sidePanelToggle */
        this.showSidePanel = false;
      }
    }
    ngOnDestroy() {
      if (this.sidePanelFocusSwap) {
        this.sidePanelFocusSwap.destroy();
      }
    }
    initializeSidePanelFocus() {
      this.sidePanelFocusSwap = this.focusSwapFactory.create(this.sidePanelContainer.nativeElement, this.bodyCardContainer.nativeElement, this.activeSidePanelToggle);
      this.focusSidePanelContainer();
    }
    focusSidePanelContainer() {
      if (this.sidePanelContainer.nativeElement.focus) {
        this.sidePanelContainer.nativeElement.focus();
      }
    }
    static {
      this.ɵfac = function EcaMonotronBodyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMonotronBodyComponent)(i0.ɵɵdirectiveInject(SidebarFocusSwapFactory), i0.ɵɵdirectiveInject(i2$4.InteractivityChecker), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaMonotronBodyComponent,
        selectors: [["eca-monotron-body"]],
        viewQuery: function EcaMonotronBodyComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c24, 5);
            i0.ɵɵviewQuery(_c25, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.bodyCardContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidePanel = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function EcaMonotronBodyComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes);
          }
        },
        inputs: {
          sidePanelPercent: "sidePanelPercent",
          showSidePanel: "showSidePanel"
        },
        ngContentSelectors: _c27,
        decls: 5,
        vars: 4,
        consts: [["bodyCardContainer", ""], ["sidePanelContainer", ""], [1, "eca-monotron-body-wrapper"], [1, "eca-monotron-body-card", 3, "ngStyle"], ["class", "eca-monotron-body-side-panel-container", 3, "ngStyle", 4, "ngIf"], [1, "eca-monotron-body-side-panel-container", 3, "ngStyle"]],
        template: function EcaMonotronBodyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c26);
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3, 0);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, EcaMonotronBodyComponent_div_4_Template, 3, 3, "div", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c28, 100 - ctx.sidePanelPercent));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showSidePanel);
          }
        },
        dependencies: [i1.NgIf, i1.NgStyle, i2.DefaultStyleDirective],
        styles: [".eca-monotron-body{width:100%;background-color:#f9f9fb;flex-direction:column;box-sizing:border-box;display:flex;flex-grow:1}.eca-monotron-body .eca-monotron-body-wrapper{padding:0 24px 3px;width:100%;max-width:1440px;display:flex;flex-direction:row;flex:1 1 0;box-sizing:border-box;align-self:center;margin-top:-44px;justify-content:center}.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-card,.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-side-panel-container{background-color:#fff;padding:22px 26px;position:relative;min-height:44px;z-index:0}.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-card .mat-radio-label,.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-side-panel-container .mat-radio-label{white-space:normal}.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-card{flex-grow:1;display:flex;flex-direction:column;justify-content:center;max-width:100%}.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-side-panel-container{flex-grow:1;flex-shrink:1;margin-left:16px;position:relative}.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-side-panel-container .eca-monotron-side-panel{position:relative}.eca-monotron-body .eca-monotron-body-wrapper .eca-monotron-body-side-panel-container .eca-monotron-side-panel .eca-monotron-close-side-panel-btn{position:absolute;top:0;right:0}\n"],
        encapsulation: 2
      });
    }
  }
  return EcaMonotronBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMonotronSidePanelToggleDirective = /*#__PURE__*/(() => {
  class EcaMonotronSidePanelToggleDirective {
    onClick() {
      this.body.activateSidePanelToggle(this.element.nativeElement);
    }
    constructor(element, body) {
      this.element = element;
      this.body = body;
    }
    static {
      this.ɵfac = function EcaMonotronSidePanelToggleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMonotronSidePanelToggleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(EcaMonotronBodyComponent));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaMonotronSidePanelToggleDirective,
        selectors: [["", "eca-side-panel-toggle", ""]],
        hostBindings: function EcaMonotronSidePanelToggleDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function EcaMonotronSidePanelToggleDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event.target);
            });
          }
        }
      });
    }
  }
  return EcaMonotronSidePanelToggleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMonotronSidePanelCloseDirective = /*#__PURE__*/(() => {
  class EcaMonotronSidePanelCloseDirective {
    onClick() {
      this.body.hideSidePanel();
    }
    constructor(element, body) {
      this.element = element;
      this.body = body;
      this.button = 'eca-monotron-close-side-panel-btn';
    }
    static {
      this.ɵfac = function EcaMonotronSidePanelCloseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMonotronSidePanelCloseDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(EcaMonotronBodyComponent));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaMonotronSidePanelCloseDirective,
        selectors: [["", "eca-monotron-side-panel-close", ""]],
        hostVars: 2,
        hostBindings: function EcaMonotronSidePanelCloseDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function EcaMonotronSidePanelCloseDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event.target);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.button);
          }
        }
      });
    }
  }
  return EcaMonotronSidePanelCloseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMonotronModule = /*#__PURE__*/(() => {
  class EcaMonotronModule {
    static {
      this.ɵfac = function EcaMonotronModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMonotronModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaMonotronModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, FlexLayoutModule, MatButtonModule]
      });
    }
  }
  return EcaMonotronModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaNotificationHistoryModule = /*#__PURE__*/(() => {
  class EcaNotificationHistoryModule {
    static {
      this.ɵfac = function EcaNotificationHistoryModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaNotificationHistoryModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaNotificationHistoryModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [DatePipe],
        imports: [A11yModule, CommonModule, EcaMonotronModule, FlexLayoutModule, MatBadgeModule, MatButtonModule, MatCardModule, MatDividerModule, MatIconModule, OverlayModule]
      });
    }
  }
  return EcaNotificationHistoryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaHeaderModule = /*#__PURE__*/(() => {
  class EcaHeaderModule {
    static forRoot(menuItemOverrides = null) {
      return {
        ngModule: EcaHeaderModule,
        providers: menuItemOverrides ? [{
          provide: MENU_ITEM_OVERRIDES,
          useValue: menuItemOverrides
        }] : []
      };
    }
    static {
      this.ɵfac = function EcaHeaderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHeaderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaHeaderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatMenuModule, MatIconModule, MatProgressSpinnerModule, EcaNotificationHistoryModule, MatButtonModule, MatDialogModule, FlexLayoutModule, EcaHeaderBaseModule, EcaHelpMenuModule, EcaUserProfileMenuModule, EcaSessionTimeoutModule, EcaSiteSelectorModule]
      });
    }
  }
  return EcaHeaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function disableClose(dialogRef) {
  if (dialogRef.disableClose !== false) {
    dialogRef.disableClose = true;
    fromEvent(window, 'keydown').pipe(takeWhile(() => dialogRef.getState() !== MatDialogState.CLOSED), filter(e => e.key === 'Escape')).subscribe(() => {
      dialogRef.close();
    });
  }
}
let EcaSiteSearchTableComponent = /*#__PURE__*/(() => {
  class EcaSiteSearchTableComponent {
    constructor() {
      this.rowClick = new EventEmitter();
      this.maxSearchLength = EcaSiteSearchService.maxSearchLength;
    }
    ngOnInit() {
      if (!this.searchControl) {
        this.searchControl = new FormControl('');
      }
    }
    onSiteRowClick(row) {
      this.rowClick.emit(row);
    }
    clearInput() {
      this.searchControl.setValue('');
    }
    static {
      this.ɵfac = function EcaSiteSearchTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSearchTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSiteSearchTableComponent,
        selectors: [["eca-site-search-table"]],
        inputs: {
          displayedColumns: "displayedColumns",
          loadingResults: "loadingResults",
          parentNameColumnLabel: "parentNameColumnLabel",
          parentCodeColumnLabel: "parentCodeColumnLabel",
          searchControl: "searchControl",
          selection: "selection",
          siteResults: "siteResults"
        },
        outputs: {
          rowClick: "rowClick"
        },
        decls: 26,
        vars: 8,
        consts: [[1, "filter-group"], [1, "eca-site-search-form-field"], ["matInput", "", "cdkFocusInitial", "", 3, "maxLength", "formControl"], [1, "table-scroll-container"], ["mat-table", "", 3, "dataSource"], ["matColumnDef", "name"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", 3, "innerHTML", 4, "matCellDef"], ["matColumnDef", "code"], ["matColumnDef", "parentSiteName"], ["mat-cell", "", 4, "matCellDef"], ["matColumnDef", "parentSiteCode"], ["matColumnDef", "select"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "click", 4, "matRowDef", "matRowDefColumns"], ["class", "spinner-container", 4, "ngIf"], ["class", "no-data-container", 4, "ngIf"], ["mat-header-cell", ""], ["mat-cell", "", 3, "innerHTML"], ["mat-cell", ""], ["mat-button", "", 1, "row-select-button", "mat-small-button", 3, "ngClass"], ["mat-header-row", ""], ["mat-row", "", 3, "click"], [1, "spinner-container"], [3, "diameter"], [1, "no-data-container"]],
        template: function EcaSiteSearchTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "mat-form-field", 1)(2, "mat-label");
            i0.ɵɵtext(3, "Search by name or code");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "eca-search", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 3)(6, "table", 4);
            i0.ɵɵelementContainerStart(7, 5);
            i0.ɵɵtemplate(8, EcaSiteSearchTableComponent_th_8_Template, 2, 0, "th", 6)(9, EcaSiteSearchTableComponent_td_9_Template, 2, 4, "td", 7);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(10, 8);
            i0.ɵɵtemplate(11, EcaSiteSearchTableComponent_th_11_Template, 2, 0, "th", 6)(12, EcaSiteSearchTableComponent_td_12_Template, 2, 4, "td", 7);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(13, 9);
            i0.ɵɵtemplate(14, EcaSiteSearchTableComponent_th_14_Template, 2, 1, "th", 6)(15, EcaSiteSearchTableComponent_td_15_Template, 2, 1, "td", 10);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(16, 11);
            i0.ɵɵtemplate(17, EcaSiteSearchTableComponent_th_17_Template, 2, 1, "th", 6)(18, EcaSiteSearchTableComponent_td_18_Template, 2, 1, "td", 10);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(19, 12);
            i0.ɵɵtemplate(20, EcaSiteSearchTableComponent_th_20_Template, 2, 0, "th", 6)(21, EcaSiteSearchTableComponent_td_21_Template, 3, 3, "td", 10);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(22, EcaSiteSearchTableComponent_tr_22_Template, 1, 0, "tr", 13)(23, EcaSiteSearchTableComponent_tr_23_Template, 1, 0, "tr", 14);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, EcaSiteSearchTableComponent_div_24_Template, 2, 1, "div", 15)(25, EcaSiteSearchTableComponent_div_25_Template, 3, 0, "div", 16);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("maxLength", ctx.maxSearchLength)("formControl", ctx.searchControl);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("dataSource", ctx.siteResults);
            i0.ɵɵadvance(16);
            i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns)("matHeaderRowDefSticky", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loadingResults);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.loadingResults && (ctx.siteResults == null ? null : ctx.siteResults.length) === 0 && ctx.searchControl.value);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, EcaSearchComponent, i2.DefaultClassDirective, i1$4.NgControlStatus, i4.MatButton, i6.MatFormField, i6.MatLabel, i7$2.MatProgressSpinner, i6$2.MatTable, i6$2.MatHeaderCellDef, i6$2.MatHeaderRowDef, i6$2.MatColumnDef, i6$2.MatCellDef, i6$2.MatRowDef, i6$2.MatHeaderCell, i6$2.MatCell, i6$2.MatHeaderRow, i6$2.MatRow, i1$4.FormControlDirective, EcaHighlightTextPipe],
        styles: [".table-scroll-container[_ngcontent-%COMP%]{height:100%;overflow:auto}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row){cursor:pointer}.table-scroll-container[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:not(.mat-mdc-header-row):hover{text-decoration:underline}.spinner-container[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;padding-top:24px}button.row-select-button[_ngcontent-%COMP%]{margin-right:16px}.mat-icon.mat-clear[_ngcontent-%COMP%]{cursor:pointer}.filter-group[_ngcontent-%COMP%]   .eca-site-search-form-field[_ngcontent-%COMP%]{margin:8px 0 -16px}.no-data-container[_ngcontent-%COMP%]{padding:8px;text-align:center}.eca-site-search-form-field[_ngcontent-%COMP%]{width:300px}"]
      });
    }
  }
  return EcaSiteSearchTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAdminTableComponent = /*#__PURE__*/(() => {
  class EcaAdminTableComponent {
    constructor() {
      this.dataSource = new MatTableDataSource();
      this.rowClick = new EventEmitter();
    }
    ngOnInit() {
      this.sort.sort({
        id: 'updateDate',
        start: 'desc',
        disableClear: false
      });
      this.dataSource.sort = this.sort;
    }
    adminResultsChanged(value) {
      this.dataSource.data = value || [];
    }
    onAdminRowClick(row) {
      this.rowClick.emit(row);
    }
    static {
      this.ɵfac = function EcaAdminTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAdminTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaAdminTableComponent,
        selectors: [["eca-admin-table"]],
        viewQuery: function EcaAdminTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
          }
        },
        inputs: {
          adminResults: "adminResults",
          displayedColumns: "displayedColumns",
          selection: "selection"
        },
        outputs: {
          rowClick: "rowClick"
        },
        decls: 19,
        vars: 4,
        consts: [[1, "table-scroll-container"], ["mat-table", "", "matSort", "", 3, "dataSource"], ["matColumnDef", "name"], ["mat-header-cell", "", "mat-sort-header", "", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["matColumnDef", "code"], ["matColumnDef", "number"], ["matColumnDef", "updateDate"], ["matColumnDef", "select"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "click", 4, "matRowDef", "matRowDefColumns"], ["mat-header-cell", "", "mat-sort-header", ""], ["mat-cell", ""], ["mat-header-cell", ""], ["mat-button", "", "matStepperNext", "", 1, "row-select-button", "mat-small-button", 3, "ngClass"], ["mat-header-row", ""], ["mat-row", "", 3, "click"]],
        template: function EcaAdminTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "table", 1);
            i0.ɵɵelementContainerStart(2, 2);
            i0.ɵɵtemplate(3, EcaAdminTableComponent_th_3_Template, 2, 0, "th", 3)(4, EcaAdminTableComponent_td_4_Template, 2, 1, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(5, 5);
            i0.ɵɵtemplate(6, EcaAdminTableComponent_th_6_Template, 2, 0, "th", 3)(7, EcaAdminTableComponent_td_7_Template, 2, 1, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(8, 6);
            i0.ɵɵtemplate(9, EcaAdminTableComponent_th_9_Template, 2, 0, "th", 3)(10, EcaAdminTableComponent_td_10_Template, 2, 1, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(11, 7);
            i0.ɵɵtemplate(12, EcaAdminTableComponent_th_12_Template, 2, 0, "th", 3)(13, EcaAdminTableComponent_td_13_Template, 3, 3, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(14, 8);
            i0.ɵɵtemplate(15, EcaAdminTableComponent_th_15_Template, 2, 0, "th", 9)(16, EcaAdminTableComponent_td_16_Template, 3, 3, "td", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(17, EcaAdminTableComponent_tr_17_Template, 1, 0, "tr", 10)(18, EcaAdminTableComponent_tr_18_Template, 1, 0, "tr", 11);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("dataSource", ctx.dataSource);
            i0.ɵɵadvance(16);
            i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns)("matHeaderRowDefSticky", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
          }
        },
        dependencies: [i1.NgClass, i2.DefaultClassDirective, i4.MatButton, i4$2.MatSort, i4$2.MatSortHeader, i7$3.MatStepperNext, i6$2.MatTable, i6$2.MatHeaderCellDef, i6$2.MatHeaderRowDef, i6$2.MatColumnDef, i6$2.MatCellDef, i6$2.MatRowDef, i6$2.MatHeaderCell, i6$2.MatCell, i6$2.MatHeaderRow, i6$2.MatRow, i1.DatePipe],
        styles: [_c30]
      });
    }
  }
  __decorate([OnChange('adminResultsChanged')], EcaAdminTableComponent.prototype, "adminResults", void 0);
  return EcaAdminTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSearchDialogComponent = /*#__PURE__*/(() => {
  class EcaSiteSearchDialogComponent {
    constructor(siteSearchService, setupConfigService, dialogRef, ngZone, data) {
      this.siteSearchService = siteSearchService;
      this.setupConfigService = setupConfigService;
      this.dialogRef = dialogRef;
      this.ngZone = ngZone;
      this.data = data;
      this.maxSearchLength = EcaSiteSearchService.maxSearchLength;
      this.firstStepDefaultLabel = 'Select a Site';
      this.firstStepLabel = this.firstStepDefaultLabel;
      this.includeAdmin = false;
      this.resultsFilter = null;
      this.selection = {
        site: new SelectionModel(false, []),
        admin: new SelectionModel(false, [])
      };
      this.displayedColumns = {
        siteTable: ['name', 'code', 'parentSiteName', 'parentSiteCode', 'select'],
        adminTable: ['name', 'code', 'number', 'updateDate', 'select']
      };
      this.loadingResults = false;
      this.siteResults = null;
      this.siteMap = new Map();
      this.adminMap = new Map();
      this.ngUnsubscribe = new Subject();
      disableClose(dialogRef);
    }
    ngOnInit() {
      this.searchControl = new FormControl();
      this.includeAdmin = this.data ? this.data.includeAdmin : false;
      this.resultsFilter = this.data ? this.data.resultsFilter : null;
      this.getFeatureToggles();
      this.subscribeToSearchInput();
    }
    ngOnDestroy() {
      this.ngUnsubscribe.next(true);
      this.ngUnsubscribe.complete();
    }
    getFeatureToggles() {
      if (this.data && this.data.clientAbbr) {
        this.setupConfigService.getAttributeForClient(this.data.clientAbbr, 'site-search-feature-toggles').subscribe(attribute => {
          const feature = attribute ? attribute.value : null;
          if (feature && feature.hideAdminCodeColumn) {
            const codeIndex = this.displayedColumns.adminTable.indexOf('code');
            this.displayedColumns.adminTable.splice(codeIndex, 1);
          }
          if (feature && feature.hideAdminNumberColumn) {
            const numberIndex = this.displayedColumns.adminTable.indexOf('number');
            this.displayedColumns.adminTable.splice(numberIndex, 1);
          }
          if (feature && feature.hideUpdateDateColumn) {
            const numberIndex = this.displayedColumns.adminTable.indexOf('updateDate');
            this.displayedColumns.adminTable.splice(numberIndex, 1);
          }
        });
      }
    }
    subscribeToSearchInput() {
      this.searchControl.valueChanges.pipe(takeUntil(this.ngUnsubscribe), debounceTime(300), filter(value => {
        return value && value.length > 2 && value !== this.selection.site;
      }), map(value => {
        // Site Service also truncates the text (50 chars) to avoid a large search query
        return value.length > this.maxSearchLength ? value.substring(0, this.maxSearchLength) : value;
      }), switchMap(value => {
        const siteSearchParams = {
          searchTerm: value,
          aclSpec: this.data.aclSpec,
          clientAbbr: this.data.clientAbbr,
          leafOnly: this.data.leafOnly,
          masterSearch: this.data.masterSearch,
          rowLimit: this.data.rowLimit,
          siteType: this.data.siteType,
          stateAbbr: this.data.stateAbbr,
          archived: this.data.archived
        };
        this.siteResults = null;
        this.loadingResults = true;
        if (!this.data.apiVersion || this.data.apiVersion === 'v1') {
          return this.siteSearchService.search(siteSearchParams);
        } else if (this.data.apiVersion === 'v2') {
          return this.siteSearchService.searchV2(siteSearchParams);
        } else {
          return of({
            sites: [],
            hierarchies: []
          });
        }
      })).subscribe(results => {
        this.loadingResults = false;
        // use an object instead of Map so we don't fight with string vs. number on the key
        const filteredAdminMap = {};
        if (this.resultsFilter && typeof this.resultsFilter === 'function') {
          results.sites = this.resultsFilter(results.sites, results.hierarchies);
          // by filtering sites we should also filter admin/hierarchies
          results.sites.forEach(site => {
            site.hierarchies.forEach(h => {
              filteredAdminMap[h.id] = h;
            });
          });
        }
        this.siteResults = results.sites.sort();
        this.siteResults.forEach(site => {
          this.siteMap.set(site.id, site);
        });
        results.hierarchies.forEach(hierarchy => {
          if (!this.resultsFilter || this.resultsFilter && Object.prototype.hasOwnProperty.call(filteredAdminMap, hierarchy.id)) {
            this.adminMap.set(hierarchy.id, hierarchy);
          }
        });
      }, err => {
        console.error(err);
        this.loadingResults = false;
      });
    }
    onSiteRowClick(row) {
      this.selection.site.toggle(row);
      if (this.includeAdmin) {
        if (this.selection.site.isSelected(row)) {
          this.firstStepLabel = `${row.name} - ${row.code}`;
          this.selection.admin.clear();
          this.updateAdminTable(row.id);
          setTimeout(() => {
            this.ngZone.run(() => {
              this.siteAdminStepper.next();
            });
          }, 1);
        } else {
          this.firstStepLabel = this.firstStepDefaultLabel;
        }
      } else {
        const site = this.siteSearchService.convertToSite(row, null);
        this.closeDialog(site);
      }
    }
    onAdminRowClick(row) {
      this.selection.admin.toggle(row);
      const site = this.siteSearchService.convertToSite(this.selection.site.selected[0], row);
      this.closeDialog(site);
    }
    closeDialog(site) {
      this.dialogRef.close(site);
    }
    updateAdminTable(siteId) {
      this.adminResults = [];
      const siteHierarchies = this.siteMap.get(siteId).hierarchies;
      if (siteHierarchies.length > 0) {
        const siteHierarchyIds = siteHierarchies.map(hierarchy => {
          return hierarchy.id;
        });
        this.adminMap.forEach(hierarchy => {
          const siteHierarchyFound = siteHierarchyIds.some(id => {
            return id.toString() === hierarchy.id.toString();
          });
          if (siteHierarchyFound) {
            this.adminResults.push(hierarchy);
          }
        });
      }
    }
    static {
      this.ɵfac = function EcaSiteSearchDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSearchDialogComponent)(i0.ɵɵdirectiveInject(EcaSiteSearchService), i0.ɵɵdirectiveInject(EcaSetupConfigurationService), i0.ɵɵdirectiveInject(i1$3.MatDialogRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSiteSearchDialogComponent,
        selectors: [["eca-site-search-dialog"]],
        viewQuery: function EcaSiteSearchDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c16, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.siteAdminStepper = _t.first);
          }
        },
        decls: 8,
        vars: 2,
        consts: [["siteAdminStepper", ""], ["mat-dialog-title", ""], ["mat-icon-button", "", "mat-dialog-close", "", "aria-label", "close", 1, "close-dialog"], ["id", "eca-site-search-dialog-content", 1, "mat-dialog-title-content"], ["class", "full-height-container", 4, "ngIf"], ["class", "no-admin-search-table-container", 4, "ngIf"], [1, "full-height-container"], ["linear", ""], ["matStepperIcon", "edit"], [3, "completed"], ["matStepLabel", ""], [3, "rowClick", "displayedColumns", "parentNameColumnLabel", "parentCodeColumnLabel", "loadingResults", "searchControl", "selection", "siteResults"], [3, "rowClick", "adminResults", "displayedColumns", "selection"], [1, "no-admin-search-table-container"], [3, "rowClick", "displayedColumns", "loadingResults", "searchControl", "selection", "siteResults"]],
        template: function EcaSiteSearchDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 1);
            i0.ɵɵtext(1, " Site Search\n");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "button", 2)(3, "mat-icon");
            i0.ɵɵtext(4, "close");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵtemplate(6, EcaSiteSearchDialogComponent_div_6_Template, 10, 12, "div", 4)(7, EcaSiteSearchDialogComponent_div_7_Template, 2, 5, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", ctx.includeAdmin);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.includeAdmin);
          }
        },
        dependencies: [i1.NgIf, i4.MatIconButton, i1$3.MatDialogClose, i1$3.MatDialogTitle, i5.MatIcon, i7$3.MatStep, i7$3.MatStepLabel, i7$3.MatStepper, i7$3.MatStepperIcon, EcaSiteSearchTableComponent, EcaAdminTableComponent],
        styles: [".eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container{height:calc(85vh - 190px);min-width:inherit}@media (max-height: 768px){.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container{height:calc(100vh - 32px)}}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .mat-dialog-title-content#eca-site-search-dialog-content{height:calc(100% - 60px);max-height:calc(100% - 60px);overflow:hidden}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .full-height-container{height:100%;overflow:hidden}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .mat-horizontal-stepper-wrapper{height:100%;overflow:hidden}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .mat-stepper-horizontal{height:100%;display:flex;flex-direction:column;overflow:hidden}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .mat-stepper-horizontal .mat-horizontal-stepper-content:not(.mat-horizontal-stepper-content-inactive){height:100%;overflow:hidden}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .mat-stepper-horizontal .mat-horizontal-stepper-content:not(.mat-horizontal-stepper-content-inactive) eca-site-search-table{height:100%;display:flex;flex-direction:column;overflow:hidden}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .mat-horizontal-content-container{height:100%;padding-bottom:16px}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .no-admin-search-table-container{padding:0 24px;height:calc(100% - 16px);overflow:hidden}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container .table-scroll-container{height:100%}.eca-site-search-panel mat-dialog-container.mat-mdc-dialog-container eca-site-search-table .table-scroll-container{height:calc(100% - 80px)}\n"],
        encapsulation: 2
      });
    }
  }
  return EcaSiteSearchDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSearchComponent = /*#__PURE__*/(() => {
  class EcaSiteSearchComponent {
    static {
      this.nextId = 0;
    }
    constructor(dialog, siteSearchService) {
      this.dialog = dialog;
      this.siteSearchService = siteSearchService;
      this.instanceId = EcaSiteSearchComponent.nextId++;
      this.openSearchModalButtonText = 'Select a Site ...';
      this.selectionText = '';
      this.selection = new SelectionModel(false, []);
      // see eca-site-search-dialog.component.scss for related styling of the dialog
      this.dialogWindowConfig = {
        minHeight: '350px',
        width: '800px',
        maxWidth: '1200px',
        minWidth: '600px',
        panelClass: 'eca-site-search-panel'
      };
    }
    openSearchModal() {
      const config = {
        ...this.dialogWindowConfig,
        data: {
          aclSpec: this.acl,
          apiVersion: this.apiVersion,
          clientAbbr: this.client,
          includeAdmin: this.includeAdmin,
          leafOnly: this.leafOnly,
          masterSearch: this.masterSearch,
          resultsFilter: this.resultsFilter,
          rowLimit: this.rowLimit,
          siteType: this.siteType,
          stateAbbr: this.state,
          parentNameColumnLabel: this.parentNameColumnLabel,
          parentCodeColumnLabel: this.parentCodeColumnLabel,
          archived: this.archived
        }
      };
      const searchModal = this.dialog.open(EcaSiteSearchDialogComponent, config);
      searchModal.afterClosed().subscribe(result => {
        if (result) {
          this.selection.select(result);
          this.setLabel(result);
          this.onChange(result);
        }
      });
      return searchModal;
    }
    setLabel(site) {
      if (this.labelCallback && typeof this.labelCallback === 'function') {
        this.selectionText = this.labelCallback(site);
      } else {
        this.selectionText = this.siteSearchService.getDescription(site, this.includeAdmin);
      }
    }
    clearSelection() {
      this.selection.clear();
      this.selectionText = this.labelPlaceholder ? this.labelPlaceholder : '';
      this.onChange(null);
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      if (value) {
        this.selection.select(value);
        this.setLabel(value);
      } else {
        this.selection.clear();
        this.selectionText = this.labelPlaceholder ? this.labelPlaceholder : '';
      }
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaSiteSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSearchComponent)(i0.ɵɵdirectiveInject(i1$3.MatDialog), i0.ɵɵdirectiveInject(EcaSiteSearchService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaSiteSearchComponent,
        selectors: [["eca-site-search"]],
        inputs: {
          acl: "acl",
          apiVersion: "apiVersion",
          client: "client",
          disabled: "disabled",
          includeAdmin: "includeAdmin",
          labelCallback: "labelCallback",
          labelPlaceholder: "labelPlaceholder",
          leafOnly: "leafOnly",
          masterSearch: "masterSearch",
          openSearchModalButtonText: "openSearchModalButtonText",
          parentNameColumnLabel: "parentNameColumnLabel",
          parentCodeColumnLabel: "parentCodeColumnLabel",
          resultsFilter: "resultsFilter",
          rowLimit: "rowLimit",
          siteType: "siteType",
          state: "state",
          archived: "archived"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: EcaSiteSearchComponent,
          multi: true
        }])],
        decls: 12,
        vars: 11,
        consts: [[1, "label-placeholder", 3, "hidden"], [3, "hidden"], ["aria-label", "open site search modal", "mat-button", "", 3, "click", "id", "disabled"], [1, "selected-container", 3, "hidden"], ["aria-label", "edit selected site", "mat-button", "", 3, "click", "disabled"], ["aria-label", "clear selected site", "mat-button", "", 3, "click", "disabled"]],
        template: function EcaSiteSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "span", 1)(3, "button", 2);
            i0.ɵɵlistener("click", function EcaSiteSearchComponent_Template_button_click_3_listener() {
              return ctx.openSearchModal();
            });
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "span", 3)(6, "mat-label");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 4);
            i0.ɵɵlistener("click", function EcaSiteSearchComponent_Template_button_click_8_listener() {
              return ctx.openSearchModal();
            });
            i0.ɵɵtext(9, " Change Site ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "button", 5);
            i0.ɵɵlistener("click", function EcaSiteSearchComponent_Template_button_click_10_listener() {
              return ctx.clearSelection();
            });
            i0.ɵɵtext(11, " Clear ");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", !ctx.labelPlaceholder || ctx.selection.hasValue());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.labelPlaceholder, "\n");
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.selection.hasValue());
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "eca-site-search-open-button-", ctx.instanceId, "");
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.openSearchModalButtonText, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", !ctx.selectionText || !ctx.selection.hasValue());
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.selectionText, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disabled);
          }
        },
        dependencies: [i4.MatButton, i6.MatLabel],
        styles: [".label-placeholder[_ngcontent-%COMP%]{margin-right:8px}.selected-container[_ngcontent-%COMP%]   .mat-mdc-button[_ngcontent-%COMP%]{margin-left:8px}"]
      });
    }
  }
  return EcaSiteSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSiteSearchModule = /*#__PURE__*/(() => {
  class EcaSiteSearchModule {
    static {
      this.ɵfac = function EcaSiteSearchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSiteSearchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaSiteSearchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [EcaSiteSearchService],
        imports: [CommonModule, EcaAutoCompleteModule, EcaHighLightTextModule, EcaSearchModule, FlexLayoutModule, FormsModule, MatButtonModule, MatDialogModule, MatIconModule, MatInputModule, MatFormFieldModule, MatRadioModule, MatProgressSpinnerModule, MatSortModule, MatStepperModule, MatTableModule, ReactiveFormsModule]
      });
    }
  }
  return EcaSiteSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaSnackbarAlertModule = /*#__PURE__*/(() => {
  class EcaSnackbarAlertModule {
    static {
      this.ɵfac = function EcaSnackbarAlertModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaSnackbarAlertModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaSnackbarAlertModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule]
      });
    }
  }
  return EcaSnackbarAlertModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMultiSelectComponent = /*#__PURE__*/(() => {
  class EcaMultiSelectComponent {
    static {
      this.nextId = 0;
    }
    /**
     * Allow string or LabelValue for array of options.
     * This is a workaround since Array<string> | Array<LabelValue> can't be merged into the same call signatures so
     * something like options.filter will give a type error.
     */
    get options() {
      return this._options;
    }
    set options(values) {
      this._options = values;
      this.optionsAreStrings = !this._options || this._options.every(option => typeof option === 'string');
      if (!this.optionsAreStrings) {
        for (const option of this._options) {
          this._optionsMap[option.value] = option.label;
        }
      }
      this.updateErrorState();
      this.stateChanges.next();
    }
    get empty() {
      const currentValue = this._value;
      return currentValue === undefined || currentValue === null || currentValue.length === 0;
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(plh) {
      this._placeholder = plh;
      this.stateChanges.next();
    }
    get required() {
      return this._required ?? this.ngControl?.control?.hasValidator(Validators.required) ?? false;
    }
    set required(req) {
      this._required = coerceBooleanProperty(req);
      this.updateErrorState();
      this.stateChanges.next();
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    // value should always be an array of strings, might be the label or the value depending on how 'options' was set;
    // the value is what is what is given to or received from the consuming control
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
      this.onChange(val);
      this.updateErrorState();
      this.stateChanges.next();
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick() {}
    get multiSelectModel() {
      return this._multiSelectModel;
    }
    set multiSelectModel(val) {
      let returnValue;
      let shouldAddSelectDeselectOption = false;
      const selectAllWasSelected = this.selectAllIsSelected;
      this.selectAllIsSelected = val && val?.some(v => {
        return typeof v === 'string' ? v === this.selectDeselectOption : v.value === this.selectDeselectOption;
      });
      if (!selectAllWasSelected && this.selectAllIsSelected) {
        // Select All was selected
        this.selectAllIsSelected = true;
        shouldAddSelectDeselectOption = true;
        returnValue = this.optionsAreStrings ? [...this.options] : this.options.map(o => o.value);
      } else if (selectAllWasSelected && !this.selectAllIsSelected) {
        // Deselect All was selected
        returnValue = [];
      } else if (this.selectAllIsSelected && val.length === 1) {
        // The one selected option was deselected, leaving the Deselect All as the only value;
        // in this case we want to uncheck Deselect All
        this.selectAllIsSelected = false;
        returnValue = [];
      } else if (val.length === 0) {
        // Nothing currently selected
        returnValue = val;
      } else if (val[0] && typeof val[0] === 'string') {
        // An option was selected
        shouldAddSelectDeselectOption = !this.selectAllIsSelected;
        this.selectAllIsSelected = true;
        returnValue = val;
      }
      this._multiSelectModel = shouldAddSelectDeselectOption ? [this.selectDeselectOption, ...returnValue] : returnValue;
      this.value = returnValue?.filter(v => v !== this.selectDeselectOption);
      this.optionsSelected.emit(this.value);
    }
    constructor(ngControl, focusMonitor, elementRef) {
      this.ngControl = ngControl;
      this.focusMonitor = focusMonitor;
      this.elementRef = elementRef;
      this.SELECT_ALL_TEXT = 'Select All';
      this.DESELECT_ALL_TEXT = 'Deselect All';
      this.selectDeselectOption = 'SELECT_DESELECT_ALL';
      this.selectAllIsSelected = false;
      this._optionsMap = {};
      this.optionsAreStrings = false;
      this.disabled = false;
      this.optionsSelected = new EventEmitter();
      /**
       * MatFormFieldControl requires several properties & methods;
       *   the properties are organized alphabetically below
       */
      this.controlType = 'eca-multi-select';
      this.errorState = false;
      this.focused = false;
      this.id = `eca-multi-select-${EcaMultiSelectComponent.nextId++}`;
      this.stateChanges = new Subject();
      this.describedBy = '';
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
      focusMonitor.monitor(elementRef.nativeElement, true).subscribe(origin => {
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }
    ngOnInit() {
      this.stateChanges.next();
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      this.focusMonitor.stopMonitoring(this.elementRef.nativeElement);
    }
    onSelectBlur() {
      this.onTouched();
      this.updateErrorState();
      this.stateChanges.next();
    }
    updateErrorState() {
      if (this.ngControl) {
        this.errorState = this.ngControl.invalid && this.ngControl.touched;
      }
    }
    get selectTriggerText() {
      return this._multiSelectModel?.filter(m => m !== this.selectDeselectOption).map(m => {
        return this.optionsAreStrings ? m : this._optionsMap[m];
      });
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      this._value = value;
      if (value && value.length) {
        this.selectAllIsSelected = true;
        this._multiSelectModel = typeof value === 'string' ? [this.selectDeselectOption, value] : [this.selectDeselectOption, ...value];
      } else {
        this.selectAllIsSelected = false;
        this._multiSelectModel = [];
      }
      this.updateErrorState();
      this.stateChanges.next();
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaMultiSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMultiSelectComponent)(i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i2$4.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaMultiSelectComponent,
        selectors: [["eca-multi-select"]],
        hostVars: 4,
        hostBindings: function EcaMultiSelectComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("id", ctx.id);
            i0.ɵɵattribute("aria-describedby", ctx.describedBy);
            i0.ɵɵclassProp("floating", ctx.shouldLabelFloat);
          }
        },
        inputs: {
          options: "options",
          disabled: "disabled",
          placeholder: "placeholder",
          required: "required",
          value: "value"
        },
        outputs: {
          optionsSelected: "optionsSelected"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: EcaMultiSelectComponent
        }])],
        decls: 10,
        vars: 9,
        consts: [[1, "eca-multi-select"], ["panelWidth", "null", "panelClass", "eca-multi-select-panel", "disableOptionCentering", "", 1, "", 3, "blur", "ngModelChange", "multiple", "disabled", "ngModel", "placeholder"], [1, "select-deselect-all"], [3, "value"], [1, "eca-multi-select-divider"], [4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"]],
        template: function EcaMultiSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "mat-select", 1);
            i0.ɵɵlistener("blur", function EcaMultiSelectComponent_Template_mat_select_blur_1_listener() {
              return ctx.onSelectBlur();
            });
            i0.ɵɵtwoWayListener("ngModelChange", function EcaMultiSelectComponent_Template_mat_select_ngModelChange_1_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.multiSelectModel, $event) || (ctx.multiSelectModel = $event);
              return $event;
            });
            i0.ɵɵelementStart(2, "mat-select-trigger");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2)(5, "mat-option", 3);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(7, "div", 4);
            i0.ɵɵtemplate(8, EcaMultiSelectComponent_span_8_Template, 2, 1, "span", 5)(9, EcaMultiSelectComponent_span_9_Template, 2, 1, "span", 5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("multiple", true)("disabled", ctx.disabled);
            i0.ɵɵtwoWayProperty("ngModel", ctx.multiSelectModel);
            i0.ɵɵproperty("placeholder", ctx.placeholder);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.selectTriggerText);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.selectDeselectOption);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.selectAllIsSelected ? ctx.DESELECT_ALL_TEXT : ctx.SELECT_ALL_TEXT, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.optionsAreStrings);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.optionsAreStrings);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i1$4.NgControlStatus, i1$4.NgModel, i4$1.MatSelect, i4$1.MatSelectTrigger, i2$3.MatOption],
        styles: [".select-deselect-all[_ngcontent-%COMP%]{background-color:#fff;padding:4px 8px}.eca-multi-select-divider[_ngcontent-%COMP%]{margin:4px 0;height:1px;border:1px solid var(--drc-light-grey)}"]
      });
    }
  }
  return EcaMultiSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMultiSelectModule = /*#__PURE__*/(() => {
  class EcaMultiSelectModule {
    static {
      this.ɵfac = function EcaMultiSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMultiSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaMultiSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatDividerModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule]
      });
    }
  }
  return EcaMultiSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SelectableCollector {
  constructor() {
    this.onCollected = new Subject();
    this.collection = new Set();
    this.selection = new Set();
  }
  collect(item) {
    this.collection.add(item);
    this.selection.delete(item);
    this.emitCollection();
  }
  collectAll(items) {
    items.forEach(item => this.collection.add(item));
    this.clearSelection();
    this.emitCollection();
  }
  collectSelection() {
    this.selection.forEach(item => this.collection.add(item));
    this.clearSelection();
    this.emitCollection();
  }
  clearSelection() {
    this.selection.clear();
  }
  disperse(item) {
    this.collection.delete(item);
    this.selection.delete(item);
    this.emitCollection();
  }
  disperseAll() {
    this.collection.clear();
    this.clearSelection();
    this.emitCollection();
  }
  disperseSelection() {
    this.selection.forEach(item => {
      if (this.isCollected(item)) {
        this.collection.delete(item);
      }
    });
    this.clearSelection();
    this.emitCollection();
  }
  isSelected(item) {
    return this.selection.has(item);
  }
  isCollected(item) {
    return this.collection.has(item);
  }
  select(item) {
    this.selection.add(item);
  }
  deselect(item) {
    this.selection.delete(item);
  }
  toggle(item) {
    this.isSelected(item) ? this.deselect(item) : this.select(item);
  }
  emitCollection() {
    this.onCollected.next(Array.from(this.collection.values()));
  }
}
let EcaCollectionBoxComponent = /*#__PURE__*/(() => {
  class EcaCollectionBoxComponent extends SelectableCollector {
    set selectable(items) {
      this.items = items;
      this.filteredItems = items;
    }
    set initCollection(toCollect) {
      const itemSet = new Set(this.items);
      toCollect.forEach(item => {
        if (!itemSet.has(item)) {
          throw getCollectionNotSelectableError();
        }
        this.collect(item);
      });
    }
    constructor() {
      super();
      this.classes = 'eca-collection-box';
      this.collected = new EventEmitter();
      this.buttonLabels = {
        add: 'add to collection',
        addAll: 'add all to collection',
        remove: 'remove from collection',
        removeAll: 'remove all from collection'
      };
      this.items = [];
    }
    collectAll() {
      super.collectAll(this.filteredItems);
    }
    isFiltered(item, value) {
      const accumulator = (currentTerm, key) => currentTerm + item[key];
      const dataStr = Object.keys(item).reduce(accumulator, '').toLowerCase();
      return dataStr.indexOf(value.trim().toLowerCase()) !== -1;
    }
    filter(search) {
      this.filteredItems = this.items.filter(item => {
        return this.isFiltered(item, search);
      });
    }
    emitCollection() {
      this.collected.emit(Array.from(this.collection.values()));
    }
    static {
      this.ɵfac = function EcaCollectionBoxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaCollectionBoxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaCollectionBoxComponent,
        selectors: [["eca-collection-box"]],
        contentQueries: function EcaCollectionBoxComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
          }
        },
        viewQuery: function EcaCollectionBoxComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c31, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function EcaCollectionBoxComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes);
          }
        },
        inputs: {
          selectionTitle: "selectionTitle",
          collectionTitle: "collectionTitle",
          selectable: "selectable",
          initCollection: "initCollection"
        },
        outputs: {
          collected: "collected"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 33,
        vars: 13,
        consts: [["searchInput", ""], [1, "eca-collection-box-panel"], [1, "eca-collection-box-section-title"], [1, "eca-collection-box-frame"], [1, "eca-no-padding-bottom"], ["matInput", "", "autocomplete", "off", "placeholder", "Search", "aria-label", "search", 3, "ngModelChange", "ngModel"], [1, "eca-collection-box-items"], [4, "ngFor", "ngForOf"], [1, "eca-collection-buttons", "eca-fx-col", "eca-fx-gap-1", "eca-fx-justify-content-center", "eca-fx-align-items-center"], ["mat-button", "", "type", "button", 1, "eca-icon-only", 3, "click", "matTooltip"], ["mat-button", "", "type", "button", 1, "double-chevron", "eca-icon-only", 3, "click", "matTooltip"], [1, "eca-collection-button-separator"], ["class", "eca-collection-box-item", 3, "click", "keyup", "dblclick", 4, "ngIf"], [1, "eca-collection-box-item", 3, "click", "keyup", "dblclick"], [1, "eca-collection-box-item-wrapper"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function EcaCollectionBoxComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "mat-form-field", 4)(5, "eca-search", 5, 0);
            i0.ɵɵlistener("ngModelChange", function EcaCollectionBoxComponent_Template_eca_search_ngModelChange_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filter($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 6);
            i0.ɵɵtemplate(8, EcaCollectionBoxComponent_ng_container_8_Template, 2, 1, "ng-container", 7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div", 8)(10, "button", 9);
            i0.ɵɵlistener("click", function EcaCollectionBoxComponent_Template_button_click_10_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.collectSelection());
            });
            i0.ɵɵelementStart(11, "mat-icon");
            i0.ɵɵtext(12, "chevron_right");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "button", 10);
            i0.ɵɵlistener("click", function EcaCollectionBoxComponent_Template_button_click_13_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.collectAll());
            });
            i0.ɵɵelementStart(14, "mat-icon");
            i0.ɵɵtext(15, "chevron_right");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "mat-icon");
            i0.ɵɵtext(17, "chevron_right");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(18, "div", 11);
            i0.ɵɵelementStart(19, "button", 9);
            i0.ɵɵlistener("click", function EcaCollectionBoxComponent_Template_button_click_19_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.disperseSelection());
            });
            i0.ɵɵelementStart(20, "mat-icon");
            i0.ɵɵtext(21, "chevron_left");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "button", 10);
            i0.ɵɵlistener("click", function EcaCollectionBoxComponent_Template_button_click_22_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.disperseAll());
            });
            i0.ɵɵelementStart(23, "mat-icon");
            i0.ɵɵtext(24, "chevron_left");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "mat-icon");
            i0.ɵɵtext(26, "chevron_left");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(27, "div", 1)(28, "div", 2);
            i0.ɵɵtext(29);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "div", 3)(31, "div", 6);
            i0.ɵɵtemplate(32, EcaCollectionBoxComponent_ng_container_32_Template, 2, 1, "ng-container", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.selectionTitle, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.search);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.filteredItems);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("matTooltip", ctx.buttonLabels.add);
            i0.ɵɵattribute("aria-label", ctx.buttonLabels.add);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", ctx.buttonLabels.addAll);
            i0.ɵɵattribute("aria-label", ctx.buttonLabels.addAll);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("matTooltip", ctx.buttonLabels.remove);
            i0.ɵɵattribute("aria-label", ctx.buttonLabels.remove);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", ctx.buttonLabels.removeAll);
            i0.ɵɵattribute("aria-label", ctx.buttonLabels.removeAll);
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate1(" ", ctx.collectionTitle, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.items);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, EcaSearchComponent, i6.MatFormField, i4.MatButton, i5.MatIcon, i1$1.MatTooltip, i1$4.NgControlStatus, i1$4.NgModel],
        styles: [".eca-collection-box{display:flex;flex-direction:row;height:100%;box-sizing:border-box}.eca-collection-box .eca-collection-box-panel{flex:1 1 0;display:flex;flex-flow:column}.eca-collection-box .eca-collection-box-section-title{font-size:18px;line-height:22px;font-weight:400;color:#585858;margin-bottom:1em}.eca-collection-buttons{flex:0;padding:8px}.eca-collection-buttons button.mat-mdc-button.double-chevron mat-icon+mat-icon{margin-left:-16px}.eca-collection-box-frame{border:1px solid #C0C0C0;background-color:#fff;flex:1;padding:10px;display:flex;flex-direction:column;overflow-y:auto}.eca-collection-box-frame .mat-mdc-form-field{width:100%}.eca-collection-box-frame .mat-mdc-form-field.mat-form-field-appearance-outline .mat-mdc-text-field-wrapper{margin-top:0;padding-bottom:0}.eca-collection-box-items{overflow-y:auto}.eca-collection-box-item{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.eca-collection-box-item-wrapper{padding:6px 8px;display:inline-block;cursor:pointer;-webkit-user-select:none;user-select:none}.eca-collection-box-item-wrapper.active,.eca-collection-box-item-wrapper:hover{background-color:#ffe780}.eca-collection-button-separator{height:1px;width:18px;background-color:silver}\n"],
        encapsulation: 2
      });
    }
  }
  return EcaCollectionBoxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getCollectionNotSelectableError() {
  return Error('Cannot collect a value that is not selectable.');
}
let EcaCollectionBoxModule = /*#__PURE__*/(() => {
  class EcaCollectionBoxModule {
    static {
      this.ɵfac = function EcaCollectionBoxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaCollectionBoxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaCollectionBoxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, EcaSearchModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatIconModule, MatTooltipModule, FormsModule, FlexLayoutModule]
      });
    }
  }
  return EcaCollectionBoxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaPillarBoxComponent = /*#__PURE__*/(() => {
  class EcaPillarBoxComponent {
    static {
      this.ɵfac = function EcaPillarBoxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPillarBoxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaPillarBoxComponent,
        selectors: [["eca-pillar-box"]],
        inputs: {
          headerTitle: "headerTitle"
        },
        ngContentSelectors: _c34,
        decls: 3,
        vars: 1,
        consts: [[1, "content", "eca-fx-auto", "eca-fx-col", "eca-fx-align-self-center"], ["class", "eca-pillar-box-header", 4, "ngIf"], [1, "eca-pillar-box-header"], ["tabindex", "-1", 1, "eca-skip-link-focus-target"]],
        template: function EcaPillarBoxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c33);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, EcaPillarBoxComponent_header_1_Template, 4, 1, "header", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headerTitle);
          }
        },
        dependencies: [i1.NgIf],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{box-sizing:border-box;padding:24px;width:100%;max-width:1440px;background-color:var(--drc-white);box-shadow:0 4px 4px #0000003d,0 0 4px #0000001f}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]   .eca-pillar-box-header[_ngcontent-%COMP%]{box-shadow:0 6px 4px #0000000a;margin:-24px -24px 16px;display:flex;flex-direction:row;align-items:center}@media (max-width: 479px){[_nghost-%COMP%]   .content[_ngcontent-%COMP%]   .eca-pillar-box-header[_ngcontent-%COMP%]{margin:-4px}}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]   .eca-pillar-box-header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{padding:8px 24px;flex:1 0 auto}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]   .eca-pillar-box-header[_ngcontent-%COMP%]     [ngprojectas=eca-inline-header-end]{flex:0 1 auto;padding:8px 24px 0 0}@media (max-width: 479px){[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:10px}}@media (max-width: 256px){[_nghost-%COMP%]   .content[_ngcontent-%COMP%]     .mat-mdc-form-field{max-width:fit-content}}"]
      });
    }
  }
  return EcaPillarBoxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaPillarBoxModule = /*#__PURE__*/(() => {
  class EcaPillarBoxModule {
    static {
      this.ɵfac = function EcaPillarBoxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPillarBoxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaPillarBoxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FlexLayoutModule]
      });
    }
  }
  return EcaPillarBoxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaPaginatorComponent = /*#__PURE__*/(() => {
  class EcaPaginatorComponent extends MatPaginator {
    /* in order to update this.pages we have to override the getter/setters from the parent class */
    get length() {
      return this._dataLength;
    }
    set length(value) {
      this._dataLength = coerceNumberProperty(value);
      this.updatePages(this.pageIndex);
      this.changeDetectorRef.markForCheck();
    }
    constructor(_intl, changeDetectorRef) {
      super(_intl, changeDetectorRef) /* istanbul ignore next */;
      this._intl = _intl;
      this.changeDetectorRef = changeDetectorRef;
      this.pageCount = 0;
      this.pages = [];
      this.acceptedPageKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      this.role = 'navigation';
      this.paginatorClass = true;
    }
    selectPage(pageNumber) {
      if (pageNumber) {
        // pages are indexed at 0 while the pageNumber is indexed at 1
        this.updatePages(pageNumber - 1);
      }
    }
    nextPage() {
      super.nextPage();
      this.updatePages(this.pageIndex);
    }
    previousPage() {
      super.previousPage();
      this.updatePages(this.pageIndex);
    }
    ngOnChanges() {
      this.updatePages(this.pageIndex);
      this.changeDetectorRef.markForCheck();
    }
    selectPageSize(size) {
      this._changePageSize(size);
      this.updatePages(this.pageIndex);
    }
    setPageInRange(newPageNo) {
      const prevPageNo = this.pageIndex;
      this.pageIndex = getValueInRange(newPageNo, this.pageCount - 1, 0);
      if (this.pageIndex !== prevPageNo && isNumber(this.length)) {
        this.page.emit({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          length: this.length
        });
      }
    }
    updatePages(newPage) {
      this.pageCount = this.getNumberOfPages();
      if (!isNumber(this.pageCount)) {
        this.pageCount = 0;
      }
      // fill-in model needed to render pages
      this.pages.length = 0;
      for (let i = 1; i <= this.pageCount; i++) {
        this.pages.push(i);
      }
      this.setPageInRange(newPage);
    }
    static {
      this.ɵfac = function EcaPaginatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPaginatorComponent)(i0.ɵɵdirectiveInject(i1$5.MatPaginatorIntl), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaPaginatorComponent,
        selectors: [["eca-paginator"]],
        hostVars: 3,
        hostBindings: function EcaPaginatorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("role", ctx.role);
            i0.ɵɵclassProp("eca-paginator", ctx.paginatorClass);
          }
        },
        inputs: {
          pageSizeSelection: "pageSizeSelection",
          totals: "totals",
          length: "length"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 15,
        vars: 14,
        consts: [[1, "eca-fx-row", "lt-md:eca-fx-col", "eca-fx-justify-content-center", "eca-fx-align-items-center", "eca-fx-auto"], [1, "eca-paginator-page-select-container", "eca-fx-row", "eca-fx-wrap", "lt-sm:eca-fx-col", "eca-fx-justify-content-center", "eca-fx-align-items-center", "eca-fx-align-content-center"], [1, "buttons", "eca-fx-auto", "eca-fx-justify-content-center"], [1, "eca-fx-row", "eca-fx-gap-1", "eca-fx-justify-content-center", "eca-fx-align-items-center", "eca-fx-align-content-center"], ["mat-button", "", "type", "button", 1, "add-border", "eca-icon-only", "mat-paginator-navigation-previous", 3, "click", "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled"], ["mat-button", "", "type", "button", 1, "add-border", "eca-icon-only", "mat-paginator-navigation-next", 3, "click", "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled"], ["class", "eca-paginator-page-select eca-fx-row eca-fx-justify-content-center eca-fx-align-items-center eca-fx-gap-1 eca-fx-align-self-center", 4, "ngIf"], ["class", "divider", 4, "ngIf"], [1, "eca-paginator-page-size-total-container", "eca-fx-row", "eca-fx-wrap", "lt-sm:eca-fx-col", "eca-fx-justify-content-center", "eca-fx-align-items-center"], ["class", "eca-paginator-size-select eca-fx-row eca-fx-align-items-center eca-fx-gap-1", 4, "ngIf"], ["class", "total-items eca-fx-grow eca-fx-justify-content-center", 4, "ngIf"], [1, "eca-paginator-page-select", "eca-fx-row", "eca-fx-justify-content-center", "eca-fx-align-items-center", "eca-fx-gap-1", "eca-fx-align-self-center"], [3, "selectionChange", "panelWidth", "value", "disabled"], [3, "value", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], [1, "eca-fx-auto", "eca-fx-justify-content-center"], [3, "value"], [1, "divider"], [1, "eca-paginator-size-select", "eca-fx-row", "eca-fx-align-items-center", "eca-fx-gap-1"], [1, "eca-fx-grow", "eca-fx-justify-content-center"], [3, "selectionChange", "panelWidth", "aria-label", "value"], [1, "total-items", "eca-fx-grow", "eca-fx-justify-content-center"]],
        template: function EcaPaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "button", 4);
            i0.ɵɵlistener("click", function EcaPaginatorComponent_Template_button_click_4_listener() {
              return ctx.previousPage();
            });
            i0.ɵɵelementStart(5, "mat-icon");
            i0.ɵɵtext(6, "chevron_left");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "button", 5);
            i0.ɵɵlistener("click", function EcaPaginatorComponent_Template_button_click_7_listener() {
              return ctx.nextPage();
            });
            i0.ɵɵelementStart(8, "mat-icon");
            i0.ɵɵtext(9, "chevron_right");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(10, EcaPaginatorComponent_div_10_Template, 8, 6, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, EcaPaginatorComponent_div_11_Template, 1, 0, "div", 7);
            i0.ɵɵelementStart(12, "div", 8);
            i0.ɵɵtemplate(13, EcaPaginatorComponent_div_13_Template, 7, 4, "div", 9)(14, EcaPaginatorComponent_div_14_Template, 3, 1, "div", 10);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("matTooltip", ctx._intl.previousPageLabel)("matTooltipDisabled", !ctx.hasPreviousPage())("matTooltipPosition", "above")("disabled", !ctx.hasPreviousPage());
            i0.ɵɵattribute("aria-label", ctx._intl.previousPageLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", ctx._intl.nextPageLabel)("matTooltipDisabled", !ctx.hasNextPage())("matTooltipPosition", "above")("disabled", !ctx.hasNextPage());
            i0.ɵɵattribute("aria-label", ctx._intl.nextPageLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.pageSizeSelection && ctx._displayedPageSizeOptions.length > 1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pageSizeSelection && ctx._displayedPageSizeOptions.length > 1 && !ctx.hidePageSize);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.pageSizeSelection && ctx._displayedPageSizeOptions.length > 1 && !ctx.hidePageSize);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.totals);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i6.MatFormField, i4$1.MatSelect, i2$3.MatOption, i4.MatButton, i5.MatIcon, i1$1.MatTooltip],
        styles: [":root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-form-field-infix,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-form-field-infix{width:initial}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-text-field-wrapper,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-text-field-wrapper{padding-bottom:0;margin:0}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-select-value,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-select-value{width:initial;min-width:0;max-width:120px;padding-right:8px}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-form-field-subscript-wrapper,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mat-mdc-form-field-subscript-wrapper{height:0;min-height:0}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-form-field-flex,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-form-field-flex{margin-top:0}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-text-field-wrapper,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-text-field-wrapper{padding-bottom:0;margin:0}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-form-field-infix,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-form-field-infix{padding:8px 0;width:initial}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-form-field-subscript-wrapper,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-input.mat-form-field-appearance-outline .mat-mdc-form-field-subscript-wrapper{height:0;min-height:0}.eca-paginator,.eca-table-paginator{justify-content:center}.eca-paginator{display:flex;align-items:center;border:1px solid var(--drc-black);border-top-width:0;background-color:var(--drc-white)}.eca-paginator label{display:inline-block;font-weight:600;color:var(--drc-black)}@media (min-width: 768px){.eca-paginator .divider{width:2px;height:44px;background-color:var(--drc-medium-grey);margin:0 8px}}@media (max-width: 767px){.eca-paginator .divider{height:2px;width:100%;background-color:var(--drc-medium-grey);margin:0}}.eca-paginator .eca-paginator-page-size-total-container,.eca-paginator .eca-paginator-page-select-container{margin:8px}.eca-paginator .eca-paginator-page-size-total-container>div,.eca-paginator .eca-paginator-page-select-container>div{margin:8px}.eca-paginator .eca-paginator-size-select,.eca-paginator .eca-paginator-page-select{margin-left:8px}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field{margin-top:-4px}.eca-paginator .eca-paginator-size-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select .mat-mdc-form-field-infix,.eca-paginator .eca-paginator-page-select .mat-mdc-form-field.mat-mdc-form-field-type-mat-select .mat-mdc-form-field-infix{padding-top:4px;padding-bottom:4px}.eca-paginator .total-items{text-align:center;vertical-align:middle}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return EcaPaginatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getValueInRange(value, max, min = 0) {
  return Math.max(Math.min(value, max), min);
}
function isNumber(value) {
  return !isNaN(toInteger(value));
}
function toInteger(value) {
  return parseInt(`${value}`, 10);
}
let EcaPaginatorModule = /*#__PURE__*/(() => {
  class EcaPaginatorModule {
    static {
      this.ɵfac = function EcaPaginatorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPaginatorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaPaginatorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatInputModule, MatFormFieldModule, MatSelectModule, MatButtonModule, MatIconModule, MatTooltipModule, FormsModule, FlexLayoutModule]
      });
    }
  }
  return EcaPaginatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// This is the base64 encoded version of drc-inisight-logo-2x.png
// The logo is intentionally 2x the required size so that it displays beautifully crisp on high dpi screens
const DRC_INSIGHT_LOGO = 'data:image/png;base64,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';
let EcaDrcInsightLogoComponent = /*#__PURE__*/(() => {
  class EcaDrcInsightLogoComponent {
    get logoUrl() {
      return this.logo === undefined ? DRC_INSIGHT_LOGO : this.logo;
    }
    static {
      this.ɵfac = function EcaDrcInsightLogoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDrcInsightLogoComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaDrcInsightLogoComponent,
        selectors: [["eca-drc-insight-logo"]],
        inputs: {
          logo: "logo"
        },
        decls: 1,
        vars: 1,
        consts: [["alt", "DRC INSIGHT Logo", "role", "img", "class", "drc-insight-logo", 3, "src", 4, "ngIf"], ["alt", "DRC INSIGHT Logo", "role", "img", 1, "drc-insight-logo", 3, "src"]],
        template: function EcaDrcInsightLogoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, EcaDrcInsightLogoComponent_img_0_Template, 1, 1, "img", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.logoUrl);
          }
        },
        dependencies: [i1.NgIf],
        styles: [".drc-insight-logo[_ngcontent-%COMP%]{display:block;width:142px;height:32px;margin-bottom:0;margin-top:8px}"]
      });
    }
  }
  return EcaDrcInsightLogoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaLoginBaseComponent = /*#__PURE__*/(() => {
  class EcaLoginBaseComponent {
    constructor(fb) {
      this.fb = fb;
      this.isLoading = false;
      this.submitForm = new EventEmitter();
      this.passInputType = 'password';
      this.capslock = false;
    }
    ngOnInit() {
      // Default to standard forgot-password link
      if (this.forgotPasswordLink === undefined) {
        this.forgotPasswordLink = '/forgot-password';
      }
      this.passInputType = 'password';
      this.form = this.fb.group({
        username: [{
          value: '',
          disabled: this.isLoading
        }, Validators.required],
        password: [{
          value: '',
          disabled: this.isLoading
        }, Validators.required]
      });
      // set caps lock warning to off in Egde and IE, since we display our own warning
      document.msCapsLockWarningOff = true;
      document.addEventListener('keydown', event => {
        this.capslock = event.getModifierState && event.getModifierState('CapsLock');
      });
    }
    togglePasswordText() {
      if (this.passInputType === 'password') {
        this.passInputType = 'text';
      } else {
        this.passInputType = 'password';
      }
    }
    login() {
      this.submitForm.emit(this.form.value);
    }
    getButtonText() {
      return this.isLoading ? 'Signing in...' : 'Sign in';
    }
    static {
      this.ɵfac = function EcaLoginBaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaLoginBaseComponent)(i0.ɵɵdirectiveInject(i1$4.UntypedFormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaLoginBaseComponent,
        selectors: [["eca-login-base"]],
        inputs: {
          logo: "logo",
          isLoading: "isLoading",
          errorMessage: "errorMessage",
          forgotPasswordLink: "forgotPasswordLink"
        },
        outputs: {
          submitForm: "submitForm"
        },
        decls: 22,
        vars: 9,
        consts: [[3, "ngSubmit", "formGroup"], ["appearance", "outlined", 1, "login-card", "shadow-1", "eca-fx-col", "eca-fx-justify-content-start", "eca-fx-align-items-center"], [3, "logo"], ["tabindex", "-1", 1, "eca-skip-link-focus-target"], ["class", "login-failed", "aria-invalid", "true", 4, "ngIf"], ["id", "loginEmailFormField", 1, "eca-login-component-field"], ["id", "loginEmailLabel"], ["matInput", "", "formControlName", "username", "name", "userEmail", "required", ""], ["id", "loginPasswordFormField", 1, "eca-login-component-field", "eca-password-composite-field"], ["matInput", "", "formControlName", "password", "name", "userPassword", "required", "", 3, "type"], ["matSuffix", "", 3, "change"], [1, "caps-lock-tooltip", "subtitle-2", 3, "hidden"], ["mat-button", "", "type", "submit", "color", "primary", 1, "mat-large-button", 3, "disabled"], ["class", "nav-bar-link", "id", "passwordResetLink", 3, "routerLink", 4, "ngIf"], ["class", "login-overlay eca-fx-auto eca-fx-justify-content-center eca-fx-align-items-center", 4, "ngIf"], ["aria-invalid", "true", 1, "login-failed"], ["id", "passwordResetLink", 1, "nav-bar-link", 3, "routerLink"], [1, "login-overlay", "eca-fx-auto", "eca-fx-justify-content-center", "eca-fx-align-items-center"], ["color", "primary", "diameter", "48"]],
        template: function EcaLoginBaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵlistener("ngSubmit", function EcaLoginBaseComponent_Template_form_ngSubmit_0_listener() {
              return ctx.login();
            });
            i0.ɵɵelementStart(1, "mat-card", 1);
            i0.ɵɵelement(2, "eca-drc-insight-logo", 2);
            i0.ɵɵelementStart(3, "h1", 3);
            i0.ɵɵtext(4, "Sign In");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, EcaLoginBaseComponent_mat_label_5_Template, 2, 1, "mat-label", 4);
            i0.ɵɵelementStart(6, "mat-form-field", 5)(7, "mat-label", 6);
            i0.ɵɵtext(8, "Username");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "mat-form-field", 8)(11, "mat-label");
            i0.ɵɵtext(12, "Password");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(13, "input", 9);
            i0.ɵɵelementStart(14, "mat-checkbox", 10);
            i0.ɵɵlistener("change", function EcaLoginBaseComponent_Template_mat_checkbox_change_14_listener() {
              return ctx.togglePasswordText();
            });
            i0.ɵɵtext(15, "Show Text");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "div", 11);
            i0.ɵɵtext(17, "Caps Lock is on");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(18, "button", 12);
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(20, EcaLoginBaseComponent_a_20_Template, 2, 3, "a", 13)(21, EcaLoginBaseComponent_div_21_Template, 2, 0, "div", 14);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("logo", ctx.logo);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.errorMessage);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("type", ctx.passInputType);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hidden", !ctx.capslock);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.form.invalid || ctx.isLoading);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.getButtonText(), " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.forgotPasswordLink);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isLoading);
          }
        },
        dependencies: [i1.NgIf, i3$1.MatCard, i4.MatButton, i6.MatFormField, i6.MatLabel, i6.MatSuffix, i6$1.MatInput, i1$4.ɵNgNoValidate, i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.RequiredValidator, i1$4.FormGroupDirective, i1$4.FormControlName, i12.MatCheckbox, i7$2.MatProgressSpinner, i2$5.RouterLink, EcaDrcInsightLogoComponent],
        styles: ["[_nghost-%COMP%]{--mdc-outlined-card-container-color: var(--drc-white);display:block;font-size:16px}[_nghost-%COMP%]   .login-card[_ngcontent-%COMP%]{padding:32px}[_nghost-%COMP%]   .login-card[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font:600 22px/24px Source Sans Pro;margin:24px}[_nghost-%COMP%]   .login-card[_ngcontent-%COMP%]   .login-failed[_ngcontent-%COMP%]{color:var(--drc-red);text-align:center;max-width:400px;padding-bottom:10px}[_nghost-%COMP%]   .login-card[_ngcontent-%COMP%]   .mat-mdc-button[_ngcontent-%COMP%]{width:390px;margin-bottom:16px;margin-top:8px}[_nghost-%COMP%]   .login-card[_ngcontent-%COMP%]   .login-overlay[_ngcontent-%COMP%]{position:absolute;top:0;width:100%;height:100%;background-color:#fff9;z-index:50}"],
        changeDetection: 0
      });
    }
  }
  return EcaLoginBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: mark as deprecated
let EcaLoginComponent = /*#__PURE__*/(() => {
  class EcaLoginComponent {
    get forgotPasswordLink() {
      return this.hideForgotPasswordLink ? '' : undefined; // sending undefined will result in the default link being used
    }
    get errorMessage() {
      return this.errorMsg ? this.errorMsg : this.timeOutMessage;
    }
    constructor(securityService, apiGatewayService, appContextService) {
      this.securityService = securityService;
      this.apiGatewayService = apiGatewayService;
      this.appContextService = appContextService;
      this.timeOutMessage = '';
      /* eslint-disable @angular-eslint/no-output-native */
      // todo: rename these outputs with the next breaking change
      this.success = new EventEmitter();
      this.error = new EventEmitter();
      /* eslint-enable @angular-eslint/no-output-native */
      this.errorMsg = '';
      this.isLoading = false;
    }
    ngOnInit() {
      this.appContextService.setToken(null);
    }
    login({
      username,
      password
    }) {
      this.isLoading = true;
      this.errorMsg = '';
      this.securityService.authenticateCredentials(username, password).subscribe(user => this.loginSuccess(user), error => this.loginError(error));
    }
    loginSuccess(userData) {
      this.errorMsg = null;
      this.apiGatewayService.clearCache();
      this.success.emit(userData);
    }
    loginError(err) {
      console.log(err);
      this.isLoading = false;
      switch (err.status) {
        case 404:
          {
            this.errorMsg = 'Security Service not found';
            break;
          }
        case 424:
          {
            this.errorMsg = 'Password expired';
            break;
          }
        case 403:
          {
            if (typeof err.error === 'string') {
              // handles a custom error message string returned from Security Service
              this.errorMsg = err.error;
            } else {
              this.errorMsg = 'Username or Password incorrect';
            }
            break;
          }
        case 0:
          {
            this.errorMsg = err.statusText;
            break;
          }
        default:
          {
            this.errorMsg = 'Username or Password incorrect';
          }
      }
      this.error.emit(err);
    }
    static {
      this.ɵfac = function EcaLoginComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaLoginComponent)(i0.ɵɵdirectiveInject(EcaSecurityService), i0.ɵɵdirectiveInject(ApiGatewayService), i0.ɵɵdirectiveInject(AppContextService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaLoginComponent,
        selectors: [["eca-login"]],
        inputs: {
          hideForgotPasswordLink: "hideForgotPasswordLink",
          timeOutMessage: "timeOutMessage"
        },
        outputs: {
          success: "success",
          error: "error"
        },
        decls: 1,
        vars: 3,
        consts: [[3, "submitForm", "isLoading", "errorMessage", "forgotPasswordLink"]],
        template: function EcaLoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "eca-login-base", 0);
            i0.ɵɵlistener("submitForm", function EcaLoginComponent_Template_eca_login_base_submitForm_0_listener($event) {
              return ctx.login($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("isLoading", ctx.isLoading)("errorMessage", ctx.errorMessage)("forgotPasswordLink", ctx.forgotPasswordLink);
          }
        },
        dependencies: [EcaLoginBaseComponent]
      });
    }
  }
  return EcaLoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaDrcInsightLogoModule = /*#__PURE__*/(() => {
  class EcaDrcInsightLogoModule {
    static {
      this.ɵfac = function EcaDrcInsightLogoModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDrcInsightLogoModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaDrcInsightLogoModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return EcaDrcInsightLogoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaLoginBaseModule = /*#__PURE__*/(() => {
  class EcaLoginBaseModule {
    static {
      this.ɵfac = function EcaLoginBaseModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaLoginBaseModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaLoginBaseModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatCardModule, MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCheckboxModule, MatProgressSpinnerModule, FlexLayoutModule, MatDialogModule, RouterModule, EcaDrcInsightLogoModule]
      });
    }
  }
  return EcaLoginBaseModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaLoginModule = /*#__PURE__*/(() => {
  class EcaLoginModule {
    static {
      this.ɵfac = function EcaLoginModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaLoginModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaLoginModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, EcaLoginBaseModule]
      });
    }
  }
  return EcaLoginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var KeyCode = /*#__PURE__*/function (KeyCode) {
  KeyCode["Right"] = "Right";
  KeyCode["Left"] = "Left";
  KeyCode["Down"] = "Down";
  KeyCode["Up"] = "Up";
  KeyCode["Esc"] = "Esc";
  KeyCode["Spacebar"] = "Spacebar";
  KeyCode["ArrowRight"] = "ArrowRight";
  KeyCode["ArrowLeft"] = "ArrowLeft";
  KeyCode["ArrowDown"] = "ArrowDown";
  KeyCode["ArrowUp"] = "ArrowUp";
  KeyCode["Tab"] = "Tab";
  KeyCode["Escape"] = "Escape";
  KeyCode["Enter"] = "Enter";
  KeyCode["Space"] = " ";
  KeyCode["Home"] = "Home";
  KeyCode["End"] = "End";
  KeyCode["Delete"] = "Delete";
  KeyCode["Backspace"] = "Backspace";
  KeyCode["Clear"] = "Clear";
  KeyCode["EraseEof"] = "EraseEof";
  return KeyCode;
}(KeyCode || {});
function isKeyUp(key) {
  return [KeyCode.Up, KeyCode.ArrowUp].includes(key);
}
function isKeyRight(key) {
  return [KeyCode.Right, KeyCode.ArrowRight].includes(key);
}
function isKeyDown(key) {
  return [KeyCode.Down, KeyCode.ArrowDown].includes(key);
}
function isKeyLeft(key) {
  return [KeyCode.Left, KeyCode.ArrowLeft].includes(key);
}
function isKeyDelete(key) {
  return [KeyCode.Delete, KeyCode.Backspace, KeyCode.Clear, KeyCode.EraseEof].includes(key);
}
function isKeyNavigation(key) {
  return [KeyCode.Tab].includes(key) || isKeyUp(key) || isKeyRight(key) || isKeyDown(key) || isKeyLeft(key);
}
function isKeySpace(key) {
  return [KeyCode.Space, KeyCode.Spacebar].includes(key);
}
function isKeyEscape(key) {
  return [KeyCode.Esc, KeyCode.Escape].includes(key);
}

/**
 * KeyCode right arrow list
 */
const keyCodesRight = [KeyCode.ArrowRight, KeyCode.Right];
/**
 * KeyCode left arrow list
 */
const keyCodesLeft = [KeyCode.ArrowLeft, KeyCode.Left];
/**
 * Focus top level (menu bar) list to first (Home) or last (End) menu item
 */
const keyCodesHomeEnd = [KeyCode.Home, KeyCode.End];
/**
 * Keys for up and down
 */
const keyCodesUpDown$1 = [KeyCode.ArrowDown, KeyCode.ArrowUp, KeyCode.Down, KeyCode.Up];
/**
 * Sub menu related opening and closing and navigation
 *
 * * `ArrowRight` will move to the next menubar item or first if the last item is focused
 * * `ArrowLeft` will move to the previous menubar item or last if the first item is focused
 *
 * Submenus will take precedence before the menubar
 * Meaning if there is a submenu of a submenu
 * * `ArrowRight` will open that sub-submenu
 * * `ArrowLeft` will find the parent-submenu
 *
 * ex:
 *
 * From Submenu 1 Item 1 focus
 *
 * ```txt
 * -->     | Menubar Item 1 | Menubar Item 2 |
 *         -----------------------------------
 * -->     | *Submenu 1 Item 1* |
 * -->     |  Submenu 1 Item 2  |
 * -->     |  Submenu 1 Item 3  |
 * ```
 *
 * To Menubar Item 2 focus and Submenu 2 open on ArrowRight
 *
 * ```txt
 * -->     | Menubar Item 1 | *Menubar Item 2* |
 *         -------------------------------------
 * -->                      | Submenu 2 Item 1 |
 * -->                      | Submenu 2 Item 2 |
 * -->                      | Submenu 2 Item 3 |
 * ```
 *
 * `Legend`
 *
 * ```txt
 * -->   =   Applicable to
 * ```
 */
const keyCodesPrevNext = [KeyCode.ArrowRight, KeyCode.ArrowLeft, KeyCode.Right, KeyCode.Left];
/**
 * Top level menu (menubar) related opening and closing
 *
 * * `ArrowDown` will open submenu and focus first item
 * * `ArrowUp` will open submenu and focus last item
 * * `Tab` will move to the next tabable item and close any open submenus
 * * `Escape` will close any open submenus
 *
 * ex:
 *
 * From Menubar Item 1 focus
 *
 * ```txt
 * -->     | *Menubar Item 1* | Menubar Item 2 |
 *         -------------------------------------
 * ```
 *
 * To Submenu open and Submenu 1 focus on ArrowDown
 *
 * ```txt
 * -->     | Menubar Item 1 | Menubar Item 2 |
 *         -----------------------------------
 *         | *Submenu 1* |
 *         |  Submenu 2  |
 *         |  Submenu 3  |
 * ```
 *
 * `Legend`
 *
 * ```txt
 * -->   =   Applicable to
 * ```
 */
const keyCodesOC = [KeyCode.ArrowDown, KeyCode.ArrowUp, KeyCode.Tab, KeyCode.Escape, KeyCode.Down, KeyCode.Up, KeyCode.Esc];
/**
 * Any menu item related activating
 *
 * Same as the mouse click event
 *
 * ex:
 *
 * ```txt
 * -->     | Menubar Item 1 | Menubar Item 2 |
 *         -------------------------------------
 * -->                      | Submenu 2 Item 1 |
 * -->                      | Submenu 2 Item 2 |
 * -->                      | Submenu 2 Item 3 |
 * ```
 *
 * `Legend`
 *
 * ```txt
 * -->   =   Applicable to
 * ```
 */
const keyCodesActivate$1 = [KeyCode.Enter, KeyCode.Space, KeyCode.Spacebar];
// installing/requiring UUID lib is overkill for what's needed here
// crypto lib is only available within https or localhost context
function generateUUIDv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
let EcaMenuDirective = /*#__PURE__*/(() => {
  class EcaMenuDirective {
    get _parentMenu() {
      return this.matMenuItem?._parentMenu;
    }
    get parentMenu() {
      return this._parentMenu?.parentMenu;
    }
    /**
     * If true prevents the menu from closing when activating the menu item
     */
    set stopPropagation(val) {
      if (val === '') {
        this._stopPropagation = true;
      } else {
        this._stopPropagation = !!val;
      }
    }
    /**
     * If true allows any components in the menu item to update any values
     */
    set preventDefault(val) {
      if (val === '') {
        this._preventDefault = true;
      } else {
        this._preventDefault = !!val;
      }
    }
    constructor(elementRef, ecaMenuComponent, matMenuTrigger, matMenuItem) {
      this.elementRef = elementRef;
      this.ecaMenuComponent = ecaMenuComponent;
      this.matMenuTrigger = matMenuTrigger;
      this.matMenuItem = matMenuItem;
      /**
       * The unique id generated for this menu item and/or menu trigger
       */
      this.id = generateUUIDv4();
      this._stopPropagation = false;
      this._preventDefault = false;
      /**
       * Emits the activated event of the menu item and/or menu trigger event
       *
       * The activation occurs on mouse click and on keyboard presses of space and enter
       *
       * Helper for activating/deactivating in menu item components such as a checkbox, radio, slider and toggle
       */
      this.activated = new EventEmitter();
    }
    /**
     * EcaMenuDirective click event
     *
     * @param event Mouse click PointerEvent
     */
    click(event) {
      this.emit(event);
    }
    /**
     * EcaMenuDirective keyboard event
     *
     * @param event Key press KeyboardEvent
     */
    keydown(event) {
      /**
       * Pressed key code
       */
      const code = event.key;
      // Menu item activated by keyboard enter / space
      if (keyCodesActivate$1.includes(code)) {
        this.emit(event);
        return;
      }
      /**
       * Length of the top level (menubar) menu triggers.
       */
      const length = this.ecaMenuComponent?.ecaMenu?.length;
      // Somehow there are no menus
      // Could be because the menu trigger isn't wrapped in <eca-menu> (EcaMenuComponent)
      if (!length) {
        // Has to be a trigger and not a menu item and `keyCodesOC` are pressed continue
        if (this.matMenuTrigger && !this.matMenuItem && keyCodesOC.includes(code)) {
          this.mainOpenClose(code);
        } else {
          this.setSubmenuFocus(code);
        }
        return;
      }
      /**
       * If index is not -1 then the button is a top level menu trigger.
       *
       * Else the button is a menu item or submenu trigger.
       */
      const index = this.ecaMenuComponent.ecaMenu.toArray().findIndex(menu => {
        return menu.id === this.id;
      });
      // Top level (menubar) trigger actions
      if (index > -1 && keyCodesOC.includes(code)) {
        // Open and/or close
        this.mainOpenClose(code);
        // Prevents scroll
        if (keyCodesUpDown$1.includes(code)) {
          event.preventDefault();
        }
        return;
      }
      /**
       * The active top level menu trigger
       */
      let currentMenu;
      /**
       * The next top level menu tigger
       */
      let nextMenu;
      // Top level (menubar) trigger actions
      if (index > -1) {
        // please refactor to fix this lint error, but maintain intended functionality
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        currentMenu = this;
        if (keyCodesPrevNext.includes(code) || keyCodesHomeEnd.includes(code)) {
          // Main navigation
          nextMenu = this.getNextMenuByMainNavigation(code, index, length);
          // Prevents scroll
          if (keyCodesHomeEnd.includes(code)) {
            event.preventDefault();
          }
        } else {
          // Character navigation
          nextMenu = this.getNextMenuByCharacterNavigation(code, index);
        }
      }
      // Submenu actions
      if (keyCodesPrevNext.includes(code) && index === -1) {
        if (length < 2) {
          this.setSubmenuFocus(code);
          return;
        }
        const tabIndex = this.getTabIndex();
        // No top level (menubar) menu triggers found to be active so return
        // getTabIndex restored the top level (menubar) trigger
        if (tabIndex === -1) {
          return;
        }
        // Submenu navigation
        nextMenu = this.getNextMenuBySubMenu(code, tabIndex, length);
        currentMenu = this.ecaMenuComponent.ecaMenu.get(tabIndex);
      }
      // Finally set the focus
      this.setFocus(currentMenu, nextMenu);
    }
    /**
     * Emits the menu item activation
     *
     * If available preventDefault and/or stopPropagation
     *
     * @param event Keyboard or Pointer Event
     */
    emit(event) {
      // Prevents the menu from closing
      if (this._stopPropagation) {
        event.stopPropagation();
      }
      // Allow use of other components and update values of those components
      if (this._preventDefault) {
        event.preventDefault();
      }
      this.activated.emit(event);
    }
    /**
     * Gets the label without icons
     */
    getLabel() {
      const clone = this.elementRef.nativeElement.cloneNode(true);
      const icons = clone.querySelectorAll('mat-icon, .material-icons');
      for (let i = 0; i < icons.length; i++) {
        icons[i].remove();
      }
      return clone.textContent.trim();
    }
    /**
     * Gets the first character of each of the top level (menubar) menu triggers
     */
    getMenuFirstCharacters() {
      return this.ecaMenuComponent.ecaMenu.reduce((pv, cv) => {
        const first = cv.getLabel().slice(0, 1);
        pv.push(first.toLocaleUpperCase());
        return pv;
      }, []);
    }
    /**
     * Runs the navigation by detecting if a "printable" character is pressed and matches the first character
     * of the next top level (menubar) menu trigger
     *
     * Starts from the current position to the end and if needed runs from start to the current position
     *
     * If none are found nothing happens
     *
     * @param code Keyboard event key code
     * @param index This position in the top level (menubar) menu list
     */
    getNextMenuByCharacterNavigation(code, index) {
      const codeUpper = code.toLocaleUpperCase();
      // The key code isn't a printable character so don't do anything
      if (!(codeUpper.length === 1 && codeUpper.match(/\S/))) {
        return;
      }
      let nextMenu;
      let nextMenuIndex;
      const characters = this.getMenuFirstCharacters();
      // Start where the current index is
      for (let i = index + 1; i < characters.length; i++) {
        if (characters[i] === codeUpper) {
          nextMenuIndex = i;
          break;
        }
      }
      // Start over and only loop to the current index
      if (nextMenuIndex == null) {
        for (let i = 0; i < index; i++) {
          if (characters[i] === codeUpper) {
            nextMenuIndex = i;
            break;
          }
        }
      }
      // Assign next menu
      if (nextMenuIndex != null && nextMenuIndex !== index) {
        nextMenu = this.ecaMenuComponent.ecaMenu.get(nextMenuIndex);
      }
      return nextMenu;
    }
    /**
     * Finds the next menu to focus and/or open
     *
     * @param code Keyboard event key code
     * @param index This position in the top level (menubar) menu list
     * @param length The top level (menubar) menu list length
     */
    getNextMenuByMainNavigation(code, index, length) {
      let nextMenu;
      // Get the next menu
      if (index === length - 1 && keyCodesRight.includes(code) || KeyCode.Home === code) {
        nextMenu = this.ecaMenuComponent.ecaMenu.get(0);
      } else if (index === 0 && keyCodesLeft.includes(code) || KeyCode.End === code) {
        nextMenu = this.ecaMenuComponent.ecaMenu.get(length - 1);
      } else if (keyCodesRight.includes(code)) {
        nextMenu = this.ecaMenuComponent.ecaMenu.get(index + 1);
        // } else if (keyCodesLeft.includes(code)) {
      } else {
        nextMenu = this.ecaMenuComponent.ecaMenu.get(index - 1);
      }
      return nextMenu;
    }
    /**
     * Finds the next menu to focus and open
     *
     * @param code Keyboard event key code
     * @param index This position in the top level (menubar) menu list
     * @param length The top level menu (menubar) list length
     */
    getNextMenuBySubMenu(code, index, length) {
      let nextMenu;
      // Find the next top level (menubar) menu trigger
      if (!this.parentMenu && keyCodesLeft.includes(code)) {
        if (index === 0) {
          nextMenu = this.ecaMenuComponent.ecaMenu.get(length - 1);
        } else {
          nextMenu = this.ecaMenuComponent.ecaMenu.get(index - 1);
        }
      } else if (!this.matMenuTrigger && keyCodesRight.includes(code)) {
        // Don't look for the next menu if the current menu item is a trigger
        if (index === length - 1) {
          nextMenu = this.ecaMenuComponent.ecaMenu.get(0);
        } else {
          nextMenu = this.ecaMenuComponent.ecaMenu.get(index + 1);
        }
      } else {
        ''.toLocaleUpperCase();
      }
      return nextMenu;
    }
    /**
     * Get the current tabable top level (menubar) menu trigger
     *
     * Restores the tab index if something went wrong
     */
    getTabIndex() {
      /**
       * The index of the tabable top level menu trigger. i.e. > -1
       */
      const tabIndex = this.ecaMenuComponent.ecaMenu.toArray().findIndex(menu => {
        return menu.elementRef.nativeElement.tabIndex > -1;
      });
      // In case tabIndex didn't get set restore it to the first item
      if (tabIndex === -1) {
        let parentMenu = this._parentMenu;
        // Make sure any existing menus close
        while (parentMenu) {
          parentMenu.close.next();
          parentMenu = parentMenu.parentMenu;
        }
        const currentMenu = this.ecaMenuComponent.ecaMenu.get(0);
        currentMenu.elementRef.nativeElement.tabIndex = 0;
        currentMenu.matMenuTrigger?.openMenu();
        currentMenu.elementRef.nativeElement.focus();
      }
      return tabIndex;
    }
    /**
     * Opens and/or closes the popup menu(s)
     *
     * @param code Keyboard event key code
     */
    mainOpenClose(code) {
      // requires matMenuTriggerFor
      // If not found can't do anything
      if (!this.matMenuTrigger) {
        return;
      }
      // Open and Close
      switch (code) {
        case KeyCode.Tab:
        case KeyCode.Escape:
        case KeyCode.Esc:
          if (this.matMenuTrigger.menuOpen) {
            this.matMenuTrigger.closeMenu();
          }
          break;
        case KeyCode.ArrowDown:
        case KeyCode.Down:
          this.matMenuTrigger.openMenu();
          this.matMenuTrigger.menu.focusFirstItem('keyboard');
          break;
        case KeyCode.ArrowUp:
        case KeyCode.Up:
          this.matMenuTrigger.openMenu();
          // The `items` property isn't exposed by Material
          // and Material doesn't have a focusLastItem method
          this.matMenuTrigger.menu['items'].last?.focus();
          break;
      }
    }
    /**
     * Set the focus and if a top level (menubar) menu is active also open the next top level (menubar) menu item
     *
     * @param currentMenu Current active top level (menubar) menu item
     * @param nextMenu Next top level (menubar) menu item
     */
    setFocus(currentMenu, nextMenu) {
      if (currentMenu === nextMenu) {
        return;
      }
      const isOpen = currentMenu?.matMenuTrigger?.menuOpen;
      // If open then close the current menu and open the next menu
      if (isOpen && nextMenu) {
        currentMenu.matMenuTrigger.closeMenu();
        nextMenu.matMenuTrigger?.openMenu();
      }
      // Remove the tabindex of the current menu if a next menu exists
      if (currentMenu && nextMenu) {
        currentMenu.elementRef.nativeElement.tabIndex = -1;
      }
      // Set the tabindex of the next menu if it exists
      if (nextMenu) {
        nextMenu.elementRef.nativeElement.tabIndex = 0;
        nextMenu.elementRef.nativeElement.focus();
      }
    }
    /**
     * Focuses the next submenu item
     *
     * @param code Keyboard event key code
     */
    setSubmenuFocus(code) {
      // Only if previous or next keys
      if (!keyCodesPrevNext.includes(code)) {
        return;
      }
      /**
       * Menu panel
       */
      const menu = this._parentMenu;
      // No menu so can't find any elements to focus
      if (!menu) {
        return;
      }
      /**
       * List of menu items
       */
      const items = menu['items'];
      /**
       * Number of menu items
       */
      const length = items.length;
      if (length < 2) {
        return;
      }
      /**
       * Current index of the focused menu item
       */
      const index = items.toArray().findIndex(item => {
        return item === this.matMenuItem;
      });
      let nextMenu;
      // If this isn't part of a parent menu continue (left)
      if (!this.parentMenu && keyCodesLeft.includes(code)) {
        if (index === 0) {
          nextMenu = items.get(length - 1);
        } else {
          nextMenu = items.get(index - 1);
        }
      } else if (!this.matMenuTrigger && keyCodesRight.includes(code)) {
        // Don't look for the next menu item if the current menu item is a trigger (right)
        if (index === length - 1) {
          nextMenu = items.get(0);
        } else {
          nextMenu = items.get(index + 1);
        }
      } else {
        ''.toLocaleUpperCase();
      }
      // Focus the next menu item
      if (nextMenu) {
        nextMenu.focus();
      }
    }
    static {
      this.ɵfac = function EcaMenuDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMenuDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(EcaMenuComponent, 8), i0.ɵɵdirectiveInject(i2$1.MatMenuTrigger, 8), i0.ɵɵdirectiveInject(i2$1.MatMenuItem, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaMenuDirective,
        selectors: [["", "eca-menu", ""]],
        hostBindings: function EcaMenuDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function EcaMenuDirective_click_HostBindingHandler($event) {
              return ctx.click($event);
            })("keydown", function EcaMenuDirective_keydown_HostBindingHandler($event) {
              return ctx.keydown($event);
            });
          }
        },
        inputs: {
          stopPropagation: "stopPropagation",
          preventDefault: "preventDefault"
        },
        outputs: {
          activated: "activated"
        },
        exportAs: ["ecaMenu"]
      });
    }
  }
  return EcaMenuDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMenuComponent = /*#__PURE__*/(() => {
  class EcaMenuComponent {
    constructor() {
      this.ecaMenu = new QueryList();
    }
    addToMenu(button, position = 'append') {
      const array = this.ecaMenu.toArray();
      switch (position) {
        case 'append':
          array.push(button);
          break;
        case 'prepend':
          array.unshift(button);
          break;
        default:
          array.splice(position, 0, button);
      }
      this.ecaMenu.reset(array);
    }
    removeFromMenu(index) {
      const array = this.ecaMenu.toArray();
      array.splice(index, 1);
      this.ecaMenu.reset(array);
    }
    reset() {
      this.ecaMenu.reset(this.ecaMenuContent.toArray());
    }
    ngAfterContentInit() {
      if (!this.ecaMenu.length) {
        this.reset();
      }
    }
    static {
      this.ɵfac = function EcaMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaMenuComponent,
        selectors: [["eca-menu"]],
        contentQueries: function EcaMenuComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, EcaMenuDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ecaMenuContent = _t);
          }
        },
        ngContentSelectors: _c6,
        decls: 1,
        vars: 0,
        template: function EcaMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        }
      });
    }
  }
  return EcaMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaMenuModule = /*#__PURE__*/(() => {
  class EcaMenuModule {
    static {
      this.ɵfac = function EcaMenuModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatMenuModule, MatButtonModule, MatIconModule]
      });
    }
  }
  return EcaMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAccordionDirective = /*#__PURE__*/(() => {
  class EcaAccordionDirective {
    constructor(elementRef) {
      if (elementRef.nativeElement.hasAttribute('eca-accordion-lg')) {
        elementRef.nativeElement.classList.add('eca-accordion-lg');
      }
    }
    static {
      this.ɵfac = function EcaAccordionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAccordionDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaAccordionDirective,
        selectors: [["", "eca-accordion", ""], ["", "eca-accordion-lg", ""]]
      });
    }
  }
  return EcaAccordionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAccordionHeaderDirective = /*#__PURE__*/(() => {
  class EcaAccordionHeaderDirective {
    constructor(toolTip, matExpansionPanelHeader) {
      this.toolTip = toolTip;
      this.matExpansionPanelHeader = matExpansionPanelHeader;
      this.observer = new ResizeObserver(headers => {
        for (const header of headers) {
          this.setDisabled(header.target);
        }
      });
    }
    setDisabled(element) {
      const title = element.querySelector('.mat-expansion-panel-header-title');
      this.toolTip.disabled = !(title.scrollWidth > title.offsetWidth);
    }
    ngAfterViewInit() {
      const header = this.matExpansionPanelHeader;
      const headerElement = header['_element'].nativeElement;
      this.observer.observe(headerElement, {
        box: 'border-box'
      });
      const _originalKeyDown = header._keydown;
      header._keydown = event => {
        const keyCode = event.keyCode;
        if (keyCode !== DOWN_ARROW && keyCode !== UP_ARROW) {
          _originalKeyDown.call(header, event);
        }
      };
    }
    ngOnDestroy() {
      this.observer.disconnect();
    }
    static {
      this.ɵfac = function EcaAccordionHeaderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAccordionHeaderDirective)(i0.ɵɵdirectiveInject(i1$1.MatTooltip), i0.ɵɵdirectiveInject(i3$2.MatExpansionPanelHeader));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaAccordionHeaderDirective,
        selectors: [["", "eca-accordion-header", ""], ["", "eca-accordion-header-lg", ""]]
      });
    }
  }
  return EcaAccordionHeaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAccordionModule = /*#__PURE__*/(() => {
  class EcaAccordionModule {
    static {
      this.ɵfac = function EcaAccordionModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAccordionModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaAccordionModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatTooltipModule]
      });
    }
  }
  return EcaAccordionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SkipToContentButtonComponent = /*#__PURE__*/(() => {
  class SkipToContentButtonComponent {
    constructor(router) {
      this.router = router;
      this.skipToContentId = 'eca-skip-link-focus-target';
    }
    ngOnInit() {
      // header-element won't have a RouterModule available
      if (this.router) {
        this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
          this.resetFocus();
        });
      }
    }
    resetFocus() {
      const htmlElement = document.getElementById('first-element-focus-target');
      htmlElement.focus();
    }
    onClickSkipToContent() {
      const htmlElementTarget = this.findSkipLinkTarget();
      if (htmlElementTarget) {
        htmlElementTarget.focus();
        // if the focus didn't work then try to find a child element that is focusable/tab-able
        if (document.activeElement !== htmlElementTarget) {
          const childTarget = this.findFocusableChild(htmlElementTarget);
          if (childTarget) {
            childTarget.focus();
          }
        }
      }
    }
    findFocusableChild(element) {
      const focusableElements = [...element.querySelectorAll('a, button, details, input, select, textarea, [contenteditable], [tabindex]:not([tabindex="-1"])')].filter(el => !el.hasAttribute('disabled'));
      return focusableElements.length > 0 ? focusableElements[0] : null;
    }
    findSkipLinkTarget() {
      const skipLinkTargetById = document.getElementById(this.skipToContentId);
      if (skipLinkTargetById) {
        return skipLinkTargetById;
      } else {
        const skipLinkTargetByClass = document.getElementsByClassName(this.skipToContentId);
        if (skipLinkTargetByClass.length > 0) {
          return skipLinkTargetByClass.item(0);
        }
      }
      console.error(`Unable to find an element with id or class ${this.skipToContentId}`);
      return null;
    }
    static {
      this.ɵfac = function SkipToContentButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SkipToContentButtonComponent)(i0.ɵɵdirectiveInject(i2$5.Router, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SkipToContentButtonComponent,
        selectors: [["eca-skip-to-content-button"]],
        decls: 3,
        vars: 0,
        consts: [["id", "first-element-focus-target", "tabindex", "-1"], ["id", "eca-skip-to-content-link", 1, "eca-link", "remove-btn-formatting", 3, "click"]],
        template: function SkipToContentButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "span", 0);
            i0.ɵɵelementStart(1, "button", 1);
            i0.ɵɵlistener("click", function SkipToContentButtonComponent_Template_button_click_1_listener() {
              return ctx.onClickSkipToContent();
            });
            i0.ɵɵtext(2, " Skip to Content\n");
            i0.ɵɵelementEnd();
          }
        },
        styles: ["#eca-skip-to-content-link[_ngcontent-%COMP%]{position:absolute;left:0;top:59px;padding:8px;background-color:#fff;transition:left .5s;width:160px;z-index:1000}#eca-skip-to-content-link[_ngcontent-%COMP%]:not(.focus-visible){left:-160px}#eca-skip-to-content-link.focus-visible[_ngcontent-%COMP%]{left:0}"]
      });
    }
  }
  return SkipToContentButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAppShellComponent = /*#__PURE__*/(() => {
  class EcaAppShellComponent {
    constructor() {}
    static {
      this.ɵfac = function EcaAppShellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAppShellComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaAppShellComponent,
        selectors: [["eca-app-shell"]],
        inputs: {
          helpLinks: "helpLinks"
        },
        ngContentSelectors: _c6,
        decls: 6,
        vars: 1,
        consts: [["role", "navigation", "title", "skip to content"], [3, "helpLinks"], ["cdkScrollable", "", 1, "container", "eca-fx-col", "eca-fx-justify-content-start", "eca-fx-align-content-start", "eca-fx-align-items-stretch"], ["role", "main", 1, "eca-fx-auto", "eca-fx-col"], ["role", "contentinfo"]],
        template: function EcaAppShellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelement(0, "eca-skip-to-content-button", 0)(1, "eca-header", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "eca-footer", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("helpLinks", ctx.helpLinks);
          }
        },
        dependencies: [i9.CdkScrollable, EcaHeaderComponent, EcaFooterComponent, SkipToContentButtonComponent],
        styles: ["BODY{padding:0;margin:0}[_nghost-%COMP%]{display:block;min-height:100vh}[_nghost-%COMP%]   .container[_ngcontent-%COMP%]{overflow-y:auto;overflow-x:hidden;background-color:#f4f4f4;height:calc(100vh - 56px)}@media (max-width: 767px){[_nghost-%COMP%]   .container[_ngcontent-%COMP%]{height:100%}}@media (max-height: 359px){[_nghost-%COMP%]   .container[_ngcontent-%COMP%]{height:100%}}@media screen and (-ms-high-contrast: none),(-ms-high-contrast: active){eca-footer[_ngcontent-%COMP%]{position:fixed;bottom:0;left:0;right:0}}"]
      });
    }
  }
  return EcaAppShellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SkipToContentButtonModule = /*#__PURE__*/(() => {
  class SkipToContentButtonModule {
    static {
      this.ɵfac = function SkipToContentButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SkipToContentButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SkipToContentButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, RouterModule]
      });
    }
  }
  return SkipToContentButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAppShellModule = /*#__PURE__*/(() => {
  class EcaAppShellModule {
    static {
      this.ɵfac = function EcaAppShellModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAppShellModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaAppShellModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [FlexLayoutModule, CommonModule, EcaHeaderModule, EcaFooterModule, SkipToContentButtonModule]
      });
    }
  }
  return EcaAppShellModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaVerticalStepperDirective = /*#__PURE__*/(() => {
  class EcaVerticalStepperDirective {
    // [eca-stepper] is an alias for [eca-vertical-stepper]="false"
    set ecaStepper(value) {
      this._isVertical = false;
      this.toggleOrientation();
    }
    set ecaVerticalStepper(isVertical) {
      this._isVertical = isVertical !== false;
      this.toggleOrientation();
    }
    get ecaVerticalStepper() {
      return this._isVertical;
    }
    constructor(elementRef, host, matTooltip) {
      this.elementRef = elementRef;
      this.host = host;
      this.matTooltip = matTooltip;
    }
    keydown(event) {
      this.keydownSelector(event);
    }
    ngAfterViewInit() {
      this.initializeTooltips();
    }
    initializeTooltips() {
      const stepperElement = this.elementRef.nativeElement;
      const stepHeaders = stepperElement.querySelectorAll('mat-step-header');
      this.matTooltip.positionAtOrigin = true;
      this.matTooltip.position = this.getPositionForTooltip();
      for (let i = 0; i < stepHeaders.length; i++) {
        const header = stepHeaders[i];
        const labelText = header.querySelector('.mat-step-text-label').textContent;
        header.addEventListener('mouseenter', () => this.showTooltip(header, labelText));
        header.addEventListener('focus', () => this.showTooltip(header, labelText));
        header.addEventListener('mouseleave', () => this.hideTooltip());
        header.addEventListener('blur', () => this.hideTooltip());
      }
    }
    getPositionForTooltip() {
      return this.ecaVerticalStepper ? 'right' : 'below';
    }
    getCoordinatesForTooltip(target) {
      const rect = target.getBoundingClientRect();
      const width = rect.width || 60;
      const height = rect.height || 44;
      if (this.ecaVerticalStepper) {
        return {
          x: rect.x + width,
          y: rect.y + height / 2
        };
      } else {
        return {
          x: rect.x + width / 2,
          y: rect.y + height
        };
      }
    }
    showTooltip(target, message) {
      // only show the tooltip when the label is hidden via stepper.scss (480px is the 'small' width)
      if (window.innerWidth >= 479) {
        return;
      }
      this.matTooltip.message = message;
      // for the tooltip to position correctly on focus we need to wait a tick
      setTimeout(() => {
        this.matTooltip.show(0, this.getCoordinatesForTooltip(target));
      }, 1);
    }
    hideTooltip() {
      this.matTooltip.hide(0);
    }
    toggleOrientation() {
      const stepperElement = this.elementRef.nativeElement;
      if (this.ecaVerticalStepper) {
        stepperElement.classList.add('eca-vertical-stepper');
      } else {
        stepperElement.classList.remove('eca-vertical-stepper');
      }
    }
    keydownSelector(event) {
      const key = event.key;
      const selectedIndex = this.host.selectedIndex;
      const previousStep = this.host.steps.get(selectedIndex - 1);
      const nextStep = this.host.steps.get(selectedIndex + 1);
      const totalSteps = this.host.steps.length;
      /**
       *  arrows should move focus; wrap from first to last and vice-versa
       */
      if (isKeyUp(key)) {
        event.preventDefault();
        if (previousStep) {
          this.host.previous();
        } else if (selectedIndex === 0) {
          this.host.steps.last.select();
        }
      } else if (isKeyDown(key)) {
        event.preventDefault();
        if (nextStep) {
          this.host.next();
        } else if (selectedIndex === totalSteps - 1) {
          this.host.steps.first.select();
        }
      }
    }
    static {
      this.ɵfac = function EcaVerticalStepperDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaVerticalStepperDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i7$3.MatStepper), i0.ɵɵdirectiveInject(i1$1.MatTooltip));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaVerticalStepperDirective,
        selectors: [["", "eca-vertical-stepper", ""], ["", "eca-stepper", ""]],
        hostBindings: function EcaVerticalStepperDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function EcaVerticalStepperDirective_keydown_HostBindingHandler($event) {
              return ctx.keydown($event);
            });
          }
        },
        inputs: {
          ecaStepper: [0, "eca-stepper", "ecaStepper"],
          ecaVerticalStepper: [0, "eca-vertical-stepper", "ecaVerticalStepper"]
        },
        features: [i0.ɵɵProvidersFeature([MatTooltip])]
      });
    }
  }
  return EcaVerticalStepperDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaVerticalStepperModule = /*#__PURE__*/(() => {
  class EcaVerticalStepperModule {
    static {
      this.ɵfac = function EcaVerticalStepperModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaVerticalStepperModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaVerticalStepperModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatTooltipModule]
      });
    }
  }
  return EcaVerticalStepperModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaPageHeaderComponent = /*#__PURE__*/(() => {
  class EcaPageHeaderComponent {
    constructor() {
      this.title = '[title]';
      this.breadcrumbs = null;
    }
    static {
      this.ɵfac = function EcaPageHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPageHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaPageHeaderComponent,
        selectors: [["eca-page-header"]],
        inputs: {
          title: "title",
          breadcrumbs: "breadcrumbs"
        },
        ngContentSelectors: _c6,
        decls: 7,
        vars: 2,
        consts: [[1, "eca-page-header-container"], ["class", "eca-page-header-breadcrumbs", 4, "ngIf"], [1, "eca-page-header-title"], ["id", "eca-skip-link-focus-target", "tabindex", "-1"], [1, "eca-page-header-sub-title"], [1, "eca-page-header-breadcrumbs"], ["aria-label", "Breadcrumb"], [1, "breadcrumb"], [4, "ngFor", "ngForOf"], ["class", "breadcrumb-item", 4, "ngIf"], ["class", "breadcrumb-item", "aria-current", "page", 4, "ngIf"], [1, "breadcrumb-item"], [3, "routerLink"], ["aria-current", "page", 1, "breadcrumb-item"]],
        template: function EcaPageHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, EcaPageHeaderComponent_div_1_Template, 4, 1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "h1", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.breadcrumbs);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i2$5.RouterLink],
        styles: [".eca-page-header-container[_ngcontent-%COMP%]{background-color:var(--drc-white);padding:8px 24px;margin-bottom:8px;box-shadow:0 6px 4px #0000000a}.eca-page-header-container[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]{margin-bottom:0}"]
      });
    }
  }
  return EcaPageHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaPageHeaderModule = /*#__PURE__*/(() => {
  class EcaPageHeaderModule {
    static {
      this.ɵfac = function EcaPageHeaderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPageHeaderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaPageHeaderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule]
      });
    }
  }
  return EcaPageHeaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaPageWithSidePanelComponent = /*#__PURE__*/(() => {
  class EcaPageWithSidePanelComponent {
    set showSidePanel(show) {
      this._showSidePanel = show;
      if (this.drawer) {
        if (show) {
          this.drawer.open();
        } else {
          this.drawer.close();
        }
      }
    }
    get showSidePanel() {
      return this._showSidePanel;
    }
    constructor() {
      this._showSidePanel = true;
      this.hasBackdrop = false;
      // 'push' and 'over' are not allowed for a11y reasons
      this.panelMode = 'side';
      this.showSidePanelChange = new EventEmitter();
    }
    closeDrawer() {
      // depends on two-way binding being properly setup
      this.showSidePanelChange.emit(false);
    }
    static {
      this.ɵfac = function EcaPageWithSidePanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPageWithSidePanelComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaPageWithSidePanelComponent,
        selectors: [["eca-page-with-side-panel"]],
        viewQuery: function EcaPageWithSidePanelComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatDrawer, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.drawer = _t.first);
          }
        },
        inputs: {
          hasBackdrop: "hasBackdrop",
          showSidePanel: "showSidePanel"
        },
        outputs: {
          showSidePanelChange: "showSidePanelChange"
        },
        ngContentSelectors: _c37,
        decls: 15,
        vars: 2,
        consts: [["drawer", ""], [3, "hasBackdrop"], [1, "main-content"], ["position", "end", "autoFocus", "first-heading", 3, "mode"], [1, "eca-side-panel-header"], ["id", "eca-page-with-side-panel-title", "tabindex", "-1"], [1, "eca-side-panel-close-button"], ["mat-button", "", "aria-label", "close", 1, "eca-icon-only", 3, "click"], [1, "eca-side-panel-scroll-container"], [1, "eca-side-panel-content"]],
        template: function EcaPageWithSidePanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c36);
            i0.ɵɵelementStart(0, "mat-drawer-container", 1)(1, "div", 2);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-drawer", 3, 0)(5, "div", 4)(6, "h2", 5);
            i0.ɵɵprojection(7, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 6)(9, "button", 7);
            i0.ɵɵlistener("click", function EcaPageWithSidePanelComponent_Template_button_click_9_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closeDrawer());
            });
            i0.ɵɵelementStart(10, "mat-icon");
            i0.ɵɵtext(11, "close");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(12, "div", 8)(13, "div", 9);
            i0.ɵɵprojection(14, 2);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hasBackdrop", ctx.hasBackdrop);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mode", ctx.panelMode);
          }
        },
        dependencies: [i5.MatIcon, i4.MatButton, i6$3.MatDrawer, i6$3.MatDrawerContainer],
        styles: ["[_nghost-%COMP%]{display:flex;flex:1 1 auto;min-height:0;width:100%;background-color:var(--drc-white);flex-direction:column;box-sizing:border-box}[_nghost-%COMP%]     .mat-drawer-container{display:flex;flex:1 1 auto;background-color:var(--drc-white);min-height:0;box-shadow:0 1px 3px var(--drc-dark-grey-15),0 1px 2px -1px var(--drc-dark-grey-15);margin:16px}[_nghost-%COMP%]     .mat-drawer-container .mat-drawer-content{flex:1 1 auto;overflow:auto;height:auto;min-height:100px;background-color:var(--drc-white)}[_nghost-%COMP%]     .mat-drawer-container .mat-drawer-content .main-content{display:flex;flex:1 1 auto;background-color:var(--drc-white);padding:24px}[_nghost-%COMP%]   .eca-side-panel-scroll-container[_ngcontent-%COMP%]{flex:1 1 auto;overflow:auto;padding:24px}[_nghost-%COMP%]   .eca-side-panel-scroll-container[_ngcontent-%COMP%]   .eca-side-panel-content[_ngcontent-%COMP%]{height:fit-content;min-height:fit-content}[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]{max-width:50%;display:flex;flex-direction:column;box-shadow:0 1px 3px var(--drc-dark-grey-15),0 1px 2px -1px var(--drc-dark-grey-15)}[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]     .mat-drawer-inner-container{overflow:hidden;display:flex;flex-direction:column}[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]   .eca-side-panel-header[_ngcontent-%COMP%]{border-bottom:1px solid var(--drc-medium-grey);display:flex;flex-direction:row;flex:0 1 auto}[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]   .eca-side-panel-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{flex:1 1 auto;align-self:center;padding:16px 0 16px 24px;margin:0}[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]   .eca-side-panel-header[_ngcontent-%COMP%]   .eca-side-panel-close-button[_ngcontent-%COMP%]{flex:0 1 auto;align-self:center;padding:0 16px}[_nghost-%COMP%]   .mat-drawer[_ngcontent-%COMP%]   .eca-side-panel-header[_ngcontent-%COMP%]   .eca-side-panel-close-button[_ngcontent-%COMP%]:hover{opacity:1}"]
      });
    }
  }
  return EcaPageWithSidePanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaPageWithSidePanelModule = /*#__PURE__*/(() => {
  class EcaPageWithSidePanelModule {
    static {
      this.ɵfac = function EcaPageWithSidePanelModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPageWithSidePanelModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaPageWithSidePanelModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule, MatButtonModule, MatSidenavModule]
      });
    }
  }
  return EcaPageWithSidePanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaReorderTableComponent = /*#__PURE__*/(() => {
  class EcaReorderTableComponent {
    set data(data) {
      this.dataSource.data = data || [];
    }
    set columns(columnNames) {
      this.columnsToDisplay = [...this.baseColumns, ...columnNames];
    }
    constructor() {
      this.reorder = new EventEmitter();
      this.showHeader = true;
      this.baseColumns = ['reorderMenu', 'reorderButtons'];
      this.columnsToDisplay = [...this.baseColumns];
      this.dataSource = new MatTableDataSource([]);
    }
    /* Hack so that [class.order-row-moved] resets and triggers CSS animation again */
    setLastMoved(currentIndex) {
      this.lastMovedIndex = -1;
      setTimeout(() => {
        this.lastMovedIndex = currentIndex;
      }, 1);
    }
    movePosition(previousIndex, currentIndex) {
      this.reorder.emit({
        previousIndex,
        currentIndex
      });
      this.setLastMoved(currentIndex);
    }
    moveRowDown(rowIndex) {
      const currentIndex = rowIndex + 1;
      this.reorder.emit({
        previousIndex: rowIndex,
        currentIndex
      });
      this.setLastMoved(currentIndex);
    }
    moveRowUp(rowIndex) {
      const currentIndex = rowIndex - 1;
      this.reorder.emit({
        previousIndex: rowIndex,
        currentIndex
      });
      this.setLastMoved(currentIndex);
    }
    ngAfterContentInit() {
      this.columnDefs.forEach(columnDef => this.table.addColumnDef(columnDef));
    }
    static {
      this.ɵfac = function EcaReorderTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaReorderTableComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaReorderTableComponent,
        selectors: [["eca-reorder-table"]],
        contentQueries: function EcaReorderTableComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatColumnDef, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnDefs = _t);
          }
        },
        viewQuery: function EcaReorderTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatTable, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.table = _t.first);
          }
        },
        inputs: {
          data: "data",
          columns: "columns",
          showHeader: "showHeader"
        },
        outputs: {
          reorder: "reorder"
        },
        ngContentSelectors: _c6,
        decls: 10,
        vars: 5,
        consts: [["matMenu", "matMenu"], [3, "dataSource"], ["matColumnDef", "reorderMenu"], [4, "matHeaderCellDef"], [4, "matCellDef"], ["matColumnDef", "reorderButtons"], [4, "matHeaderRowDef"], [3, "order-row-moved", 4, "matRowDef", "matRowDefColumns"], ["matMenuContent", ""], ["mat-button", "", "color", "secondary", 1, "mat-menu-button", 3, "matMenuTriggerFor"], [4, "ngFor", "ngForOf"], ["mat-menu-item", "", "title", "Row Order", 3, "value", "click", 4, "ngIf"], ["mat-menu-item", "", "title", "Row Order", 3, "click", "value"], ["mat-icon-button", "", "title", "Move row up", 1, "reorder-button", "eca-icon-only", 3, "click", "disabled"], ["mat-icon-button", "", "title", "Move row down", 1, "reorder-button", 3, "click", "disabled"]],
        template: function EcaReorderTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "mat-table", 1);
            i0.ɵɵelementContainerStart(1, 2);
            i0.ɵɵtemplate(2, EcaReorderTableComponent_mat_header_cell_2_Template, 2, 0, "mat-header-cell", 3)(3, EcaReorderTableComponent_mat_cell_3_Template, 6, 2, "mat-cell", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(4, 5);
            i0.ɵɵtemplate(5, EcaReorderTableComponent_mat_header_cell_5_Template, 2, 0, "mat-header-cell", 3)(6, EcaReorderTableComponent_mat_cell_6_Template, 7, 2, "mat-cell", 4);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵprojection(7);
            i0.ɵɵtemplate(8, EcaReorderTableComponent_mat_header_row_8_Template, 1, 0, "mat-header-row", 6)(9, EcaReorderTableComponent_mat_row_9_Template, 1, 2, "mat-row", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("hide-header", !ctx.showHeader);
            i0.ɵɵproperty("dataSource", ctx.dataSource);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("matHeaderRowDef", ctx.columnsToDisplay);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matRowDefColumns", ctx.columnsToDisplay);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i6$2.MatTable, i6$2.MatHeaderCellDef, i6$2.MatHeaderRowDef, i6$2.MatColumnDef, i6$2.MatCellDef, i6$2.MatRowDef, i6$2.MatHeaderCell, i6$2.MatCell, i6$2.MatHeaderRow, i6$2.MatRow, i2$1.MatMenu, i2$1.MatMenuItem, i2$1.MatMenuContent, i2$1.MatMenuTrigger, i4.MatButton, i4.MatIconButton, i5.MatIcon],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}.mat-mdc-row[_ngcontent-%COMP%]{position:relative;box-sizing:border-box}mat-table.hide-header[_ngcontent-%COMP%]   .mat-mdc-header-row[_ngcontent-%COMP%]{display:none}.mat-mdc-cell[_ngcontent-%COMP%]{min-height:68px}.mat-column-reorderMenu[_ngcontent-%COMP%]{flex:0 0 72px;padding-left:24px;padding-right:18px}.mat-column-reorderButtons[_ngcontent-%COMP%]{flex:0 0 104px;padding-right:24px;padding-left:2px}.mat-column-reorderButtons[_ngcontent-%COMP%]   .reorder-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{left:-2px;top:-2px;position:relative}.order-row-moved.mat-mdc-row[_ngcontent-%COMP%]:after{content:\" \";display:block;height:100%;width:100%;position:absolute;box-sizing:border-box;pointer-events:none;animation-duration:2s;animation-name:_ngcontent-%COMP%_fadeBorderOut}@keyframes _ngcontent-%COMP%_fadeBorderOut{0%{border:2px solid var(--drc-blue)}80%{border:2px solid var(--drc-blue)}to{border:2px solid transparent}}"]
      });
    }
  }
  return EcaReorderTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const keyCodesUp = [KeyCode.ArrowUp, KeyCode.Up];
const keyCodesDown = [KeyCode.ArrowDown, KeyCode.Down];
const keyCodesUpDown = [...keyCodesUp, ...keyCodesDown];
const keyCodesActivate = [KeyCode.Enter, KeyCode.Space, KeyCode.Spacebar];
const keyCodesEscape = [KeyCode.Escape, KeyCode.Esc];
// Note: this class corresponds to a style rule in table.scss
const activatedCssClass = 'eca-reorder-directive-activated';
let EcaReorderDirective = /*#__PURE__*/(() => {
  class EcaReorderDirective {
    constructor(elementRef) {
      this.elementRef = elementRef;
      // Event Emitted when the element should move up/down
      this.ecaReorderElementMoved = new EventEmitter();
    }
    /**
     * Ensure row is not activated once focus leaves the element
     * HOWEVER, when a row is moved up it seems to lose focus on the button element
     * so use an animation frame and cancel it if focusin happens quickly after this focusout
     */
    focusout() {
      this.inactivateId = requestAnimationFrame(() => {
        this.inactivateRow();
      });
    }
    focusin() {
      cancelAnimationFrame(this.inactivateId);
    }
    /**
     * Listen for keyboard events while the element has focus
     */
    keydown(event) {
      const code = event.key;
      // Activate (select) the row
      if (keyCodesActivate.includes(code)) {
        this.activateRow();
        return;
      }
      // Handle keys that will emit that a row should move
      if (keyCodesUpDown.includes(code)) {
        if (this.isActivated()) {
          this.emitMoved(event, code);
        }
      }
      // Escape should always inactivate (unselect) the row
      if (keyCodesEscape.includes(code)) {
        this.inactivateRow();
      }
      // maintain focus on this element which is moving the row
      this.elementRef.nativeElement.focus();
    }
    findRootElement() {
      let parentElement = this.elementRef.nativeElement.parentElement;
      for (let i = 0; i < 5; i++) {
        if (parentElement.classList.contains(this.ecaReorderRootElementClass)) {
          return parentElement;
        } else {
          parentElement = parentElement.parentElement;
        }
      }
      return null;
    }
    emitMoved(event, code) {
      let newIndex = this.rowIndex;
      if (keyCodesUp.includes(code)) {
        newIndex -= 1;
      } else if (keyCodesDown.includes(code)) {
        newIndex += 1;
      }
      event.stopPropagation();
      event.preventDefault();
      this.ecaReorderElementMoved.emit({
        previousIndex: this.rowIndex,
        currentIndex: newIndex
      });
    }
    /**
     * Return true/false whether the corresponding row is activated (selected)
     */
    isActivated() {
      const rootElement = this.findRootElement();
      return rootElement && rootElement.classList.contains(activatedCssClass);
    }
    /**
     * toggle the CSS class to indicate activated / selected
     */
    activateRow() {
      const rootElement = this.findRootElement();
      if (rootElement && rootElement.classList.contains(activatedCssClass)) {
        rootElement.classList.remove(activatedCssClass);
      } else {
        rootElement.classList.add(activatedCssClass);
      }
    }
    /**
     * remove the CSS class
     */
    inactivateRow() {
      const rootElement = this.findRootElement();
      if (rootElement) {
        rootElement.classList.remove(activatedCssClass);
      }
    }
    static {
      this.ɵfac = function EcaReorderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaReorderDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaReorderDirective,
        selectors: [["", "eca-reorder", ""]],
        hostBindings: function EcaReorderDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focusout", function EcaReorderDirective_focusout_HostBindingHandler($event) {
              return ctx.focusout($event);
            })("focusin", function EcaReorderDirective_focusin_HostBindingHandler($event) {
              return ctx.focusin($event);
            })("keydown", function EcaReorderDirective_keydown_HostBindingHandler($event) {
              return ctx.keydown($event);
            });
          }
        },
        inputs: {
          rowIndex: [0, "eca-reorder", "rowIndex"],
          ecaReorderRootElementClass: "ecaReorderRootElementClass"
        },
        outputs: {
          ecaReorderElementMoved: "ecaReorderElementMoved"
        },
        exportAs: ["ecaReorder"]
      });
    }
  }
  return EcaReorderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const materialModules = [MatTableModule, MatMenuModule, MatButtonModule, MatIconModule];
let EcaReorderTableModule = /*#__PURE__*/(() => {
  class EcaReorderTableModule {
    static {
      this.ɵfac = function EcaReorderTableModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaReorderTableModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaReorderTableModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, materialModules]
      });
    }
  }
  return EcaReorderTableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaErrorComponent = /*#__PURE__*/(() => {
  class EcaErrorComponent {
    constructor(location, activatedRoute, router) {
      this.location = location;
      this.activatedRoute = activatedRoute;
      this.router = router;
      this.code = '';
      this.desc = 'An error has occurred';
      this.detail = 'It seems the system is not responding.';
    }
    ngOnInit() {
      this.activatedRoute.queryParams.subscribe(params => {
        if (params['desc']) {
          this.desc = params['desc'];
        }
        if (params['detail']) {
          this.detail = params['detail'];
        }
      });
      const codeFromRouteParams = this.activatedRoute.snapshot.params['code'];
      this.code = codeFromRouteParams ? codeFromRouteParams : this.code;
    }
    goBack() {
      // Go back to previous location if there's somewhere to go
      // Otherwise navigate to Portal login
      if (window?.history?.length > 1) {
        this.location.back();
      }
      this.router.navigate(['/']);
    }
    static {
      this.ɵfac = function EcaErrorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaErrorComponent)(i0.ɵɵdirectiveInject(i1.Location), i0.ɵɵdirectiveInject(i2$5.ActivatedRoute), i0.ɵɵdirectiveInject(i2$5.Router));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaErrorComponent,
        selectors: [["eca-error"]],
        inputs: {
          code: "code",
          desc: "desc",
          detail: "detail"
        },
        decls: 14,
        vars: 4,
        consts: [[2, "text-align", "center"], ["width", "297", "height", "172", "viewBox", "0 0 297 172", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M191.929 142H64.4434C59.0274 142 54.6368 136.09 54.6368 128.8C54.6368 121.51 59.0274 115.6 64.4434 115.6H9.8066C4.39057 115.6 0 109.69 0 102.4C0 95.1098 4.39057 89.2 9.8066 89.2H65.8443C71.2604 89.2 75.6509 83.2902 75.6509 76C75.6509 68.7098 71.2604 62.8 65.8443 62.8H30.8208C25.4047 62.8 21.0142 56.8902 21.0142 49.6C21.0142 42.3098 25.4047 36.4 30.8208 36.4H86.8585C81.4425 36.4 77.0519 30.4902 77.0519 23.2C77.0519 15.9098 81.4425 10 86.8585 10L166.712 10C172.128 10 176.519 15.9098 176.519 23.2C176.519 30.4902 172.128 36.4 166.712 36.4H256.373C261.789 36.4 266.179 42.3098 266.179 49.6C266.179 56.8902 261.789 62.8 256.373 62.8H287.193C292.609 62.8 297 68.7098 297 76C297 83.2902 292.609 89.2 287.193 89.2H260.575C255.159 89.2 250.769 95.1098 250.769 102.4C250.769 109.69 255.159 115.6 260.575 115.6H268.981C274.397 115.6 278.788 121.51 278.788 128.8C278.788 136.09 274.397 142 268.981 142H196.132C195.411 142 194.708 141.895 194.031 141.696C193.354 141.895 192.651 142 191.929 142Z", "fill", "#EDF6FF"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M212.379 132.918C208.286 136.221 203.82 139.214 199.038 141.85L199.315 165.589C199.336 167.451 197.848 168.978 195.99 169C195.235 169.009 194.499 168.762 193.9 168.301L172.604 151.879C164.621 153.72 156.201 154.705 147.5 154.705C96.4137 154.705 55 120.745 55 78.8527C55 36.9604 96.4137 3 147.5 3C198.586 3 240 36.9604 240 78.8527C240 90.4476 236.827 101.435 231.155 111.263C230.109 113.075 228.978 114.848 227.766 116.578", "fill", "white"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M147.5 6C97.4864 6 58 39.1464 58 78.8527C58 118.559 97.4864 151.705 147.5 151.705C155.974 151.705 164.168 150.746 171.929 148.955L173.312 148.636L195.732 165.925C195.797 165.975 195.875 166.001 195.955 166C196.15 165.998 196.317 165.836 196.315 165.624L196.017 140.09L197.59 139.223C202.223 136.669 206.543 133.773 210.495 130.584C211.784 129.543 213.673 129.745 214.714 131.034C215.754 132.324 215.552 134.212 214.263 135.253C210.483 138.304 206.4 141.094 202.058 143.592L202.314 165.554C202.355 169.066 199.546 171.958 196.026 172C194.595 172.016 193.201 171.55 192.068 170.676L171.886 155.114C164.098 156.805 155.924 157.705 147.5 157.705C95.3409 157.705 52 122.931 52 78.8527C52 34.7743 95.3409 0 147.5 0C199.659 0 243 34.7743 243 78.8527C243 91.0083 239.671 102.509 233.754 112.762C232.663 114.652 231.485 116.499 230.223 118.3C229.273 119.657 227.402 119.986 226.045 119.036C224.688 118.085 224.358 116.214 225.309 114.857C226.472 113.197 227.555 111.498 228.557 109.763C233.984 100.361 237 89.8868 237 78.8527C237 39.1464 197.514 6 147.5 6Z", "fill", "black"], ["x", "99", "y", "99", "fill", "black", "font-size", "4em", "font-weight", "bold"], [2, "margin", "auto"], ["mat-button", "", "color", "primary", 3, "click"]],
        template: function EcaErrorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵelement(2, "path", 2)(3, "path", 3)(4, "path", 4);
            i0.ɵɵelementStart(5, "text", 5);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(7, "h2");
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "p", 6);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "br");
            i0.ɵɵelementStart(12, "button", 7);
            i0.ɵɵlistener("click", function EcaErrorComponent_Template_button_click_12_listener() {
              return ctx.goBack();
            });
            i0.ɵɵtext(13, "Go Back");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(ctx.code);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2("", ctx.code, " - ", ctx.desc, "");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.detail, " ");
          }
        },
        dependencies: [i4.MatButton],
        styles: ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{box-sizing:border-box;height:100%;padding:32px}@media (max-width: 479px){[_nghost-%COMP%] > div[_ngcontent-%COMP%]{padding-left:16px;padding-right:16px}}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--drc-dark-grey)}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{max-width:100%;height:auto}"]
      });
    }
  }
  return EcaErrorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaErrorModule = /*#__PURE__*/(() => {
  class EcaErrorModule {
    static {
      this.ɵfac = function EcaErrorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaErrorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaErrorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FlexLayoutModule, MatCardModule, MatButtonModule]
      });
    }
  }
  return EcaErrorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAccessDeniedComponent = /*#__PURE__*/(() => {
  class EcaAccessDeniedComponent {
    constructor() {
      this.title = 'Authorization Required';
      this.description = 'You currently do not have access privileges to view this content.';
    }
    static {
      this.ɵfac = function EcaAccessDeniedComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAccessDeniedComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaAccessDeniedComponent,
        selectors: [["eca-access-denied"]],
        decls: 29,
        vars: 2,
        consts: [[1, "eca-fx-row", "eca-fx-justify-content-center"], [1, "eca-fx-col", "eca-fx-gap-3"], ["width", "237", "height", "219", "viewBox", "0 0 237 219", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M86.5 5L0 43.3636V100.909C0 154.139 36.9067 203.915 86.5 216C136.093 203.915 173 154.139 173 100.909V43.3636L86.5 5Z", "fill", "#C88A12"], ["d", "M86.5 0L0 38.3636V95.9091C0 149.139 36.9067 198.915 86.5 211C136.093 198.915 173 149.139 173 95.9091V38.3636L86.5 0Z", "fill", "url(#paint0_linear_1078_929)"], ["filter", "url(#filter0_d_1078_929)"], ["cx", "167", "cy", "149", "r", "45", "fill", "white"], ["d", "M166.5 99.0889C139.151 99.0889 117 121.26 117 148.633C117 176.007 139.151 198.178 166.5 198.178C193.849 198.178 216 176.007 216 148.633C216 121.26 193.849 99.0889 166.5 99.0889ZM166.5 116.182C174.173 116.182 180.36 122.499 180.36 130.054C180.36 137.61 174.049 143.927 166.5 143.927C158.951 143.927 152.64 137.61 152.64 130.054C152.64 122.499 158.827 116.182 166.5 116.182ZM166.5 182.695C154.991 182.695 144.968 176.997 138.78 168.203C139.399 159.285 157.466 154.826 166.5 154.826C175.534 154.826 193.601 159.285 194.22 168.203C188.032 176.997 178.009 182.695 166.5 182.695Z", "fill", "#002A5F"], ["cx", "132.002", "cy", "121.002", "r", "9", "fill", "white"], ["d", "M132 111C126.48 111 122 115.48 122 121C122 126.52 126.48 131 132 131C137.52 131 142 126.52 142 121C142 115.48 137.52 111 132 111ZM132 129C127.58 129 124 125.42 124 121C124 119.15 124.63 117.45 125.69 116.1L136.9 127.31C135.55 128.37 133.85 129 132 129ZM138.31 125.9L127.1 114.69C128.45 113.63 130.15 113 132 113C136.42 113 140 116.58 140 121C140 122.85 139.37 124.55 138.31 125.9Z", "fill", "#B50000"], ["id", "filter0_d_1078_929", "x", "97", "y", "79", "width", "140", "height", "140", "filterUnits", "userSpaceOnUse", "color-interpolation-filters", "sRGB"], ["flood-opacity", "0", "result", "BackgroundImageFix"], ["in", "SourceAlpha", "type", "matrix", "values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", "result", "hardAlpha"], ["radius", "10", "operator", "dilate", "in", "SourceAlpha", "result", "effect1_dropShadow_1078_929"], ["stdDeviation", "7.5"], ["in2", "hardAlpha", "operator", "out"], ["type", "matrix", "values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"], ["mode", "normal", "in2", "BackgroundImageFix", "result", "effect1_dropShadow_1078_929"], ["mode", "normal", "in", "SourceGraphic", "in2", "effect1_dropShadow_1078_929", "result", "shape"], ["id", "paint0_linear_1078_929", "x1", "1.28895e-06", "y1", "105.5", "x2", "179.07", "y2", "105.5", "gradientUnits", "userSpaceOnUse"], ["stop-color", "#DEB408"], ["offset", "0.481167", "stop-color", "#DEB408"], ["offset", "0.481267", "stop-color", "#C88A12"], [3, "innerHTML"]],
        template: function EcaAccessDeniedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(2, "svg", 2);
            i0.ɵɵelement(3, "path", 3)(4, "path", 4);
            i0.ɵɵelementStart(5, "g", 5);
            i0.ɵɵelement(6, "circle", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "path", 7)(8, "circle", 8)(9, "path", 9);
            i0.ɵɵelementStart(10, "defs")(11, "filter", 10);
            i0.ɵɵelement(12, "feFlood", 11)(13, "feColorMatrix", 12)(14, "feMorphology", 13)(15, "feOffset")(16, "feGaussianBlur", 14)(17, "feComposite", 15)(18, "feColorMatrix", 16)(19, "feBlend", 17)(20, "feBlend", 18);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "linearGradient", 19);
            i0.ɵɵelement(22, "stop", 20)(23, "stop", 21)(24, "stop", 22);
            i0.ɵɵelementEnd()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(25, "div")(26, "h1");
            i0.ɵɵtext(27);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(28, "p", 23);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(27);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.description, i0.ɵɵsanitizeHtml);
          }
        },
        styles: ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{width:100%;height:100%;padding:32px}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--drc-dark-grey)}"]
      });
    }
  }
  return EcaAccessDeniedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAccessDeniedModule = /*#__PURE__*/(() => {
  class EcaAccessDeniedModule {
    static {
      this.ɵfac = function EcaAccessDeniedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAccessDeniedModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaAccessDeniedModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FlexLayoutModule, MatCardModule]
      });
    }
  }
  return EcaAccessDeniedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaNoResultsComponent = /*#__PURE__*/(() => {
  class EcaNoResultsComponent {
    constructor() {
      this.defaultTitle = 'No data to display';
      this.defaultDescription = '';
      this.defaultHeadingLevel = 'h2';
      this.headingLevel = this.defaultHeadingLevel;
      this.title = this.defaultTitle;
      this.description = this.defaultDescription;
    }
    ngOnChanges(simpleChanges) {
      if (simpleChanges.description && simpleChanges.description.currentValue === '') {
        this.description = this.defaultDescription;
      }
    }
    static {
      this.ɵfac = function EcaNoResultsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaNoResultsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaNoResultsComponent,
        selectors: [["eca-no-results"]],
        inputs: {
          headingLevel: "headingLevel",
          title: "title",
          description: "description"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 35,
        vars: 6,
        consts: [[1, "eca-fx-row", "eca-fx-justify-content-center"], [1, "eca-fx-col"], ["width", "280", "height", "215", "viewBox", "0 0 280 215", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M201.061 33.9893C200.796 33.9893 200.538 34.0025 200.273 34.0091C189.488 13.7757 168.196 0 143.668 0C112.999 0 87.3665 21.5303 81.0542 50.2991C77.7458 48.7309 74.0471 47.8509 70.1499 47.8509C59.2125 47.8509 49.883 54.752 46.2703 64.432C44.6294 64.2335 42.9554 64.121 41.2615 64.121C18.4737 64.121 0 82.5945 0 105.382C0 128.169 18.4737 146.643 41.2615 146.643H190.176C191.989 146.643 193.782 146.55 195.542 146.371C197.362 146.55 199.195 146.643 201.061 146.643C232.172 146.643 257.388 121.427 257.388 90.3226C257.388 59.2049 232.172 33.9893 201.061 33.9893Z", "fill", "#EDF6FF"], ["d", "M235.123 45.4625C239.808 53.6736 242.501 63.175 242.501 73.3115C242.501 104.416 217.285 129.632 186.18 129.632C178.213 129.632 170.637 127.978 163.776 124.993C189.336 116.557 207.79 92.4995 207.79 64.1145C207.79 43.9076 198.434 25.8841 183.831 14.1331C187.9 22.5559 190.183 32.011 190.183 41.9954C190.183 77.4006 161.48 106.11 126.067 106.11C111.253 106.11 97.6156 101.068 86.7576 92.6319C92.1833 87.9606 95.6306 81.0529 95.6306 73.3314C95.6306 65.8216 92.3752 59.0727 87.2076 54.4146C89.4969 58.1662 90.8203 62.5663 90.8203 67.2839C90.8203 80.9404 80.227 92.9561 60.4365 92.9561C57.6575 92.9561 54.991 92.4995 52.4899 91.6791C57.0157 96.0394 63.1494 98.739 69.9182 98.8117C67.6818 119.488 50.1675 135.573 28.8949 135.573C21.332 135.573 14.239 133.529 8.14502 129.976C15.6616 140.086 27.7039 146.636 41.2747 146.636C64.0625 146.636 199.267 146.636 201.074 146.636C232.185 146.636 257.401 121.421 257.401 90.3161C257.388 72.0081 248.648 55.7446 235.123 45.4625Z", "fill", "#A0CAFF"], ["filter", "url(#filter0_d_549_1158)"], ["d", "M222.755 149.264H218.283L215.698 146.736C221.245 140.283 224.585 131.906 224.585 122.792C224.585 102.472 208.113 86 187.792 86C167.472 86 151 102.472 151 122.792C151 143.113 167.472 159.585 187.792 159.585C196.906 159.585 205.283 156.245 211.736 150.698L214.264 153.283V157.755L241.566 185L250 176.566L222.755 149.264ZM187.792 148.264C173.698 148.264 162.321 136.887 162.321 122.792C162.321 108.698 173.698 97.3208 187.792 97.3208C201.887 97.3208 213.264 108.698 213.264 122.792C213.264 136.887 201.887 148.264 187.792 148.264Z", "fill", "black"], ["cx", "188", "cy", "123.5", "rx", "31", "ry", "31.5", "fill", "white"], ["d", "M217.547 148.528H222.019L250.264 176.83L241.83 185.264L213.528 157.019V152.547L212 150.962L215.962 147L217.547 148.528Z", "fill", "url(#paint0_linear_549_1158)"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M188 148C201.807 148 213 136.807 213 123C213 109.193 201.807 98 188 98C174.193 98 163 109.193 163 123C163 136.807 174.193 148 188 148ZM188 160C208.435 160 225 143.435 225 123C225 102.565 208.435 86 188 86C167.565 86 151 102.565 151 123C151 143.435 167.565 160 188 160Z", "fill", "url(#paint1_radial_549_1158)"], ["id", "filter0_d_549_1158", "x", "121", "y", "56", "width", "159", "height", "159", "filterUnits", "userSpaceOnUse", "color-interpolation-filters", "sRGB"], ["flood-opacity", "0", "result", "BackgroundImageFix"], ["in", "SourceAlpha", "type", "matrix", "values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", "result", "hardAlpha"], ["stdDeviation", "15"], ["in2", "hardAlpha", "operator", "out"], ["type", "matrix", "values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"], ["mode", "normal", "in2", "BackgroundImageFix", "result", "effect1_dropShadow_549_1158"], ["mode", "normal", "in", "SourceGraphic", "in2", "effect1_dropShadow_549_1158", "result", "shape"], ["id", "paint0_linear_549_1158", "x1", "234.5", "y1", "161.5", "x2", "226.5", "y2", "169.5", "gradientUnits", "userSpaceOnUse"], ["offset", "0.520833", "stop-color", "#262D39"], ["offset", "0.520933"], ["id", "paint1_radial_549_1158", "cx", "0", "cy", "0", "r", "1", "gradientUnits", "userSpaceOnUse", "gradientTransform", "translate(188 123) rotate(90) scale(37)"], ["offset", "0.838442"], ["offset", "0.838542", "stop-color", "#262D39"], ["offset", "1", "stop-color", "#262D39"], [1, "no-results-text-container", "eca-fx-col", "eca-fx-justify-content-center", "eca-fx-align-items-center"], [4, "ngIf"], [3, "innerHTML"]],
        template: function EcaNoResultsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div");
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(3, "svg", 2);
            i0.ɵɵelement(4, "path", 3)(5, "path", 4);
            i0.ɵɵelementStart(6, "g", 5);
            i0.ɵɵelement(7, "path", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "ellipse", 7)(9, "path", 8)(10, "path", 9);
            i0.ɵɵelementStart(11, "defs")(12, "filter", 10);
            i0.ɵɵelement(13, "feFlood", 11)(14, "feColorMatrix", 12)(15, "feOffset")(16, "feGaussianBlur", 13)(17, "feComposite", 14)(18, "feColorMatrix", 15)(19, "feBlend", 16)(20, "feBlend", 17);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "linearGradient", 18);
            i0.ɵɵelement(22, "stop", 19)(23, "stop", 20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "radialGradient", 21);
            i0.ɵɵelement(25, "stop", 22)(26, "stop", 23)(27, "stop", 24);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(28, "div", 25);
            i0.ɵɵtemplate(29, EcaNoResultsComponent_h2_29_Template, 2, 1, "h2", 26)(30, EcaNoResultsComponent_h3_30_Template, 2, 1, "h3", 26)(31, EcaNoResultsComponent_h4_31_Template, 2, 1, "h4", 26)(32, EcaNoResultsComponent_h5_32_Template, 2, 1, "h5", 26)(33, EcaNoResultsComponent_h6_33_Template, 2, 1, "h6", 26);
            i0.ɵɵelement(34, "p", 27);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(29);
            i0.ɵɵproperty("ngIf", ctx.headingLevel === "h2");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headingLevel === "h3");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headingLevel === "h4");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headingLevel === "h5");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headingLevel === "h6");
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.description, i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [i1.NgIf],
        styles: ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{width:100%;height:100%}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{padding:8px}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   .no-results-text-container[_ngcontent-%COMP%]{margin-top:-24px}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}[_nghost-%COMP%] > div[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%], [_nghost-%COMP%] > div[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--drc-dark-grey);margin-bottom:8px}"]
      });
    }
  }
  return EcaNoResultsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaNoResultsModule = /*#__PURE__*/(() => {
  class EcaNoResultsModule {
    static {
      this.ɵfac = function EcaNoResultsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaNoResultsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaNoResultsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FlexLayoutModule, MatCardModule]
      });
    }
  }
  return EcaNoResultsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFormColumnComponent = /*#__PURE__*/(() => {
  class EcaFormColumnComponent {
    constructor() {
      /**
       * acceptable values are 'center' | 'start' | 'end' | 'space-around' | 'space-between' | 'space-evenly'
       * see https://github.com/angular/flex-layout/wiki/fxLayoutAlign-API
       */
      this.align = 'center';
    }
    static {
      this.ɵfac = function EcaFormColumnComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFormColumnComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaFormColumnComponent,
        selectors: [["eca-form-column"]],
        inputs: {
          align: "align"
        },
        ngContentSelectors: _c6,
        decls: 3,
        vars: 1,
        consts: [["fxLayout", "row", 3, "fxLayoutAlign"], ["fxFlex", "0 1 496px"]],
        template: function EcaFormColumnComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("fxLayoutAlign", ctx.align);
          }
        },
        dependencies: [i3.DefaultLayoutDirective, i3.DefaultLayoutAlignDirective, i3.DefaultFlexDirective],
        styles: ["[_nghost-%COMP%]     h1, [_nghost-%COMP%]     p{width:100%;text-align:center}[_nghost-%COMP%]     mat-form-field:not(.eca-shrink-width){width:100%}[_nghost-%COMP%]     mat-form-field.eca-shrink-width{max-width:min-content}[_nghost-%COMP%]     .eca-form-column-buttons-ltr{display:flex;flex-direction:row}[_nghost-%COMP%]     .eca-form-column-buttons-ltr button{flex:1 1 1px;margin-right:16px;margin-bottom:8px}[_nghost-%COMP%]     .eca-form-column-buttons-ltr button:last-of-type{margin-right:0}[_nghost-%COMP%]     .eca-form-column-buttons{display:flex;flex-direction:row-reverse}[_nghost-%COMP%]     .eca-form-column-buttons button{flex:1 1 1px;margin-right:8px;margin-bottom:8px}[_nghost-%COMP%]     .eca-form-column-buttons button:first-of-type{margin-right:0}"]
      });
    }
  }
  return EcaFormColumnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaFormColumnModule = /*#__PURE__*/(() => {
  class EcaFormColumnModule {
    static {
      this.ɵfac = function EcaFormColumnModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaFormColumnModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaFormColumnModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FlexLayoutModule]
      });
    }
  }
  return EcaFormColumnModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class BrowserDetectorService {}
let EcaBrowserDetectorComponent = /*#__PURE__*/(() => {
  class EcaBrowserDetectorComponent {
    constructor(dialog, deviceService, appContextService, windowService) {
      this.dialog = dialog;
      this.deviceService = deviceService;
      this.appContextService = appContextService;
      this.windowService = windowService;
      this.deviceInfo = {};
      this.isMobile = false;
      this.isTablet = false;
      this.isDesktop = false;
    }
    ngOnInit() {
      this.deviceInfo = this.deviceService.getDeviceInfo();
      this.isMobile = this.deviceService.isMobile();
      this.isTablet = this.deviceService.isTablet();
      this.isDesktop = this.deviceService.isDesktop();
      if (this.shouldDisplayAlert()) {
        this.openModal();
      }
    }
    get browser() {
      return this.deviceInfo.browser;
    }
    get browserVersion() {
      return this.deviceInfo.browser_version;
    }
    get isIE() {
      return this.deviceInfo.browser === 'IE';
    }
    get OS() {
      return this.deviceInfo.os;
    }
    get OSVersion() {
      return this.deviceInfo.os_version;
    }
    get userAgent() {
      return this.deviceInfo.userAgent;
    }
    /*
     * Add conditions here to determine when the alert will be shown.
    */
    shouldDisplayAlert() {
      return this.isIE;
    }
    openModal() {
      this.dialog.open(this.dialogTemplate, {
        width: '650px',
        disableClose: true
      });
    }
    navigateTo(event, url) {
      event.stopPropagation();
      this.windowService.navigateTo(`${this.appContextService.getPortalUrl()}/#/${url}`);
    }
    static {
      this.ɵfac = function EcaBrowserDetectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaBrowserDetectorComponent)(i0.ɵɵdirectiveInject(i1$3.MatDialog), i0.ɵɵdirectiveInject(BrowserDetectorService), i0.ɵɵdirectiveInject(AppContextService), i0.ɵɵdirectiveInject(WindowService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaBrowserDetectorComponent,
        selectors: [["eca-browser-detector"]],
        viewQuery: function EcaBrowserDetectorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c38, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogTemplate = _t.first);
          }
        },
        decls: 2,
        vars: 0,
        consts: [["browserWarningTemplate", ""], ["mat-icon-button", "", "mat-dialog-close", "", "aria-label", "close", 1, "close-dialog"], ["mat-dialog-title", ""], [1, "mat-dialog-title-content"], ["tabindex", "0", 1, "scroll-container"], [3, "click", "keydown"], ["mat-dialog-actions", ""], ["mat-button", "", "color", "primary", 3, "mat-dialog-close"]],
        template: function EcaBrowserDetectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, EcaBrowserDetectorComponent_ng_template_0_Template, 17, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
        },
        dependencies: [i1$3.MatDialogClose, i1$3.MatDialogTitle, i1$3.MatDialogActions, i5.MatIcon, i4.MatButton, i4.MatIconButton],
        styles: [".scroll-container[_ngcontent-%COMP%]{padding:20px 35px;font-size:16px}h4[_ngcontent-%COMP%]{font-size:20px;font-weight:600}h4[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:400}a[_ngcontent-%COMP%]:hover{cursor:pointer}@media screen and (-ms-high-contrast: none),(-ms-high-contrast: active){button.mat-mdc-button[_ngcontent-%COMP%]{margin-left:auto}}@supports (-ms-ime-align: auto){button.mat-mdc-button[_ngcontent-%COMP%]{margin-left:auto}}"]
      });
    }
  }
  return EcaBrowserDetectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaBrowserDetectorModule = /*#__PURE__*/(() => {
  class EcaBrowserDetectorModule {
    static {
      this.ɵfac = function EcaBrowserDetectorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaBrowserDetectorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaBrowserDetectorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule]
      });
    }
  }
  return EcaBrowserDetectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ecaIconNames = {
  assigning: 'assigning',
  groupOfStudents: 'group-of-students',
  handStop: 'hand-stop',
  monitoring: 'monitoring',
  reporting: 'reporting',
  single: 'single',
  testSession: 'test-session',
  warningTriangle: 'warning-triangle',
  documentation: 'documentation',
  downloadStatus: 'download-status',
  downloadStudent: 'download-student',
  orderMaterials: 'order-materials',
  widaScore: 'wida-score'
};
let EcaIconDefinitionsComponent = /*#__PURE__*/(() => {
  class EcaIconDefinitionsComponent {
    constructor() {
      this.iconNames = ecaIconNames;
    }
    static {
      this.ɵfac = function EcaIconDefinitionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaIconDefinitionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaIconDefinitionsComponent,
        selectors: [["eca-icon-definitions"]],
        decls: 104,
        vars: 13,
        consts: [[3, "id"], ["width", "48", "height", "48", "viewBox", "0 0 48 48", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M8.84204 15.3402C8.84204 14.5203 9.45899 13.8557 10.22 13.8557H21.244C22.005 13.8557 22.6219 14.5203 22.6219 15.3402V30.1856C22.6219 31.0055 22.005 31.6701 21.244 31.6701H10.22C9.45899 31.6701 8.84204 31.0055 8.84204 30.1856V15.3402Z", "fill", "white"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M11.598 16.8248V28.701H19.866V16.8248H11.598ZM10.22 13.8557C9.45899 13.8557 8.84204 14.5203 8.84204 15.3402V30.1856C8.84204 31.0055 9.45899 31.6701 10.22 31.6701H21.244C22.005 31.6701 22.6219 31.0055 22.6219 30.1856V15.3402C22.6219 14.5203 22.005 13.8557 21.244 13.8557H10.22Z", "fill", "black"], ["d", "M13.5962 19.8681H17.7302", "stroke", "black", "stroke-linecap", "square"], ["d", "M13.596 22.8371H15.663", "stroke", "black", "stroke-linecap", "square"], ["d", "M39.1407 33.1546L36.712 35.7711L39.4335 38.7216H32.2679V42.433H39.4335L36.6947 45.3835L39.1407 48L46.0479 40.5959L39.1407 33.1546Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M35.7129 19.0515C35.7129 21.1021 34.1712 22.7629 32.2679 22.7629C30.3645 22.7629 28.8229 21.1021 28.8229 19.0515C28.8229 17.001 30.3645 15.3402 32.2679 15.3402C34.1712 15.3402 35.7129 17.001 35.7129 19.0515ZM25.3779 27.299C25.3779 25.1052 29.9684 24 32.2679 24C34.5674 24 39.1578 25.1052 39.1578 27.299V28.1237C39.1578 28.5773 38.7703 28.9485 38.2966 28.9485H26.2392C25.7655 28.9485 25.3779 28.5773 25.3779 28.1237V27.299Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 11.0103V33.7732V34.5155C4.36364 35.8082 5.34545 36.866 6.54545 36.866H28.5955V41.567H4.36364C1.96364 41.567 0 39.4515 0 36.866V36.3711V8.65979V5.19587C0 2.33814 1.96364 0 4.36364 0H43.6364C46.0364 0 48 2.33814 48 5.19587V8.65979V19.9631V28.701H43.6364V19.9631V11.0103C43.6364 9.71752 42.6545 8.65979 41.4545 8.65979H6.54545C5.34545 8.65979 4.36364 9.71752 4.36364 11.0103Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 34.8511L4.36364 11.3617C4.36364 11.3617 4.36364 11.3617 4.36364 11.3617C4.36364 10.9268 4.46799 10.5177 4.65022 10.1637C5.02699 9.432 5.73667 8.93618 6.54545 8.93618L41.4545 8.93617C42.6545 8.93617 43.6364 10.0277 43.6364 11.3617V20.6002V22.7234V26.5532H48V22.7234V20.6002V8.93617V5.3617C48 2.41277 46.0364 0 43.6364 0H4.36364C1.96364 0 0 2.41277 0 5.3617V8.93617V8.93618V37.5319V38.0425C0 38.7096 0.122727 39.3463 0.344318 39.9261C1.00909 41.6657 2.56364 42.8936 4.36364 42.8936L26.2637 42.8936V38.0426L24 38.0425H6.54546C6.53608 38.0425 6.52672 38.0425 6.51737 38.0423C5.33017 38.0255 4.36364 36.9406 4.36364 35.617L4.36364 34.8511ZM41.7416 31.1489V37.4681H47.4258V41.6809H41.7416V48H37.9522V41.6809H32.2679V37.4681H37.9522V31.1489H41.7416ZM33.8043 27.5729V19.8646L24 25.3333L12 18.6667L24 12L36 18.6667V27.5729H33.8043ZM16.3915 23.3021L24 27.5729L31.6085 23.3021V27.7812L24 32L16.3915 27.7812V23.3021Z", "fill", "black"], ["d", "M6.54545 8.93618H41.4545C42.6545 8.93618 43.6364 10.0277 43.6364 11.3617V28.0851H48V8.93618C48 6.26809 46.0364 4.08511 43.6364 4.08511H4.36364C1.96364 4.08511 0 6.26809 0 8.93618V38.0426C0 40.7106 1.96364 42.8936 4.36364 42.8936H25.1353V38.0426H6.54545C5.34545 38.0426 4.36364 36.9511 4.36364 35.617V11.3617C4.36364 10.0277 5.34545 8.93618 6.54545 8.93618Z", "fill", "black"], ["d", "M6.54545 8.93618H41.4545C42.6545 8.93618 43.6364 10.0277 43.6364 11.3617V22.7234H48V8.93618C48 6.26809 46.0364 4.08511 43.6364 4.08511H4.36364C1.96364 4.08511 0 6.26809 0 8.93618V38.0426C0 40.7106 1.96364 42.8936 4.36364 42.8936H24V38.0426H6.54545C5.34545 38.0426 4.36364 36.9511 4.36364 35.617V11.3617C4.36364 10.0277 5.34545 8.93618 6.54545 8.93618Z", "fill", "black"], ["d", "M6.54545 5.3617H41.4545C42.6545 5.3617 43.6364 6.56809 43.6364 8.04255V20.6002H48V5.3617C48 2.41277 46.0364 0 43.6364 0H4.36364C1.96364 0 0 2.41277 0 5.3617V37.5319C0 40.4809 4.36364 36.3255 4.36364 34.8511V8.04255C4.36364 6.56809 5.34545 5.3617 6.54545 5.3617Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M10.842 23.0213V14.766H17.866V23.0213H10.842ZM8.84204 13.766C8.84204 13.2137 9.28976 12.766 9.84204 12.766H18.866C19.4183 12.766 19.866 13.2137 19.866 13.766V24.0213C19.866 24.5736 19.4183 25.0213 18.866 25.0213H9.84204C9.28976 25.0213 8.84204 24.5736 8.84204 24.0213V13.766ZM24.6219 23.0213V14.766H37.1578V23.0213H24.6219ZM22.6219 13.766C22.6219 13.2137 23.0697 12.766 23.6219 12.766H38.1578C38.7101 12.766 39.1578 13.2137 39.1578 13.766V24.0213C39.1578 24.5736 38.7101 25.0213 38.1578 25.0213H23.6219C23.0697 25.0213 22.6219 24.5736 22.6219 24.0213V13.766ZM8.84204 29.617H19.866V32.6809H8.84204V29.617ZM44.0627 39.609C44.1135 39.0753 44.1304 38.5417 44.0796 38.0265L45.8892 36.4623C46.0584 36.3151 46.0922 36.0759 45.9907 35.8735L44.2488 32.5796C44.1473 32.3772 43.9274 32.3036 43.7245 32.3772L41.5597 33.2973C41.1707 32.9845 40.7479 32.7269 40.2913 32.5244L39.9531 30.0219C39.9192 29.7826 39.7501 29.617 39.5303 29.617H36.0294C35.8265 29.617 35.6405 29.7826 35.6066 30.0035L35.2684 32.506C34.8287 32.7085 34.4059 32.9845 34.0169 33.2789L31.8521 32.3588C31.6492 32.2668 31.4293 32.3588 31.3278 32.5612L29.5859 35.8551C29.4844 36.0575 29.5182 36.2967 29.6874 36.4439L31.497 38.0265C31.4462 38.5601 31.4293 39.0937 31.4801 39.609L29.6705 41.1731C29.5013 41.3203 29.4675 41.5595 29.569 41.7619L31.3109 45.0558C31.4124 45.2582 31.6323 45.3318 31.8352 45.2582L33.9831 44.3381C34.372 44.6509 34.7948 44.9086 35.2515 45.111L35.5897 47.6136C35.6235 47.8344 35.7927 48 36.0125 48H39.5133C39.7163 48 39.9023 47.8344 39.9361 47.6136L40.2744 45.111C40.7141 44.9086 41.1369 44.6325 41.5259 44.3381L43.6907 45.2582C43.8936 45.3502 44.1135 45.2582 44.2149 45.0558L45.9569 41.7619C46.0584 41.5595 46.0245 41.3203 45.8554 41.1731L44.0627 39.609ZM37.7798 41.8723C36.2549 41.8723 35.0239 40.5038 35.0239 38.8085C35.0239 37.1132 36.2549 35.7447 37.7798 35.7447C39.3048 35.7447 40.5358 37.1132 40.5358 38.8085C40.5358 40.5038 39.3048 41.8723 37.7798 41.8723Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M45.2231 36.4725C45.5906 38.2711 45.2064 39.9327 44.4213 41.3031L47.5114 44.5065C48.1629 45.1745 48.1629 46.2537 47.5114 46.9218C46.86 47.5899 45.8077 47.5899 45.1563 46.9218L42.0495 43.7356C40.7132 44.5407 39.093 44.9347 37.3391 44.5578C34.5998 43.9754 32.4284 41.6115 32.0609 38.7679C31.4763 34.2627 35.1844 30.4769 39.5774 31.0594C42.3501 31.4191 44.6552 33.6631 45.2231 36.4725ZM35.3516 37.8431C35.3516 39.7274 36.8549 41.2691 38.6922 41.2691C40.5296 41.2691 42.0329 39.7274 42.0329 37.8431C42.0329 35.9588 40.5296 34.4171 38.6922 34.4171C36.8549 34.4171 35.3516 35.9588 35.3516 37.8431Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 11.1502V34.2024V34.9541C4.36364 36.2633 5.34545 37.3345 6.54545 37.3345H26.756V42.0953H4.36364C1.96364 42.0953 0 39.9529 0 37.3345V36.8334V8.76985V5.26191C0 2.36786 1.96364 0 4.36364 0H43.6364C46.0364 0 48 2.36786 48 5.26191V8.76985V20.2168V27.5624H45.1701H43.6364V20.2168V11.1502C43.6364 9.84103 42.6545 8.76985 41.4545 8.76985H6.54545C5.34545 8.76985 4.36364 9.84103 4.36364 11.1502Z", "fill", "black"], ["d", "M32.787 18.0307L34.3512 19.7114L29.0504 25.4073L25.4767 21.5673C25.0531 21.1121 24.3688 21.1121 23.9452 21.5673L17.4278 28.5821C17.0042 29.0373 17.0042 29.7726 17.4278 30.2278C17.8515 30.683 18.5358 30.683 18.9594 30.2278L24.7055 24.0417L28.2792 27.8818C28.7028 28.337 29.3871 28.337 29.8108 27.8818L35.8827 21.3688L37.4469 23.0496C37.7836 23.4114 38.3702 23.1546 38.3702 22.6411V17.6222C38.381 17.2954 38.1421 17.0386 37.8379 17.0386H33.178C32.6892 17.0386 32.4503 17.6689 32.787 18.0307V18.0307Z", "fill", "black", "stroke", "black", "stroke-width", "0.5"], ["d", "M9.53101 14.7834H23.3109", "stroke", "black", "stroke-width", "2", "stroke-linecap", "square"], ["d", "M9.53101 20.7971H16.421", "stroke", "black", "stroke-width", "2", "stroke-linecap", "square"], ["d", "M9.53102 26.8107H10.22", "stroke", "black", "stroke-width", "2", "stroke-linecap", "square"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 34.8511V11.3617C4.36364 10.0277 5.34545 8.93618 6.54545 8.93618H41.4545C42.6545 8.93618 43.6364 10.0277 43.6364 11.3617V20.6002V24.1476H48V20.6002V8.93618V5.3617C48 2.41277 46.0364 0 43.6364 0H4.36364C1.96364 0 0 2.41277 0 5.3617V8.93618V37.5319V38.0426C0 40.7107 1.96364 42.8936 4.36364 42.8936H24V38.0426V37.5319H6.54545C5.34545 37.5319 4.36364 36.3255 4.36364 34.8511ZM24 23.4894C26.284 23.4894 28.134 21.4328 28.134 18.8936C28.134 16.3545 26.284 14.2979 24 14.2979C21.716 14.2979 19.866 16.3545 19.866 18.8936C19.866 21.4328 21.716 23.4894 24 23.4894ZM24 25.0213C21.2406 25.0213 15.7321 26.3898 15.7321 29.1064V30.1277C15.7321 30.6894 16.1971 31.1489 16.7656 31.1489H31.2345C31.8029 31.1489 32.2679 30.6894 32.2679 30.1277V29.1064C32.2679 26.3898 26.7594 25.0213 24 25.0213ZM40.7081 28.0851V35.5532H47.4258V40.5319H40.7081V48H36.2297V40.5319H29.512V35.5532H36.2297V28.0851H40.7081Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 34.8511V11.3617C4.36364 10.0277 5.34545 8.9362 6.54545 8.9362H41.4545C42.6545 8.9362 43.6364 10.0277 43.6364 11.3617V20.6002V22.7234V28.0851H48V22.7234V20.6002V8.9362V5.3617C48 2.41277 46.0364 0 43.6364 0H4.36364C1.96364 0 0 2.41277 0 5.3617V8.9362V37.5319V38.0426C0 40.7107 1.96364 42.8936 4.36364 42.8936H25.1353H28.9017V38.0426H25.1353H6.54545C5.34545 38.0426 4.36364 36.9511 4.36364 35.617V34.8511ZM33.6459 15.8298H22.622V18.8936H33.6459V15.8298ZM13.5981 14.766V19.9575H17.866V14.766H13.5981ZM12.5981 12.766C12.0458 12.766 11.5981 13.2137 11.5981 13.766V20.9575C11.5981 21.5097 12.0458 21.9575 12.5981 21.9575H18.866C19.4183 21.9575 19.866 21.5097 19.866 20.9575V13.766C19.866 13.2137 19.4183 12.766 18.866 12.766H12.5981ZM33.6459 28.0851H22.622V31.1489H33.6459V28.0851ZM13.5981 27.0213V32.2128H17.866V27.0213H13.5981ZM12.5981 25.0213C12.0458 25.0213 11.5981 25.469 11.5981 26.0213V33.2128C11.5981 33.7651 12.0458 34.2128 12.5981 34.2128H18.866C19.4183 34.2128 19.866 33.7651 19.866 33.2128V26.0213C19.866 25.469 19.4183 25.0213 18.866 25.0213H12.5981ZM37.7799 48H33.6459V34.2128H46.0479V38.8085H40.6944L46.0479 44.76L43.1334 48L37.7799 42.0485V48Z", "fill", "black"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 128 110", "fill", "none", "preserveAspectRatio", "xMidYMid meet"], ["d", "M4 107.5H124L64 4L4 107.5Z", "stroke", "black", "stroke-width", "4", 1, "drc-yellow"], ["d", "M69.4546 91.1579H58.5455V80.2632H69.4546V91.1579Z", "fill", "black"], ["d", "M69.4546 69.3684H58.5455V47.5789H69.4546V69.3684Z", "fill", "black"], ["width", "28", "height", "28", "viewBox", "0 0 28 28", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M17.0149 4.07961C17.5454 4.08329 18.0526 4.29753 18.4251 4.67519L22.9046 9.21736C23.2771 9.59502 23.4843 10.1052 23.4806 10.6356L23.4364 17.0149C23.4327 17.5454 23.2185 18.0526 22.8408 18.4251L18.2986 22.9047C17.921 23.2771 17.4108 23.4843 16.8804 23.4806L10.501 23.4364C9.97062 23.4327 9.46338 23.2185 9.09092 22.8408L4.61133 18.2986C4.23887 17.921 4.03169 17.4108 4.03536 16.8804L4.07961 10.501C4.08329 9.97062 4.29753 9.46339 4.67519 9.09092L9.21735 4.61133C9.59502 4.23887 10.1052 4.03169 10.6356 4.03537L17.0149 4.07961Z", "fill", "black"], ["d", "M17.5 11.29V17.335C17.5 17.7766 17.3246 18.2001 17.0123 18.5123C16.7001 18.8246 16.2766 19 15.835 19H12.79C12.34 19 11.915 18.82 11.605 18.5L8.33499 15.18C8.33499 15.18 8.85999 14.665 8.87499 14.66C8.96499 14.58 9.07999 14.535 9.20499 14.535C9.29499 14.535 9.37999 14.56 9.45499 14.605C9.46999 14.61 11.25 15.63 11.25 15.63V10.665C11.25 10.4992 11.3158 10.3403 11.433 10.2231C11.5503 10.1058 11.7092 10.04 11.875 10.04C12.0408 10.04 12.1997 10.1058 12.3169 10.2231C12.4341 10.3403 12.5 10.4992 12.5 10.665V13.585H12.915V9.625C12.915 9.45924 12.9808 9.30027 13.098 9.18306C13.2153 9.06585 13.3742 9 13.54 9C13.89 9 14.165 9.28 14.165 9.625V13.585H14.585V10.04C14.585 9.695 14.86 9.415 15.21 9.415C15.3758 9.415 15.5347 9.48085 15.6519 9.59806C15.7691 9.71527 15.835 9.87424 15.835 10.04V13.585H16.25V11.29C16.25 11.1242 16.3158 10.9653 16.433 10.8481C16.5503 10.7308 16.7092 10.665 16.875 10.665C17.0408 10.665 17.1997 10.7308 17.3169 10.8481C17.4341 10.9653 17.5 11.1242 17.5 11.29Z", "fill", "white", 1, "drc-white"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 11.3616V34.8511V35.6169C4.36364 36.951 5.34546 38.0425 6.54545 38.0425H25.1353L28.9017 38.0425V42.8935H25.1353H4.36364C2.11364 42.8935 0.247159 40.9749 0.0226385 38.5366C0.00767045 38.3741 0 38.2092 0 38.0425V37.5319V8.9361V5.3617C0 2.41277 1.96364 0 4.36364 0H43.6364C46.0364 0 48 2.41277 48 5.3617V8.9361V20.6002V22.7233V28.085H43.6364V22.7233V20.6002V11.3616C43.6364 10.0276 42.6545 8.9361 41.4545 8.9361H6.54545C5.34546 8.9361 4.36364 10.0276 4.36364 11.3616ZM29.1094 20.8203H24.5V16.25L29.1094 20.8203ZM25.3594 15H18.6797C18.237 15 17.8464 15.1693 17.5078 15.5078C17.1953 15.8203 17.0391 16.1979 17.0391 16.6406L17 30C17 30.4427 17.1693 30.8333 17.5078 31.1719C17.8464 31.4844 18.237 31.6406 18.6797 31.6406H28.6797C29.1224 31.6406 29.513 31.4844 29.8516 31.1719C30.1901 30.8333 30.3594 30.4427 30.3594 30V20L25.3594 15Z", "fill", "black"], ["d", "M39.0638 37.5938C39.4681 37.1979 39.9468 37 40.5 37C41.0532 37 41.5319 37.1979 41.9362 37.5938C42.3404 37.9896 42.5426 38.4583 42.5426 39C42.5426 39.5417 42.3404 40.0104 41.9362 40.4063C41.5319 40.8021 41.0532 41 40.5 41C39.9468 41 39.4681 40.8021 39.0638 40.4063C38.6596 40.0104 38.4574 39.5417 38.4574 39C38.4574 38.4583 38.6596 37.9896 39.0638 37.5938ZM38.0745 41.375C38.7553 42.0208 39.5638 42.3438 40.5 42.3438C41.4362 42.3438 42.234 42.0208 42.8936 41.375C43.5745 40.7083 43.9149 39.9167 43.9149 39C43.9149 38.0833 43.5745 37.3021 42.8936 36.6563C42.234 35.9896 41.4362 35.6563 40.5 35.6563C39.5638 35.6563 38.7553 35.9896 38.0745 36.6563C37.4149 37.3021 37.0851 38.0833 37.0851 39C37.0851 39.9167 37.4149 40.7083 38.0745 41.375ZM35.9362 35.375C37.2979 34.4583 38.8191 34 40.5 34C42.1809 34 43.7021 34.4583 45.0638 35.375C46.4255 36.2917 47.4043 37.5 48 39C47.4043 40.5 46.4255 41.7083 45.0638 42.625C43.7021 43.5417 42.1809 44 40.5 44C38.8191 44 37.2979 43.5417 35.9362 42.625C34.5745 41.7083 33.5957 40.5 33 39C33.5957 37.5 34.5745 36.2917 35.9362 35.375Z", "fill", "black"], ["width", "49", "height", "48", "viewBox", "0 0 49 48", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M32.787 18.0307L34.3512 19.7114L29.0504 25.4073L25.4767 21.5672C25.0531 21.112 24.3688 21.112 23.9452 21.5672L17.4278 28.582C17.0042 29.0372 17.0042 29.7726 17.4278 30.2278C17.8515 30.683 18.5358 30.683 18.9594 30.2278L24.7055 24.0417L28.2792 27.8817C28.7028 28.3369 29.3871 28.3369 29.8108 27.8817L35.8827 21.3688L37.4469 23.0496C37.7836 23.4114 38.3702 23.1546 38.3702 22.641V17.6221C38.381 17.2953 38.1421 17.0385 37.8379 17.0385H33.178C32.6892 17.0385 32.4503 17.6688 32.787 18.0307V18.0307Z", "fill", "black", "stroke", "black", "stroke-width", "0.5"], ["d", "M45.8291 39.3935L38.4965 48L31.1638 39.3935H35.3469V32H41.6461V39.3935H45.8291Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 11.3616V34.8511C4.36364 36.3255 5.34545 37.5319 6.54545 37.5319H24V38.0425V42.8935V42.8936H4.36364C4.33773 42.8936 4.31187 42.8933 4.28607 42.8928C1.92147 42.8464 0 40.6818 0 38.0425V37.5319V8.93609V5.3617C0 2.41277 1.96364 0 4.36364 0H43.6364C46.0364 0 48 2.41277 48 5.3617V8.93609V20.6002V24.1475H43.6364V20.6002V11.3616C43.6364 10.0276 42.6545 8.93609 41.4545 8.93609H6.54545C5.34545 8.93609 4.36364 10.0276 4.36364 11.3616Z", "fill", "black"], ["d", "M47 37.3935L39 46L31 37.3935H35.5638V30H42.4362V37.3935H47Z", "fill", "black"], ["d", "M24 12L36 18.6667V27.5729H33.8043V19.8646L24 25.3333L12 18.6667L24 12ZM16.3915 23.3021L24 27.5729L31.6085 23.3021V27.7813L24 32L16.3915 27.7813V23.3021Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 11.3616V34.8511V35.6169C4.36364 36.951 5.34545 38.0425 6.54545 38.0425H25.1353H28.9017V42.8935H25.1353H4.36364C1.96364 42.8935 0 40.7106 0 38.0425V37.5319V8.9361V5.3617C0 2.41277 1.96364 0 4.36364 0H43.6364C46.0364 0 48 2.41277 48 5.3617V8.9361V20.6002V22.7233V28.085H43.6364V22.7233V20.6002V11.3616C43.6364 10.0276 42.6545 8.9361 41.4545 8.9361H6.54545C5.34545 8.9361 4.36364 10.0276 4.36364 11.3616Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M46.2147 39.8619C46.2607 40.2823 46.2453 40.7177 46.1993 41.1532L47.8255 42.4294C47.9789 42.5495 48.0096 42.7447 47.9175 42.9099L46.3374 45.5976C46.2453 45.7628 46.0459 45.8378 45.8618 45.7628L43.8981 45.012C43.5453 45.2522 43.1617 45.4775 42.7628 45.6426L42.456 47.6847C42.4253 47.8649 42.2566 48 42.0725 48H38.8968C38.6974 48 38.544 47.8649 38.5133 47.6847L38.2065 45.6426C37.7923 45.4775 37.4087 45.2673 37.0559 45.012L35.1075 45.7628C34.9234 45.8228 34.724 45.7628 34.6319 45.5976L33.0518 42.9099C32.9597 42.7447 32.9904 42.5495 33.1438 42.4294L34.7853 41.1532C34.7393 40.7327 34.7547 40.2973 34.8007 39.8619L33.1592 38.5706C33.0058 38.4504 32.9751 38.2553 33.0671 38.0901L34.6473 35.4024C34.7393 35.2372 34.9388 35.1622 35.1229 35.2372L37.0866 35.988C37.4394 35.7477 37.8229 35.5225 38.2218 35.3574L38.5286 33.3153C38.5593 33.1351 38.7281 33 38.9122 33H42.0878C42.2873 33 42.4407 33.1351 42.4714 33.3303L42.7782 35.3724C43.1924 35.5375 43.5759 35.7477 43.9288 36.003L45.8925 35.2523C46.0766 35.1922 46.276 35.2523 46.3681 35.4174L47.9482 38.1051C48.0403 38.2703 48.0096 38.4655 47.8562 38.5856L46.2147 39.8619ZM38 40.5C38 41.8833 39.1167 43 40.5 43C41.8833 43 43 41.8833 43 40.5C43 39.1167 41.8833 38 40.5 38C39.1167 38 38 39.1167 38 40.5Z", "fill", "black"], ["d", "M32.0357 18.0896L24.9643 14.2448C24.3729 13.9184 23.6271 13.9184 23.0357 14.2448L15.9643 18.0896C15.3729 18.416 15 19.0084 15 19.6613V27.3387C15 27.9916 15.3729 28.584 15.9643 28.9104L23.0357 32.7552C23.6271 33.0816 24.3729 33.0816 24.9643 32.7552L32.0357 28.9104C32.6271 28.584 33 27.9916 33 27.3387V19.6613C33 19.0084 32.6271 18.416 32.0357 18.0896ZM17.5714 26.9881V21.4023L22.7143 24.2073V29.7809L17.5714 26.9881ZM24 22.1157L18.8571 19.3107L24 16.5178L29.1429 19.3107L24 22.1157ZM25.2857 29.7809V24.2073L30.4286 21.4023V26.9881L25.2857 29.7809Z", "fill", "black"], ["width", "50", "height", "48", "viewBox", "0 0 50 48", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.36364 11.3616V34.8511V35.6169C4.36364 36.951 5.34545 38.0425 6.54545 38.0425H25.1353H28.9017V42.8935H25.1353H4.36364C1.96364 42.8935 0 40.7106 0 38.0425V37.5319V8.9361V5.3617C0 2.41277 1.96364 0 4.36364 0H43.6364C46.0364 0 48 2.41277 48 5.3617V8.9361V20.6002V22.7233V28.085H43.6364V22.7233V20.6002V11.3616C43.6364 10.0276 42.6545 8.9361 41.4545 8.9361H6.54545C5.34545 8.9361 4.36364 10.0276 4.36364 11.3616ZM22.6221 15.8299H33.6461V18.8937H22.6221V15.8299ZM33.6461 28.0852H22.6221V31.149H33.6461V28.0852Z", "fill", "black"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M34.172 40.3516L37.6486 43.8281L37.6486 43.8281L34.172 40.3516L34.172 40.3516ZM46.4767 35L47.6486 36.1719L47.6486 36.1719L46.4767 35L46.4767 35ZM46.4767 33.5858L37.6486 42.4139L34.172 38.9373L31.5859 41.5234L37.6486 47.5861L49.0628 36.1719L46.4767 33.5858Z", "fill", "black"], ["cx", "15.5", "cy", "17.5", "r", "4.5", "fill", "black"], ["cx", "15.5", "cy", "29.5", "r", "3.5", "stroke", "black", "stroke-width", "2"]],
        template: function EcaIconDefinitionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg")(1, "defs")(2, "g", 0);
            i0.ɵɵtext(3, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(4, "svg", 1)(5, "title");
            i0.ɵɵtext(6, "Assigning");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "path", 2)(8, "path", 3)(9, "path", 4)(10, "path", 5)(11, "path", 6)(12, "path", 7)(13, "path", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "g", 0);
            i0.ɵɵtext(15, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(16, "svg", 1)(17, "title");
            i0.ɵɵtext(18, "Group of Students");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(19, "path", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "g", 0);
            i0.ɵɵtext(21, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(22, "svg", 1)(23, "title");
            i0.ɵɵtext(24, "Monitoring");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(25, "path", 10)(26, "path", 11)(27, "path", 12)(28, "path", 13);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(29, "g", 0);
            i0.ɵɵtext(30, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(31, "svg", 1)(32, "title");
            i0.ɵɵtext(33, "Reporting");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(34, "path", 14)(35, "path", 15)(36, "path", 16)(37, "path", 17)(38, "path", 18)(39, "path", 19);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(40, "g", 0);
            i0.ɵɵtext(41, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(42, "svg", 1)(43, "title");
            i0.ɵɵtext(44, "Single");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(45, "path", 20);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(46, "g", 0);
            i0.ɵɵtext(47, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(48, "svg", 1)(49, "title");
            i0.ɵɵtext(50, "Test Session");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(51, "path", 21);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(52, "g", 0);
            i0.ɵɵtext(53, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(54, "svg", 22)(55, "title");
            i0.ɵɵtext(56, "Warning");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(57, "path", 23)(58, "path", 24)(59, "path", 25);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(60, "g", 0);
            i0.ɵɵtext(61, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(62, "svg", 26);
            i0.ɵɵelement(63, "path", 27)(64, "path", 28);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(65, "g", 0)(66, "svg", 1);
            i0.ɵɵelement(67, "path", 29)(68, "path", 30);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(69, "g", 0);
            i0.ɵɵtext(70, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(71, "svg", 31)(72, "title");
            i0.ɵɵtext(73, "Download Status");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(74, "path", 15)(75, "path", 32)(76, "path", 17)(77, "path", 18)(78, "path", 19)(79, "path", 33);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(80, "g", 0);
            i0.ɵɵtext(81, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(82, "svg", 1)(83, "title");
            i0.ɵɵtext(84, "Download Student");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(85, "path", 34)(86, "path", 35)(87, "path", 36);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(88, "g", 0)(89, "svg", 1)(90, "title");
            i0.ɵɵtext(91, "Order Materials");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(92, "path", 37)(93, "path", 38)(94, "path", 39);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(95, "g", 0);
            i0.ɵɵtext(96, " <?xml version=\"1.0\" encoding=\"UTF-8\"?> ");
            i0.ɵɵelementStart(97, "svg", 40)(98, "title");
            i0.ɵɵtext(99, "WIDA Score");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(100, "path", 41)(101, "path", 42)(102, "circle", 43)(103, "circle", 44);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.assigning);
            i0.ɵɵadvance(12);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.groupOfStudents);
            i0.ɵɵadvance(6);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.monitoring);
            i0.ɵɵadvance(9);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.reporting);
            i0.ɵɵadvance(11);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.single);
            i0.ɵɵadvance(6);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.testSession);
            i0.ɵɵadvance(6);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.warningTriangle);
            i0.ɵɵadvance(8);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.handStop);
            i0.ɵɵadvance(5);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.documentation);
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.downloadStatus);
            i0.ɵɵadvance(11);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.downloadStudent);
            i0.ɵɵadvance(8);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.orderMaterials);
            i0.ɵɵadvance(7);
            i0.ɵɵpropertyInterpolate("id", ctx.iconNames.widaScore);
          }
        },
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}[_nghost-%COMP%]{display:none}svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]   polygon[_ngcontent-%COMP%]{fill:var(--drc-blue)}svg[_ngcontent-%COMP%]   path.drc-yellow[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]   polygon.drc-yellow[_ngcontent-%COMP%]{fill:var(--drc-yellow)}svg[_ngcontent-%COMP%]   path.drc-white[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]   polygon.drc-white[_ngcontent-%COMP%]{fill:var(--drc-white)}"]
      });
    }
  }
  return EcaIconDefinitionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaDialogComponent = /*#__PURE__*/(() => {
  class EcaDialogComponent {
    constructor(data, dialogRef) {
      this.data = data;
      this.dialogRef = dialogRef;
      this.ecaDialogClose = true;
      this.ecaDialogNegativeButtonDisabled = false;
      this.ecaDialogPositiveButtonDisabled = false;
      disableClose(dialogRef);
    }
    ok() {
      this.dialogRef.close(this.ecaDialogClose);
    }
    static {
      this.ɵfac = function EcaDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$3.MatDialogRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaDialogComponent,
        selectors: [["eca-dialog"]],
        inputs: {
          ecaDialogClose: "ecaDialogClose",
          ecaDialogNegativeButtonDisabled: "ecaDialogNegativeButtonDisabled",
          ecaDialogPositiveButtonDisabled: "ecaDialogPositiveButtonDisabled"
        },
        ngContentSelectors: _c6,
        decls: 8,
        vars: 3,
        consts: [["mat-icon-button", "", "mat-dialog-close", "", "class", "close-dialog", "aria-label", "close", 4, "ngIf"], ["mat-dialog-title", ""], [1, "mat-dialog-title-content"], ["tabindex", "0", 1, "scroll-container"], ["mat-dialog-actions", "", 4, "ngIf"], ["mat-icon-button", "", "mat-dialog-close", "", "aria-label", "close", 1, "close-dialog"], ["mat-dialog-actions", ""], ["mat-button", "", "mat-dialog-close", "", 3, "disabled", 4, "ngIf"], ["mat-button", "", "color", "primary", 3, "disabled", "click", 4, "ngIf"], ["mat-button", "", "mat-dialog-close", "", 3, "disabled"], ["mat-button", "", "color", "primary", 3, "click", "disabled"]],
        template: function EcaDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelement(0, "eca-icon-definitions");
            i0.ɵɵtemplate(1, EcaDialogComponent_button_1_Template, 3, 0, "button", 0);
            i0.ɵɵelementStart(2, "h2", 1);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2)(5, "div", 3);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, EcaDialogComponent_div_7_Template, 3, 2, "div", 4);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !(ctx.data == null ? null : ctx.data.buttons == null ? null : ctx.data.buttons.negative == null ? null : ctx.data.buttons.negative.label));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.data == null ? null : ctx.data.title, "\n");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.buttons == null ? null : ctx.data.buttons.negative == null ? null : ctx.data.buttons.negative.label) || (ctx.data == null ? null : ctx.data.buttons == null ? null : ctx.data.buttons.positive == null ? null : ctx.data.buttons.positive.label));
          }
        },
        dependencies: [i1.NgIf, i1$3.MatDialogClose, i1$3.MatDialogTitle, i1$3.MatDialogActions, i5.MatIcon, i4.MatButton, i4.MatIconButton, EcaIconDefinitionsComponent],
        changeDetection: 0
      });
    }
  }
  return EcaDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaIconComponent = /*#__PURE__*/(() => {
  class EcaIconComponent {
    constructor() {}
    static {
      this.ɵfac = function EcaIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaIconComponent,
        selectors: [["eca-icon"]],
        inputs: {
          name: "name"
        },
        decls: 2,
        vars: 1,
        consts: [["version", "1.1", "xmlns", "http://www.w3.org/2000/svg"]],
        template: function EcaIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "use");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵattribute("href", "#" + ctx.name, null, "xlink");
          }
        },
        styles: ["[_nghost-%COMP%]{display:inline-block}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{display:inline-block;all:inherit}"]
      });
    }
  }
  return EcaIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaGenericMessageDialogComponent = /*#__PURE__*/(() => {
  class EcaGenericMessageDialogComponent {
    constructor(data, dialogRef, domSanitizer) {
      this.data = data;
      this.dialogRef = dialogRef;
      this.domSanitizer = domSanitizer;
      disableClose(dialogRef);
    }
    static {
      this.ɵfac = function EcaGenericMessageDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaGenericMessageDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$3.MatDialogRef), i0.ɵɵdirectiveInject(i2$6.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaGenericMessageDialogComponent,
        selectors: [["eca-generic-message-dialog"]],
        decls: 4,
        vars: 3,
        consts: [["class", "icon", 4, "ngIf"], [3, "innerHtml", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "icon"], [3, "name"], [3, "innerHtml"]],
        template: function EcaGenericMessageDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "eca-dialog");
            i0.ɵɵtemplate(1, EcaGenericMessageDialogComponent_div_1_Template, 2, 1, "div", 0)(2, EcaGenericMessageDialogComponent_div_2_Template, 1, 1, "div", 1)(3, EcaGenericMessageDialogComponent_div_3_Template, 2, 1, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.message);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.data.messages);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, EcaDialogComponent, EcaIconComponent],
        styles: [".icon[_ngcontent-%COMP%]{text-align:center}eca-icon[_ngcontent-%COMP%]{width:120px}"],
        changeDetection: 0
      });
    }
  }
  return EcaGenericMessageDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaIconModule = /*#__PURE__*/(() => {
  class EcaIconModule {
    static {
      this.ɵfac = function EcaIconModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaIconModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaIconModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return EcaIconModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaDialogModule = /*#__PURE__*/(() => {
  class EcaDialogModule {
    static {
      this.ɵfac = function EcaDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, EcaIconModule]
      });
    }
  }
  return EcaDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaGenericMessageDialogModule = /*#__PURE__*/(() => {
  class EcaGenericMessageDialogModule {
    static {
      this.ɵfac = function EcaGenericMessageDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaGenericMessageDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaGenericMessageDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, EcaDialogModule, EcaIconModule]
      });
    }
  }
  return EcaGenericMessageDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Taken from https://github.dev/angular/components/tree/main/src/material/form-field/directives/floating-label.ts
 */
/**
 * Internal directive that maintains a MDC floating label. This directive does not
 * use the `MDCFloatingLabelFoundation` class, as it is not worth the size cost of
 * including it just to measure the label width and toggle some classes.
 *
 * The use of a directive allows us to conditionally render a floating label in the
 * template without having to manually manage instantiation and destruction of the
 * floating label component based on.
 *
 * The component is responsible for setting up the floating label styles, measuring label
 * width for the outline notch, and providing inputs that can be used to toggle the
 * label's floating or required state.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
let EcaCheckboxGroupLabel = /*#__PURE__*/(() => {
  class EcaCheckboxGroupLabel {
    constructor(_elementRef) {
      this._elementRef = _elementRef;
    }
    /** Gets the HTML element for the floating label. */
    get element() {
      return this._elementRef.nativeElement;
    }
    static {
      this.ɵfac = function EcaCheckboxGroupLabel_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaCheckboxGroupLabel)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EcaCheckboxGroupLabel,
        selectors: [["label", "ecaCheckboxGroupLabel", ""]],
        hostAttrs: [1, "eca-label"]
      });
    }
  }
  return EcaCheckboxGroupLabel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let nextUniqueId$1 = 0;
const ECA_CHECKBOX_GROUP = new InjectionToken('ECA_CHECKBOX_GROUP');
function getMatFormFieldDuplicatedHintError(align) {
  return Error(`A hint was already declared for 'align="${align}"'.`);
}
/**
 * When grouping checkboxes in the same group use `eca-checkbox-group` in your component with `mat-label`
 *
 * `[required]` (optional) - adding `required` to your template will add the "required" `*` to the label
 *
 * `[touched]` (optional) - adding `touched` to your template will set the value of `touched` to `eca-checkbox-group`
 *
 * `(touchedChanged)` (optional) - adding `touchedChanged` will output `touched` changes from `eca-checkbox-group`
 *
 * ex. template
 *
 * ```
 * <form [formGroup]="formGroupExample">
 *   <eca-checkbox-group [required]="true" [touched]="groupTouched" (touchedChanged)="groupTouched = $event">
 *     <mat-label>Subjects</mat-label>
 *     <div><mat-checkbox formControlName="math">Math</mat-checkbox></div>
 *     <div><mat-checkbox formControlName="reading">Reading</mat-checkbox></div>
 *     <div><mat-checkbox formControlName="writing">Writing</mat-checkbox></div>
 *     <mat-error *ngIf="groupTouched && formGroupExample.touched && formGroupExample.errors">
 *       Please select at least one subject.
 *     </mat-error>
 *     <mat-hint>Select a subject.</mat-hint>
 *   </eca-checkbox-group>
 * </form>
 * ```
 */
let EcaCheckboxGroupComponent = /*#__PURE__*/(() => {
  class EcaCheckboxGroupComponent {
    /**
     * Set a timer for the checkbox group.
     * This is to keep the validation in check while the form is still in focus.
     *
     * Used because focusout bubbles and is not cancelable and blur is not triggered when an inner element stops propagation.
     */
    _setTouchedTimer() {
      if (!this.touched) {
        this._groupTouchedTime = setTimeout(() => {
          this.touched = true;
          this.touchedChanged.emit(this.touched);
        }, 0);
      }
    }
    get _role() {
      return 'group';
    }
    /**
     * True if the checkbox group is marked as `touched`.
     *
     * A checkbox group is marked `touched` once the user has triggered a blur event on it.
     */
    get touched() {
      return this._touched;
    }
    set touched(value) {
      this._touched = coerceBooleanProperty(value);
    }
    /**
     * When true the label will show the required `*`
     */
    get required() {
      return this._required;
    }
    set required(value) {
      this._required = coerceBooleanProperty(value);
    }
    /**
     * Text for the checkbox group hint.
     */
    get hintLabel() {
      return this._hintLabel;
    }
    set hintLabel(value) {
      this._hintLabel = value;
      this._processHints();
    }
    constructor(_elementRef, _changeDetectorRef) {
      this._elementRef = _elementRef;
      this._changeDetectorRef = _changeDetectorRef;
      /**
       * Event emitted when the checkbox group has been touched.
       */
      this.touchedChanged = new EventEmitter();
      this._touched = false;
      this._required = false;
      this._hintLabel = '';
      /**
       * @internal
       */
      this._hintLabelId = `eca-hint-checkboxgroup-${nextUniqueId$1}`;
      /**
       * @internal
       */
      this._labelId = `eca-checkboxgroup-label-${nextUniqueId$1}`;
      /**
       * @internal
       */
      this._id = `eca-checkboxgroup-id-${nextUniqueId$1}`;
      this._destroyed = new Subject();
      ++nextUniqueId$1;
    }
    /**
     * Determines whether to display hints or errors.
     *
     * @internal
     */
    _getDisplayedMessages() {
      return this._errorChildren && this._errorChildren.length > 0 ? 'error' : 'hint';
    }
    /** Does any extra processing that is required when handling the hints. */
    _processHints() {
      this._validateHints();
      this._syncDescribedByIds();
    }
    /**
     * Ensure that there is a maximum of one of each "mat-hint" alignment specified. The hint
     * label specified set through the input is being considered as "start" aligned.
     *
     * This method is a noop if Angular runs in production mode.
     */
    _validateHints() {
      if (this._hintChildren) {
        let startHint;
        let endHint;
        this._hintChildren.forEach(hint => {
          if (hint.align === 'start') {
            if (startHint || this.hintLabel) {
              throw getMatFormFieldDuplicatedHintError('start');
            }
            startHint = hint;
          } else if (hint.align === 'end') {
            if (endHint) {
              throw getMatFormFieldDuplicatedHintError('end');
            }
            endHint = hint;
          }
        });
      }
    }
    /**
     * Sets the list of element IDs that describe the child control. This allows the control to update
     * its `aria-describedby` attribute accordingly.
     */
    _syncDescribedByIds() {
      const ids = [];
      if (this._getDisplayedMessages() === 'hint') {
        const startHint = this._hintChildren ? this._hintChildren.find(hint => {
          return hint.align === 'start';
        }) : null;
        const endHint = this._hintChildren ? this._hintChildren.find(hint => {
          return hint.align === 'end';
        }) : null;
        if (startHint) {
          ids.push(startHint.id);
        } else if (this._hintLabel) {
          ids.push(this._hintLabelId);
        }
        if (endHint) {
          ids.push(endHint.id);
        }
      } else if (this._errorChildren) {
        ids.push(...this._errorChildren.map(error => error.id));
      }
      this._setDescribedByIds(ids);
    }
    _setDescribedByIds(ids) {
      const controlElement = this._elementRef.nativeElement;
      const label = ids.join(' ') || null;
      if (label) {
        controlElement.setAttribute('aria-describedby', label);
      } else {
        controlElement.removeAttribute('aria-describedby');
      }
    }
    _setLabelledById(id) {
      const controlElement = this._elementRef.nativeElement;
      const label = id || null;
      if (label) {
        controlElement.setAttribute('aria-labelledby', label);
      } else {
        controlElement.removeAttribute('aria-labelledby');
      }
    }
    /** Initializes the registered form field control. */
    _initializeControl() {
      this._elementRef.nativeElement.id = this._id;
      // Subscribe to changes in the child control state in order to update the form field UI.
      this._matCheckbox.changes.pipe(takeUntil(this._destroyed)).subscribe(checkboxList => {
        checkboxList.forEach(checkbox => {
          this._setCheckboxListener(checkbox);
        });
        this._syncDescribedByIds();
        this._changeDetectorRef.markForCheck();
      });
      this._setLabelledById(this._label?.element.id);
    }
    _setCheckboxListener(checkbox) {
      // This prevents a listener to be added to an existing checkbox that already has a listener
      if (!checkbox['group-focusin-listener']) {
        checkbox['group-focusin-listener'] = this._clearTouchedTimer;
        checkbox._elementRef.nativeElement.addEventListener('focusin', this._clearTouchedTimer.bind(this));
      }
    }
    _initializeCheckboxListeners() {
      this._matCheckbox.forEach(checkbox => {
        this._setCheckboxListener(checkbox);
      });
    }
    _clearTouchedTimer() {
      if (this._groupTouchedTime) {
        clearTimeout(this._groupTouchedTime);
      }
    }
    /**
     * Initializes the subscript by validating hints and synchronizing "aria-describedby" ids
     * with the custom form field control. Also subscribes to hint and error changes in order
     * to be able to validate and synchronize ids on change.
     */
    _initializeSubscript() {
      // Re-validate when the number of hints changes.
      this._hintChildren.changes.pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._processHints();
        this._changeDetectorRef.markForCheck();
      });
      // Update the aria-described by when the number of errors changes.
      this._errorChildren.changes.pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._syncDescribedByIds();
        this._changeDetectorRef.markForCheck();
      });
      // Initial mat-hint validation and subscript describedByIds sync.
      this._validateHints();
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
      this._initializeControl();
      this._initializeSubscript();
      this._initializeCheckboxListeners();
      this._syncDescribedByIds();
    }
    /**
     * @internal
     */
    ngOnDestroy() {
      this._destroyed.next(true);
      this._destroyed.complete();
    }
    static {
      this.ɵfac = function EcaCheckboxGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaCheckboxGroupComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaCheckboxGroupComponent,
        selectors: [["eca-checkbox-group"]],
        contentQueries: function EcaCheckboxGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatLabel, 5);
            i0.ɵɵcontentQuery(dirIndex, MatLabel, 7);
            i0.ɵɵcontentQuery(dirIndex, MatCheckbox, 5);
            i0.ɵɵcontentQuery(dirIndex, MAT_ERROR, 5);
            i0.ɵɵcontentQuery(dirIndex, MatHint, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._labelChildNonStatic = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._labelChildStatic = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._matCheckbox = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._errorChildren = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._hintChildren = _t);
          }
        },
        viewQuery: function EcaCheckboxGroupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(EcaCheckboxGroupLabel, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._label = _t.first);
          }
        },
        hostVars: 1,
        hostBindings: function EcaCheckboxGroupComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focusout", function EcaCheckboxGroupComponent_focusout_HostBindingHandler() {
              return ctx._setTouchedTimer();
            });
          }
          if (rf & 2) {
            i0.ɵɵhostProperty("role", ctx._role);
          }
        },
        inputs: {
          touched: "touched",
          required: "required",
          hintLabel: "hintLabel"
        },
        outputs: {
          touchedChanged: "touchedChanged"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: ECA_CHECKBOX_GROUP,
          useExisting: EcaCheckboxGroupComponent
        }])],
        ngContentSelectors: _c40,
        decls: 9,
        vars: 4,
        consts: [["labelTemplate", ""], [1, "eca-checkbox-wrapper", "eca-checkbox-group"], [1, "eca-checkbox-infix"], [3, "ngTemplateOutlet"], [1, "eca-checkbox-subscript-wrapper", 3, "ngSwitch"], ["class", "eca-checkbox-error-wrapper", 4, "ngSwitchCase"], ["class", "eca-checkbox-hint-wrapper", 4, "ngSwitchCase"], ["ecaCheckboxGroupLabel", "", 3, "id", 4, "ngIf"], ["ecaCheckboxGroupLabel", "", 3, "id"], ["aria-hidden", "true", "class", "eca-required-marker", 4, "ngIf"], ["aria-hidden", "true", 1, "eca-required-marker"], [1, "eca-checkbox-error-wrapper"], [1, "eca-checkbox-hint-wrapper"], [3, "id", 4, "ngIf"], [1, "eca-checkbox-hint-spacer"], [3, "id"]],
        template: function EcaCheckboxGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c39);
            i0.ɵɵtemplate(0, EcaCheckboxGroupComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2);
            i0.ɵɵtemplate(4, EcaCheckboxGroupComponent_ng_template_4_Template, 0, 0, "ng-template", 3);
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵtemplate(7, EcaCheckboxGroupComponent_div_7_Template, 2, 0, "div", 5)(8, EcaCheckboxGroupComponent_div_8_Template, 5, 1, "div", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const labelTemplate_r2 = i0.ɵɵreference(1);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngTemplateOutlet", labelTemplate_r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitch", ctx._getDisplayedMessages());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "error");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "hint");
          }
        },
        dependencies: [i1.NgIf, i1.NgTemplateOutlet, i1.NgSwitch, i1.NgSwitchCase, i6.MatHint, EcaCheckboxGroupLabel],
        styles: [":root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}.eca-checkbox-wrapper{padding-bottom:32px;position:relative}.eca-checkbox-subscript-wrapper{position:absolute;top:calc(100% - 26px)}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return EcaCheckboxGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaCheckboxGroupModule = /*#__PURE__*/(() => {
  class EcaCheckboxGroupModule {
    static {
      this.ɵfac = function EcaCheckboxGroupModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaCheckboxGroupModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaCheckboxGroupModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatCheckboxModule]
      });
    }
  }
  return EcaCheckboxGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let nextUniqueId = 0;
let EcaProgressBarComponent = /*#__PURE__*/(() => {
  class EcaProgressBarComponent {
    constructor() {
      this.label = 'Progress';
      this.mode = 'determinate';
      this.labelId = `eca-progress-bar-label-${nextUniqueId}`;
      ++nextUniqueId;
    }
    static {
      this.ɵfac = function EcaProgressBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaProgressBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaProgressBarComponent,
        selectors: [["eca-progress-bar"]],
        inputs: {
          label: "label",
          mode: "mode",
          percent: "percent"
        },
        decls: 6,
        vars: 5,
        consts: [[1, "eca-fx-row", "eca-fx-gap-2", "eca-fx-align-items-center"], [1, "eca-fx-grow", "eca-form-field-label", 3, "id"], ["mode", "determinate", 3, "value"], [1, "eca-form-field-label", "eca-progress-bar-percent"]],
        template: function EcaProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "mat-label", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "mat-progress-bar", 2);
            i0.ɵɵelementStart(4, "mat-label", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.labelId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("value", ctx.percent);
            i0.ɵɵattribute("aria-labelledby", ctx.labelId);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", ctx.percent, "%");
          }
        },
        dependencies: [i6.MatLabel, i2$7.MatProgressBar],
        styles: ["mat-label[_ngcontent-%COMP%]{margin-top:0}.eca-progress-bar-percent[_ngcontent-%COMP%]{flex:0 0 40px}"]
      });
    }
  }
  return EcaProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaProgressBarModule = /*#__PURE__*/(() => {
  class EcaProgressBarModule {
    static {
      this.ɵfac = function EcaProgressBarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaProgressBarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaProgressBarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatFormFieldModule, MatProgressBarModule]
      });
    }
  }
  return EcaProgressBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ECA_LOCALE = 'en-US';
const getDateOptions = ({
  day,
  month,
  year
}) => ({
  day,
  month,
  year
});
/*const getTimeOptions: (options: Intl.DateTimeFormatOptions) => Intl.DateTimeFormatOptions = ({
  hour,
  hour12,
  minute,
  second,
  timeZone,
  timeZoneName,
}) => ({
  hour,
  hour12,
  minute,
  second,
  timeZone,
  timeZoneName,
});*/
const displayFormatOptions = {
  day: '2-digit',
  hour: '2-digit',
  hour12: false,
  minute: '2-digit',
  month: '2-digit',
  second: '2-digit',
  timeZoneName: 'short',
  year: 'numeric'
};
const displayFormatters = {
  date: date => date.replace(/\//g, '-'),
  time: time => time
};
const isDateLike = item => item !== undefined && (item instanceof Date || ['string', 'number'].includes(typeof item));
const isWindowLike = item => item !== undefined && typeof item === 'object' && 'startDate' in item && isDateLike(item['startDate']) && 'endDate' in item && isDateLike(item['endDate']);
class DateService {
  static get options() {
    return DateService._options;
  }
  static set options(value) {
    DateService._dateOptions = getDateOptions(value);
    DateService._options = value;
  }
  static {
    DateService.options = displayFormatOptions;
    DateService.customize = displayFormatters;
  }
  static dateFactory(date = null) {
    let nativeDate;
    if (date instanceof Date) {
      nativeDate = date;
    } else {
      nativeDate = new Date(date);
    }
    return nativeDate;
  }
  static get systemTimeZoneCode() {
    const dateWithCode = new Intl.DateTimeFormat(ECA_LOCALE, {
      timeZoneName: 'short'
    }).formatToParts();
    const code = dateWithCode.find(part => part.type === 'timeZoneName').value;
    return code;
  }
  static get today() {
    const date = new Date().toLocaleDateString(ECA_LOCALE, DateService._dateOptions);
    const customDate = DateService.customize.date(date);
    return customDate;
  }
  static formatDate(date = null, options) {
    const nativeDate = DateService.dateFactory(date);
    const customDate = DateService.customize.date(nativeDate.toLocaleDateString(ECA_LOCALE, {
      ...DateService._dateOptions,
      ...options
    }));
    return customDate;
  }
  static formatDateRange(window, options) {
    let startDate;
    let endDate;
    if (isWindowLike(window)) {
      startDate = window.startDate;
      endDate = window.endDate;
    } else {
      throw new TypeError('formatRange input(s) not parseable as a date');
    }
    const customStartDate = DateService.formatDate(startDate, options);
    const customEndDate = DateService.formatDate(endDate, options);
    return `${customStartDate} - ${customEndDate}`;
  }
}
const ECA_DATEPICKER_FORMAT = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'MM-DD-YYYY',
    monthLabel: 'MMM',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
class EcaDateAdapter extends NativeDateAdapter {
  constructor(matDateLocale) {
    super(matDateLocale);
  }
  /**
   * Currently we only care about the displayed format of the eca-datepicker component.
   * If we need to care about other labels, add here.
   */
  format(date, format) {
    if (format === ECA_DATEPICKER_FORMAT.display.dateInput) {
      return DateService.formatDate(date);
    } else {
      return super.format(date, format);
    }
  }
  /**
   * This is needed because the NativeDateAdapter will parse a value in format 'YYYY-MM-DD'
   * like '2020-03-16' as midnight UTC and then adjust the time using the local timezone
   * which results in a displayed date value of '2020-03-15'
   *
   * ToDo: consider switching to MomentDateAdapter if more robust parsing logic is needed
   */
  parse(value) {
    if (typeof value === 'string' && value.indexOf('-') > -1) {
      const str = value.split('-');
      const year = Number(str[0]);
      const month = Number(str[1]) - 1;
      const date = Number(str[2]);
      // assumes a 4-digit value is intended to be the year
      if (year >= 1000) {
        return new Date(year, month, date);
      } else {
        return super.parse(value);
      }
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }
}
let EcaDatePipe = /*#__PURE__*/(() => {
  class EcaDatePipe {
    transform(value, options) {
      return DateService.formatDate(value, options);
    }
    static {
      this.ɵfac = function EcaDatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "ecaDate",
        type: EcaDatePipe,
        pure: true
      });
    }
  }
  return EcaDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaDateRangePipe = /*#__PURE__*/(() => {
  class EcaDateRangePipe {
    transform(window, options) {
      return DateService.formatDateRange(window, options);
    }
    static {
      this.ɵfac = function EcaDateRangePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDateRangePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "ecaDateRange",
        type: EcaDateRangePipe,
        pure: true
      });
    }
  }
  return EcaDateRangePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaDatepickerCalendarHeaderComponent = /*#__PURE__*/(() => {
  class EcaDatepickerCalendarHeaderComponent extends MatCalendarHeader {
    constructor(_intl, calendar, _dateAdapter, _dateFormats, changeDetectorRef) {
      super(_intl, calendar, _dateAdapter, _dateFormats, changeDetectorRef);
      // _dateAdapter is private in MatCalendarHeader so make a variable in EcaDatepickerCalendarHeaderComponent
      this.dateAdapter = _dateAdapter;
    }
    get periodButtonText() {
      if (this.calendar.currentView === 'month') {
        const dateFormat = {
          year: 'numeric',
          month: 'long'
        };
        return this.dateAdapter.format(this.calendar.activeDate, dateFormat);
      }
      // https://github.com/microsoft/TypeScript/issues/338
      // super.periodButtonText is a getter and is added to the prototype chain so this is valid.
      return super.periodButtonText;
    }
    static {
      this.ɵfac = function EcaDatepickerCalendarHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDatepickerCalendarHeaderComponent)(i0.ɵɵdirectiveInject(i6$4.MatDatepickerIntl), i0.ɵɵdirectiveInject(forwardRef(() => MatCalendar)), i0.ɵɵdirectiveInject(i2$3.DateAdapter, 8), i0.ɵɵdirectiveInject(MAT_DATE_FORMATS, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaDatepickerCalendarHeaderComponent,
        selectors: [["eca-datepicker-calendar-header"]],
        exportAs: ["ecaDatepickerCalendarHeader"],
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c6,
        decls: 15,
        vars: 10,
        consts: [["expandMore", ""], [1, "mat-calendar-header"], [1, "mat-calendar-controls"], ["mat-button", "", "type", "button", 1, "eca-icon-only", "add-border", 3, "click", "disabled"], ["mat-button", "", "type", "button", "cdkAriaLive", "polite", 3, "click"], [4, "ngIf", "ngIfElse"], [1, "left-spacing"]],
        template: function EcaDatepickerCalendarHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵprojection(2);
            i0.ɵɵelementStart(3, "button", 3);
            i0.ɵɵlistener("click", function EcaDatepickerCalendarHeaderComponent_Template_button_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.previousClicked());
            });
            i0.ɵɵelementStart(4, "mat-icon");
            i0.ɵɵtext(5, "chevron_left");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵlistener("click", function EcaDatepickerCalendarHeaderComponent_Template_button_click_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.currentPeriodClicked());
            });
            i0.ɵɵelementStart(7, "span");
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, EcaDatepickerCalendarHeaderComponent_ng_container_9_Template, 3, 0, "ng-container", 5)(10, EcaDatepickerCalendarHeaderComponent_ng_template_10_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "button", 3);
            i0.ɵɵlistener("click", function EcaDatepickerCalendarHeaderComponent_Template_button_click_12_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.nextClicked());
            });
            i0.ɵɵelementStart(13, "mat-icon");
            i0.ɵɵtext(14, "chevron_right");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            const expandMore_r2 = i0.ɵɵreference(11);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.previousEnabled());
            i0.ɵɵattribute("aria-label", ctx.prevButtonLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("aria-label", ctx.periodButtonLabel)("aria-describedby", ctx._periodButtonLabelId);
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", ctx._periodButtonLabelId);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.periodButtonText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.calendar.currentView !== "month")("ngIfElse", expandMore_r2);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.nextEnabled());
            i0.ɵɵattribute("aria-label", ctx.nextButtonLabel);
          }
        },
        dependencies: [i1.NgIf, i4.MatButton, i5.MatIcon],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return EcaDatepickerCalendarHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaDatepickerModule = /*#__PURE__*/(() => {
  class EcaDatepickerModule {
    static {
      this.ɵfac = function EcaDatepickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaDatepickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaDatepickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: MAT_DATE_FORMATS,
          useValue: ECA_DATEPICKER_FORMAT
        }, {
          provide: DateAdapter,
          useClass: EcaDateAdapter,
          deps: [MAT_DATE_LOCALE]
        }],
        imports: [CommonModule, MatButtonModule, MatDatepickerModule, MatIconModule]
      });
    }
  }
  return EcaDatepickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const navigationKeyCodes = [KeyCode.Tab, KeyCode.Left, KeyCode.ArrowLeft, KeyCode.Right, KeyCode.ArrowRight];
let EcaTimeComponent = /*#__PURE__*/(() => {
  class EcaTimeComponent {
    static {
      this.nextId = 0;
    }
    get is12HourFormat() {
      return this.displayFormat === '12';
    }
    get empty() {
      const currentValue = this._value;
      return currentValue === undefined || currentValue === null || !currentValue.trim();
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(plh) {
      this._placeholder = plh;
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(req) {
      this._required = coerceBooleanProperty(req);
      this.updateErrorState();
      this.stateChanges.next();
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    // the value is what is what is given to or received from the consuming control
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
      if (this.onChange) {
        this.onChange(val);
      }
      this.updateErrorState();
      this.stateChanges.next();
    }
    get hourInput() {
      return this._hourInput;
    }
    set hourInput(enteredString) {
      if (this.parseHourInput(enteredString)) {
        this.focusMonitor.focusVia(this.ecaMinuteInput.nativeElement, 'program');
      }
      this.setValue();
    }
    get minuteInput() {
      return this._minuteInput;
    }
    set minuteInput(enteredString) {
      if (this.parseMinuteInput(enteredString) && this.ecaMeridianInput) {
        this.focusMonitor.focusVia(this.ecaMeridianInput.nativeElement, 'program');
      }
      this.setValue();
    }
    get meridianInput() {
      return this._meridianInput;
    }
    set meridianInput(enteredString) {
      this._meridianInput = enteredString;
      this.setValue();
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick(event) {
      const tagName = event.target.tagName.toLowerCase();
      if (tagName !== 'input' && tagName !== 'button' && tagName !== 'mat-icon') {
        this.focusMonitor.focusVia(this.ecaHourInput.nativeElement, 'program');
      }
    }
    constructor(ngControl, focusMonitor, elementRef) {
      this.ngControl = ngControl;
      this.focusMonitor = focusMonitor;
      this.elementRef = elementRef;
      this.disabled = false;
      this.readonly = false;
      // 12  => 3:45 PM
      // 24  => 15:45
      // MIL => 1545
      this.displayFormat = '12';
      /**
       * MatFormFieldControl requires several properties & methods;
       *   the properties are organized alphabetically below
       */
      this.controlType = 'eca-time';
      this.errorState = false;
      this.focused = false;
      this.id = `eca-time-${EcaTimeComponent.nextId++}`;
      this._placeholder = '--';
      this.stateChanges = new Subject();
      this.destroyed = new BehaviorSubject(false);
      /**
       * variables and config related to the overlay (aka. drawer) opened via the icon button
       */
      this.hourOptions = [];
      this.minuteOptions = [];
      this.meridianOptions = [];
      this.overlayIsOpen = false;
      this.overlayMinWidth = '132px';
      this.overlayMinHeight = '334px';
      this.overlayPositions = [{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetX: -16,
        offsetY: 10
      }, {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        offsetX: -16,
        offsetY: -6
      }];
      /**
       * instance method needs to be defined after instance fields
       * these are required MatFormFieldControl methods
       */
      this.describedBy = '';
      this.document = this.elementRef.nativeElement.ownerDocument;
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
      focusMonitor.monitor(elementRef.nativeElement, true).subscribe(origin => {
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }
    ngOnInit() {
      this.stateChanges.next();
      // const focusOnInit = this.elementRef.nativeElement.hasAttribute('cdkfocusinitial');
      // if (focusOnInit) {
      //   this.focusMonitor.focusVia(this.elementRef.nativeElement.querySelector('input'), 'program');
      // }
      this.setupTimeOptions();
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      this.focusMonitor.stopMonitoring(this.elementRef.nativeElement);
      this.destroyed.next(true);
      this.destroyed.complete();
    }
    /**
     * To populate the options (hour, minute) in the overlay
     */
    setupTimeOptions() {
      this.hourOptions = [];
      this.minuteOptions = [];
      const minHour = this.is12HourFormat ? 1 : 0;
      const maxHour = this.is12HourFormat ? 12 : 23;
      const minMinute = 0;
      const maxMinute = 59;
      for (let i = minHour; i <= maxHour; i++) {
        const hourString = i < 10 ? '0' + i.toString() : i.toString(10);
        this.hourOptions.push(hourString);
      }
      for (let i = minMinute; i <= maxMinute; i++) {
        const minuteString = i < 10 ? '0' + i.toString() : i.toString(10);
        this.minuteOptions.push(minuteString);
      }
      this.meridianOptions = ['AM', 'PM'];
    }
    /**
     * Need to have all the pieces for Time otherwise sets the value to ''
     * called whenever any part of the time changes
     */
    setValue() {
      if (this.hourInput && this.minuteInput && (!this.is12HourFormat || this.is12HourFormat && !!this.meridianInput)) {
        // convert to 24hr value
        if (this.is12HourFormat) {
          const hour = Number.parseInt(this.hourInput, 10);
          if (hour === 12) {
            if (this.meridianInput === 'PM') {
              // if hour is 12 then it should remain as 12
              this.value = this.hourInput + ':' + this.minuteInput;
            } else if (this.meridianInput === 'AM') {
              // if hour is 12 then it should get converted to 00
              this.value = '00:' + this.minuteInput;
            }
          } else if (this.meridianInput === 'PM') {
            this.value = (hour + 12).toString(10) + ':' + this.minuteInput;
          } else if (this.meridianInput === 'AM') {
            this.value = this.hourInput + ':' + this.minuteInput;
          }
        } else {
          this.value = this.hourInput + ':' + this.minuteInput;
        }
      } else {
        this.value = '';
      }
    }
    /**
     * Intelligently extrapolate the hour portion given any combination of number values
     * 0-0 = 00 or 01 AM (if 12hr)
     * 0-1 = 01 (from 1 to 9)
     * 1-0 = 10
     * 1-1 = 11
     * 1-2 = 12
     * 1-3 = 13 or 01 PM (from 3 to 9)
     *   2 = 02 (from 2 to 9 if 12hr)
     * 2-0 = 20 if not 12hr
     * 2-1 = 21 if not 12hr
     * 2-2 = 22 if not 12hr
     * 2-3 = 23 if not 12hr
     */
    parseHourInput(enteredString) {
      // if enteredString is 2 digits we process them 1 at a time
      if (enteredString && enteredString.length > 1) {
        this._previousHourKey = '';
        this.parseHourInput(enteredString[0]);
        this.parseHourInput(enteredString[1]);
        return true;
      }
      if (enteredString === null || enteredString === '' || enteredString === undefined) {
        this._hourInput = '';
        return false;
      }
      let enteredNum = Number.parseInt(enteredString, 10);
      if (!this._previousHourKey) {
        this._hourInput = '0' + enteredString;
        if (this.is12HourFormat && enteredNum > 1 || !this.is12HourFormat && enteredNum > 2) {
          this._previousHourKey = enteredString;
          return true;
        }
      } else {
        if (this._previousHourKey === '0') {
          if (enteredString === '0' && this.is12HourFormat) {
            // the minimum for 12 hour format is '01'
            this._hourInput = '12';
            if (!this.meridianInput) {
              this.meridianInput = 'AM';
            }
          } else {
            this._hourInput = '0' + enteredString;
          }
        } else if (this._previousHourKey === '1') {
          this._hourInput = this._previousHourKey + enteredString;
          if (enteredNum > 2 && this.is12HourFormat) {
            this._hourInput = '0' + (enteredNum - 2).toString(10);
            this.meridianInput = 'PM';
          }
        } else if (this._previousHourKey === '2') {
          // max is 23
          if (enteredNum > 3) {
            enteredNum = 3;
            enteredString = '3';
          }
          // handle input of 20, 21, 22, 23 when 12hr format
          if (this.is12HourFormat) {
            const equivalent12Hour = (enteredNum + 8).toString(10);
            this._hourInput = enteredNum + 8 < 10 ? '0' + equivalent12Hour : equivalent12Hour;
            this.meridianInput = 'PM';
          } else {
            this._hourInput = this._previousHourKey + enteredString;
          }
          return true;
        } else {
          console.error('Unhandled hour input');
          return false;
        }
        return true;
      }
      this._previousHourKey = enteredString;
      return false;
    }
    /**
     * Intelligently extrapolate the minute portion given any combination of number values from 00 to 59
     * returns true if a complete Minute has been entered
     */
    parseMinuteInput(enteredString) {
      // if enteredString is 2 digits we process them 1 at a time
      if (enteredString && enteredString.length > 1) {
        this._previousMinuteKey = '';
        this.parseMinuteInput(enteredString[0]);
        this.parseMinuteInput(enteredString[1]);
        return true;
      }
      if (enteredString === null || enteredString === '' || enteredString === undefined) {
        this._minuteInput = '';
        return false;
      }
      const enteredNum = Number.parseInt(enteredString, 10);
      const previousNum = Number.parseInt(this._previousMinuteKey, 10);
      if (!this._previousMinuteKey) {
        this._minuteInput = '0' + enteredString;
        if (enteredNum > 5) {
          return true;
        }
      } else {
        if (previousNum < 6) {
          this._minuteInput = this._previousMinuteKey + enteredString;
          return true;
        } else {
          console.error('Unhandled minute input');
          return false;
        }
      }
      this._previousMinuteKey = enteredString;
      return false;
    }
    hourInputClick(hour) {
      this.parseHourInput(hour);
      this.setValue();
    }
    minuteInputClick(minute) {
      this.parseMinuteInput(minute);
      this.setValue();
    }
    clearInputs() {
      this.hourInput = '';
      this.minuteInput = '';
      this.meridianInput = '';
    }
    onInputBlur() {
      this._previousHourKey = '';
      this._previousMinuteKey = '';
      if (this.onTouched) {
        this.onTouched();
      }
      this.updateErrorState();
      this.stateChanges.next();
    }
    updateErrorState() {
      if (this.ngControl) {
        this.errorState = this.ngControl.invalid && this.ngControl.touched;
      }
    }
    /**
     * handles keydown events within the Hour and Minute input fields
     */
    keydownNumber(event, field) {
      if (this.readonly) {
        return true;
      }
      if (this.isNumber(event)) {
        event.preventDefault();
        if (field === 'hour') {
          this.hourInput = event.key;
        } else if (field === 'minute') {
          this.minuteInput = event.key;
        }
        return true;
      } else if (isKeyDelete(event.key)) {
        if (field === 'hour') {
          this.hourInput = '';
        } else if (field === 'minute') {
          this.minuteInput = '';
        }
        return true;
      } else if (navigationKeyCodes.includes(event.key)) {
        // could add handling of arrow left/right keys and set focus accordingly
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
    isNumber(event) {
      return /[0-9]/.test(event.key);
    }
    /**
     * handles keydown events within the Meridian input field
     */
    keydownMeridian(event) {
      if (this.readonly) {
        return true;
      }
      if (event.key === 'a' || event.key === 'A') {
        this.meridianInput = 'AM';
        return true;
      } else if (event.key === 'p' || event.key === 'P') {
        this.meridianInput = 'PM';
        return true;
      } else if (isKeyDelete(event.key)) {
        this.meridianInput = '';
        return true;
      } else if (navigationKeyCodes.includes(event.key)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
    /**
     * handles keydown events within the overlay (navigating and selecting values)
     */
    keydownSelector(event) {
      const key = event.key;
      const previousElement = this.document.activeElement.previousElementSibling;
      const nextElement = this.document.activeElement.nextElementSibling;
      /**
       *  arrows and tab should move focus
       */
      if (isKeyUp(key) && previousElement) {
        event.preventDefault();
        this.focusMonitor.focusVia(previousElement, 'program');
      } else if (isKeyDown(key) && nextElement) {
        event.preventDefault();
        this.focusMonitor.focusVia(nextElement, 'program');
      } else if (key === KeyCode.Tab) {
        // Tab focus is handled by tabindex=0 on the proper elements
        return true;
      }
      // space or enter selects the focused value
      if (isKeySpace(key) || key === KeyCode.Enter) {
        event.preventDefault();
        this.document.activeElement.click();
      }
      // esc closes the drawer/overlay
      if (isKeyEscape(key)) {
        this.overlayIsOpen = false;
        // set focus back to the button that opened the overlay
        const timeButton = this.document.getElementById(this.id + '-button-toggle');
        this.focusMonitor.focusVia(timeButton, 'program');
      }
    }
    toggleDrawer() {
      this.overlayIsOpen = !this.overlayIsOpen;
      if (this.overlayIsOpen) {
        requestAnimationFrame(() => {
          const hourColumnElement = this.document.getElementsByClassName('eca-time-hour-column')[0];
          const minuteColumnElement = this.document.getElementsByClassName('eca-time-minute-column')[0];
          const hourIndex = this.hourOptions.findIndex(h => h === this.hourInput);
          const minuteIndex = this.minuteOptions.findIndex(m => m === this.minuteInput);
          if (hourColumnElement) {
            hourColumnElement.scrollTo({
              top: hourIndex * 44
            });
            if (hourIndex !== -1) {
              const selectedHourElement = hourColumnElement.getElementsByTagName('div')[hourIndex];
              if (selectedHourElement) {
                this.focusMonitor.focusVia(selectedHourElement, 'program');
              }
            } else {
              this.focusMonitor.focusVia(hourColumnElement.getElementsByTagName('div')[0], 'program');
            }
          }
          if (minuteColumnElement) {
            minuteColumnElement.scrollTo({
              top: minuteIndex * 44
            });
          }
        });
      }
    }
    /**
     * Functions required by ControlValueAccessor
     */
    // Writes a new value to the element (from the outside).
    writeValue(value) {
      if (value) {
        const [hour, minute] = value.split(':');
        this.parseHourInput(hour);
        this.parseMinuteInput(minute);
        if (this.is12HourFormat) {
          const hourNum = Number.parseInt(hour, 10);
          this.meridianInput = hourNum < 12 ? 'AM' : 'PM';
        }
      } else {
        this.clearInputs();
      }
      this.updateErrorState();
      this.stateChanges.next();
    }
    // Registers a callback function that should be called when the control's value changes in the UI.
    registerOnChange(fn) {
      this.onChange = fn;
    }
    // Registers a callback function that should be called when the control receives a blur event.
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    // This function is called by the forms API when the control status changes to or from "DISABLED".
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function EcaTimeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaTimeComponent)(i0.ɵɵdirectiveInject(i1$4.NgControl, 10), i0.ɵɵdirectiveInject(i2$4.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaTimeComponent,
        selectors: [["eca-time"]],
        viewQuery: function EcaTimeComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c41, 5);
            i0.ɵɵviewQuery(_c42, 5);
            i0.ɵɵviewQuery(_c43, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ecaHourInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ecaMinuteInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ecaMeridianInput = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function EcaTimeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("id", ctx.id);
            i0.ɵɵattribute("aria-describedby", ctx.describedBy);
            i0.ɵɵclassProp("floating", ctx.shouldLabelFloat);
          }
        },
        inputs: {
          disabled: "disabled",
          readonly: "readonly",
          displayFormat: "displayFormat",
          placeholder: "placeholder",
          required: "required",
          value: "value"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: EcaTimeComponent
        }])],
        decls: 12,
        vars: 30,
        consts: [["trigger", "cdkOverlayOrigin"], ["ecaHourInput", ""], ["ecaMinuteInput", ""], ["ecaMeridianInput", ""], ["cdkOverlayOrigin", "", 1, "eca-time-input-container"], ["matInput", "", "aria-label", "hour", "type", "text", "maxlength", "2", "autocomplete", "off", "pattern", "[0-9]{2}", 1, "eca-hour-input", 3, "keydown", "blur", "ngClass", "placeholder", "ngModel", "required", "readonly", "disabled"], ["class", "eca-time-colon", 4, "ngIf"], ["matInput", "", "aria-label", "minute", "type", "text", "maxlength", "2", "autocomplete", "off", "pattern", "[0-9]{2}", 1, "eca-minute-input", 3, "keydown", "blur", "ngClass", "placeholder", "ngModel", "required", "readonly", "disabled"], ["matInput", "", "aria-label", "meridian", "type", "text", "class", "eca-meridian-input", "maxlength", "2", "autocomplete", "off", "placeholder", "--", "pattern", "AM|PM", 3, "ngModel", "required", "readonly", "disabled", "ngModelChange", "keydown", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "aria-label", "open time selector", 1, "eca-icon-only", 3, "click", "id", "disabled"], ["role", "img"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayPanelClass", "eca-time-selector-panel", 3, "backdropClick", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPush"], [1, "eca-time-colon"], ["matInput", "", "aria-label", "meridian", "type", "text", "maxlength", "2", "autocomplete", "off", "placeholder", "--", "pattern", "AM|PM", 1, "eca-meridian-input", 3, "ngModelChange", "keydown", "ngModel", "required", "readonly", "disabled"], ["cdkTrapFocus", "", 1, "overlay-container", "eca-fx-auto", "eca-fx-row", "eca-fx-justify-content-start", "eca-fx-gap-1"], [1, "eca-time-hour-column", 3, "keydown", "id"], [3, "tabindex", "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "eca-time-minute-column", 3, "keydown", "id"], ["class", "eca-time-meridian-column", 3, "id", "keydown", 4, "ngIf"], [3, "click", "tabindex", "ngClass"], [1, "eca-time-meridian-column", 3, "keydown", "id"]],
        template: function EcaTimeComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 4, 0)(2, "input", 5, 1);
            i0.ɵɵlistener("keydown", function EcaTimeComponent_Template_input_keydown_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.keydownNumber($event, "hour"));
            })("blur", function EcaTimeComponent_Template_input_blur_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, EcaTimeComponent_span_4_Template, 2, 0, "span", 6);
            i0.ɵɵelementStart(5, "input", 7, 2);
            i0.ɵɵlistener("keydown", function EcaTimeComponent_Template_input_keydown_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.keydownNumber($event, "minute"));
            })("blur", function EcaTimeComponent_Template_input_blur_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, EcaTimeComponent_input_7_Template, 2, 4, "input", 8);
            i0.ɵɵelementStart(8, "button", 9);
            i0.ɵɵlistener("click", function EcaTimeComponent_Template_button_click_8_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleDrawer());
            });
            i0.ɵɵelementStart(9, "mat-icon", 10);
            i0.ɵɵtext(10, "schedule");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(11, EcaTimeComponent_ng_template_11_Template, 6, 5, "ng-template", 11);
            i0.ɵɵlistener("backdropClick", function EcaTimeComponent_Template_ng_template_backdropClick_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleDrawer());
            });
          }
          if (rf & 2) {
            const trigger_r15 = i0.ɵɵreference(1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c44, ctx.displayFormat === "MIL"))("placeholder", ctx.placeholder)("ngModel", ctx.hourInput)("required", ctx.required)("readonly", ctx.readonly)("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.displayFormat !== "MIL");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c44, ctx.displayFormat === "MIL"))("placeholder", ctx.placeholder)("ngModel", ctx.minuteInput)("required", ctx.required)("readonly", ctx.readonly)("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.displayFormat === "12");
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.id + "-button-toggle")("disabled", ctx.disabled || ctx.readonly);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cdkConnectedOverlayFlexibleDimensions", false)("cdkConnectedOverlayGrowAfterOpen", false)("cdkConnectedOverlayBackdropClass", "cdk-overlay-transparent-backdrop")("cdkConnectedOverlayHasBackdrop", true)("cdkConnectedOverlayMinWidth", ctx.overlayMinWidth)("cdkConnectedOverlayHeight", ctx.overlayMinHeight)("cdkConnectedOverlayOrigin", trigger_r15)("cdkConnectedOverlayOpen", ctx.overlayIsOpen)("cdkConnectedOverlayPositions", ctx.overlayPositions)("cdkConnectedOverlayPush", true);
          }
        },
        dependencies: [i2$4.CdkTrapFocus, i1.NgClass, i1.NgForOf, i1.NgIf, i2.DefaultClassDirective, i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.RequiredValidator, i1$4.MaxLengthValidator, i1$4.PatternValidator, i1$4.NgModel, i4.MatIconButton, i6.MatSuffix, i5.MatIcon, i6$1.MatInput, i9.CdkConnectedOverlay, i9.CdkOverlayOrigin],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent;z-index:1;--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0}eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-autocomplete[_ngcontent-%COMP%]   .eca-autocomplete[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-search-chip-list[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .eca-search[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), eca-time[_ngcontent-%COMP%]   .eca-time-input-container[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{background-color:var(--drc-light-blue);border:3px solid var(--drc-blue);border-radius:4px;box-shadow:none;padding:0 7px!important;line-height:38px!important}.mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%]   .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-toggle[_ngcontent-%COMP%] ~ button.mat-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:7px;line-height:inherit}.mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .mat-mdc-table[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-side-panel-close-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], .eca-no-border-icon-button[_ngcontent-%COMP%]   button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]{border-color:transparent}.mat-mdc-button.mat-unthemed[_ngcontent-%COMP%]{--mdc-text-button-label-text-color: var(--drc-blue)}button.mat-mdc-button[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]{border-radius:4px;line-height:40px;font-style:normal;font-weight:600;font-size:16px;border:2px solid var(--drc-blue);position:relative;min-width:initial;color:var(--drc-blue);width:max-content;background-color:var(--drc-white);--mat-icon-button-hover-state-layer-opacity: 0;--mat-icon-button-focus-state-layer-opacity: 0;--mat-icon-button-pressed-state-layer-opacity: 0;--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{--mat-mdc-button-persistent-ripple-color: var(--drc-white);--mat-text-button-state-layer-color: var(--drc-white)}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{--mdc-icon-button-state-layer-size: 44px}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-mdc-button-touch-target[_ngcontent-%COMP%]{max-height:44px;max-width:44px}button.mat-mdc-button.mat-mdc-button-base[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-button-base[_ngcontent-%COMP%]{height:44px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only), .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only){padding:0 14px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon[_ngcontent-%COMP%]{margin-right:8px;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]:not(.mat-mdc-icon-button):not(.eca-icon-only)   .mat-icon.left-spacing[_ngcontent-%COMP%]{margin-right:0;margin-left:4px}button.mat-mdc-button.mat-primary[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-primary[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-primary[_ngcontent-%COMP%]{background-color:var(--drc-blue);border:2px solid var(--drc-blue);color:var(--drc-white)}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]{padding:0 8px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.eca-icon-only.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.eca-icon-only.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 10px}button.mat-mdc-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin:0;height:24px;width:24px;font-size:24px;line-height:24px;vertical-align:middle;padding-bottom:2px}button.mat-mdc-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], button.mat-mdc-icon-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.eca-icon-only.eca-suffix[_ngcontent-%COMP%], .mat-datepicker-close-button.mat-mdc-icon-button.eca-suffix[_ngcontent-%COMP%]{border-radius:0 4px 4px 0}button.mat-mdc-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], button.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-datepicker-close-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{line-height:20px}button.mat-mdc-button[disabled][_ngcontent-%COMP%], button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%], .mat-datepicker-close-button[disabled][_ngcontent-%COMP%]{background-color:var(--drc-light-grey);border:2px solid var(--drc-light-grey);color:var(--drc-dark-grey)!important}button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button.mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{line-height:36px}button.mat-mdc-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-button[_ngcontent-%COMP%]:focus:not([disabled]):before, button.mat-mdc-icon-button[_ngcontent-%COMP%]:hover:not([disabled]), button.mat-mdc-icon-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), button.mat-mdc-icon-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), button.mat-mdc-icon-button[_ngcontent-%COMP%]:focus:not([disabled]):before, .mat-datepicker-close-button[_ngcontent-%COMP%]:hover:not([disabled]), .mat-datepicker-close-button.focus-visible[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus-visible:not([disabled]), .mat-datepicker-close-button.cdk-focused[_ngcontent-%COMP%]:not([disabled]), .mat-datepicker-close-button[_ngcontent-%COMP%]:focus:not([disabled]):before{padding:2px 16px;background-color:var(--drc-white);color:var(--drc-blue);border:none;box-shadow:0 8px 10px -6px var(--drc-dark-grey-15),inset 0 -2px 0 var(--drc-accent-blue),inset 0 2px 0 var(--drc-accent-blue)}button.mat-mdc-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-button.mat-mdc-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.eca-icon-only.add-border[_ngcontent-%COMP%]:not(:disabled), button.mat-icon-button.mat-icon-button.add-border[_ngcontent-%COMP%]:not(:disabled){border-color:var(--drc-blue)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).mat-primary{border-color:var(--drc-white)}.eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .eca-monotron[_ngcontent-%COMP%]   .eca-monotron-wrapper[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, .drc-dark-grey-bg[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):hover, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus-visible, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]).cdk-focused, eca-header-base[_ngcontent-%COMP%]   eca-site-selector[_ngcontent-%COMP%]   button.mat-mdc-button[_ngcontent-%COMP%]:not([disabled]):focus:before{background-color:var(--drc-bright-accent-blue);color:var(--drc-black);border:none;box-shadow:0 20px 25px -5px #262d3980,inset 0 -2px 0 var(--drc-white),inset 0 2px 0 var(--drc-white)}button.remove-btn-formatting[_ngcontent-%COMP%]{border:none!important;margin:0;padding:0;background:transparent;font-size:inherit;font-weight:400}button.remove-btn-formatting[_ngcontent-%COMP%]:not(#eca-skip-to-content-link, .nav-menu-link[_ngcontent-%COMP%], .mdc-icon-button[_ngcontent-%COMP%], #eca-user-profile-menu-link[_ngcontent-%COMP%], .eca-notification-history)[_ngcontent-%COMP%]{height:24px;line-height:24px}.eca-link[_ngcontent-%COMP%]:not([disabled]){color:var(--drc-blue);cursor:pointer}.eca-link[_ngcontent-%COMP%]:not([disabled]):not(.mat-mdc-menu-item){text-decoration:underline}.eca-time-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus::placeholder, .eca-time-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{color:var(--drc-white)}.eca-time-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{text-align:center;caret-color:transparent}.eca-time-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not([readonly=true]):focus, .eca-time-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not([readonly=true]).focus-visible, .eca-time-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not([readonly=true])::selection{background-color:var(--drc-black);color:var(--drc-white)}.eca-time-input-container[_ngcontent-%COMP%]   input.eca-hour-input[_ngcontent-%COMP%], .eca-time-input-container[_ngcontent-%COMP%]   input.eca-minute-input[_ngcontent-%COMP%], .eca-time-input-container[_ngcontent-%COMP%]   input.eca-meridian-input[_ngcontent-%COMP%]{width:24px}.eca-time-input-container[_ngcontent-%COMP%]   input.eca-hour-input.eca-is-using-military-format[_ngcontent-%COMP%]:first-of-type, .eca-time-input-container[_ngcontent-%COMP%]   input.eca-minute-input.eca-is-using-military-format[_ngcontent-%COMP%]:first-of-type, .eca-time-input-container[_ngcontent-%COMP%]   input.eca-meridian-input.eca-is-using-military-format[_ngcontent-%COMP%]:first-of-type{text-align:right}.eca-time-input-container[_ngcontent-%COMP%]   input.eca-hour-input.eca-is-using-military-format[_ngcontent-%COMP%]:last-of-type, .eca-time-input-container[_ngcontent-%COMP%]   input.eca-minute-input.eca-is-using-military-format[_ngcontent-%COMP%]:last-of-type, .eca-time-input-container[_ngcontent-%COMP%]   input.eca-meridian-input.eca-is-using-military-format[_ngcontent-%COMP%]:last-of-type{text-align:left}.eca-time-input-container[_ngcontent-%COMP%]   input.eca-meridian-input[_ngcontent-%COMP%]{margin-left:4px}.eca-time-input-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:last-of-type{margin-right:32px}.eca-time-colon[_ngcontent-%COMP%]{top:0;position:relative}button.mat-mdc-icon-button[_ngcontent-%COMP%]{position:absolute;top:0;right:-16px;background-color:transparent;height:inherit;width:inherit;max-width:44px}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]{border:2px solid transparent;background-color:transparent}button.mat-mdc-icon-button[disabled][_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:var(--drc-light-grey)}.overlay-container[_ngcontent-%COMP%]{background-color:var(--drc-white);padding:16px;box-shadow:4px 4px 16px #00000026;border-radius:4px}.overlay-container[_ngcontent-%COMP%]   .eca-time-hour-column[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-minute-column[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-meridian-column[_ngcontent-%COMP%]{overflow:scroll;scrollbar-width:none;-ms-overflow-style:none}.overlay-container[_ngcontent-%COMP%]   .eca-time-hour-column[_ngcontent-%COMP%]::-webkit-scrollbar, .overlay-container[_ngcontent-%COMP%]   .eca-time-minute-column[_ngcontent-%COMP%]::-webkit-scrollbar, .overlay-container[_ngcontent-%COMP%]   .eca-time-meridian-column[_ngcontent-%COMP%]::-webkit-scrollbar{width:0}.overlay-container[_ngcontent-%COMP%]   .eca-time-hour-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-minute-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-meridian-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{height:44px;width:44px;line-height:40px;text-align:center;border:2px solid transparent;cursor:pointer}.overlay-container[_ngcontent-%COMP%]   .eca-time-hour-column[_ngcontent-%COMP%]   div.eca-selected-time[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-minute-column[_ngcontent-%COMP%]   div.eca-selected-time[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-meridian-column[_ngcontent-%COMP%]   div.eca-selected-time[_ngcontent-%COMP%]{background-color:var(--drc-blue);color:var(--drc-white)}.overlay-container[_ngcontent-%COMP%]   .eca-time-hour-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover, .overlay-container[_ngcontent-%COMP%]   .eca-time-hour-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:focus, .overlay-container[_ngcontent-%COMP%]   .eca-time-hour-column[_ngcontent-%COMP%]   div.focus-visible[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-minute-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover, .overlay-container[_ngcontent-%COMP%]   .eca-time-minute-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:focus, .overlay-container[_ngcontent-%COMP%]   .eca-time-minute-column[_ngcontent-%COMP%]   div.focus-visible[_ngcontent-%COMP%], .overlay-container[_ngcontent-%COMP%]   .eca-time-meridian-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover, .overlay-container[_ngcontent-%COMP%]   .eca-time-meridian-column[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:focus, .overlay-container[_ngcontent-%COMP%]   .eca-time-meridian-column[_ngcontent-%COMP%]   div.focus-visible[_ngcontent-%COMP%]{background-color:var(--drc-light-blue);border-color:var(--drc-blue);color:var(--drc-black);outline:none}"]
      });
    }
  }
  return EcaTimeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaTimeModule = /*#__PURE__*/(() => {
  class EcaTimeModule {
    static {
      this.ɵfac = function EcaTimeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaTimeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaTimeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [A11yModule, CommonModule, FlexLayoutModule, FormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, OverlayModule, ReactiveFormsModule]
      });
    }
  }
  return EcaTimeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaNavigationTileComponent = /*#__PURE__*/(() => {
  class EcaNavigationTileComponent {
    constructor() {
      // todo: rename this output with the next breaking change
      // eslint-disable-next-line @angular-eslint/no-output-native
      this.click = new EventEmitter();
    }
    ngOnInit() {
      this.descriptionLines = this.description.split('\n');
    }
    handleEvent(event) {
      this.click.emit(event);
      event.stopPropagation();
    }
    static {
      this.ɵfac = function EcaNavigationTileComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaNavigationTileComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaNavigationTileComponent,
        selectors: [["eca-navigation-tile"]],
        inputs: {
          icon: "icon",
          title: "title",
          description: "description"
        },
        outputs: {
          click: "click"
        },
        decls: 12,
        vars: 3,
        consts: [["mat-button", "", 1, "navigation-tile", "eca-fx-col", "eca-fx-justify-content-start", "eca-fx-align-items-start", 3, "click"], [1, "icon"], [1, "eca-nav-card-title"], [1, "description"], [4, "ngFor", "ngForOf"], [1, "arrow-button-row", "eca-fx-row", "eca-fx-justify-content-end", "eca-fx-align-items-end", "eca-fx-auto"], [1, "eca-fx-auto"], [1, "arrow-button", "eca-fx-justify-content-end", "eca-fx-align-items-end"]],
        template: function EcaNavigationTileComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function EcaNavigationTileComponent_Template_button_click_0_listener($event) {
              return ctx.handleEvent($event);
            });
            i0.ɵɵelementStart(1, "mat-icon", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵtemplate(6, EcaNavigationTileComponent_div_6_Template, 2, 1, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 5);
            i0.ɵɵelement(8, "div", 6);
            i0.ɵɵelementStart(9, "div", 7)(10, "mat-icon");
            i0.ɵɵtext(11, "arrow_forward");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.icon);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.descriptionLines);
          }
        },
        dependencies: [i1.NgForOf, i5.MatIcon],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}[_nghost-%COMP%]{flex:0 1 auto;display:flex;align-items:stretch}.navigation-tile[_ngcontent-%COMP%]{text-align:left;cursor:pointer;padding:16px;margin:8px 16px 16px 8px;width:240px;border:0 solid transparent;box-sizing:border-box;box-shadow:0 -20px 25px -5px var(--drc-dark-grey-15);border-radius:6px 25px;background-color:#fff;outline:0;position:relative;flex:0 1 auto}@media (max-width: 479px){.navigation-tile[_ngcontent-%COMP%]{width:auto;max-width:240px}}.navigation-tile[_ngcontent-%COMP%]:before{pointer-events:none;content:\"\";border-bottom:4px solid var(--drc-purple);box-shadow:0 -8px 10px -6px var(--drc-dark-grey-15);position:absolute;inset:0;border-radius:6px 25px}.navigation-tile[_ngcontent-%COMP%]:focus, .navigation-tile[_ngcontent-%COMP%]:focus-visible, .navigation-tile[_ngcontent-%COMP%]:focus-within, .navigation-tile[_ngcontent-%COMP%]:hover, .navigation-tile[_ngcontent-%COMP%]   .focus-visible[_ngcontent-%COMP%]{box-shadow:0 4px 0 0 var(--drc-accent-blue) inset,0 -4px 0 0 var(--drc-accent-blue) inset}.navigation-tile[_ngcontent-%COMP%]:focus:before, .navigation-tile[_ngcontent-%COMP%]:focus-visible:before, .navigation-tile[_ngcontent-%COMP%]:focus-within:before, .navigation-tile[_ngcontent-%COMP%]:hover:before, .navigation-tile[_ngcontent-%COMP%]   .focus-visible[_ngcontent-%COMP%]:before{border-color:transparent}.navigation-tile[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:40px;height:40px;width:auto;padding-bottom:1px;color:var(--drc-purple)}.navigation-tile[_ngcontent-%COMP%]   .eca-nav-card-title[_ngcontent-%COMP%]{font-style:normal;font-weight:600;font-size:20px;line-height:30px;letter-spacing:.16px;margin:8px 0;color:var(--drc-purple);cursor:pointer}.navigation-tile[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{font-style:normal;font-weight:400;font-size:16px;line-height:24px;letter-spacing:.16px;text-overflow:ellipsis;overflow:hidden;margin-bottom:0;max-height:6em;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical}.navigation-tile[_ngcontent-%COMP%]   .arrow-button-row[_ngcontent-%COMP%]{width:100%}.navigation-tile[_ngcontent-%COMP%]   .arrow-button[_ngcontent-%COMP%]{margin-top:16px;background-color:var(--drc-blue);padding:10px;border-radius:4px}.navigation-tile[_ngcontent-%COMP%]   .arrow-button[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#fff}"]
      });
    }
  }
  return EcaNavigationTileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaNavigationTileModule = /*#__PURE__*/(() => {
  class EcaNavigationTileModule {
    static {
      this.ɵfac = function EcaNavigationTileModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaNavigationTileModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaNavigationTileModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FlexLayoutModule, MatIconModule]
      });
    }
  }
  return EcaNavigationTileModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaLeftNavService = /*#__PURE__*/(() => {
  class EcaLeftNavService {
    constructor() {}
    setLinks(links) {
      this.links = links;
    }
    getLinks() {
      return this.links;
    }
    setIsOpen(isOpen) {
      this.isOpen = isOpen;
    }
    static {
      this.ɵfac = function EcaLeftNavService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaLeftNavService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaLeftNavService,
        factory: EcaLeftNavService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaLeftNavService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaLeftNavComponent = /*#__PURE__*/(() => {
  class EcaLeftNavComponent {
    constructor() {
      this.opened = true;
      this.openedChange = new EventEmitter();
      this.ecaLeftNavService = inject(EcaLeftNavService);
      this.routeActiveClass = 'is-active';
    }
    ngOnInit() {
      if (!this.links || this.links.length === 0) {
        this.links = this.ecaLeftNavService.getLinks();
      }
    }
    onToggle() {
      this.opened = !this.opened;
      this.ecaLeftNavService.setIsOpen(this.opened);
      this.openedChange.emit(this.opened);
    }
    isActiveChange(expansionPanel, navListItem) {
      of(null).pipe(
      // need to delay 1 ms otherwise the panel is in a weird partially expanded state
      delay(1)).subscribe(() => {
        let hasOpenValues = false;
        // get siblings and check if any of them are active
        Array.from(navListItem._hostElement.parentElement.children).forEach(anchor => {
          if (anchor.classList.contains(this.routeActiveClass)) {
            hasOpenValues = true;
          }
        });
        hasOpenValues ? expansionPanel.open() : expansionPanel.close();
      });
    }
    static {
      this.ɵfac = function EcaLeftNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaLeftNavComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaLeftNavComponent,
        selectors: [["eca-left-nav"]],
        inputs: {
          links: "links",
          opened: "opened"
        },
        outputs: {
          openedChange: "openedChange"
        },
        ngContentSelectors: _c6,
        decls: 16,
        vars: 6,
        consts: [["parentMenu", ""], ["childMenu", ""], ["expansionPanel", ""], ["navListItem", ""], [1, "eca-left-nav-container"], [1, "eca-no-border-icon-button"], ["mat-button", "", 1, "eca-icon-only", 3, "click", "title"], [4, "ngIf"], ["mode", "side", "autoFocus", "autoFocus", "role", "navigation", 3, "opened"], ["aria-label", "Sub", 1, "side-navnar"], [4, "ngFor", "ngForOf"], ["multi", "false", "displayMode", "flat"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["mat-list-item", "", 3, "href"], ["mat-list-item", "", 3, "routerLink", "routerLinkActive", "routerLinkActiveOptions"], ["mat-list-item", "", 3, "isActiveChange", "routerLink", "routerLinkActive", "routerLinkActiveOptions"]],
        template: function EcaLeftNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "button", 6);
            i0.ɵɵlistener("click", function EcaLeftNavComponent_Template_button_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onToggle());
            });
            i0.ɵɵtemplate(3, EcaLeftNavComponent_mat_icon_3_Template, 2, 0, "mat-icon", 7)(4, EcaLeftNavComponent_mat_icon_4_Template, 2, 0, "mat-icon", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "mat-sidenav-container")(6, "mat-sidenav", 8)(7, "mat-nav-list", 9);
            i0.ɵɵtemplate(8, EcaLeftNavComponent_ng_container_8_Template, 2, 4, "ng-container", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, EcaLeftNavComponent_ng_template_9_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(11, "mat-accordion", 11);
            i0.ɵɵtemplate(12, EcaLeftNavComponent_ng_template_12_Template, 6, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "mat-sidenav-content");
            i0.ɵɵprojection(15);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("title", ctx.opened ? "close" : "open");
            i0.ɵɵattribute("aria-label", (ctx.opened ? "close" : "open") + " left nav menu");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.opened);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.opened);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("opened", ctx.opened);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.links);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i4.MatButton, i3$2.MatAccordion, i3$2.MatExpansionPanel, i3$2.MatExpansionPanelHeader, i5.MatIcon, i5$3.MatNavList, i5$3.MatListItem, i6$3.MatSidenav, i6$3.MatSidenavContainer, i6$3.MatSidenavContent, i2$5.RouterLink, i2$5.RouterLinkActive],
        styles: ["[_ngcontent-%COMP%]:root{--drc-blue: #002A5F;--drc-insight-gold: #C88A12;--drc-black: #000000;--drc-amber: #DEB408;--drc-accent-blue: #3071AD;--drc-bright-accent-blue: #43A7DE;--drc-medium-blue: #82C3FF;--drc-light-blue: #EDF6FF;--drc-cool-grey: #545761;--drc-dark-grey: #262D39;--drc-dark-grey-15: #262D3926;--drc-medium-grey: #B1B8C4;--drc-light-grey: #EFEFF0;--drc-white: #FFFFFF;--drc-green: #34520D;--drc-yellow: #FFFF00;--drc-red: #B50000;--drc-purple: #6E1492}[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 0 auto}.eca-left-nav-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:100%;flex:1 0 auto;background-color:var(--drc-light-grey)}.eca-left-nav-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:8px 24px;background-color:transparent}@media (max-width: 767px){.eca-left-nav-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:8px}}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]{display:flex;flex:1 1 auto}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]{padding:8px 8px 8px 0;background-color:var(--drc-light-grey);flex:0 1 auto}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]{--mdc-list-list-item-one-line-container-height: 44px;--mdc-list-list-item-label-text-line-height: 44px;padding-top:0;display:flex;flex-direction:column}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item[_ngcontent-%COMP%], .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header[_ngcontent-%COMP%]{font-size:16px;font-weight:600;width:auto;color:var(--drc-blue);flex:1 0 auto}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel[_ngcontent-%COMP%]{background-color:transparent}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel.mat-expanded[_ngcontent-%COMP%]{background-color:var(--drc-white);color:var(--drc-blue)}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body{color:inherit}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body .mat-mdc-list-item{color:inherit;display:block}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header[_ngcontent-%COMP%]{height:44px;padding-left:16px;padding-right:16px}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header[_ngcontent-%COMP%]     .mat-expansion-indicator{margin-left:16px}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header[_ngcontent-%COMP%]     .mat-expansion-indicator:after{font-family:Material Icons Round;border:none;content:\"\\e145\";transform:none;font-size:16px;color:var(--drc-blue);vertical-align:unset}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]{background-color:var(--drc-white);color:var(--drc-blue)}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]     .mat-expansion-indicator:after{content:\"\\e15b\";color:var(--drc-blue)}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item.is-active[_ngcontent-%COMP%]{background-color:var(--drc-dark-grey);--mdc-list-list-item-label-text-color: var(--drc-white);color:var(--drc-white);border-radius:4px}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item.is-active[_ngcontent-%COMP%]:not(:hover):not(.focus-visible):not(:focus-visible):focus:before{opacity:0}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item.is-active[_ngcontent-%COMP%]:not(:hover):not(.focus-visible):not(:focus-visible):focus     .mdc-list-item__primary-text{--mdc-list-list-item-focus-label-text-color: var(--drc-white)}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]     .mat-expansion-panel.mat-expanded .mat-mdc-list-item.is-active{background-color:var(--drc-dark-grey);color:var(--drc-white)}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item.focus-visible[_ngcontent-%COMP%], .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item[_ngcontent-%COMP%]:hover, .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header.focus-visible[_ngcontent-%COMP%], .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header[_ngcontent-%COMP%]:hover{outline:none;text-decoration:none;background-color:var(--drc-white);color:var(--drc-blue);border-radius:4px;cursor:pointer}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item.focus-visible[_ngcontent-%COMP%]:after, .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-mdc-list-item[_ngcontent-%COMP%]:hover:after, .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header.focus-visible[_ngcontent-%COMP%]:after, .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header[_ngcontent-%COMP%]:hover:after{content:\"\";display:block;height:100%;width:100%;position:absolute;z-index:1000;background-color:transparent;box-sizing:content-box!important;top:0;left:0;box-shadow:0 8px 10px -6px var(--drc-dark-grey-15),inset 0 -2px 0 var(--drc-accent-blue),inset 0 2px 0 var(--drc-accent-blue),inset -2px 0 0 var(--drc-white),inset 2px 0 0 var(--drc-white);border:none;padding:0}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header.mat-expanded.focus-visible[_ngcontent-%COMP%], .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]   .mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]:hover, .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]     .mat-expansion-panel.mat-expanded .mat-mdc-list-item.focus-visible, .eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-container[_ngcontent-%COMP%]   mat-sidenav[_ngcontent-%COMP%]   mat-nav-list.mat-mdc-list-base[_ngcontent-%COMP%]     .mat-expansion-panel.mat-expanded .mat-mdc-list-item:hover{background-color:var(--drc-white);color:var(--drc-blue)}.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-content[_ngcontent-%COMP%]{flex:1 1 auto;height:100%}@media (max-width: 479px){.eca-left-nav-container[_ngcontent-%COMP%]   mat-sidenav-content[_ngcontent-%COMP%]{padding:0}}"]
      });
    }
  }
  return EcaLeftNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaLeftNavModule = /*#__PURE__*/(() => {
  class EcaLeftNavModule {
    static {
      this.ɵfac = function EcaLeftNavModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaLeftNavModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaLeftNavModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatExpansionModule, MatIconModule, MatListModule, MatSidenavModule, MatButtonModule, RouterModule]
      });
    }
  }
  return EcaLeftNavModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var SessionState = /*#__PURE__*/function (SessionState) {
  SessionState[SessionState["ACTIVE"] = 0] = "ACTIVE";
  SessionState[SessionState["IDLE"] = 1] = "IDLE";
  SessionState[SessionState["EXPIRED"] = 2] = "EXPIRED";
  return SessionState;
}(SessionState || {});
/**
 * A generic retry strategy for when an observable stream throws an error
 *
 * This will retry the stream until a maximum retry limit is reached with a retry backoff or if the stream emits a status code that should not be retried
 *
 * @param options retry options
 */
function genericRetryStrategy({
  maxRetryAttempts = 3,
  scalingDuration = 500,
  excludedStatusCodes = []
} = {}) {
  return error$ => {
    return error$.pipe(mergeMap((error, i) => {
      const retryAttempt = i + 1;
      // if maximum number of retries have been met
      // or response is a status code we don't wish to retry, throw error
      if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => {
        return e === error.status;
      })) {
        return throwError(error);
      }
      // retry after 1s, 2s, etc...
      return timer(retryAttempt * scalingDuration);
    }));
  };
}

/**
 * This is a checkbox group validator that has a requirement of a number of checkboxes to be checked.
 *
 * ex.
 * ```
 * formGroup = new FormGroup(
 *   {
 *     math: new FormControl(),
 *     reading: new FormControl(),
 *     writing: new FormControl(),
 *   },
 *   requireCheckboxValidator(2) // <- defaults to 1
 * );
 *
 * // Get the errors
 * formGroup.errors?.requireCheckboxesToBeChecked
 * ```
 *
 * @param num Number of required checkboxes for the FormGroup to be valid.
 */
function requireCheckboxValidator(num = 1) {
  return formGroup => {
    let checked = 0;
    const minRequired = num;
    if (num < 1) {
      console.warn(`requireCheckboxValidator value is less than the default. Please check your validator usage`);
    }
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      if (control.value === true) {
        checked++;
      }
    });
    if (checked < minRequired) {
      return {
        requireCheckboxesToBeChecked: true
      };
    }
    return null;
  };
}

/**
 * This 'guard' always returns true - its purpose (side effect) is to set the help links in the header
 *
 * A route should have at least two 'data' properties
 * 1. helpLinksAttributeTag with its value corresponding to an attribute group tag
 * 2. helpLinksAttributeName with its value corresponding to an attribute name
 * 3. productCode is only required if no product/client context is set in AppContextService
 *
 * For Example:
 *
 export const routes: Routes = [
 {
      path: '',
      component: ParentOutletComponent,
      canActivateChild: [EcaHelpLinksGuard],
      data: {
        helpLinksAttributeTag: 'userManagementHelpLinks'
      },
      children: [
        {
          path: '',
          pathMatch: 'full',
          component: ChildListComponent,
          data: {
            helpLinksAttributeName: 'user-management'
          }
        },
      ...
      ]
    }
 ...
 ]
 *
 */
let EcaHelpLinksGuard = /*#__PURE__*/(() => {
  class EcaHelpLinksGuard {
    constructor(setupConfigService, appContextService, ecaHeaderService) {
      this.setupConfigService = setupConfigService;
      this.appContextService = appContextService;
      this.ecaHeaderService = ecaHeaderService;
    }
    canActivate(route) {
      return this.setHelpLinks(route);
    }
    canActivateChild(route) {
      return this.setHelpLinks(route);
    }
    /**
     * map the value of helpLinksAttributeName data on the route to setup config attributes and set via EcaHeaderService
     */
    setHelpLinks(route) {
      const attributeTag = this.getHelpLinksRouteData(route, 'helpLinksAttributeTag');
      const attributeName = this.getHelpLinksRouteData(route, 'helpLinksAttributeName');
      const productCode = this.getHelpLinksRouteData(route, 'productCode');
      const useCache = this.getHelpLinksRouteData(route, 'useCache');
      if (attributeTag && attributeName) {
        return this.loadAttributes(attributeTag, productCode, useCache).pipe(map(helpLinkAttributesMap => {
          if (helpLinkAttributesMap.has(attributeName)) {
            this.ecaHeaderService.setHelpLinks(helpLinkAttributesMap.get(attributeName));
          } else {
            this.ecaHeaderService.setHelpLinks(null);
          }
          return true;
        }));
      } else {
        this.ecaHeaderService.setHelpLinks(null);
        return of(true);
      }
    }
    /**
     * recursive function to get the route data values for help links
     */
    getHelpLinksRouteData(route, propertyKey) {
      if (route && route.data) {
        if (Object.prototype.hasOwnProperty.call(route.data, propertyKey)) {
          return route.data[propertyKey];
        }
      }
      if (route && route.parent) {
        return this.getHelpLinksRouteData(route.parent, propertyKey);
      }
    }
    loadAttributes(attributeTag, routeDataProductCode, useCache = true) {
      // optimization: could provide some caching here so the same Map is returned given the same Tag and Product
      return this.appContextService.selectedProductCode$.pipe(concatMap(productCode => {
        if (!productCode) {
          productCode = routeDataProductCode;
        }
        if (productCode) {
          return this.setupConfigService.getAttributesForClientByTag(productCode, attributeTag, {
            cache: useCache
          });
        } else {
          return of([]);
        }
      }), map(attributes => {
        const helpLinkAttributesMap = new Map();
        attributes.forEach(attr => {
          helpLinkAttributesMap.set(attr.attribute.key, attr.value.links);
        });
        return helpLinkAttributesMap;
      }));
    }
    static {
      this.ɵfac = function EcaHelpLinksGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaHelpLinksGuard)(i0.ɵɵinject(EcaSetupConfigurationService), i0.ɵɵinject(AppContextService), i0.ɵɵinject(EcaHeaderService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaHelpLinksGuard,
        factory: EcaHelpLinksGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaHelpLinksGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAuthenticatedGuard = /*#__PURE__*/(() => {
  class EcaAuthenticatedGuard {
    constructor(apiGatewayService, appContextService, ecaSecurityService, router, windowService) {
      this.apiGatewayService = apiGatewayService;
      this.appContextService = appContextService;
      this.ecaSecurityService = ecaSecurityService;
      this.router = router;
      this.windowService = windowService;
    }
    canActivate() {
      return this.checkLoggedIn();
    }
    canActivateChild() {
      return this.checkLoggedIn();
    }
    canLoad() {
      return this.checkLoggedIn();
    }
    checkLoggedIn() {
      return this.ecaSecurityService.isUserLoggedIn.pipe(take(1),
      // to complete the observable as this is no longer checking the session state
      switchMap(loginState => {
        if (loginState) {
          // true if logged in
          return of(true);
        } else {
          return this.appContextService.getSelectedProductCode().pipe(map(productCode => {
            let v2PortalUrl = '';
            if (this.apiGatewayService?.config?.apiGatewayUrl) {
              v2PortalUrl = this.apiGatewayService.config.apiGatewayUrl.replace('api-gateway', 'cdn-app');
              v2PortalUrl = v2PortalUrl.replace('cdn-app.', 'www.');
              v2PortalUrl = v2PortalUrl.endsWith('/') ? v2PortalUrl + 'all/eca-portal-v2-ui' : v2PortalUrl + '/all/eca-portal-v2-ui';
            }
            const returnUrl = encodeURIComponent(`${window.location.href}`);
            const portalUrl = this.appContextService.getPortalUrl() || v2PortalUrl;
            if (portalUrl) {
              let redirectUrl;
              if (productCode) {
                redirectUrl = `${portalUrl}/#/login/${productCode}?returnUrl=${returnUrl}`;
              } else {
                redirectUrl = `${portalUrl}/#/login?returnUrl=${returnUrl}`;
              }
              this.windowService.navigateTo(redirectUrl);
            }
            return false;
          }));
        }
      }));
    }
    static {
      this.ɵfac = function EcaAuthenticatedGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAuthenticatedGuard)(i0.ɵɵinject(ApiGatewayService), i0.ɵɵinject(AppContextService), i0.ɵɵinject(EcaSecurityService), i0.ɵɵinject(i2$5.Router), i0.ɵɵinject(WindowService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaAuthenticatedGuard,
        factory: EcaAuthenticatedGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaAuthenticatedGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaAuthorizedGuard = /*#__PURE__*/(() => {
  class EcaAuthorizedGuard {
    constructor(appContextService, ecaSecurityService, router) {
      this.appContextService = appContextService;
      this.ecaSecurityService = ecaSecurityService;
      this.router = router;
    }
    canActivate(route) {
      return this.checkPermissions(route.data);
    }
    canLoad(route) {
      return this.checkPermissions(route.data);
    }
    checkPermissions(data) {
      if (data && data.authAcl) {
        return this.appContextService.getSelectedProductCode().pipe(switchMap(productCode => {
          const permissionRequests = [];
          data.authAcl.forEach(ace => {
            const prefixedAce = productCode ? `${productCode}:${ace}` : `DRCPORTAL:${ace}`;
            permissionRequests.push(this.ecaSecurityService.userHasPermission(prefixedAce));
          });
          return forkJoin(permissionRequests).pipe(map(authResponses => {
            let authorized;
            if (data.authAceJoin && data.authAceJoin === 'and') {
              authorized = authResponses.every(ar => !!ar);
            } else {
              authorized = authResponses.some(ar => !!ar);
            }
            if (!authorized) {
              if (data.noAuthRoute) {
                this.router.navigate([data.noAuthRoute]);
              }
              return false;
            } else {
              return true;
            }
          }));
        }));
      } else {
        return of(true);
      }
    }
    static {
      this.ɵfac = function EcaAuthorizedGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaAuthorizedGuard)(i0.ɵɵinject(AppContextService), i0.ɵɵinject(EcaSecurityService), i0.ɵɵinject(i2$5.Router));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaAuthorizedGuard,
        factory: EcaAuthorizedGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaAuthorizedGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const OKTA_CONFIG = new InjectionToken('OKTA_CONFIG');
let OktaService = /*#__PURE__*/(() => {
  class OktaService {
    get accessToken$() {
      return this.accessToken.asObservable();
    }
    get idToken$() {
      return this.idToken.asObservable();
    }
    get refreshToken$() {
      return this.refreshToken.asObservable();
    }
    constructor(config, windowService) {
      this.config = config;
      this.windowService = windowService;
      this.accessToken = new BehaviorSubject(null);
      this.idToken = new BehaviorSubject(null);
      this.refreshToken = new BehaviorSubject(null);
      /**
       * @deprecated - This variable is only used by sessionExists() and will be removed in a future release
       */
      this.hasOktaSession = false;
      if (!this.config) {
        return;
      }
      // specify default scopes
      if (!this.config.scopes) {
        this.config.scopes = ['openid', 'profile'];
      }
      this.okta = new OktaAuth(this.config.clientConfig);
    }
    get forceOktaSession() {
      return !!this.config && this.config.forceOktaSession;
    }
    /**
     * @deprecated - this method relies on 3rd party cookies. Modern browsers have begun blocking 3rd party cookies. This method will be removed in a future release
     */
    async sessionExists() {
      if (!this.config) {
        return false;
      }
      if (!this.hasOktaSession) {
        this.hasOktaSession = await this.okta.session.exists();
      }
      return this.hasOktaSession;
    }
    /**
     * Attempts to pick up an Okta session. If it cannot, it redirects to Okta to establish one.
     * @returns true when a session is established, false if a redirect was initiated.
     */
    async establishSession() {
      if (this.okta.isLoginRedirect()) {
        try {
          await this.okta.handleRedirect();
          await this.okta.start();
          const originalUri = this.okta.getOriginalUri();
          if (originalUri) {
            this.windowService.location.href = originalUri;
          }
          return true;
        } catch (e) {
          console.error(e);
          return false;
        }
      }
      if (await this.okta.isAuthenticated()) {
        const {
          clientId
        } = (await this.okta.tokenManager?.get('idToken')) || {};
        if (clientId === this.config.clientConfig.clientId) {
          await this.okta.start();
          return true;
        }
      }
      // if the calling application supplies config, use it
      const opts = {
        originalUri: this.windowService.location.href,
        idp: this.config.idp,
        scopes: ['offline_access', 'openid', ...this.config.scopes]
      };
      // Start the browser based oidc flow, then parse tokens from the redirect callback url
      await this.okta.signInWithRedirect(opts);
      return false;
    }
    async initializeTokens(apiGatewayService) {
      this.tokens = await this.okta.tokenManager.getTokens();
      this.accessToken.next(this.tokens.accessToken.accessToken);
      this.idToken.next(this.tokens.idToken.idToken);
      this.refreshToken.next(this.tokens.refreshToken.refreshToken);
      apiGatewayService.accessToken = this.tokens.accessToken.accessToken;
      // Called within 30 secs of token actually expiring
      this.okta.tokenManager.on('expired', key => {
        this.okta.tokenManager.renew(key);
      });
      // Upon renewal, save new token to local variables and apiGatewayService
      this.okta.tokenManager.on('renewed', async (key, newToken) => {
        this.tokens[key] = newToken;
        this[key].next(newToken[key]);
        if ('accessToken' === key && null !== apiGatewayService) {
          apiGatewayService.accessToken = newToken.accessToken;
        }
      });
      // Triggered when an OAuthError is returned via the API (typically during token renew)
      this.okta.tokenManager.on('error', function (err) {
        console.error('TokenManager error:', err);
      });
    }
    getAccessToken() {
      return this.tokens?.accessToken.accessToken;
    }
    getUserInfo() {
      return this.tokens?.idToken.claims;
    }
    getAppAcl() {
      return this.tokens?.accessToken.claims?.acl;
    }
    getUser() {
      return of(this.getUserInfo());
    }
    getToken() {
      return of(this.getAccessToken());
    }
    getAcl() {
      return of(this.getAppAcl());
    }
    isAuthenticated() {
      return from(this.okta.isAuthenticated());
    }
    signOut(postLogoutRedirectUri) {
      return this.okta.signOut({
        postLogoutRedirectUri
      });
    }
    static {
      this.ɵfac = function OktaService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OktaService)(i0.ɵɵinject(OKTA_CONFIG, 8), i0.ɵɵinject(WindowService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OktaService,
        factory: OktaService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OktaService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthService = /*#__PURE__*/(() => {
  class AuthService {
    constructor(oktaService, ecaSecurityService, apiGatewayService, appContextService, ecaSetupConfigurationService) {
      this.oktaService = oktaService;
      this.ecaSecurityService = ecaSecurityService;
      this.apiGatewayService = apiGatewayService;
      this.appContextService = appContextService;
      this.ecaSetupConfigurationService = ecaSetupConfigurationService;
    }
    async initialize() {
      const hasOktaSession = this.oktaService.forceOktaSession ? Promise.resolve(true) : this.oktaService.sessionExists();
      const isOktaEnabledForClient = this.appContextService.getSelectedProductCode().pipe(switchMap(productCode => {
        if (!productCode) {
          return of({
            value: 'false'
          });
        }
        return this.ecaSetupConfigurationService.getAttribute('use-okta-permissions');
      })).toPromise();
      if ((await hasOktaSession) && (await isOktaEnabledForClient).value.toLowerCase() === 'true') {
        this.securityProvider = this.oktaService;
        const sessionEstablished = await this.oktaService.establishSession();
        if (sessionEstablished) {
          await this.oktaService.initializeTokens(this.apiGatewayService);
        }
      } else {
        this.securityProvider = this.ecaSecurityService;
      }
    }
    getAccessToken() {
      return this.securityProvider.getToken();
    }
    getUserInfo() {
      return this.securityProvider.getUser();
    }
    getAcl() {
      return this.securityProvider.getAcl();
    }
    isAuthenticated() {
      return this.securityProvider.isAuthenticated();
    }
    static {
      this.ɵfac = function AuthService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AuthService)(i0.ɵɵinject(OktaService), i0.ɵɵinject(EcaSecurityService), i0.ɵɵinject(ApiGatewayService), i0.ɵɵinject(AppContextService), i0.ɵɵinject(EcaSetupConfigurationService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AuthService,
        factory: AuthService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AuthService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const EcaAuthProvider = {
  provide: APP_INITIALIZER,
  useFactory: initializeAuthFactory,
  deps: [AuthService],
  multi: true
};
/**
 * Angular APP_INITIALIZER factory to determine which type of session
 * is present: Okta or ECA.
 * @param authService
 * @returns
 */
function initializeAuthFactory(authService) {
  return () => authService.initialize();
}
let EcaPubSubService = /*#__PURE__*/(() => {
  class EcaPubSubService {
    constructor() {
      this.topics = {};
    }
    publish(topic, event) {
      if (this.topics[topic]) {
        this.topics[topic].next(event);
      }
    }
    getObservable(topic) {
      if (!this.topics[topic]) {
        this.topics[topic] = new Subject();
      }
      return this.topics[topic].asObservable();
    }
    subscribe(topic, callback) {
      if (!this.topics[topic]) {
        this.topics[topic] = new Subject();
      }
      return this.topics[topic].subscribe(callback);
    }
    static {
      this.ɵfac = function EcaPubSubService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaPubSubService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaPubSubService,
        factory: EcaPubSubService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaPubSubService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaWorkflowService = /*#__PURE__*/(() => {
  class EcaWorkflowService {
    constructor(apiGatewayService, httpClient) {
      this.apiGatewayService = apiGatewayService;
      this.httpClient = httpClient;
      this.baseApiUrl = 'https://eca-workflow-management-api';
      this.teamSubdomain = 'team-s';
      this.start$ = new ReplaySubject(1);
    }
    // call this to pass the search parameters when initializing/finding a workflow template
    startWorkflow(parameters) {
      this.start$.next(parameters);
    }
    // Search available workflows
    findWorkflow(request) {
      const options = this.getDefaultOptions();
      let params = new HttpParams();
      params = params.set('portalApplication', request.portalApplication);
      params = params.set('ecosystem', request.ecosystem);
      params = params.set('client', request.client);
      options.httpOptions = {
        params
      };
      return this.apiGatewayService.get(this.getFullUrl() + '/workflow-request', options);
    }
    // Create a workflow instance
    createWorkflowInstance(requestBody) {
      const options = this.getDefaultOptions();
      return this.apiGatewayService.post(this.getFullUrl() + '/workflow-request', requestBody, options);
    }
    getDetails(workflowId) {
      const options = this.getDefaultOptions();
      let params = new HttpParams();
      params = params.set('id', workflowId);
      options.httpOptions = {
        params
      };
      return this.apiGatewayService.get(this.getFullUrl() + '/workflow-details', options);
    }
    // Example URL:
    // https://eca-workflow-management-api-sqa.team-s-le.drcedirect.com/workflow-request
    getFullUrl() {
      const environment = this.apiGatewayService.getEnvironment();
      const environmentSuffix = environment === ApiEnvironments.prod ? '' : '-' + environment;
      return `${this.baseApiUrl}${environmentSuffix}.${this.getTeamSubdomain()}.drcedirect.com`;
    }
    getTeamSubdomain() {
      return this.apiGatewayService.isLowerEnvironment() ? this.teamSubdomain + '-le' : this.teamSubdomain;
    }
    getDefaultOptions() {
      return {
        withCredentials: false
      };
    }
    static {
      this.ɵfac = function EcaWorkflowService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaWorkflowService)(i0.ɵɵinject(ApiGatewayService), i0.ɵɵinject(i1$2.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaWorkflowService,
        factory: EcaWorkflowService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return EcaWorkflowService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaWorkflowFormComponent = /*#__PURE__*/(() => {
  class EcaWorkflowFormComponent {
    constructor(ecaWorkflowService, snackBar) {
      this.ecaWorkflowService = ecaWorkflowService;
      this.snackBar = snackBar;
      this.submitted = new EventEmitter();
      this.errored = new EventEmitter();
      this.loading = false;
      this.errorMessage = '';
      this.workflowControl = new FormControl(null, Validators.required);
      this.nameControl = new FormControl(null, Validators.required);
      this.descriptionControl = new FormControl();
      this.dateControl = new FormControl(null, Validators.required);
      this.timeControl = new FormControl();
      this.taskTrackingData = null;
      this.ecaCalendarHeader = EcaDatepickerCalendarHeaderComponent;
    }
    ngOnInit() {
      this.formGroup = new FormGroup({
        workflowId: this.workflowControl,
        name: this.nameControl,
        description: this.descriptionControl,
        dueDate: this.dateControl,
        dueTime: this.timeControl
      });
      this.workflowOption$ = this.ecaWorkflowService.start$.asObservable().pipe(tap(() => {
        this.loading = true;
      }), concatMap(requestParams => {
        return this.ecaWorkflowService.findWorkflow(requestParams).pipe(tap(() => {
          this.taskTrackingData = requestParams.taskTrackingData;
        }), map(results => {
          if (results.length) {
            return results.map(result => {
              return {
                value: result.id,
                label: result.name
              };
            });
          }
        }));
      }), tap(() => {
        this.loading = false;
      }), catchError(errorResponse => {
        this.loading = false;
        const config = new EcaSnackbarAlertConfig(`${errorResponse.error}`, 'negative');
        this.snackBar.openFromComponent(EcaSnackbarAlertComponent, config);
        return [];
      }));
      // Get the Workflow Description and whether the request description should be required
      this.workflowControl.valueChanges.pipe(filter(workflowId => !!workflowId), tap(() => {
        this.loading = true;
      }), concatMap(workflowId => {
        return this.ecaWorkflowService.getDetails(workflowId);
      }), tap(details => {
        this.workflowDescription = details.description;
        if (details.requestDescriptionRequired) {
          this.formGroup.get('description').addValidators(Validators.required);
          this.formGroup.get('description').updateValueAndValidity();
        } else {
          this.formGroup.get('description').removeValidators(Validators.required);
          this.formGroup.get('description').updateValueAndValidity();
        }
        this.loading = false;
      })).subscribe();
    }
    submit() {
      this.loading = true;
      const requestParams = {
        ...this.formGroup.value,
        templateDescription: this.workflowDescription,
        trackingData: typeof this.taskTrackingData === 'string' ? this.taskTrackingData : JSON.stringify(this.taskTrackingData)
      };
      this.ecaWorkflowService.createWorkflowInstance(requestParams).subscribe(response => {
        this.formGroup.reset();
        this.submitted.emit(response);
        this.loading = false;
      }, errorResponse => {
        this.nameControl.setErrors({
          error: errorResponse.error
        });
        this.errored.emit(errorResponse);
        this.loading = false;
      });
    }
    static {
      this.ɵfac = function EcaWorkflowFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaWorkflowFormComponent)(i0.ɵɵdirectiveInject(EcaWorkflowService), i0.ɵɵdirectiveInject(i2$2.MatSnackBar));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcaWorkflowFormComponent,
        selectors: [["eca-workflow-form"]],
        inputs: {
          workflowId: "workflowId"
        },
        outputs: {
          submitted: "submitted",
          errored: "errored"
        },
        decls: 46,
        vars: 19,
        consts: [["picker", ""], [1, "eca-workflow-form-container"], ["class", "spinner-overlay", 4, "ngIf"], ["disableOptionCentering", "", 3, "formControl"], [3, "value", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["matInput", "", 3, "formControl"], [1, "workflow-description-container"], [1, "eca-form-field-label"], ["matInput", "", "rows", "5", 3, "formControl"], [1, "due-field-container"], ["matInput", "", "autocomplete", "off", "placeholder", "Choose a date", 3, "matDatepicker", "formControl"], ["matSuffix", "", 3, "for"], ["matDatepickerToggleIcon", ""], [3, "calendarHeaderComponent"], [3, "formControl"], ["mat-button", "", "color", "primary", 3, "click", "disabled"], [1, "spinner-overlay"], ["diameter", "48"], [3, "value"]],
        template: function EcaWorkflowFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, EcaWorkflowFormComponent_div_1_Template, 2, 0, "div", 2);
            i0.ɵɵelementStart(2, "div")(3, "mat-form-field")(4, "mat-label");
            i0.ɵɵtext(5, "Workflow");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "mat-select", 3);
            i0.ɵɵtemplate(7, EcaWorkflowFormComponent_mat_option_7_Template, 2, 2, "mat-option", 4);
            i0.ɵɵpipe(8, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, EcaWorkflowFormComponent_mat_error_9_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div")(11, "mat-form-field")(12, "mat-label");
            i0.ɵɵtext(13, "Name");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(14, "input", 6);
            i0.ɵɵtemplate(15, EcaWorkflowFormComponent_mat_error_15_Template, 2, 1, "mat-error", 5)(16, EcaWorkflowFormComponent_mat_error_16_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 7)(18, "label", 8);
            i0.ɵɵtext(19, "Workflow Description");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "p");
            i0.ɵɵtext(21);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "div")(23, "mat-form-field")(24, "mat-label");
            i0.ɵɵtext(25, "Request Description");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(26, "textarea", 9);
            i0.ɵɵtemplate(27, EcaWorkflowFormComponent_mat_error_27_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "div", 10)(29, "mat-form-field")(30, "mat-label");
            i0.ɵɵtext(31, "Due Date");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(32, "input", 11);
            i0.ɵɵelementStart(33, "mat-datepicker-toggle", 12)(34, "mat-icon", 13);
            i0.ɵɵtext(35, "date_range");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(36, "mat-datepicker", 14, 0);
            i0.ɵɵtemplate(38, EcaWorkflowFormComponent_mat_error_38_Template, 2, 0, "mat-error", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "mat-form-field")(40, "mat-label");
            i0.ɵɵtext(41, "Due Time");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(42, "eca-time", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(43, "div")(44, "button", 16);
            i0.ɵɵlistener("click", function EcaWorkflowFormComponent_Template_button_click_44_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.submit());
            });
            i0.ɵɵtext(45, " Submit & Close ");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            const picker_r4 = i0.ɵɵreference(37);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("formControl", ctx.workflowControl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(8, 17, ctx.workflowOption$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.nameControl.hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("formControl", ctx.nameControl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.nameControl.hasError("error"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.nameControl.hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.workflowDescription);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("formControl", ctx.descriptionControl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.descriptionControl.hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("matDatepicker", picker_r4)("formControl", ctx.dateControl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("for", picker_r4);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("calendarHeaderComponent", ctx.ecaCalendarHeader);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.dateControl.hasError("required"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("formControl", ctx.timeControl);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.formGroup.invalid);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, EcaTimeComponent, i4.MatButton, i6$4.MatDatepicker, i6$4.MatDatepickerInput, i6$4.MatDatepickerToggle, i6$4.MatDatepickerToggleIcon, i5.MatIcon, i6$1.MatInput, i6.MatFormField, i6.MatLabel, i6.MatError, i6.MatSuffix, i4$1.MatSelect, i2$3.MatOption, i7$2.MatProgressSpinner, i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.FormControlDirective, i1.AsyncPipe],
        styles: [".eca-workflow-form-container[_ngcontent-%COMP%]{min-width:420px}.spinner-overlay[_ngcontent-%COMP%]{position:absolute;inset:0;background:#fff9;display:flex;z-index:9;justify-content:center;align-items:center}.mat-mdc-form-field[_ngcontent-%COMP%]{width:100%}.due-field-container[_ngcontent-%COMP%]   .mat-mdc-form-field[_ngcontent-%COMP%]{width:auto}.due-field-container[_ngcontent-%COMP%]   .mat-mdc-form-field[_ngcontent-%COMP%]:last-of-type{padding-left:16px}.workflow-description-container[_ngcontent-%COMP%]{max-width:480px}"]
      });
    }
  }
  return EcaWorkflowFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaWorkflowModule = /*#__PURE__*/(() => {
  class EcaWorkflowModule {
    static {
      this.ɵfac = function EcaWorkflowModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaWorkflowModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaWorkflowModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, EcaDatepickerModule, EcaSnackbarAlertModule, EcaTimeModule, MatButtonModule, MatDatepickerModule, MatIconModule, MatInputModule, MatFormFieldModule, MatSelectModule, MatSnackBarModule, MatProgressSpinnerModule, ReactiveFormsModule]
      });
    }
  }
  return EcaWorkflowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaGoogleAnalyticsService = /*#__PURE__*/(() => {
  class EcaGoogleAnalyticsService {
    constructor(gtConfig, router) {
      this.router = router;
      window['dataLayer'] = window['dataLayer'] || [];
      window['gtag'] = function () {
        // eslint-disable-next-line prefer-rest-params
        window['dataLayer'].push(arguments);
      };
      window['gtag']('js', new Date());
      this.init(gtConfig);
    }
    init(config) {
      this.mergedConfig = {
        trackPageViews: true,
        ...config
      };
      this.config(this.mergedConfig);
      if (this.mergedConfig.trackPageViews) {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd), tap(() => {
          this.pageView();
        })).subscribe();
      }
      return true;
    }
    event(action, params = {}) {
      try {
        this.debugMessage(['send ', action, ' with: ', params]);
        gtag('event', action, params);
      } catch (err) {
        console.error('Google Analytics event error', err);
      }
    }
    pageView(params) {
      try {
        const defaults = {
          page_path: this.router.url,
          page_location: window.location.href
        };
        params = {
          ...defaults,
          ...params
        };
        this.debugMessage(['send page_view with: ', params]);
        gtag('event', 'page_view', params);
      } catch (err) {
        console.error('Google Analytics pageView error', err);
      }
    }
    config(params = {}) {
      try {
        if (this.mergedConfig.tagId) {
          this.debugMessage(['send config with tagId', this.mergedConfig.tagId, params]);
          gtag('config', this.mergedConfig.tagId, params);
        }
      } catch (err) {
        console.error('Google Analytics config error', err);
      }
    }
    debugMessage(consoleLogParams) {
      if (this.mergedConfig.debug) {
        console.log(...consoleLogParams);
      }
    }
    static {
      this.ɵfac = function EcaGoogleAnalyticsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaGoogleAnalyticsService)(i0.ɵɵinject('config'), i0.ɵɵinject(i2$5.Router));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: EcaGoogleAnalyticsService,
        factory: EcaGoogleAnalyticsService.ɵfac
      });
    }
  }
  return EcaGoogleAnalyticsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcaGoogleAnalyticsModule = /*#__PURE__*/(() => {
  class EcaGoogleAnalyticsModule {
    static forRoot(config) {
      return {
        ngModule: EcaGoogleAnalyticsModule,
        providers: [EcaGoogleAnalyticsService, {
          provide: 'config',
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function EcaGoogleAnalyticsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcaGoogleAnalyticsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EcaGoogleAnalyticsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return EcaGoogleAnalyticsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of eca-components-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { API_GATEWAY_CONFIG, ActivityMonitorService, ApiEnvironments, ApiGatewayService, AppContextService, AuthService, BreakpointHeight, BreakpointWidth, BrowserDetectorService, DateService, ECA_DATEPICKER_FORMAT, ECA_LOCALE, EDITABLE_HEADING_VALUE_ACCESSOR, EcaAccessDeniedComponent, EcaAccessDeniedModule, EcaAccordionDirective, EcaAccordionHeaderDirective, EcaAccordionModule, EcaAdminSelectorTableComponent, EcaAppShellComponent, EcaAppShellModule, EcaAuthProvider, EcaAuthenticatedGuard, EcaAuthorizedGuard, EcaAutoCompleteModule, EcaAutocompleteComponent, EcaBrowserDetectorComponent, EcaBrowserDetectorModule, EcaCacheInterceptor, EcaCheckboxGroupComponent, EcaCheckboxGroupModule, EcaCollectionBoxComponent, EcaCollectionBoxModule, EcaComponentsLibModule, EcaDateAdapter, EcaDatePipe, EcaDateRangePipe, EcaDatepickerCalendarHeaderComponent, EcaDatepickerModule, EcaDialogComponent, EcaDialogModule, EcaDrcInsightLogoComponent, EcaDrcInsightLogoModule, EcaEditableHeadingComponent, EcaErrorComponent, EcaErrorModule, EcaFileSelectorComponent, EcaFileSelectorLabel, EcaFileSelectorModule, EcaFooterBaseComponent, EcaFooterBaseModule, EcaFooterComponent, EcaFooterModule, EcaFormColumnComponent, EcaFormColumnModule, EcaGenericMessageDialogComponent, EcaGenericMessageDialogModule, EcaGoogleAnalyticsModule, EcaGoogleAnalyticsService, EcaHeaderBaseComponent, EcaHeaderBaseModule, EcaHeaderComponent, EcaHeaderModule, EcaHeaderService, EcaHelpLinksGuard, EcaHelpMenuComponent, EcaHelpMenuModule, EcaIconComponent, EcaIconDefinitionsComponent, EcaIconModule, EcaLeftNavComponent, EcaLeftNavModule, EcaLeftNavService, EcaLoginBaseComponent, EcaLoginBaseModule, EcaLoginComponent, EcaLoginModule, EcaMenuComponent, EcaMenuDirective, EcaMenuModule, EcaMonotronBodyComponent, EcaMonotronComponent, EcaMonotronModule, EcaMonotronSidePanelCloseDirective, EcaMonotronSidePanelToggleDirective, EcaMultiSelectComponent, EcaMultiSelectModule, EcaNavigationTileComponent, EcaNavigationTileModule, EcaNoResultsComponent, EcaNoResultsModule, EcaNotificationHistoryComponent, EcaNotificationHistoryModule, EcaNotificationHistoryService, EcaPageHeaderComponent, EcaPageHeaderModule, EcaPageWithSidePanelComponent, EcaPageWithSidePanelModule, EcaPaginatorComponent, EcaPaginatorModule, EcaPillarBoxComponent, EcaPillarBoxModule, EcaProgressBarComponent, EcaProgressBarModule, EcaPubSubService, EcaReorderDirective, EcaReorderTableComponent, EcaReorderTableModule, EcaSearchChipListComponent, EcaSearchComponent, EcaSearchModule, EcaSearchSuffixComponent, EcaSecurityService, EcaSetupConfigurationService, EcaSiteSearchComponent, EcaSiteSearchDialogComponent, EcaSiteSearchModule, EcaSiteSearchService, EcaSiteSelectorAdvancedComponent, EcaSiteSelectorBasicComponent, EcaSiteSelectorComponent, EcaSiteSelectorModule, EcaSiteSelectorService, EcaSiteSelectorTableComponent, EcaSiteService, EcaSnackbarAlertComponent, EcaSnackbarAlertConfig, EcaSnackbarAlertModule, EcaTimeComponent, EcaTimeModule, EcaUserProfileMenuComponent, EcaUserProfileMenuModule, EcaVerticalStepperDirective, EcaVerticalStepperModule, EcaWorkflowFormComponent, EcaWorkflowModule, EcaWorkflowService, MENU_ITEM_OVERRIDES, NotificationRequest, OKTA_CONFIG, OktaService, OnChange, SessionState, SiteSelectorParameterDefault, SkipToContentButtonComponent, SkipToContentButtonModule, UX_PATTERN_FORM_FIELD_OPTIONS, UX_PATTERN_RIPPLE_CONFIG, UrlService, WebsocketService, WindowService, administrationDefinition, disableClose, distinctUntilKeyChangedNullSafe, districtDefinition, ecaIconNames, genericRetryStrategy, getCollectionNotSelectableError, getValueInRange, initializeAuthFactory, isNumber, requireCheckboxValidator, schoolDefinition, siteSelectorFieldDefaults, stateDefinition, toInteger };
